(function bootstrapDynamicSite() {
  "use strict";

  var API_BASE = "/api";
  var CART_STORAGE_KEY = "vr_cart_v1";
  var CHECKOUT_DRAFT_KEY = "vr_checkout_draft_v1";
  var PRODUCT_REVIEWER_KEY = "vr_product_reviewer_v1";
  var PRODUCT_REVIEW_RATINGS_KEY = "vr_product_review_ratings_v1";
  var CART_UPDATE_EVENT = "vr-cart-updated";
  var CART_ITEM_ADDED_EVENT = "vr-cart-item-added";
  var MAX_CART_QUANTITY = 99;
  var LOW_STOCK_THRESHOLD = 5;
  var PRODUCTS_PAGE_SIZE = 16;
  var FREE_DELIVERY_THRESHOLD_BAM = 150;
  var DELIVERY_FEE_BAM = 13;
  var CHECKOUT_PAYMENT_METHOD = "brza_posta";
  var CHECKOUT_PAYMENT_METHOD_LABEL = "Brza Posta";
  var CART_DRAWER_OPEN_CLASS = "vr-cart-drawer-open";
  var CART_DRAWER_FLY_IN_CLASS = "vr-cart-drawer-fly-in";
  var PRODUCT_QUICK_VIEW_OPEN_CLASS = "vr-product-quick-view-open";
  var TRUST_INSTAGRAM_PLACEHOLDER = "instagram.com/webflowapp";
  var TRUST_FACEBOOK_PLACEHOLDER = "facebook.com/webflow";
  var TRUST_TWITTER_PLACEHOLDER = "twitter.com/webflow";
  var CONTACT_EMAIL = "info@vaperepublic.ba";
  var CONTACT_PHONE = "+38765015366";
  var cartDrawerFlyTimeoutId = null;
  var cartDrawerInteractionsBound = false;
  var cartDrawerLastFocusedElement = null;
  var productQuickViewLastFocusedElement = null;
  var productQuickViewRequestId = 0;
  var productReviewSaveRequestIds = Object.create(null);
  var quickViewCloseButtonProbeCache = Object.create(null);
  var mobileNavMenuInitialized = false;
  var mobileNavMenuRoot = null;
  var mobileNavMenuList = null;
  var mobileBottomMenuButton = null;
  var mobileNavMenuLastFocusedElement = null;
  var productsGridResizeTimeoutId = null;
  var productsGridResizeBound = false;
  var productsCardHeightSyncFrameId = null;
  var productCardImageObserver = null;
  var PRODUCT_CARD_IMAGE_OBSERVER_MARGIN_PX = 320;
  var PRODUCT_IMAGE_PLACEHOLDER_URL = "/images/placeholder-1_1.svg";
  var INDEX_CATEGORY_BRAND_IMAGE_BY_SLUG = {
    "oxva-tecnosti-za-e-cigarete-novo": "/images/category-branding/oxva-e-liquids.webp?v=20260818-03",
    "oxva-xlim-pro-2-xlim-sq-pro-2-pouzdani-i-moderni-uredjaji":
      "/images/category-branding/oxva-xlim-pro.webp?v=20260818-03",
    "oxbar-dual-blend-50k-dvije-arome-u-jednom": "/images/category-branding/oxbar-dual-blend.webp?v=20260818-03",
    "oxbar-tri-fusion-45k-dimova": "/images/category-branding/oxbar-tri-fusion.webp?v=20260818-03",
    "oxbar-rovota-40k-dimova": "/images/category-branding/oxbar-rovota.webp?v=20260818-03",
    "oxbar-svopp-16k-dimova": "/images/category-branding/oxbar-svopp.webp?v=20260818-03",
    "oxbar-oxhukka-25k-dimova": "/images/category-branding/oxbar-oxhukka.webp?v=20260818-03"
  };
  var RESPONSIVE_IMAGE_WIDTH_STEPS = [96, 120, 160, 240, 320, 400, 480, 640, 768, 960, 1200, 1440, 1680, 1920, 2200];
  var RESPONSIVE_IMAGE_QUALITY_BY_ROLE = {
    card: 72,
    "quick-view": 76,
    detail: 82,
    zoom: 88,
    cart: 62,
    checkout: 66
  };
  var RESPONSIVE_IMAGE_MAX_WIDTH_BY_ROLE = {
    card: 640,
    "quick-view": 960,
    detail: 1440,
    zoom: 2200,
    cart: 160,
    checkout: 220
  };
  var RESPONSIVE_IMAGE_DEFAULT_WIDTH_BY_ROLE = {
    card: 320,
    "quick-view": 720,
    detail: 1200,
    zoom: 1800,
    cart: 120,
    checkout: 180
  };
  var productCardImageLoadQueue = [];
  var productCardImageLoadsInFlight = 0;
  var productCardImageQueueTimerId = 0;
  var productCardImageQueueOrder = 0;
  var desktopProductsStickyCartSource = null;
  var desktopProductsStickyCartClone = null;
  var desktopProductsStickyCartSyncFrameId = 0;
  var desktopProductsStickyCartBound = false;
  var desktopProductsStickyCartHiddenSource = null;
  var desktopProductsStickyLogoSource = null;
  var desktopProductsStickyLogoClone = null;
  var desktopProductsStickyLogoHiddenSource = null;
  var DESKTOP_PRODUCTS_STICKY_LOGO_MIN_WIDTH = 1200;
  var DESKTOP_PRODUCTS_STICKY_LOGO_GUTTER_PX = 16;
  var LANGUAGE_STORAGE_KEY = "vr_language_v1";
  var WHOLESALE_SESSION_STORAGE_KEY = "vr_wholesale_session_v1";
  var WHOLESALE_ROLE = "wholesale_client";
  var WHOLESALE_REQUEST_MODAL_ID = "vr-wholesale-request-modal";
  var WHOLESALE_REQUEST_MODAL_OPEN_CLASS = "vr-wholesale-request-modal-open";
  var WHOLESALE_REQUEST_MODAL_CLOSE_MS = 170;
  var WHOLESALE_LOGOUT_CONFIRM_MODAL_ID = "vr-wholesale-logout-confirm-modal";
  var WHOLESALE_LOGOUT_CONFIRM_MODAL_OPEN_CLASS = "vr-wholesale-logout-confirm-open";
  var WHOLESALE_LOGOUT_RELOAD_GUARD_STORAGE_KEY = "vr_wholesale_logout_reload_guard_v1";
  var WHOLESALE_LOGOUT_RELOAD_GUARD_WINDOW_MS = 4000;
  var WHOLESALE_AUTH_PANEL_RETRY_DELAY_MS = 180;
  var WHOLESALE_AUTH_PANEL_MAX_RETRY_ATTEMPTS = 20;
  var RECAPTCHA_READY_TIMEOUT_MS = 10000;
  var RECAPTCHA_READY_POLL_MS = 50;
  var PUBLIC_RECAPTCHA_ACTIONS = {
    contact: "contact_form",
    wholesaleLogin: "wholesale_login",
    wholesaleAccountRequest: "wholesale_account_request"
  };
  var LANGUAGE_BS = "bs";
  var LANGUAGE_EN = "en";
  var TRANSLATABLE_ATTRIBUTES = [
    "placeholder",
    "title",
    "aria-label",
    "value",
    "data-loading-text",
    "data-wait",
    "data-default-text",
    "data-subscription-text"
  ];
  var currentLanguage = LANGUAGE_BS;
  var languageSupportInitialized = false;
  var languageSelectorIndex = 0;
  var languageObserver = null;
  var languageSyncTimeoutId = null;
  var isApplyingLanguage = false;
  var textNodeBaseValues = typeof WeakMap === "function" ? new WeakMap() : null;
  var attributeBaseValues = typeof WeakMap === "function" ? new WeakMap() : null;
  var documentTitleBaseValue = null;
  var metadataBaseValues = {};
  var METADATA_TRANSLATABLE_SELECTORS = [
    "meta[name='description']",
    "meta[property='og:title']",
    "meta[property='og:description']",
    "meta[property='twitter:title']",
    "meta[property='twitter:description']"
  ];
  var wholesaleProfile = null;
  var wholesaleRequestModalLastFocusedElement = null;
  var wholesaleLogoutConfirmModalLastFocusedElement = null;
  var wholesaleAuthPanelRetryTimeoutId = null;
  var wholesaleAuthPanelRetryAttempts = 0;
  var publicRecaptchaEnabled = false;
  var publicRecaptchaSiteKey = "";
  var publicRecaptchaConfigPromise = null;
  var publicRecaptchaScriptPromise = null;

  var BS_TO_EN_DICTIONARY = buildTranslationDictionary([
    ["Jezik", "Language"],
    ["Izaberi jezik", "Choose language"],
    ["proizvodi", "Products"],
    ["gdje kupiti OXBAR", "Where to Buy OXBAR"],
    ["Veleprodaja", "Wholesale"],
    ["veleprodaja", "Wholesale"],
    ["kontakt", "Contact"],
    ["Korpa", "Cart"],
    ["korpa", "Cart"],
    ["Sve", "All"],
    ["Akcije", "Deals"],
    ["Ekskluzivni distributer Oxbar Vape za cijelu Bosnu i Hercegovinu", "Exclusive Oxbar Vape distributor for all of Bosnia and Herzegovina"],
    ["Nadji OXBAR Radnju", "Find an OXBAR Store"],
    ["Naruci Online", "Order Online"],
    ["(BRZA Posta Dostava)", "(Express Delivery)"],
    ["Oxbar Vape | Vape Republic BiH - Ekskluzivni Distributer", "Oxbar Vape | Vape Republic BiH - Exclusive Distributor"],
    [
      "Vape Republic je ekskluzivni distributer Oxbar uredjaja za cijelu Bosnu i Hercegovinu. Kupite jednokratne vape-ove do 36K dimova uz brzu postu ili pronadjite OXBAR radnju u blizini.",
      "Vape Republic is the exclusive distributor of Oxbar devices across Bosnia and Herzegovina. Buy disposable vapes up to 36K puffs with fast delivery or find a nearby OXBAR store."
    ],
    ["Nasi proizvodi", "Our products"],
    ["Kontakt", "Contact"],
    ["Stupite u kontakt", "Get in touch"],
    ["Kontakt centar", "Contact center"],
    ["Imate pitanje? Rjesavamo ga brzo.", "Have a question? We solve it quickly."],
    [
      "Pisite nam za narudzbe, veleprodaju ili pitanja o proizvodima. Tim odgovara u roku od 24-48h.",
      "Message us about orders, wholesale, or product questions. The team responds within 24-48 hours."
    ],
    [
      "Imate pitanje o narudzbi, veleprodaji ili proizvodima? Posaljite poruku i nas tim ce odgovoriti sto je prije moguce.",
      "Have a question about an order, wholesale, or products? Send us a message and our team will reply as soon as possible."
    ],
    ["Radno vrijeme", "Working hours"],
    ["Narudzbe", "Orders"],
    ["Dostava", "Delivery"],
    ["Povrati", "Returns"],
    ["OXBAR pitanja", "OXBAR questions"],
    ["Politike kupovine", "Shopping policies"],
    ["Dostava u Bosni i Hercegovini", "Shipping across Bosnia and Herzegovina"],
    [
      "Dostavljamo iskljucivo na adrese u BiH. Narudzbe potvrdene do 15:00 radnim danom obicno izlaze isti dan, a isporuka stize za 24-48h.",
      "We currently ship only to addresses in Bosnia and Herzegovina. Orders confirmed by 15:00 on business days usually leave the same day, and delivery arrives within 24-48h."
    ],
    [
      "Dostava je dostupna na adrese u Bosni i Hercegovini. Za narudžbe ispod 150 BAM dostava iznosi 13 BAM. Za narudžbe od 150 BAM i više dostava je besplatna.",
      "Delivery is available to addresses in Bosnia and Herzegovina. Delivery costs 13 BAM for orders below 150 BAM and is free for orders of 150 BAM or more."
    ],
    [
      "Trošak dostave prikazan je u korpi i pri završetku narudžbe. Za informacije o konkretnoj pošiljci kontaktirajte nas uz broj narudžbe.",
      "The delivery charge is shown in the cart and at checkout. For information about a specific shipment, contact us with your order number."
    ],
    [
      "Za pitanja o povratu ili reklamaciji javite se putem kontakt forme, na",
      "For questions about a return or defect claim, use the contact form, email"
    ],
    ["ili na", "or call"],
    [
      "Navedite broj narudžbe i opišite razlog upita kako bi tim mogao provjeriti konkretan slučaj i objasniti naredne korake.",
      "Include your order number and describe your inquiry so the team can review your case and explain the next steps."
    ],
    ["Cijena dostave", "Shipping price"],
    ["13 BAM ispod 150 BAM", "13 BAM below 150 BAM"],
    ["Besplatna dostava", "Free shipping"],
    ["150 BAM i vise", "150 BAM and above"],
    ["Brza otprema", "Fast dispatch"],
    ["isti radni dan do 15:00", "same business day before 15:00"],
    [
      "Dostavu organizujemo preko Brza Posta mreze na teritoriji cijele Bosne i Hercegovine.",
      "Shipping is handled through the Brza Posta network across the whole of Bosnia and Herzegovina."
    ],
    [
      "Prag za besplatnu dostavu se automatski racuna u korpi bez dodatnog kupona ili poziva.",
      "The free-shipping threshold is calculated automatically in the cart without any coupon or manual confirmation."
    ],
    [
      "Za status narudzbe i adresne izmjene javite se na info@vaperepublic.ba ili +387 65 015 366 prije preuzimanja posiljke.",
      "For order status updates or address changes, contact info@vaperepublic.ba or +387 65 015 366 before the parcel is collected."
    ],
    ["Podrska nakon kupovine", "After-purchase support"],
    ["Povrati i reklamacije", "Returns and defect claims"],
    [
      "Povrat odobravamo samo za proizvod sa proizvodnom greskom ili ostecenjem nastalim prije isporuke. Ne nudimo povrat za otvorene ili ispravne proizvode po osnovu promjene misljenja.",
      "We approve returns only for products with a manufacturing defect or damage that occurred before delivery. We do not offer returns for opened or working products due to a change of mind."
    ],
    ["Telefon ili email", "Phone or email"],
    ["Kako prijaviti problem", "How to report an issue"],
    [
      "Posaljite broj narudzbe, kratak opis problema i fotografije proizvoda na info@vaperepublic.ba ili +387 65 015 366.",
      "Send your order number, a short description of the issue, and product photos to info@vaperepublic.ba or +387 65 015 366."
    ],
    ["Provjera zahtjeva", "Claim review"],
    ["Obrada reklamacije", "Defect review process"],
    [
      "Tim pregledava prijavu isti ili naredni radni dan i potvrduje zamjenu proizvoda ili drugi dogovoreni nacin rjesavanja.",
      "The team reviews the claim the same or next business day and confirms a replacement product or another agreed resolution."
    ],
    ["Preuzimanje paketa", "Package pickup"],
    ["Povrat samo uz dogovor", "Return only by arrangement"],
    [
      "Ako je reklamacija odobrena, organizujemo povrat preko dostavne sluzbe ili dogovorenu predaju, bez slanja proizvoda na svoju ruku.",
      "If the claim is approved, we arrange the return through the delivery service or an agreed handoff, instead of having products sent back without coordination."
    ],
    ["Pogledajte mapu radnji", "View store map"],
    ["Posaljite upit", "Send inquiry"],
    [
      "Upit stize direktno timu za podrsku. Unesite osnovne informacije i kratko opisite sta vam je potrebno.",
      "Your inquiry goes directly to the support team. Enter the basic details and briefly describe what you need."
    ],
    ["Unesite vase ime", "Enter your name"],
    ["Email adresa", "Email address"],
    ["Poruka", "Message"],
    ["Napisite poruku...", "Write your message..."],
    ["Posalji upit", "Send inquiry"],
    ["Hvala! Primili smo vas upit i javljamo se uskoro.", "Thank you! We received your inquiry and will respond soon."],
    ["Doslo je do greske. Pokusajte ponovo za nekoliko trenutaka.", "An error occurred. Please try again shortly."],
    ["Brza pomoc", "Quick help"],
    ["Najcesca pitanja prije kupovine", "Frequently asked questions before purchase"],
    ["Koliko traje dostava?", "How long does shipping take?"],
    [
      "Narudzbe potvrdene do 15:00 obicno se salju isti radni dan. Prosjecna dostava traje 24-48h u BiH.",
      "Orders confirmed by 15:00 are usually shipped the same business day. Average delivery in BiH is 24-48h."
    ],
    ["Treba vam veleprodaja?", "Need wholesale?"],
    [
      "Za partnere imamo poseban proces aktivacije. Posaljite upit i tim zakazuje poziv u roku od 24h.",
      "We have a dedicated activation process for partners. Send an inquiry and the team schedules a call within 24h."
    ],
    ["Gdje preuzeti proizvod?", "Where can I pick up a product?"],
    [
      "Ako zelite licno preuzimanje ili adresu najblizeg partnera, otvorite mapu i odaberite najblizu lokaciju.",
      "If you want in-person pickup or the address of the nearest partner, open the map and choose the closest location."
    ],
    ["Odaberite kanal koji vam najvise odgovara.", "Choose the channel that suits you best."],
    ["Podrska kupcima", "Customer support"],
    ["Pon - Sub, 08:00 - 21:00 (CET)", "Mon - Sat, 08:00 - 21:00 (CET)"],
    ["Pon - Pet, 08:00 - 16:00", "Mon - Fri, 08:00 - 16:00"],
    ["Odgovor u roku od 24-48h", "Reply within 24-48 hours"],
    ["Lokacija", "Location"],
    ["Preuzimanje po dogovoru", "Pickup by arrangement"],
    ["Radnje", "Stores"],
    [
      "Kompletna mapa lokacija nasih partnerskih prodajnih mjesta u BiH",
      "Complete map of our partner retail locations in BiH"
    ],
    ["Mapa i", "The map and"],
    ["spisak adresa", "address list"],
    [
      "prikazuju iste lokacije. Prodavnice, partnerske lokacije i moguće buduće lokacije označene su odvojeno. Za potvrdu radnog vremena kontaktirajte odabranu lokaciju.",
      "show the same locations. Stores, partner locations and potential future locations are labelled separately. Contact your chosen location to confirm its opening hours."
    ],
    ["Mapa lokacija", "Location map"],
    ["Adrese lokacija", "Location addresses"],
    ["Učitavanje spiska lokacija…", "Loading the location list…"],
    ["Naše prodavnice", "Our stores"],
    ["Partnerske lokacije", "Partner locations"],
    ["Moguće buduće lokacije", "Potential future locations"],
    ["Ove lokacije nisu potvrđena prodajna mjesta.", "These are not confirmed retail locations."],
    ["Adrese su dostupne i bez otvaranja markera na mapi.", "Addresses are also available without opening map markers."],
    ["Spisak trenutno nije moguće osvježiti. Za potvrdu adrese kontaktirajte nas.", "The list could not be refreshed. Contact us to confirm an address."],
    ["Mapa trenutno nije dostupna. Koristite spisak adresa ispod.", "The map is currently unavailable. Use the address list below."],
    ["Za ažurirani spisak lokacija kontaktirajte", "For the current location list, contact"],
    ["Nasa prodavnica", "Our store"],
    ["Neskovic pumpa", "Neskovic gas station"],
    ["Postanite veleprodajni partner Vape Republic-a", "Become a Vape Republic wholesale partner"],
    [
      "Javi nam se telefonom, putem sajta ili Vibera - za 24-48 h zakazujemo sastanak, upoznajemo se i zajedno odlucujemo o saradnji. Uz",
      "Reach us by phone, website, or Viber and within 24-48h we schedule a meeting, get to know each other, and decide on cooperation together. With"
    ],
    [
      "dobijas prvoklasne jednokratne vape uredjaje po konkurentnim veleprodajnim cijenama, uz brzu i pouzdanu isporuku koju ce tvoji kupci obozavati.",
      "you get top-tier disposable vape devices at competitive wholesale prices with fast, reliable delivery your customers will love."
    ],
    ["Kontaktiraj Odmah Preko Telefona", "Contact us by phone now"],
    ["Zovi Nas Direktno", "Call us directly"],
    ["Viber Broj:", "Viber number:"],
    ["Radno vrijeme: pon - sub, 08 - 21h (CET)", "Working hours: Mon - Sat, 08 - 21h (CET)"],
    ["Ili Preko Poruke", "Or by message"],
    ["Kontaktiraj Preko Sajta", "Contact via website"],
    ["Kontaktiraj Preko Mejla", "Contact by email"],
    ["Odgovor u tokom 24 - 48h", "Reply within 24 - 48h"],
    ["Prijava za veleprodajne klijente", "Wholesale client login"],
    ["Prijavite se da vidite veleprodajne cijene u cijelom katalogu.", "Sign in to see wholesale prices across the full catalog."],
    ["Sifra", "Password"],
    ["Prijavi se", "Sign in"],
    ["Odjavi se", "Sign out"],
    ["Veleprodajne cijene su aktivne", "Wholesale pricing is active"],
    ["Aktivan nalog:", "Active account:"],
    ["Unesite email i sifru.", "Enter email and password."],
    ["Prijava...", "Signing in..."],
    ["Prijava nije uspjela. Pokusajte ponovo.", "Sign in failed. Please try again."],
    ["Prijava uspjesna. Ucitavam veleprodajne cijene...", "Sign-in successful. Loading wholesale prices..."],
    ["Neispravan email ili sifra.", "Invalid email or password."],
    ["Vas nalog nema pristup veleprodajnim cijenama.", "Your account does not have access to wholesale pricing."],
    ["Prijava trenutno nije dostupna. Pokusajte kasnije.", "Sign in is currently unavailable. Please try again later."],
    ["Nemate veleprodajni nalog?", "Don't have a wholesale account?"],
    ["Zatrazite kreiranje naloga", "Request account creation"],
    ["Kreiraj veleprodajni nalog", "Create wholesale account"],
    ["Zahtjev za kreiranje veleprodajnog naloga", "Wholesale account creation request"],
    ["Popunite podatke i tim ce vas kontaktirati u roku od 24-48h.", "Fill in your details and our team will contact you within 24-48h."],
    ["Firma", "Business"],
    ["Osnovni podaci o kompaniji.", "Basic company details."],
    ["Kontakt i adresa", "Contact and address"],
    ["Kako da vas kontaktiramo i gdje poslujete.", "How we can reach you and where you operate."],
    ["Dodatno", "Additional"],
    ["Opcioni podaci koji nam olaksavaju obradu zahtjeva.", "Optional details that help us process your request."],
    ["Naziv firme", "Business name"],
    ["Kontakt osoba", "Contact person"],
    ["Poreski broj / JIB (opcionalno)", "Tax ID / JIB (optional)"],
    ["Web stranica (opcionalno)", "Website (optional)"],
    ["Napomena (opcionalno)", "Note (optional)"],
    ["Nazad", "Back"],
    ["Dalje", "Next"],
    ["Posalji zahtjev", "Send request"],
    ["Otkazi", "Cancel"],
    ["Unesite naziv firme", "Enter business name"],
    ["Unesite kontakt osobu", "Enter contact person"],
    ["Unesite broj telefona", "Enter phone number"],
    ["Unesite adresu", "Enter address"],
    ["Unesite grad", "Enter city"],
    ["Unesite postanski broj", "Enter postal code"],
    ["Unesite poreski broj ili JIB", "Enter tax ID or JIB"],
    ["https://primjer.com", "https://example.com"],
    [
      "Dodatne informacije o prodavnici, lokaciji i planu saradnje.",
      "Additional details about your shop, location, and cooperation plans."
    ],
    ["Odjavljeni ste.", "You have been signed out."],
    ["Korpa je prazna.", "Your cart is empty."],
    ["Pogledaj proizvode", "Browse products"],
    ["Ukloni proizvod", "Remove item"],
    ["Zatvori korpu", "Close cart"],
    ["Stavke", "Items"],
    ["Ukupno", "Total"],
    ["Sada", "Now"],
    ["Nastavi na pla\u0107anje", "Proceed to checkout"],
    ["Dodaj u korpu", "Add to cart"],
    ["Nedostupno", "Unavailable"],
    ["Rasprodato", "Sold out"],
    ["Dodato", "Added"],
    ["Pokusaj ponovo", "Try again"],
    ["Pretrazi proizvode...", "Search products..."],
    ["Pretrazi", "Search"],
    ["Ocisti", "Clear"],
    ["Prethodna", "Previous"],
    ["Sljedeca", "Next"],
    ["Prethodna stranica", "Previous page"],
    ["Sljedeca stranica", "Next page"],
    ["Kolicina", "Quantity"],
    ["Kupi sad", "Buy now"],
    ["Dostupno: {count}", "{count} available"],
    ["Proizvod nije dostupan za narudzbu.", "This product is unavailable for ordering."],
    ["Proizvod je dodat u korpu.", "Product added to cart."],
    ["Dodavanje u korpu trenutno nije dostupno.", "Adding to cart is currently unavailable."],
    ["Podaci za narudzbu", "Order details"],
    ["Ime i prezime", "Full name"],
    ["Telefon", "Phone"],
    ["Drzava", "Country"],
    ["\ud83c\udde7\ud83c\udde6 Bosna i Hercegovina", "\ud83c\udde7\ud83c\udde6 Bosnia and Herzegovina"],
    ["Bosna i Hercegovina", "Bosnia and Herzegovina"],
    ["Adresa", "Address"],
    ["Adresa 2 (opcionalno)", "Address 2 (optional)"],
    ["Grad", "City"],
    ["Postanski broj", "Postal code"],
    ["Dostava i placanje", "Shipping and payment"],
    ["Napomena", "Note"],
    ["Potvrdi narudzbu", "Confirm order"],
    ["Pregled narudzbe", "Order summary"],
    [
      "Dostava i placanje se vrse putem Brze Poste. Nakon potvrde narudzbe, dobicete broj narudzbe i potvrdu.",
      "Shipping and payment are handled through Brza Posta. After confirmation, you will receive your order number and confirmation."
    ],
    ["Provjerite obavezna polja, email i broj telefona.", "Please check required fields, email, and phone number."],
    ["Slanje narudzbe...", "Submitting order..."],
    ["Neki proizvodi vise nisu dostupni i uklonjeni su iz korpe.", "Some products are no longer available and were removed from your cart."],
    ["Narudzba nije uspjesno kreirana.", "Order could not be created."],
    ["Potvrda narudzbe", "Order confirmation"],
    ["Ucitavanje narudzbe...", "Loading order..."],
    ["Nedostaje referenca narudzbe.", "Order reference is missing."],
    ["Hvala vam. Narudzba je uspjesno evidentirana.", "Thank you. Your order was recorded successfully."],
    ["Broj narudzbe", "Order number"],
    ["Datum", "Date"],
    ["Kupac", "Customer"],
    ["Nema stavki.", "No items."],
    ["Nastavi kupovinu", "Continue shopping"],
    ["Ucitavanje proizvoda...", "Loading product..."],
    ["Proizvod trenutno nije dostupan.", "This product is currently unavailable."],
    ["Zatvori detalje proizvoda", "Close product details"],
    ["Nacin placanja", "Payment method"],
    ["Narudzba nije pronadjena.", "Order not found."],
    ["Brza Posta", "Express Delivery"],
    ["Pouzecem", "Cash on delivery"],
    ["Uplata na racun", "Bank transfer"]
  ]);

  var BS_TO_EN_REGEX_REPLACEMENTS = [
    {
      pattern: /^aktiv(?:an|ni)\s+nalog:/i,
      replace: "Active account:"
    },
    {
      pattern: /^korpa\s*\((\d+)\)$/i,
      replace: "Cart ($1)"
    },
    {
      pattern: /(\d+\s*K?)\s*Dimova/gi,
      replace: "$1 Puffs"
    },
    {
      pattern: /\bDimova\b/gi,
      replace: "Puffs"
    },
    {
      pattern: /\bpouzdani i moderni uredjaji\b/gi,
      replace: "reliable and modern devices"
    },
    {
      pattern: /\bDvije Arome U Jednom\b/gi,
      replace: "Two Flavors in One"
    },
    {
      pattern: /\btecnosti\b/gi,
      replace: "e-liquids"
    },
    {
      pattern: /\bte(?:c|\u010d)nosti\b/gi,
      replace: "e-liquids"
    },
    {
      pattern: /\bza e-cigarete\b/gi,
      replace: "for e-cigarettes"
    },
    {
      pattern: /\bza OXVA Xlim uredjaje\b/gi,
      replace: "for OXVA Xlim devices"
    },
    {
      pattern: /\bGrijaci\b/gi,
      replace: "Coils"
    },
    {
      pattern: /\buredjaje\b/gi,
      replace: "devices"
    },
    {
      pattern: /\buredjaji\b/gi,
      replace: "devices"
    },
    {
      pattern: /^Slika proizvoda: /i,
      replace: "Product image: "
    },
    {
      pattern: /^Slika nije dostupna: /i,
      replace: "Image unavailable: "
    },
    {
      pattern: /^Upute za /i,
      replace: "Directions to "
    },
    {
      pattern: /\bMoguca buduca lokacija\b/gi,
      replace: "Potential future location"
    },
    {
      pattern: /\bNeskovi(?:c|\u0107) Pumpa\b/gi,
      replace: "Neskovic Gas Station"
    },
    {
      pattern: /\bNeskovic Pumpa\b/gi,
      replace: "Neskovic Gas Station"
    },
    {
      pattern: /\bNovo\b/gi,
      replace: "New"
    }
  ];

  function normalizeLanguage(value) {
    return String(value || "").trim().toLowerCase() === LANGUAGE_EN ? LANGUAGE_EN : LANGUAGE_BS;
  }

  function readStoredLanguage() {
    try {
      return normalizeLanguage(window.localStorage.getItem(LANGUAGE_STORAGE_KEY));
    } catch (_error) {
      return LANGUAGE_BS;
    }
  }

  function persistLanguage(language) {
    try {
      window.localStorage.setItem(LANGUAGE_STORAGE_KEY, normalizeLanguage(language));
    } catch (_error) {
      return;
    }
  }

  function normalizeTranslationKey(value) {
    var normalized = String(value || "")
      .replace(/\u00a0/g, " ")
      .replace(/[\u2010-\u2015]/g, "-")
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201c\u201d]/g, '"');

    if (typeof normalized.normalize === "function") {
      normalized = normalized.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    return normalized.replace(/\s+/g, " ").trim().toLowerCase();
  }

  function buildTranslationDictionary(entries) {
    var dictionary = {};

    if (!Array.isArray(entries)) {
      return dictionary;
    }

    entries.forEach(function registerTranslation(entry) {
      if (!Array.isArray(entry) || entry.length < 2) {
        return;
      }

      var key = normalizeTranslationKey(entry[0]);
      if (!key) {
        return;
      }

      dictionary[key] = String(entry[1] || "");
    });

    return dictionary;
  }

  function translateCoreText(value, language) {
    var source = String(value || "");
    if (!source || language !== LANGUAGE_EN) {
      return source;
    }

    var normalizedKey = normalizeTranslationKey(source);
    if (normalizedKey && Object.prototype.hasOwnProperty.call(BS_TO_EN_DICTIONARY, normalizedKey)) {
      return BS_TO_EN_DICTIONARY[normalizedKey];
    }

    var translated = source;

    BS_TO_EN_REGEX_REPLACEMENTS.forEach(function applyRegexReplacement(rule) {
      if (!rule || !(rule.pattern instanceof RegExp)) {
        return;
      }

      translated = translated.replace(rule.pattern, rule.replace);
    });

    return translated;
  }

  function translateString(value, language) {
    var source = String(value || "");
    if (!source || language !== LANGUAGE_EN) {
      return source;
    }

    var leadingWhitespaceMatch = source.match(/^\s*/);
    var trailingWhitespaceMatch = source.match(/\s*$/);
    var leadingWhitespace = leadingWhitespaceMatch ? leadingWhitespaceMatch[0] : "";
    var trailingWhitespace = trailingWhitespaceMatch ? trailingWhitespaceMatch[0] : "";
    var core = source.slice(leadingWhitespace.length, source.length - trailingWhitespace.length);

    if (!core) {
      return source;
    }

    return leadingWhitespace + translateCoreText(core, language) + trailingWhitespace;
  }

  function resetTranslationCaches() {
    textNodeBaseValues = typeof WeakMap === "function" ? new WeakMap() : null;
    attributeBaseValues = typeof WeakMap === "function" ? new WeakMap() : null;
    documentTitleBaseValue = null;
    metadataBaseValues = {};
  }

  function getStoredTextBaseValue(node) {
    if (!node) {
      return undefined;
    }

    if (textNodeBaseValues) {
      return textNodeBaseValues.has(node) ? textNodeBaseValues.get(node) : undefined;
    }

    return Object.prototype.hasOwnProperty.call(node, "__vrBaseText") ? node.__vrBaseText : undefined;
  }

  function setStoredTextBaseValue(node, value) {
    if (!node) {
      return;
    }

    if (textNodeBaseValues) {
      textNodeBaseValues.set(node, value);
      return;
    }

    node.__vrBaseText = value;
  }

  function readAttributeStorageMap(element, createIfMissing) {
    if (!element) {
      return null;
    }

    if (attributeBaseValues) {
      var map = attributeBaseValues.get(element);
      if (!map && createIfMissing) {
        map = {};
        attributeBaseValues.set(element, map);
      }

      return map || null;
    }

    if (!Object.prototype.hasOwnProperty.call(element, "__vrBaseAttributes")) {
      if (!createIfMissing) {
        return null;
      }

      element.__vrBaseAttributes = {};
    }

    return element.__vrBaseAttributes;
  }

  function getStoredAttributeBaseValue(element, attributeName) {
    var map = readAttributeStorageMap(element, false);
    if (!map || !Object.prototype.hasOwnProperty.call(map, attributeName)) {
      return undefined;
    }

    return map[attributeName];
  }

  function setStoredAttributeBaseValue(element, attributeName, value) {
    var map = readAttributeStorageMap(element, true);
    if (!map) {
      return;
    }

    map[attributeName] = value;
  }

  function shouldTranslateValueAttribute(element) {
    if (!element || !element.tagName) {
      return false;
    }

    var tagName = String(element.tagName).toUpperCase();
    if (tagName === "INPUT") {
      var inputType = String(element.getAttribute("type") || "").trim().toLowerCase();
      if (inputType === "submit" || inputType === "button" || inputType === "reset") {
        return true;
      }

      return !!(element.classList && element.classList.contains("vr-fixed-field"));
    }

    return tagName === "BUTTON";
  }

  function readElementAttributeValue(element, attributeName) {
    if (!element) {
      return "";
    }

    if (attributeName === "value" && "value" in element && shouldTranslateValueAttribute(element)) {
      return String(element.value || "");
    }

    var value = element.getAttribute(attributeName);
    return typeof value === "string" ? value : "";
  }

  function writeElementAttributeValue(element, attributeName, value) {
    if (!element) {
      return;
    }

    if (attributeName === "value" && shouldTranslateValueAttribute(element)) {
      element.setAttribute(attributeName, value);

      if ("value" in element) {
        element.value = value;
      }

      return;
    }

    element.setAttribute(attributeName, value);
  }

  function isElementExcludedFromTranslation(element) {
    return !!(
      element &&
      typeof element.closest === "function" &&
      element.closest("[data-vr-no-translate='1']")
    );
  }

  function isTextNodeTranslatable(node) {
    if (!node || node.nodeType !== 3) {
      return false;
    }

    var parentElement = node.parentElement;
    if (!parentElement) {
      return false;
    }

    if (isElementExcludedFromTranslation(parentElement)) {
      return false;
    }

    var parentTag = String(parentElement.tagName || "").toUpperCase();
    if (parentTag === "SCRIPT" || parentTag === "STYLE" || parentTag === "NOSCRIPT") {
      return false;
    }

    return String(node.nodeValue || "").trim().length > 0;
  }

  function applyLanguageToTextNode(node, language) {
    if (!isTextNodeTranslatable(node)) {
      return;
    }

    var currentValue = String(node.nodeValue || "");

    if (language === LANGUAGE_EN) {
      var baseValue = getStoredTextBaseValue(node);
      if (typeof baseValue !== "string") {
        baseValue = currentValue;
        setStoredTextBaseValue(node, baseValue);
      } else {
        var translatedFromBase = translateString(baseValue, LANGUAGE_EN);
        if (currentValue !== translatedFromBase) {
          baseValue = currentValue;
          setStoredTextBaseValue(node, baseValue);
        }
      }

      var translatedValue = translateString(baseValue, LANGUAGE_EN);
      if (translatedValue !== currentValue) {
        node.nodeValue = translatedValue;
      }

      return;
    }

    var storedBaseValue = getStoredTextBaseValue(node);
    if (typeof storedBaseValue === "string" && storedBaseValue !== currentValue) {
      node.nodeValue = storedBaseValue;
    }
  }

  function applyLanguageToElementAttribute(element, attributeName, language) {
    if (!element || isElementExcludedFromTranslation(element)) {
      return;
    }

    if (attributeName === "value" && !shouldTranslateValueAttribute(element)) {
      return;
    }

    if (!element.hasAttribute(attributeName)) {
      return;
    }

    var currentValue = readElementAttributeValue(element, attributeName);

    if (language === LANGUAGE_EN) {
      var baseValue = getStoredAttributeBaseValue(element, attributeName);

      if (typeof baseValue !== "string") {
        baseValue = currentValue;
        setStoredAttributeBaseValue(element, attributeName, baseValue);
      } else {
        var translatedFromBase = translateString(baseValue, LANGUAGE_EN);
        if (currentValue !== translatedFromBase) {
          baseValue = currentValue;
          setStoredAttributeBaseValue(element, attributeName, baseValue);
        }
      }

      var translatedValue = translateString(baseValue, LANGUAGE_EN);
      if (translatedValue !== currentValue) {
        writeElementAttributeValue(element, attributeName, translatedValue);
      }

      return;
    }

    var storedBaseValue = getStoredAttributeBaseValue(element, attributeName);
    if (typeof storedBaseValue === "string" && storedBaseValue !== currentValue) {
      writeElementAttributeValue(element, attributeName, storedBaseValue);
    }
  }

  function applyLanguageToMetadata(language) {
    if (language === LANGUAGE_EN) {
      if (typeof documentTitleBaseValue !== "string") {
        documentTitleBaseValue = String(document.title || "");
      } else if (document.title !== translateString(documentTitleBaseValue, LANGUAGE_EN)) {
        documentTitleBaseValue = String(document.title || "");
      }

      document.title = translateString(documentTitleBaseValue, LANGUAGE_EN);

      METADATA_TRANSLATABLE_SELECTORS.forEach(function applyMetaTranslation(selector) {
        var metaNode = document.querySelector(selector);
        if (!metaNode) {
          return;
        }

        var currentValue = String(metaNode.getAttribute("content") || "");
        if (!currentValue) {
          return;
        }

        var baseValue = metadataBaseValues[selector];

        if (typeof baseValue !== "string") {
          baseValue = currentValue;
          metadataBaseValues[selector] = baseValue;
        } else if (currentValue !== translateString(baseValue, LANGUAGE_EN)) {
          baseValue = currentValue;
          metadataBaseValues[selector] = baseValue;
        }

        metaNode.setAttribute("content", translateString(baseValue, LANGUAGE_EN));
      });

      return;
    }

    if (typeof documentTitleBaseValue === "string") {
      document.title = documentTitleBaseValue;
    }

    METADATA_TRANSLATABLE_SELECTORS.forEach(function restoreMetaTranslation(selector) {
      var metaNode = document.querySelector(selector);
      var baseValue = metadataBaseValues[selector];

      if (!metaNode || typeof baseValue !== "string") {
        return;
      }

      metaNode.setAttribute("content", baseValue);
    });
  }

  function applyLanguageToTree(language) {
    var root = document.body || document.documentElement;
    if (!root) {
      return;
    }

    var textNodes = [];
    var textFilter = window.NodeFilter ? window.NodeFilter.SHOW_TEXT : 4;
    var walker = document.createTreeWalker(root, textFilter, null);
    var currentNode = walker.nextNode();

    while (currentNode) {
      textNodes.push(currentNode);
      currentNode = walker.nextNode();
    }

    textNodes.forEach(function translateNode(node) {
      applyLanguageToTextNode(node, language);
    });

    var elements = [root].concat(Array.prototype.slice.call(root.querySelectorAll("*")));

    elements.forEach(function translateElementAttributes(element) {
      TRANSLATABLE_ATTRIBUTES.forEach(function applyAttributeTranslation(attributeName) {
        applyLanguageToElementAttribute(element, attributeName, language);
      });
    });
  }

  function syncLanguageSelectorUi() {
    var isEnglish = currentLanguage === LANGUAGE_EN;

    document.querySelectorAll(".vr-lang-switch").forEach(function syncSelector(selector) {
      var select = selector.querySelector("[data-vr-lang-select]");
      var resolvedColor = "#111827";
      var navRoot =
        selector && typeof selector.closest === "function"
          ? selector.closest(".navigation-items")
          : null;
      var colorSource =
        navRoot && typeof navRoot.querySelector === "function"
          ? navRoot.querySelector(".navigation-item:not(.cart-icon)")
          : null;

      if (colorSource && typeof window.getComputedStyle === "function") {
        var sampledColor = window.getComputedStyle(colorSource).color;
        if (sampledColor) {
          resolvedColor = sampledColor;
        }
      }

      selector.style.setProperty("--vr-lang-color", resolvedColor);

      if (select) {
        select.value = currentLanguage;
        select.setAttribute("aria-label", isEnglish ? "Choose language" : "Izaberi jezik");
      }
    });
  }

  function ensureLanguageSelector() {
    var navContainers = Array.prototype.slice.call(document.querySelectorAll(".navigation .navigation-items"));

    navContainers.forEach(function insertSelector(navContainer) {
      if (!navContainer || navContainer.querySelector(".vr-lang-switch")) {
        return;
      }

      var logoLink = navContainer.querySelector("a.logo-link.w-nav-brand");
      if (!logoLink) {
        return;
      }

      languageSelectorIndex += 1;
      var selectId = "vr-language-select-" + languageSelectorIndex;

      var selector = document.createElement("div");
      selector.className = "vr-lang-switch";
      selector.setAttribute("data-vr-no-translate", "1");
      selector.innerHTML = [
        '<select id="' + selectId + '" class="vr-lang-switch-select" data-vr-lang-select aria-label="Izaberi jezik">',
        '  <option value="bs">\ud83c\udde7\ud83c\udde6 BiH</option>',
        '  <option value="en">\ud83c\uddec\ud83c\udde7 ENG</option>',
        "</select>",
        '<span class="vr-lang-switch-chevron" aria-hidden="true">',
        '  <svg viewBox="0 0 24 24" focusable="false">',
        '    <path d="m6 9 6 6 6-6"></path>',
        "  </svg>",
        "</span>"
      ].join("");

      if (logoLink.nextSibling) {
        navContainer.insertBefore(selector, logoLink.nextSibling);
      } else {
        navContainer.appendChild(selector);
      }

      var select = selector.querySelector("[data-vr-lang-select]");
      if (select) {
        select.value = currentLanguage;
        select.addEventListener("change", function onLanguageChange(event) {
          changeLanguage(event.target ? event.target.value : LANGUAGE_BS);
        });
      }
    });

    syncLanguageSelectorUi();
  }

  function applyLanguageToDocument(language) {
    var normalizedLanguage = normalizeLanguage(language);

    if (isApplyingLanguage) {
      return;
    }

    isApplyingLanguage = true;

    try {
      ensureLanguageSelector();
      applyLanguageToMetadata(normalizedLanguage);
      applyLanguageToTree(normalizedLanguage);
      syncLanguageSelectorUi();

      if (document.documentElement) {
        document.documentElement.setAttribute("lang", normalizedLanguage);
      }

      if (normalizedLanguage === LANGUAGE_BS) {
        resetTranslationCaches();
      }

      initWholesaleViberCopy();
    } finally {
      isApplyingLanguage = false;
    }
  }

  function requestLanguageSync() {
    if (currentLanguage !== LANGUAGE_EN || isApplyingLanguage || languageSyncTimeoutId) {
      return;
    }

    languageSyncTimeoutId = window.setTimeout(function flushLanguageSync() {
      languageSyncTimeoutId = null;
      applyLanguageToDocument(currentLanguage);
    }, 0);
  }

  function observeLanguageMutations() {
    if (languageObserver || typeof MutationObserver !== "function" || !document.body) {
      return;
    }

    languageObserver = new MutationObserver(function onLanguageMutation(mutations) {
      if (currentLanguage !== LANGUAGE_EN || isApplyingLanguage) {
        return;
      }

      var hasRelevantMutation = false;

      for (var index = 0; index < mutations.length; index += 1) {
        var mutation = mutations[index];

        if (mutation.type === "childList" || mutation.type === "characterData") {
          hasRelevantMutation = true;
          break;
        }
      }

      if (hasRelevantMutation) {
        requestLanguageSync();
      }
    });

    languageObserver.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true
    });
  }

  function changeLanguage(language, options) {
    var config = options && typeof options === "object" ? options : {};
    var nextLanguage = normalizeLanguage(language);

    if (nextLanguage === currentLanguage && !config.force) {
      syncLanguageSelectorUi();
      return;
    }

    currentLanguage = nextLanguage;

    if (!config.skipPersist) {
      persistLanguage(currentLanguage);
    }

    applyLanguageToDocument(currentLanguage);
    normalizeFooterTrustLinks();
    syncProductsWholesaleIndicator();
    syncWholesaleLogoutConfirmModalCopy();

    if (currentLanguage === LANGUAGE_EN) {
      requestLanguageSync();
    } else if (languageSyncTimeoutId) {
      window.clearTimeout(languageSyncTimeoutId);
      languageSyncTimeoutId = null;
    }
  }

  function initializeLanguageSupport() {
    if (languageSupportInitialized) {
      ensureLanguageSelector();
      syncLanguageSelectorUi();
      return;
    }

    languageSupportInitialized = true;
    currentLanguage = readStoredLanguage();
    observeLanguageMutations();
    applyLanguageToDocument(currentLanguage);
  }

  function byPathname(pathname) {
    var path = pathname.toLowerCase();

    if (path === "/" || path.endsWith("/index.html")) {
      return "index";
    }

    if (path.includes("order-confirmation")) {
      return "order_confirmation";
    }

    if (path.includes("checkout.html") || path.endsWith("/checkout")) {
      return "checkout";
    }

    if (path.includes("detail_product") || path.includes("detail_sku")) {
      return "detail_product";
    }

    if (path.includes("detail_category")) {
      return "detail_category";
    }

    if (/\/products\/[^/?#]+$/.test(path)) {
      return "detail_product";
    }

    if (path.includes("products")) {
      return "products";
    }

    if (path.includes("contact")) {
      return "contact";
    }

    if (path.includes("veleprodaja")) {
      return "wholesale";
    }

    return "other";
  }

  function formatPrice(rawPrice) {
    if (rawPrice === null || rawPrice === undefined || rawPrice === "") {
      return "";
    }

    var price = Number(rawPrice);
    if (!Number.isFinite(price)) {
      return String(rawPrice);
    }

    try {
      var priceLocale = currentLanguage === LANGUAGE_EN ? "en-US" : "bs-BA";

      return new Intl.NumberFormat(priceLocale, {
        style: "currency",
        currency: "BAM",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(price);
    } catch (error) {
      return "BAM " + price.toFixed(2);
    }
  }

  function getProductPriceDisplayParts(rawPrice) {
    var normalizedPrice = normalizeMoney(rawPrice);
    var isNegative = normalizedPrice < 0;
    var absolutePrice = Math.abs(normalizedPrice);
    var wholeValue = Math.floor(absolutePrice);
    var centsValue = Math.round((absolutePrice - wholeValue) * 100);

    if (centsValue === 100) {
      wholeValue += 1;
      centsValue = 0;
    }

    var locale = currentLanguage === LANGUAGE_EN ? "en-US" : "bs-BA";
    var wholeText = String(wholeValue);
    var currencyText = currentLanguage === LANGUAGE_EN ? "BAM" : "KM";

    try {
      wholeText = new Intl.NumberFormat(locale, {
        maximumFractionDigits: 0
      }).format(wholeValue);
    } catch (_error) {
      wholeText = String(wholeValue);
    }

    if (isNegative) {
      wholeText = "-" + wholeText;
    }

    try {
      var currencyParts = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: "BAM",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).formatToParts(1);

      for (var i = 0; i < currencyParts.length; i += 1) {
        if (currencyParts[i] && currencyParts[i].type === "currency" && currencyParts[i].value) {
          currencyText = String(currencyParts[i].value).replace(/\s+/g, "");
          break;
        }
      }
    } catch (_error) {
      currencyText = currentLanguage === LANGUAGE_EN ? "BAM" : "KM";
    }

    return {
      currency: currencyText,
      whole: wholeText,
      cents: String(centsValue).padStart(2, "0")
    };
  }

  function createProductPriceMainElement(rawPrice) {
    var priceParts = getProductPriceDisplayParts(rawPrice);
    var priceMain = document.createElement("div");
    priceMain.className = "product-price-text vr-product-price-main";

    var currency = document.createElement("span");
    currency.className = "vr-product-price-currency";
    currency.textContent = priceParts.currency;

    var whole = document.createElement("span");
    whole.className = "vr-product-price-whole";
    whole.textContent = priceParts.whole;

    var cents = document.createElement("span");
    cents.className = "vr-product-price-cents";
    cents.textContent = priceParts.cents;

    priceMain.appendChild(currency);
    priceMain.appendChild(whole);
    priceMain.appendChild(cents);

    return priceMain;
  }

  function createProductPriceRow(product) {
    var wholesaleComparePrice = getWholesaleComparePrice(product);
    var compareAtSalePrice = getCompareAtSalePrice(product);
    var isWholesalePrice = wholesaleComparePrice !== null;
    var hasSalePrice = !isWholesalePrice && compareAtSalePrice !== null;
    var comparePrice = isWholesalePrice ? wholesaleComparePrice : compareAtSalePrice;
    var showComparison = comparePrice !== null;
    var rowVariantClass = isWholesalePrice ? " vr-product-price-wholesale" : hasSalePrice ? " vr-product-price-sale" : "";
    var priceRow = document.createElement("div");
    priceRow.className = "vr-product-price-row" + rowVariantClass;

    if (showComparison) {
      var nowLabel = document.createElement("span");
      nowLabel.className = "vr-product-now-label";
      nowLabel.textContent = isWholesalePrice
        ? currentLanguage === LANGUAGE_EN
          ? "Wholesale"
          : "Veleprodaja"
        : currentLanguage === LANGUAGE_EN
          ? "Now"
          : "Sada";
      priceRow.appendChild(nowLabel);
    }

    priceRow.appendChild(createProductPriceMainElement(product && product.price_bam));

    if (showComparison) {
      var compareAtPrice = document.createElement("div");
      compareAtPrice.className = "vr-product-compare-price";
      compareAtPrice.textContent = formatPrice(comparePrice);
      priceRow.appendChild(compareAtPrice);
    }

    return priceRow;
  }

  function formatDate(rawDate) {
    if (!rawDate) {
      return "";
    }

    var date = new Date(rawDate);
    if (Number.isNaN(date.getTime())) {
      return String(rawDate);
    }

    var dateLocale = currentLanguage === LANGUAGE_EN ? "en-US" : "bs-BA";

    return date.toLocaleString(dateLocale, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  }

  function normalizePhoneDigits(value) {
    return String(value || "").replace(/\D/g, "");
  }

  function copyTextToClipboard(rawValue, onSuccess, onFailure) {
    var value = String(rawValue || "");
    var successCallback = typeof onSuccess === "function" ? onSuccess : function () {};
    var failureCallback = typeof onFailure === "function" ? onFailure : function () {};

    if (window.navigator && window.navigator.clipboard && typeof window.navigator.clipboard.writeText === "function") {
      window.navigator.clipboard
        .writeText(value)
        .then(successCallback)
        .catch(function () {
          fallbackCopyText(value, successCallback, failureCallback);
        });
      return;
    }

    fallbackCopyText(value, successCallback, failureCallback);
  }

  function fallbackCopyText(value, onSuccess, onFailure) {
    var textArea = null;

    try {
      textArea = document.createElement("textarea");
      textArea.value = value;
      textArea.setAttribute("readonly", "readonly");
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      textArea.style.left = "-99999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      var copied = document.execCommand("copy");
      if (copied) {
        onSuccess();
      } else {
        onFailure();
      }
    } catch (error) {
      onFailure(error);
    } finally {
      if (textArea && textArea.parentNode) {
        textArea.parentNode.removeChild(textArea);
      }
    }
  }

  function getWholesaleViberCopyLabels() {
    return currentLanguage === LANGUAGE_EN
      ? {
          idle: "Copy",
          copied: "Copied",
          failed: "Try again",
          aria: "Copy Viber number"
        }
      : {
          idle: "Kopiraj",
          copied: "Kopirano",
          failed: "Pokušaj ponovo",
          aria: "Kopiraj Viber broj"
        };
  }

  function getWholesaleViberCopyButtonLabelNode(button) {
    if (!button || typeof button.querySelector !== "function") {
      return null;
    }

    return button.querySelector("[data-vr-viber-copy-label]");
  }

  function setWholesaleViberCopyButtonState(button, state) {
    if (!button) {
      return;
    }

    var labels = getWholesaleViberCopyLabels();
    var labelNode = getWholesaleViberCopyButtonLabelNode(button);
    var setLabel = function setLabel(nextLabel) {
      if (labelNode) {
        labelNode.textContent = nextLabel;
        return;
      }

      button.textContent = nextLabel;
    };

    if (state === "copied") {
      setLabel(labels.copied);
      button.setAttribute("data-vr-copy-state", "copied");
      button.setAttribute("aria-pressed", "true");
      return;
    }

    if (state === "failed") {
      setLabel(labels.failed);
      button.setAttribute("data-vr-copy-state", "failed");
      button.removeAttribute("aria-pressed");
      return;
    }

    setLabel(labels.idle);
    button.setAttribute("data-vr-copy-state", "idle");
    button.removeAttribute("aria-pressed");
  }

  function initWholesaleViberCopy() {
    var buttons = Array.prototype.slice.call(document.querySelectorAll("[data-vr-viber-copy-btn]"));
    if (!buttons.length) {
      return;
    }

    var labels = getWholesaleViberCopyLabels();
    buttons.forEach(function setupButton(button) {
      if (button.__vrViberCopyBound) {
        button.setAttribute("aria-label", labels.aria);
        setWholesaleViberCopyButtonState(button, "idle");
        return;
      }

      button.__vrViberCopyBound = true;
      button.type = "button";
      button.setAttribute("aria-label", labels.aria);
      setWholesaleViberCopyButtonState(button, "idle");

      button.addEventListener("click", function onCopyViberNumber() {
        var container = button.closest("[data-vr-viber-number], .vr-viber-copy-wrap");
        var valueNode = container ? container.querySelector("[data-vr-viber-number]") : null;
        var value = valueNode ? String(valueNode.getAttribute("data-vr-viber-number") || valueNode.textContent || "") : "";
        if (!value) {
          value = button.value || "";
        }

        value = String(value).replace(/\s+/g, "");
        button.disabled = true;

        copyTextToClipboard(
          value,
          function onCopySuccess() {
            setWholesaleViberCopyButtonState(button, "copied");
            window.setTimeout(function resetCopyButton() {
              setWholesaleViberCopyButtonState(button, "idle");
              button.disabled = false;
            }, 1300);
          },
          function onCopyFailure() {
            setWholesaleViberCopyButtonState(button, "failed");
            window.setTimeout(function resetCopyButton() {
              setWholesaleViberCopyButtonState(button, "idle");
              button.disabled = false;
            }, 1300);
          }
        );
      });
    });
  }

  function isPhoneValid(value) {
    var digits = normalizePhoneDigits(value);
    return digits.length >= 8 && digits.length <= 15;
  }

  function formatPaymentMethod(value) {
    var normalized = String(value || "")
      .trim()
      .toLowerCase();

    if (normalized === "brza_posta") {
      return currentLanguage === LANGUAGE_EN ? "Express Delivery" : "Brza Posta";
    }

    if (normalized === "cash_on_delivery") {
      return currentLanguage === LANGUAGE_EN ? "Cash on delivery" : "Pouzecem";
    }

    if (normalized === "bank_transfer") {
      return currentLanguage === LANGUAGE_EN ? "Bank transfer" : "Uplata na racun";
    }

    return value || "-";
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function isElementVisible(element) {
    if (!element || !(element instanceof Element)) {
      return false;
    }

    if (element.hidden) {
      return false;
    }

    var computed = window.getComputedStyle(element);
    if (!computed || computed.visibility === "hidden" || computed.display === "none") {
      return false;
    }

    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function getFocusableElements(container) {
    if (!container) {
      return [];
    }

    return Array.prototype.slice
      .call(
        container.querySelectorAll(
          "a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex='-1'])"
        )
      )
      .filter(function filterFocusable(element) {
        return isElementVisible(element) && !element.getAttribute("aria-hidden");
      });
  }

  function focusFirstInteractive(container) {
    var focusable = getFocusableElements(container);
    if (!focusable.length) {
      return false;
    }

    focusable[0].focus();
    return true;
  }

  function trapFocusInContainer(event, container) {
    if (!event || event.key !== "Tab" || !container) {
      return;
    }

    var focusable = getFocusableElements(container);
    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    var active = document.activeElement;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey) {
      if (active === first || !container.contains(active)) {
        event.preventDefault();
        last.focus();
      }
      return;
    }

    if (active === last || !container.contains(active)) {
      event.preventDefault();
      first.focus();
    }
  }

  function restoreFocusIfPossible(element) {
    if (!element || typeof element.focus !== "function") {
      return;
    }

    if (!isElementVisible(element)) {
      return;
    }

    element.focus();
  }

  function normalizeSearch(value) {
    return typeof value === "string" ? value.trim().toLowerCase() : "";
  }

  function productMatchesSearch(product, search) {
    if (!search) {
      return true;
    }

    return [product.name, product.slug, product.sku, product.category_name, product.description].some(function (field) {
      return String(field || "")
        .toLowerCase()
        .includes(search);
    });
  }

  function normalizeApiErrorMessage(payload, statusCode) {
    var rawMessage = payload && (payload.error || payload.details || payload.message || payload.raw);
    if (typeof rawMessage !== "string") {
      return "Request failed with status " + String(statusCode || 500);
    }

    var compact = rawMessage.replace(/\s+/g, " ").trim();
    if (!compact) {
      return "Request failed with status " + String(statusCode || 500);
    }

    if (compact.charAt(0) === "<") {
      return "Request failed with status " + String(statusCode || 500);
    }

    return compact.length > 300 ? compact.slice(0, 300) + "..." : compact;
  }

  function normalizeWholesaleSession(payload) {
    if (!payload || typeof payload !== "object") {
      return null;
    }

    var accessToken = String(payload.access_token || "").trim();
    if (!accessToken) {
      return null;
    }

    var expiresAtRaw = payload.expires_at;
    var expiresAt = Number.parseInt(expiresAtRaw, 10);

    if (Number.isFinite(expiresAt) && expiresAt > 0 && Date.now() >= expiresAt * 1000) {
      return null;
    }

    return {
      access_token: accessToken,
      refresh_token: String(payload.refresh_token || "").trim(),
      token_type: String(payload.token_type || "bearer").trim() || "bearer",
      expires_at: Number.isFinite(expiresAt) && expiresAt > 0 ? expiresAt : null
    };
  }

  function readWholesaleSession() {
    try {
      var raw = window.localStorage.getItem(WHOLESALE_SESSION_STORAGE_KEY);
      if (!raw) {
        return null;
      }

      var parsed = JSON.parse(raw);
      var normalized = normalizeWholesaleSession(parsed);
      if (!normalized) {
        window.localStorage.removeItem(WHOLESALE_SESSION_STORAGE_KEY);
        return null;
      }

      return normalized;
    } catch (_error) {
      return null;
    }
  }

  function writeWholesaleSession(session) {
    var normalized = normalizeWholesaleSession(session);
    if (!normalized) {
      window.localStorage.removeItem(WHOLESALE_SESSION_STORAGE_KEY);
      return null;
    }

    window.localStorage.setItem(WHOLESALE_SESSION_STORAGE_KEY, JSON.stringify(normalized));
    return normalized;
  }

  function setWholesaleProfile(profile) {
    var normalized =
      profile &&
      typeof profile === "object" &&
      profile.role === WHOLESALE_ROLE &&
      profile.is_active
        ? profile
        : null;

    wholesaleProfile = normalized;
    if (document.body) {
      document.body.classList.toggle("vr-wholesale-client-active", Boolean(normalized));
    }
    syncWholesaleAuthPanels();
    syncProductsWholesaleIndicator();
  }

  function clearWholesaleSession() {
    try {
      window.localStorage.removeItem(WHOLESALE_SESSION_STORAGE_KEY);
    } catch (_error) {
      return;
    } finally {
      setWholesaleProfile(null);
    }
  }

  function runGuardedPageReload(storageKey, cooldownMs, fallbackHref) {
    var shouldReload = true;
    var now = Date.now();

    try {
      if (window.sessionStorage && storageKey) {
        var previous = Number.parseInt(window.sessionStorage.getItem(storageKey), 10);
        var windowSize = Number.isFinite(Number(cooldownMs)) ? Number(cooldownMs) : 0;

        if (Number.isFinite(previous) && windowSize > 0 && now - previous < windowSize) {
          shouldReload = false;
        } else {
          window.sessionStorage.setItem(storageKey, String(now));
        }
      }
    } catch (_error) {
      shouldReload = true;
    }

    if (!shouldReload) {
      return false;
    }

    if (window.location && typeof window.location.reload === "function") {
      window.location.reload();
      return true;
    }

    if (fallbackHref) {
      window.location.href = fallbackHref;
      return true;
    }

    return false;
  }

  function isWholesaleClientAuthenticated() {
    return Boolean(wholesaleProfile && wholesaleProfile.role === WHOLESALE_ROLE && wholesaleProfile.is_active);
  }

  function shouldAttachWholesaleToken(path) {
    var normalizedPath = String(path || "");
    return /^\/products(?:[/?]|$)/.test(normalizedPath) || /^\/orders(?:[/?]|$)/.test(normalizedPath);
  }

  function getWholesaleAccessToken() {
    var session = readWholesaleSession();
    if (!session) {
      return "";
    }

    return session.access_token;
  }

  async function hydrateWholesaleClientSession() {
    var session = readWholesaleSession();
    if (!session || !session.access_token) {
      setWholesaleProfile(null);
      return;
    }

    try {
      var payload = await requestJson("/wholesale/me", {
        headers: {
          Authorization: "Bearer " + session.access_token
        }
      });
      setWholesaleProfile(payload && payload.profile ? payload.profile : null);
    } catch (_error) {
      clearWholesaleSession();
    }
  }

  async function requestJson(path, options) {
    var requestOptions = options || {};
    var fetchOptions = Object.assign({}, requestOptions);
    var headers = Object.assign({}, requestOptions.headers || {});

    if (!headers.Authorization && !headers.authorization && shouldAttachWholesaleToken(path)) {
      var wholesaleAccessToken = getWholesaleAccessToken();
      if (wholesaleAccessToken) {
        headers.Authorization = "Bearer " + wholesaleAccessToken;
      }
    }

    if (Object.keys(headers).length) {
      fetchOptions.headers = headers;
    }

    var response = await fetch(API_BASE + path, fetchOptions);
    var text = await response.text();
    var payload = {};

    if (text) {
      try {
        payload = JSON.parse(text);
      } catch (_error) {
        payload = {
          raw: text
        };
      }
    }

    if (!response.ok) {
      var apiError = new Error(normalizeApiErrorMessage(payload, response.status));
      apiError.statusCode = response.status;
      apiError.apiPayload = payload;
      throw apiError;
    }

    return payload;
  }

  function normalizeText(value) {
    return typeof value === "string" ? value.trim() : "";
  }

  async function readPublicRecaptchaConfig() {
    if (!publicRecaptchaConfigPromise) {
      publicRecaptchaConfigPromise = requestJson("/site/config", {
        method: "GET"
      })
        .then(function onPublicRecaptchaConfig(payload) {
          publicRecaptchaEnabled = !!(payload && payload.captchaEnabled);
          publicRecaptchaSiteKey = normalizeText(payload && payload.captchaSiteKey);

          return {
            enabled: publicRecaptchaEnabled,
            siteKey: publicRecaptchaSiteKey
          };
        })
        .catch(function onPublicRecaptchaConfigError(error) {
          publicRecaptchaConfigPromise = null;
          throw error;
        });
    }

    return publicRecaptchaConfigPromise;
  }

  async function loadPublicRecaptchaScript() {
    var config = await readPublicRecaptchaConfig();
    if (!config.enabled || !config.siteKey) {
      return null;
    }

    if (window.grecaptcha && typeof window.grecaptcha.execute === "function") {
      return window.grecaptcha;
    }

    if (!publicRecaptchaScriptPromise) {
      publicRecaptchaScriptPromise = new Promise(function waitForPublicRecaptcha(resolve, reject) {
        var existingScript = document.querySelector("script[data-vr-site-recaptcha='true']");
        var script = existingScript || document.createElement("script");
        var readyDeadline = Date.now() + RECAPTCHA_READY_TIMEOUT_MS;
        var readyTimerId = null;

        function clearReadyTimer() {
          if (readyTimerId !== null) {
            window.clearTimeout(readyTimerId);
            readyTimerId = null;
          }
        }

        function resolveWhenReady() {
          if (window.grecaptcha && typeof window.grecaptcha.ready === "function" && typeof window.grecaptcha.execute === "function") {
            clearReadyTimer();
            window.grecaptcha.ready(function onRecaptchaReady() {
              resolve(window.grecaptcha);
            });
            return;
          }

          if (Date.now() >= readyDeadline) {
            clearReadyTimer();
            reject(new Error("Failed to load Google reCAPTCHA."));
            return;
          }

          clearReadyTimer();
          readyTimerId = window.setTimeout(resolveWhenReady, RECAPTCHA_READY_POLL_MS);
        }

        if (window.grecaptcha && typeof window.grecaptcha.execute === "function") {
          resolveWhenReady();
          return;
        }

        script.addEventListener("load", resolveWhenReady, {
          once: true
        });
        script.addEventListener(
          "error",
          function onRecaptchaError() {
            reject(new Error("Failed to load Google reCAPTCHA."));
          },
          {
            once: true
          }
        );

        if (!existingScript) {
          script.src = "https://www.google.com/recaptcha/api.js?render=" + encodeURIComponent(config.siteKey);
          script.async = true;
          script.defer = true;
          script.setAttribute("data-vr-site-recaptcha", "true");
          document.head.appendChild(script);
        }
      }).catch(function onPublicRecaptchaScriptError(error) {
        publicRecaptchaScriptPromise = null;
        throw error;
      });
    }

    return publicRecaptchaScriptPromise;
  }

  async function requestPublicRecaptchaToken(action) {
    var config = await readPublicRecaptchaConfig();
    if (!config.enabled || !config.siteKey) {
      return "";
    }

    var grecaptcha = await loadPublicRecaptchaScript();
    var captchaAction = normalizeText(action);
    if (!captchaAction) {
      throw new Error("Security check failed. Please try again.");
    }

    return new Promise(function resolvePublicRecaptchaToken(resolve, reject) {
      grecaptcha.ready(function onRecaptchaReady() {
        grecaptcha
          .execute(config.siteKey, {
            action: captchaAction
          })
          .then(function onCaptchaToken(token) {
            var normalizedToken = normalizeText(token);
            if (!normalizedToken) {
              reject(new Error("Security check failed. Please try again."));
              return;
            }

            resolve(normalizedToken);
          })
          .catch(function onCaptchaExecuteError() {
            reject(new Error("Security check failed. Please try again."));
          });
      });
    });
  }

  function primePublicRecaptcha() {
    readPublicRecaptchaConfig()
      .then(function onPublicRecaptchaConfigReady(config) {
        if (!config.enabled || !config.siteKey) {
          return null;
        }

        return loadPublicRecaptchaScript();
      })
      .catch(function noop() {
        return null;
      });
  }

  function setBackgroundImage(element, imageUrl, options) {
    if (!element) {
      return;
    }

    var normalizedUrl = typeof imageUrl === "string" ? imageUrl.trim() : "";
    var config = options && typeof options === "object" ? options : {};
    var backgroundSize = typeof config.size === "string" && config.size.trim() ? config.size.trim() : "cover";
    var backgroundPosition =
      typeof config.position === "string" && config.position.trim()
        ? config.position.trim()
        : "50% 50%";
    var backgroundRepeat =
      typeof config.repeat === "string" && config.repeat.trim() ? config.repeat.trim() : "no-repeat";

    if (!normalizedUrl) {
      element.style.backgroundImage = "";
      element.style.removeProperty("background-size");
      element.style.removeProperty("background-position");
      element.style.removeProperty("background-repeat");
      return;
    }

    element.style.backgroundImage = 'url("' + normalizedUrl.replace(/\"/g, "%22") + '")';
    element.style.backgroundSize = backgroundSize;
    element.style.backgroundPosition = backgroundPosition;
    element.style.backgroundRepeat = backgroundRepeat;
  }

  function setProductImageAccessibleState(element, state) {
    if (!element || !element.hasAttribute("data-vr-product-image-name")) {
      return;
    }

    var productName = element.getAttribute("data-vr-product-image-name") || "";
    var label = (state === "unavailable" ? "Slika nije dostupna: " : "Slika proizvoda: ") + productName;
    element.setAttribute("role", "img");
    setStoredAttributeBaseValue(element, "aria-label", label);
    element.setAttribute("aria-label", translateString(label, currentLanguage));
    element.setAttribute("aria-busy", state === "loading" ? "true" : "false");
  }

  function setProductCardImagePlaceholder(element) {
    setBackgroundImage(element, PRODUCT_IMAGE_PLACEHOLDER_URL);
    setProductImageAccessibleState(element, "unavailable");
  }

  function readResponsiveImageRole(options, fallbackRole) {
    var config = options && typeof options === "object" ? options : {};
    var role = typeof config.role === "string" ? config.role.trim().toLowerCase() : "";
    if (!role) {
      role = typeof fallbackRole === "string" ? fallbackRole.trim().toLowerCase() : "";
    }
    return role || "card";
  }

  function isResponsiveTransformSupportedUrl(rawUrl) {
    var normalizedUrl = typeof rawUrl === "string" ? rawUrl.trim() : "";
    if (!normalizedUrl) {
      return false;
    }

    var safePath = normalizedUrl.split("?")[0].split("#")[0].toLowerCase();
    if (/\.svg$/i.test(safePath) || /\.gif$/i.test(safePath)) {
      return false;
    }

    return normalizedUrl.indexOf("/storage/v1/object/public/") >= 0;
  }

  function clampImageTransformQuality(value) {
    var parsed = Number.parseInt(value, 10);
    if (!Number.isFinite(parsed)) {
      return 76;
    }
    return Math.max(45, Math.min(92, parsed));
  }

  function pickResponsiveImageWidth(targetWidth, maxWidth) {
    var safeTarget = Math.max(1, Math.round(Number(targetWidth) || 1));
    var safeMax = Math.max(1, Math.round(Number(maxWidth) || safeTarget));
    var limitedTarget = Math.min(safeTarget, safeMax);
    var availableSteps = RESPONSIVE_IMAGE_WIDTH_STEPS.filter(function keepWidthStep(step) {
      return Number(step) <= safeMax;
    });

    if (!availableSteps.length) {
      return safeMax;
    }

    for (var i = 0; i < availableSteps.length; i += 1) {
      if (availableSteps[i] >= limitedTarget) {
        return availableSteps[i];
      }
    }

    return availableSteps[availableSteps.length - 1];
  }

  function buildResponsiveImageUrl(rawUrl, options) {
    var normalizedUrl = typeof rawUrl === "string" ? rawUrl.trim() : "";
    if (!normalizedUrl || !isResponsiveTransformSupportedUrl(normalizedUrl)) {
      return normalizedUrl;
    }

    var config = options && typeof options === "object" ? options : {};
    var role = readResponsiveImageRole(config, "card");
    var element = config.element && typeof config.element.getBoundingClientRect === "function" ? config.element : null;
    var widthHint = Number(config.widthHint);
    var maxWidth = Number(RESPONSIVE_IMAGE_MAX_WIDTH_BY_ROLE[role]) || RESPONSIVE_IMAGE_MAX_WIDTH_BY_ROLE.card;
    var quality = clampImageTransformQuality(
      Number.isFinite(Number(config.quality))
        ? Number(config.quality)
        : RESPONSIVE_IMAGE_QUALITY_BY_ROLE[role] || RESPONSIVE_IMAGE_QUALITY_BY_ROLE.card
    );
    var dpr = Number.isFinite(Number(config.dpr)) && Number(config.dpr) > 0
      ? Number(config.dpr)
      : typeof window !== "undefined" && Number.isFinite(Number(window.devicePixelRatio))
        ? Number(window.devicePixelRatio)
        : 1;
    dpr = Math.min(2, Math.max(1, dpr));

    var cssWidth = Number.isFinite(widthHint) && widthHint > 0
      ? widthHint
      : element
        ? Number(element.getBoundingClientRect().width)
        : 0;
    if (!Number.isFinite(cssWidth) || cssWidth <= 0) {
      cssWidth = Number(RESPONSIVE_IMAGE_DEFAULT_WIDTH_BY_ROLE[role]) || RESPONSIVE_IMAGE_DEFAULT_WIDTH_BY_ROLE.card;
    }

    var requestedWidth = pickResponsiveImageWidth(cssWidth * dpr, maxWidth);

    try {
      var parsed = new URL(normalizedUrl, window.location.origin);
      parsed.pathname = parsed.pathname.replace(
        "/storage/v1/object/public/",
        "/storage/v1/render/image/public/"
      );
      parsed.searchParams.set("width", String(requestedWidth));
      parsed.searchParams.set("quality", String(quality));
      parsed.searchParams.delete("format");

      if (role === "card" && element) {
        var cssHeight = Number(element.getBoundingClientRect().height);
        if (!Number.isFinite(cssHeight) || cssHeight <= 0) {
          cssHeight = 300;
        }
        var requestedHeight = pickResponsiveImageWidth(cssHeight * dpr, maxWidth);
        parsed.searchParams.set("height", String(requestedHeight));
        parsed.searchParams.set("resize", "cover");
      }

      return parsed.toString();
    } catch (_error) {
      return normalizedUrl;
    }
  }

  function resolveResponsiveBackgroundImageUrls(rawUrl, options) {
    var normalizedUrl = typeof rawUrl === "string" ? rawUrl.trim() : "";
    if (!normalizedUrl) {
      return {
        primary: "",
        fallback: ""
      };
    }

    var transformedUrl = buildResponsiveImageUrl(normalizedUrl, options);
    return {
      primary: transformedUrl || normalizedUrl,
      fallback: transformedUrl && transformedUrl !== normalizedUrl ? normalizedUrl : ""
    };
  }

  function buildResponsiveImageSrcset(rawUrl, role) {
    var normalizedUrl = typeof rawUrl === "string" ? rawUrl.trim() : "";
    if (!normalizedUrl || !isResponsiveTransformSupportedUrl(normalizedUrl)) {
      return "";
    }

    var normalizedRole = readResponsiveImageRole({ role: role }, "card");
    var maxWidth = Number(RESPONSIVE_IMAGE_MAX_WIDTH_BY_ROLE[normalizedRole]) || RESPONSIVE_IMAGE_MAX_WIDTH_BY_ROLE.card;
    var quality = RESPONSIVE_IMAGE_QUALITY_BY_ROLE[normalizedRole] || RESPONSIVE_IMAGE_QUALITY_BY_ROLE.card;
    return RESPONSIVE_IMAGE_WIDTH_STEPS
      .filter(function keepSrcsetWidth(step) {
        return Number(step) <= maxWidth;
      })
      .map(function mapResponsiveSrcsetStep(step) {
        var widthValue = Number(step);
        var transformed = buildResponsiveImageUrl(normalizedUrl, {
          role: normalizedRole,
          widthHint: widthValue,
          dpr: 1,
          quality: quality
        });
        return transformed ? transformed + " " + String(widthValue) + "w" : "";
      })
      .filter(Boolean)
      .join(", ");
  }

  function clearDetailImageZoom(element) {
    if (!element) {
      return;
    }

    if (typeof element.__vrDetailZoomCleanup === "function") {
      element.__vrDetailZoomCleanup();
    }

    element.__vrDetailZoomCleanup = null;
    element.classList.remove("vr-detail-zoom-enabled");
    element.classList.remove("vr-detail-zoom-active");
  }

  function initDetailImageZoom(element, imageUrl) {
    if (!element) {
      return;
    }

    clearDetailImageZoom(element);

    var normalizedUrl = typeof imageUrl === "string" ? imageUrl.trim() : "";
    if (!normalizedUrl) {
      return;
    }

    var isCoarseTouchOnly = false;
    if (typeof window.matchMedia === "function") {
      isCoarseTouchOnly = window.matchMedia("(hover: none) and (pointer: coarse)").matches;
    }

    if (isCoarseTouchOnly) {
      return;
    }

    var lens = document.createElement("span");
    lens.className = "vr-detail-zoom-lens";
    lens.setAttribute("aria-hidden", "true");
    lens.style.backgroundImage = 'url("' + normalizedUrl.replace(/\"/g, "%22") + '")';
    lens.style.backgroundRepeat = "no-repeat";
    element.appendChild(lens);
    element.classList.add("vr-detail-zoom-enabled");

    var zoomLevel = 2.45;
    var naturalImageWidth = 0;
    var naturalImageHeight = 0;
    var imageProbe = new Image();
    imageProbe.onload = function onDetailZoomImageLoaded() {
      naturalImageWidth = imageProbe.naturalWidth || imageProbe.width || 0;
      naturalImageHeight = imageProbe.naturalHeight || imageProbe.height || 0;
    };
    imageProbe.src = normalizedUrl;

    function applyPointerPosition(clientX, clientY) {
      var bounds = element.getBoundingClientRect();
      if (!bounds.width || !bounds.height) {
        return;
      }

      var cursorX = clientX - bounds.left;
      var cursorY = clientY - bounds.top;

      if (cursorX < 0 || cursorY < 0 || cursorX > bounds.width || cursorY > bounds.height) {
        element.classList.remove("vr-detail-zoom-active");
        return;
      }

      var sourceWidth = naturalImageWidth || bounds.width;
      var sourceHeight = naturalImageHeight || bounds.height;
      var coverScale = Math.max(bounds.width / sourceWidth, bounds.height / sourceHeight);
      var renderedWidth = sourceWidth * coverScale;
      var renderedHeight = sourceHeight * coverScale;
      var renderedOffsetX = (bounds.width - renderedWidth) / 2;
      var renderedOffsetY = (bounds.height - renderedHeight) / 2;
      var lensDiameter = lens.offsetWidth || 168;
      var lensRadius = lensDiameter / 2;
      var lensX = Math.max(lensRadius, Math.min(bounds.width - lensRadius, cursorX));
      var lensY = Math.max(lensRadius, Math.min(bounds.height - lensRadius, cursorY));
      var sourceX = Math.max(0, Math.min(renderedWidth, cursorX - renderedOffsetX));
      var sourceY = Math.max(0, Math.min(renderedHeight, cursorY - renderedOffsetY));
      var backgroundWidth = renderedWidth * zoomLevel;
      var backgroundHeight = renderedHeight * zoomLevel;
      var backgroundOffsetX = lensRadius - sourceX * zoomLevel;
      var backgroundOffsetY = lensRadius - sourceY * zoomLevel;

      lens.style.left = lensX + "px";
      lens.style.top = lensY + "px";
      lens.style.backgroundSize = backgroundWidth + "px " + backgroundHeight + "px";
      lens.style.backgroundPosition = backgroundOffsetX + "px " + backgroundOffsetY + "px";
      element.classList.add("vr-detail-zoom-active");
    }

    function onPointerMove(event) {
      if (event.pointerType === "touch") {
        return;
      }

      applyPointerPosition(event.clientX, event.clientY);
    }

    function onMouseMove(event) {
      applyPointerPosition(event.clientX, event.clientY);
    }

    function onPointerLeave() {
      element.classList.remove("vr-detail-zoom-active");
    }

    var usePointerEvents = typeof window.PointerEvent === "function";

    function cleanup() {
      if (usePointerEvents) {
        element.removeEventListener("pointermove", onPointerMove);
        element.removeEventListener("pointerleave", onPointerLeave);
      } else {
        element.removeEventListener("mousemove", onMouseMove);
        element.removeEventListener("mouseleave", onPointerLeave);
      }
      element.removeEventListener("blur", onPointerLeave, true);
      window.removeEventListener("scroll", onPointerLeave, true);

      if (lens.parentNode === element) {
        element.removeChild(lens);
      }

      imageProbe.onload = null;
      imageProbe.onerror = null;
    }

    if (usePointerEvents) {
      element.addEventListener("pointermove", onPointerMove);
      element.addEventListener("pointerleave", onPointerLeave);
    } else {
      element.addEventListener("mousemove", onMouseMove);
      element.addEventListener("mouseleave", onPointerLeave);
    }
    element.addEventListener("blur", onPointerLeave, true);
    window.addEventListener("scroll", onPointerLeave, true);
    element.__vrDetailZoomCleanup = cleanup;
  }

  function readNetworkInformation() {
    if (typeof navigator === "undefined") {
      return null;
    }

    return navigator.connection || navigator.mozConnection || navigator.webkitConnection || null;
  }

  function readProductCardImageObserverMarginPx() {
    var connection = readNetworkInformation();
    var effectiveType = connection && typeof connection.effectiveType === "string" ? connection.effectiveType : "";
    var saveData = !!(connection && connection.saveData);
    if (saveData) {
      return 260;
    }

    if (effectiveType === "slow-2g" || effectiveType === "2g") {
      return 500;
    }

    if (effectiveType === "3g") {
      return 420;
    }

    return PRODUCT_CARD_IMAGE_OBSERVER_MARGIN_PX;
  }

  function readProductCardImageMaxConcurrency() {
    var connection = readNetworkInformation();
    var effectiveType = connection && typeof connection.effectiveType === "string" ? connection.effectiveType : "";
    var saveData = !!(connection && connection.saveData);
    if (saveData) {
      return 1;
    }

    if (effectiveType === "slow-2g" || effectiveType === "2g") {
      return 1;
    }

    if (effectiveType === "3g") {
      return 3;
    }

    var cores = typeof navigator !== "undefined" && Number.isFinite(navigator.hardwareConcurrency)
      ? navigator.hardwareConcurrency
      : 4;
    return cores <= 4 ? 4 : 6;
  }

  function readProductCardImageQueueStepDelayMs() {
    var connection = readNetworkInformation();
    var effectiveType = connection && typeof connection.effectiveType === "string" ? connection.effectiveType : "";
    var saveData = !!(connection && connection.saveData);
    if (saveData) {
      return 150;
    }

    if (effectiveType === "slow-2g" || effectiveType === "2g") {
      return 180;
    }

    if (effectiveType === "3g") {
      return 100;
    }

    return 44;
  }

  function readProductCardImageViewportDistance(element) {
    if (!element || typeof element.getBoundingClientRect !== "function") {
      return 0;
    }

    var bounds = element.getBoundingClientRect();
    var viewportHeight =
      typeof window !== "undefined" && window.innerHeight
        ? window.innerHeight
        : document.documentElement && document.documentElement.clientHeight
          ? document.documentElement.clientHeight
          : 0;
    if (!viewportHeight) {
      return 0;
    }

    if (bounds.bottom < 0) {
      return Math.abs(bounds.bottom);
    }

    if (bounds.top > viewportHeight) {
      return bounds.top - viewportHeight;
    }

    return 0;
  }

  function compareProductCardImageQueueEntries(a, b) {
    if (b.priority !== a.priority) {
      return b.priority - a.priority;
    }

    if (a.distance !== b.distance) {
      return a.distance - b.distance;
    }

    return a.order - b.order;
  }

  function scheduleProductCardImageQueuePump(immediate) {
    if (immediate) {
      if (productCardImageQueueTimerId) {
        window.clearTimeout(productCardImageQueueTimerId);
        productCardImageQueueTimerId = 0;
      }
      processProductCardImageLoadQueue();
      return;
    }

    if (productCardImageQueueTimerId) {
      return;
    }

    productCardImageQueueTimerId = window.setTimeout(function onProductCardImageQueueTick() {
      productCardImageQueueTimerId = 0;
      processProductCardImageLoadQueue();
    }, readProductCardImageQueueStepDelayMs());
  }

  function dropQueuedProductCardImageLoadsForElement(element) {
    if (!element || !productCardImageLoadQueue.length) {
      return;
    }

    productCardImageLoadQueue = productCardImageLoadQueue.filter(function keepQueuedProductCardImageLoad(entry) {
      return !!entry && entry.element !== element;
    });
  }

  function enqueueProductCardImageLoad(element, imageUrl, requestId, options) {
    if (!element) {
      return;
    }

    var normalizedUrl = typeof imageUrl === "string" ? imageUrl.trim() : "";
    if (!normalizedUrl) {
      loadProductCardImageNow(element, "", requestId);
      return;
    }

    if (element.getAttribute("data-vr-image-request-id") !== requestId) {
      return;
    }

    var config = options && typeof options === "object" ? options : {};
    var priority = Number.isFinite(config.priority) ? config.priority : 1;
    var immediate = config.immediate === true;
    var fallbackUrl = typeof config.fallbackUrl === "string" ? config.fallbackUrl.trim() : "";

    dropQueuedProductCardImageLoadsForElement(element);
    productCardImageLoadQueue.push({
      element: element,
      imageUrl: normalizedUrl,
      fallbackUrl: fallbackUrl,
      requestId: requestId,
      priority: priority,
      distance: readProductCardImageViewportDistance(element),
      order: productCardImageQueueOrder
    });
    productCardImageQueueOrder += 1;

    scheduleProductCardImageQueuePump(immediate || priority >= 3);
  }

  function processProductCardImageLoadQueue() {
    if (!productCardImageLoadQueue.length) {
      return;
    }

    var maxConcurrency = readProductCardImageMaxConcurrency();
    if (productCardImageLoadsInFlight >= maxConcurrency) {
      return;
    }

    for (var i = 0; i < productCardImageLoadQueue.length; i += 1) {
      var entry = productCardImageLoadQueue[i];
      if (!entry || !entry.element) {
        continue;
      }
      entry.distance = readProductCardImageViewportDistance(entry.element);
      if (entry.distance <= 0) {
        entry.priority = Math.max(entry.priority, 3);
      }
    }
    productCardImageLoadQueue.sort(compareProductCardImageQueueEntries);

    var startedLoads = 0;
    while (productCardImageLoadsInFlight < maxConcurrency && productCardImageLoadQueue.length) {
      var nextEntry = null;
      while (productCardImageLoadQueue.length) {
        var candidate = productCardImageLoadQueue.shift();
        if (!candidate || !candidate.element) {
          continue;
        }

        if (candidate.element.getAttribute("data-vr-image-request-id") !== candidate.requestId) {
          continue;
        }

        nextEntry = candidate;
        break;
      }

      if (!nextEntry) {
        break;
      }

      startedLoads += 1;
      productCardImageLoadsInFlight += 1;
      loadProductCardImageNow(nextEntry.element, nextEntry.imageUrl, nextEntry.requestId, {
        fallbackUrl: nextEntry.fallbackUrl,
        onSettled: function onProductCardImageTaskSettled() {
          productCardImageLoadsInFlight = Math.max(0, productCardImageLoadsInFlight - 1);
          if (productCardImageLoadQueue.length) {
            scheduleProductCardImageQueuePump(true);
          }
        }
      });
    }

    if (!startedLoads && productCardImageLoadQueue.length) {
      scheduleProductCardImageQueuePump(false);
    }
  }

  function ensureProductCardImageObserver() {
    if (productCardImageObserver) {
      return productCardImageObserver;
    }

    if (typeof window === "undefined" || typeof window.IntersectionObserver !== "function") {
      return null;
    }

    productCardImageObserver = new window.IntersectionObserver(
      function onProductCardImageIntersect(entries) {
        entries.forEach(function onProductCardImageEntry(entry) {
          if (!entry || !entry.target) {
            return;
          }

          if (!entry.isIntersecting && entry.intersectionRatio <= 0) {
            return;
          }

          var target = entry.target;
          productCardImageObserver.unobserve(target);

          var pendingRequestId = target.getAttribute("data-vr-image-pending-id");
          var pendingUrl = target.getAttribute("data-vr-image-pending-url");
          var pendingFallbackUrl = target.getAttribute("data-vr-image-pending-fallback");
          if (!pendingRequestId || !pendingUrl) {
            return;
          }

          enqueueProductCardImageLoad(target, pendingUrl, pendingRequestId, {
            fallbackUrl: pendingFallbackUrl,
            priority: 3,
            immediate: true
          });
        });
      },
      {
        root: null,
        rootMargin: readProductCardImageObserverMarginPx() + "px 0px",
        threshold: 0.01
      }
    );

    return productCardImageObserver;
  }

  function unobserveProductCardImage(element) {
    if (!productCardImageObserver || !element) {
      return;
    }

    productCardImageObserver.unobserve(element);
  }

  function isProductCardImageNearViewport(element, preloadMarginPx) {
    if (!element || typeof element.getBoundingClientRect !== "function") {
      return true;
    }

    var bounds = element.getBoundingClientRect();
    var viewportHeight =
      typeof window !== "undefined" && window.innerHeight
        ? window.innerHeight
        : document.documentElement && document.documentElement.clientHeight
          ? document.documentElement.clientHeight
          : 0;
    var margin = Number.isFinite(preloadMarginPx) ? preloadMarginPx : PRODUCT_CARD_IMAGE_OBSERVER_MARGIN_PX;
    if (!viewportHeight) {
      return true;
    }

    return bounds.top <= viewportHeight + margin && bounds.bottom >= -margin;
  }

  function loadProductCardImageNow(element, imageUrl, requestId, options) {
    var config = options && typeof options === "object" ? options : {};
    var onSettled = typeof config.onSettled === "function" ? config.onSettled : null;
    var fallbackUrl = typeof config.fallbackUrl === "string" ? config.fallbackUrl.trim() : "";
    var settled = false;

    function settleTask() {
      if (settled) {
        return;
      }

      settled = true;
      if (onSettled) {
        onSettled();
      }
    }

    if (!element) {
      settleTask();
      return;
    }

    var normalizedUrl = typeof imageUrl === "string" ? imageUrl.trim() : "";
    if (element.getAttribute("data-vr-image-request-id") !== requestId) {
      settleTask();
      return;
    }

    element.classList.remove("vr-image-pending");
    element.classList.add("vr-image-loading");
    element.removeAttribute("data-vr-image-pending-id");
    element.removeAttribute("data-vr-image-pending-url");
    element.removeAttribute("data-vr-image-pending-fallback");

    if (!normalizedUrl) {
      element.classList.remove("vr-image-loading");
      element.classList.remove("vr-image-loaded");
      setProductCardImagePlaceholder(element);
      settleTask();
      return;
    }

    var loader = new Image();
    var resolved = false;
    var activeImageUrl = normalizedUrl;
    var fallbackAttempted = false;

    function complete(success) {
      if (resolved) {
        return;
      }

      resolved = true;

      if (element.getAttribute("data-vr-image-request-id") !== requestId) {
        settleTask();
        return;
      }

      if (success) {
        setBackgroundImage(element, activeImageUrl);
        element.classList.add("vr-image-loaded");
        setProductImageAccessibleState(element, "loaded");
      } else {
        element.classList.remove("vr-image-loaded");
        setProductCardImagePlaceholder(element);
      }

      element.classList.remove("vr-image-loading");
      settleTask();
    }

    if ("decoding" in loader) {
      loader.decoding = "async";
    }

    loader.onload = function onProductImageLoad() {
      complete(true);
    };

    loader.onerror = function onProductImageError() {
      if (!fallbackAttempted && fallbackUrl && fallbackUrl !== activeImageUrl) {
        fallbackAttempted = true;
        activeImageUrl = fallbackUrl;
        loader.src = activeImageUrl;
        if (loader.complete) {
          complete(loader.naturalWidth > 0);
        }
        return;
      }
      complete(false);
    };

    loader.src = activeImageUrl;

    if (loader.complete) {
      complete(loader.naturalWidth > 0);
    }
  }

  function queueProductCardImageLoad(element, imageUrl, requestId, options) {
    if (!element) {
      return;
    }

    var normalizedUrl = typeof imageUrl === "string" ? imageUrl.trim() : "";
    if (!normalizedUrl) {
      loadProductCardImageNow(element, "", requestId);
      return;
    }

    var config = options && typeof options === "object" ? options : {};
    var eager = config.eager === true;
    var isQuickViewImage =
      !!(element.classList && typeof element.classList.contains === "function" && element.classList.contains("vr-product-quick-view-image"));
    var role = readResponsiveImageRole(config, isQuickViewImage ? "quick-view" : "card");
    var responsiveImageUrls = resolveResponsiveBackgroundImageUrls(normalizedUrl, {
      role: role,
      element: element
    });
    var resolvedImageUrl = responsiveImageUrls.primary || normalizedUrl;
    var resolvedFallbackUrl = responsiveImageUrls.fallback || "";

    if (isQuickViewImage) {
      loadProductCardImageNow(element, resolvedImageUrl, requestId, {
        fallbackUrl: resolvedFallbackUrl
      });
      return;
    }

    var observer = ensureProductCardImageObserver();
    var nearViewportMargin = Math.max(150, Math.floor(readProductCardImageObserverMarginPx() * 0.62));
    if (eager || !observer || isProductCardImageNearViewport(element, nearViewportMargin)) {
      enqueueProductCardImageLoad(element, resolvedImageUrl, requestId, {
        fallbackUrl: resolvedFallbackUrl,
        priority: eager ? 4 : 3,
        immediate: true
      });
      return;
    }

    element.classList.add("vr-image-pending");
    element.classList.remove("vr-image-loading");
    element.classList.remove("vr-image-loaded");
    element.setAttribute("data-vr-image-pending-id", requestId);
    element.setAttribute("data-vr-image-pending-url", resolvedImageUrl);
    if (resolvedFallbackUrl) {
      element.setAttribute("data-vr-image-pending-fallback", resolvedFallbackUrl);
    } else {
      element.removeAttribute("data-vr-image-pending-fallback");
    }
    observer.observe(element);
  }

  function setProductCardImage(element, imageUrl, options) {
    if (!element) {
      return;
    }

    var config = options && typeof options === "object" ? options : {};
    if (typeof config.productName === "string") {
      element.setAttribute("data-vr-product-image-name", config.productName);
    }
    element.classList.add("vr-product-image-shell");
    var normalizedUrl = typeof imageUrl === "string" ? imageUrl.trim() : "";
    var requestId = String(Date.now()) + "-" + String(Math.random());
    element.setAttribute("data-vr-image-request-id", requestId);
    setProductCardImagePlaceholder(element);
    element.classList.remove("vr-image-loaded");
    element.classList.remove("vr-image-pending");
    unobserveProductCardImage(element);
    dropQueuedProductCardImageLoadsForElement(element);
    element.removeAttribute("data-vr-image-pending-id");
    element.removeAttribute("data-vr-image-pending-url");
    element.removeAttribute("data-vr-image-pending-fallback");

    if (!normalizedUrl) {
      element.classList.remove("vr-image-loading");
      return;
    }

    setProductImageAccessibleState(element, "loading");
    queueProductCardImageLoad(element, normalizedUrl, requestId, options);
  }

  function clampInRange(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function isPointInsideRect(pointX, pointY, rect) {
    if (!rect) {
      return false;
    }

    return pointX >= rect.left && pointX <= rect.right && pointY >= rect.top && pointY <= rect.bottom;
  }

  function getContainPlacement(containerWidth, containerHeight, sourceWidth, sourceHeight) {
    if (!(containerWidth > 0) || !(containerHeight > 0) || !(sourceWidth > 0) || !(sourceHeight > 0)) {
      return null;
    }

    var containScale = Math.min(containerWidth / sourceWidth, containerHeight / sourceHeight);
    var drawWidth = sourceWidth * containScale;
    var drawHeight = sourceHeight * containScale;

    return {
      drawWidth: drawWidth,
      drawHeight: drawHeight,
      offsetX: (containerWidth - drawWidth) / 2,
      offsetY: (containerHeight - drawHeight) / 2
    };
  }

  function setQuickViewCloseButtonTone(closeButton, useLightTone) {
    if (!closeButton || !closeButton.style) {
      return;
    }

    if (useLightTone) {
      closeButton.style.setProperty("--vr-product-quick-view-close-color", "#f8fafc");
      closeButton.style.setProperty("--vr-product-quick-view-close-shadow", "0 2px 10px rgba(15,23,42,.56)");
      return;
    }

    closeButton.style.setProperty("--vr-product-quick-view-close-color", "#0f172a");
    closeButton.style.setProperty("--vr-product-quick-view-close-shadow", "0 1px 2px rgba(255,255,255,.48)");
  }

  function getQuickViewImageProbe(imageUrl) {
    var normalizedUrl = typeof imageUrl === "string" ? imageUrl.trim() : "";
    if (!normalizedUrl) {
      return Promise.resolve(null);
    }

    if (quickViewCloseButtonProbeCache[normalizedUrl]) {
      return quickViewCloseButtonProbeCache[normalizedUrl];
    }

    quickViewCloseButtonProbeCache[normalizedUrl] = new Promise(function resolveQuickViewImageProbe(resolve) {
      var probe = new Image();
      var settled = false;

      function complete(result) {
        if (settled) {
          return;
        }

        settled = true;
        resolve(result);
      }

      probe.onload = function onQuickViewImageProbeLoad() {
        complete(probe);
      };

      probe.onerror = function onQuickViewImageProbeError() {
        complete(null);
      };

      probe.crossOrigin = "anonymous";
      probe.src = normalizedUrl;

      if (probe.complete && (probe.naturalWidth || probe.width || 0) > 0) {
        complete(probe);
      }
    });

    return quickViewCloseButtonProbeCache[normalizedUrl];
  }

  async function updateProductQuickViewCloseButtonContrast(modalRoot, imageUrl) {
    if (!modalRoot || !modalRoot.isConnected) {
      return;
    }

    var closeButton = modalRoot.querySelector(".vr-product-quick-view-close");
    var imageElement = modalRoot.querySelector(".vr-product-quick-view-image");

    if (!closeButton) {
      return;
    }

    setQuickViewCloseButtonTone(closeButton, false);

    if (!imageElement) {
      return;
    }

    var buttonRect = closeButton.getBoundingClientRect();
    var imageRect = imageElement.getBoundingClientRect();
    if (!buttonRect.width || !buttonRect.height || !imageRect.width || !imageRect.height) {
      return;
    }

    var samplePointX = buttonRect.left + buttonRect.width / 2;
    var samplePointY = buttonRect.top + buttonRect.height / 2;
    if (!isPointInsideRect(samplePointX, samplePointY, imageRect)) {
      return;
    }

    var probeRequestId = String(Date.now()) + "-" + String(Math.random());
    modalRoot.__vrQuickViewCloseToneRequestId = probeRequestId;
    var probe = await getQuickViewImageProbe(imageUrl);

    if (!probe || !modalRoot.isConnected || modalRoot.__vrQuickViewCloseToneRequestId !== probeRequestId) {
      return;
    }

    var canvasWidth = Math.max(1, Math.round(imageRect.width));
    var canvasHeight = Math.max(1, Math.round(imageRect.height));
    var sampleCanvas = document.createElement("canvas");
    sampleCanvas.width = canvasWidth;
    sampleCanvas.height = canvasHeight;
    var context = sampleCanvas.getContext("2d");
    if (!context) {
      return;
    }

    context.fillStyle = "#eef2f6";
    context.fillRect(0, 0, canvasWidth, canvasHeight);

    var naturalWidth = probe.naturalWidth || probe.width || 0;
    var naturalHeight = probe.naturalHeight || probe.height || 0;
    var placement = getContainPlacement(canvasWidth, canvasHeight, naturalWidth, naturalHeight);
    if (!placement) {
      return;
    }

    try {
      context.drawImage(probe, placement.offsetX, placement.offsetY, placement.drawWidth, placement.drawHeight);
    } catch (_error) {
      return;
    }

    var localX = samplePointX - imageRect.left;
    var localY = samplePointY - imageRect.top;
    var sampleSize = Math.max(16, Math.round(Math.min(buttonRect.width, buttonRect.height) * 1.35));
    var sampleLeft = clampInRange(Math.round(localX - sampleSize / 2), 0, Math.max(0, canvasWidth - 1));
    var sampleTop = clampInRange(Math.round(localY - sampleSize / 2), 0, Math.max(0, canvasHeight - 1));
    var sampleWidth = Math.max(1, Math.min(sampleSize, canvasWidth - sampleLeft));
    var sampleHeight = Math.max(1, Math.min(sampleSize, canvasHeight - sampleTop));
    var pixels;

    try {
      pixels = context.getImageData(sampleLeft, sampleTop, sampleWidth, sampleHeight).data;
    } catch (_error) {
      return;
    }

    var luminanceTotal = 0;
    var alphaTotal = 0;
    for (var i = 0; i < pixels.length; i += 4) {
      var alpha = pixels[i + 3] / 255;
      if (alpha <= 0.01) {
        continue;
      }

      var red = pixels[i];
      var green = pixels[i + 1];
      var blue = pixels[i + 2];
      var luminance = 0.2126 * red + 0.7152 * green + 0.0722 * blue;
      luminanceTotal += luminance * alpha;
      alphaTotal += alpha;
    }

    if (!(alphaTotal > 0) || !modalRoot.isConnected || modalRoot.__vrQuickViewCloseToneRequestId !== probeRequestId) {
      return;
    }

    var averageLuminance = luminanceTotal / alphaTotal;
    setQuickViewCloseButtonTone(closeButton, averageLuminance < 152);
  }

  function resetProductQuickViewImageSizing(modalRoot) {
    if (!modalRoot) {
      return;
    }

    var panel = modalRoot.querySelector(".vr-product-quick-view-panel");
    if (!panel) {
      return;
    }

    panel.classList.remove("vr-quick-view-portrait-media");
    panel.style.removeProperty("--vr-product-quick-view-panel-width");
    panel.style.removeProperty("--vr-product-quick-view-panel-height");
    panel.style.removeProperty("--vr-product-quick-view-media-width");
  }

  function applyProductQuickViewImageAspectRatio(modalRoot, aspectRatio) {
    if (!modalRoot || !modalRoot.isConnected) {
      return;
    }

    var panel = modalRoot.querySelector(".vr-product-quick-view-panel");
    if (!panel) {
      return;
    }

    var numericRatio = Number(aspectRatio);
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    if (!(numericRatio > 0) || numericRatio >= 1 || viewportWidth <= 991 || !(viewportHeight > 0)) {
      resetProductQuickViewImageSizing(modalRoot);
      return;
    }

    var defaultPanelWidth = Math.min(1360, viewportWidth * 0.96, viewportHeight * 0.92 * 2);
    if (!(defaultPanelWidth > 0)) {
      resetProductQuickViewImageSizing(modalRoot);
      return;
    }

    var panelHeight = defaultPanelWidth / 2;
    var mediaWidth = Math.max(260, Math.round(panelHeight * numericRatio));
    var panelWidth = Math.round(mediaWidth + panelHeight);

    panel.classList.add("vr-quick-view-portrait-media");
    panel.style.setProperty("--vr-product-quick-view-panel-width", panelWidth + "px");
    panel.style.setProperty("--vr-product-quick-view-panel-height", Math.round(panelHeight) + "px");
    panel.style.setProperty("--vr-product-quick-view-media-width", mediaWidth + "px");
  }

  async function updateProductQuickViewImageSizing(modalRoot, imageUrl) {
    if (!modalRoot || !modalRoot.isConnected) {
      return;
    }

    var normalizedUrl = typeof imageUrl === "string" ? imageUrl.trim() : "";
    var sizingRequestId = String(Date.now()) + "-" + String(Math.random());
    modalRoot.__vrQuickViewImageSizingRequestId = sizingRequestId;
    modalRoot.__vrQuickViewImageAspectRatio = 0;
    resetProductQuickViewImageSizing(modalRoot);

    if (!normalizedUrl) {
      return;
    }

    var probe = await getQuickViewImageProbe(normalizedUrl);
    if (!probe || !modalRoot.isConnected || modalRoot.__vrQuickViewImageSizingRequestId !== sizingRequestId) {
      return;
    }

    var naturalWidth = probe.naturalWidth || probe.width || 0;
    var naturalHeight = probe.naturalHeight || probe.height || 0;
    if (!(naturalWidth > 0) || !(naturalHeight > 0)) {
      return;
    }

    modalRoot.__vrQuickViewImageAspectRatio = naturalWidth / naturalHeight;
    applyProductQuickViewImageAspectRatio(modalRoot, modalRoot.__vrQuickViewImageAspectRatio);
  }

  function extractCssUrl(value) {
    var match = String(value || "").match(/url\((['"]?)(.*?)\1\)/i);
    if (!match || !match[2]) {
      return "";
    }

    return String(match[2] || "").trim();
  }

  function findCartIconTarget() {
    var cartLinks = Array.prototype.slice.call(document.querySelectorAll("a.navigation-item.cart-icon"));
    var fallbackTarget = null;

    function isVisibleAnimationTarget(element) {
      var rect = element.getBoundingClientRect();
      if (rect.width < 4 || rect.height < 4) {
        return false;
      }

      var computed = window.getComputedStyle(element);
      if (!computed || computed.display === "none" || computed.visibility === "hidden") {
        return false;
      }

      return Number(computed.opacity) > 0;
    }

    function getCartVisualTarget(link) {
      var container = link.closest(".div-block-6");
      if (container) {
        var iconWrap = container.querySelector(".vr-cart-icon-wrap");
        if (iconWrap) {
          return iconWrap;
        }

        var iconImage = container.querySelector(".image-3");
        if (iconImage) {
          return iconImage;
        }
      }

      return null;
    }

    for (var i = 0; i < cartLinks.length; i += 1) {
      var link = cartLinks[i];
      if (isVisibleAnimationTarget(link)) {
        return link;
      }

      if (!fallbackTarget) {
        fallbackTarget = getCartVisualTarget(link);
      }
    }

    if (fallbackTarget && isVisibleAnimationTarget(fallbackTarget)) {
      return fallbackTarget;
    }

    return null;
  }

  function pulseCartIcon(target) {
    if (!target || !target.classList) {
      return;
    }

    target.classList.remove("vr-cart-icon-pop");
    void target.offsetWidth;
    target.classList.add("vr-cart-icon-pop");
    window.setTimeout(function clearCartIconPulseClass() {
      target.classList.remove("vr-cart-icon-pop");
    }, 360);
  }

  function animateImageToCart(options) {
    if (!document.body) {
      return false;
    }

    var config = options && typeof options === "object" ? options : {};
    var target = findCartIconTarget();
    if (!target) {
      return false;
    }

    var sourceElement = config.sourceElement instanceof Element ? config.sourceElement : null;
    var sourceRect = sourceElement ? sourceElement.getBoundingClientRect() : null;
    var hasSourceRect = !!sourceRect && sourceRect.width > 2 && sourceRect.height > 2;
    var targetRect = target.getBoundingClientRect();

    if (targetRect.width < 2 || targetRect.height < 2) {
      return false;
    }

    var startSize = hasSourceRect ? Math.max(48, Math.min(112, Math.min(sourceRect.width, sourceRect.height))) : 72;
    var startX = hasSourceRect
      ? sourceRect.left + sourceRect.width / 2 - startSize / 2
      : window.innerWidth / 2 - startSize / 2;
    var startY = hasSourceRect
      ? sourceRect.top + sourceRect.height / 2 - startSize / 2
      : window.innerHeight / 2 - startSize / 2;

    var endX = targetRect.left + targetRect.width / 2 - startSize / 2;
    var endY = targetRect.top + targetRect.height / 2 - startSize / 2;
    var endSize = Math.max(18, Math.min(30, Math.min(targetRect.width, targetRect.height)));
    var endScale = endSize / startSize;

    var deltaX = endX - startX;
    var deltaY = endY - startY;
    var arcHeight = Math.min(140, Math.max(70, Math.abs(deltaX) * 0.22));
    var midX = startX + deltaX * 0.52;
    var midY = startY + deltaY * 0.52 - arcHeight;

    var imageUrl = typeof config.imageUrl === "string" ? config.imageUrl.trim() : "";
    if (!imageUrl && sourceElement) {
      if (sourceElement.tagName === "IMG" && sourceElement.currentSrc) {
        imageUrl = sourceElement.currentSrc;
      } else if (sourceElement.tagName === "IMG" && sourceElement.src) {
        imageUrl = sourceElement.src;
      } else {
        imageUrl = extractCssUrl(sourceElement.style && sourceElement.style.backgroundImage);

        if (!imageUrl) {
          var computedSource = window.getComputedStyle(sourceElement);
          imageUrl = extractCssUrl(computedSource ? computedSource.backgroundImage : "");
        }

        if (!imageUrl) {
          var nestedImage = sourceElement.querySelector("img");
          if (nestedImage && (nestedImage.currentSrc || nestedImage.src)) {
            imageUrl = nestedImage.currentSrc || nestedImage.src;
          }
        }
      }
    }

    var clone = document.createElement("div");
    clone.className = "vr-fly-to-cart-clone";
    clone.style.width = startSize + "px";
    clone.style.height = startSize + "px";
    clone.style.transform = "translate3d(" + startX + "px," + startY + "px,0) scale(1)";

    if (imageUrl) {
      clone.style.backgroundImage = 'url("' + imageUrl.replace(/\"/g, "%22") + '")';
    }

    document.body.appendChild(clone);

    var cleanedUp = false;
    function finish() {
      if (cleanedUp) {
        return;
      }

      cleanedUp = true;

      if (clone.parentNode) {
        clone.parentNode.removeChild(clone);
      }

      pulseCartIcon(target);
    }

    if (typeof clone.animate === "function") {
      var animation = clone.animate(
        [
          {
            transform: "translate3d(" + startX + "px," + startY + "px,0) scale(1)",
            opacity: 1
          },
          {
            transform: "translate3d(" + midX + "px," + midY + "px,0) scale(.84)",
            opacity: 0.95
          },
          {
            transform: "translate3d(" + endX + "px," + endY + "px,0) scale(" + endScale + ")",
            opacity: 0.12
          }
        ],
        {
          duration: 640,
          easing: "cubic-bezier(.22,.72,.25,1)",
          fill: "forwards"
        }
      );

      animation.onfinish = finish;
      animation.oncancel = finish;
    } else {
      clone.style.transition = "transform .64s cubic-bezier(.22,.72,.25,1),opacity .64s ease";

      window.requestAnimationFrame(function startFallbackFlyAnimation() {
        clone.style.transform = "translate3d(" + endX + "px," + endY + "px,0) scale(" + endScale + ")";
        clone.style.opacity = "0.12";
      });

      window.setTimeout(finish, 660);
    }

    return true;
  }

  function launchAddToCartConfetti(sourceElement, originPoint) {
    if (!document.body || !(sourceElement instanceof Element)) {
      return;
    }

    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    var rect = sourceElement.getBoundingClientRect();
    if (rect.width < 2 || rect.height < 2) {
      return;
    }

    var centerX = rect.left + rect.width / 2;
    var centerY = rect.top + rect.height / 2;
    var hasOriginPoint =
      originPoint &&
      Number.isFinite(originPoint.x) &&
      Number.isFinite(originPoint.y) &&
      originPoint.x >= 0 &&
      originPoint.y >= 0 &&
      originPoint.x <= window.innerWidth &&
      originPoint.y <= window.innerHeight;

    if (hasOriginPoint) {
      centerX = originPoint.x;
      centerY = Math.min(window.innerHeight, originPoint.y + 8);
    }
    var colors = ["#22c55e", "#4ade80", "#facc15", "#60a5fa", "#f472b6", "#fb7185"];
    var totalPieces = 18;

    for (var i = 0; i < totalPieces; i += 1) {
      var piece = document.createElement("span");
      piece.className = "vr-add-confetti";

      var angle = (Math.PI * 2 * i) / totalPieces + (Math.random() - 0.5) * 0.3;
      var distance = 38 + Math.random() * 44;
      var driftX = Math.cos(angle) * distance;
      var driftY = Math.sin(angle) * distance - (18 + Math.random() * 22);
      var rotate = Math.round(Math.random() * 520 - 260) + "deg";

      piece.style.left = centerX + "px";
      piece.style.top = centerY + "px";
      piece.style.width = 6 + Math.floor(Math.random() * 4) + "px";
      piece.style.height = 10 + Math.floor(Math.random() * 6) + "px";
      piece.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      piece.style.setProperty("--vr-confetti-x", driftX.toFixed(1) + "px");
      piece.style.setProperty("--vr-confetti-y", driftY.toFixed(1) + "px");
      piece.style.setProperty("--vr-confetti-rot", rotate);

      if (Math.random() > 0.55) {
        piece.style.borderRadius = "999px";
      }

      document.body.appendChild(piece);

      (function removeConfetti(node) {
        window.setTimeout(function cleanupConfettiPiece() {
          if (node.parentNode) {
            node.parentNode.removeChild(node);
          }
        }, 780);
      })(piece);
    }
  }

  function clearChildren(node) {
    if (!node) {
      return;
    }

    while (node.firstChild) {
      node.removeChild(node.firstChild);
    }
  }

  function setDynEmptyVisibility(container, hasItems) {
    var dynList = container ? container.closest(".w-dyn-list") : null;
    if (!dynList) {
      return;
    }

    var emptyState = dynList.querySelector(".w-dyn-empty");
    if (emptyState) {
      emptyState.style.display = hasItems ? "none" : "";
    }
  }

  function isDealsQueryEnabled(rawValue) {
    if (typeof rawValue !== "string") {
      return false;
    }

    var normalized = rawValue.trim().toLowerCase();
    return normalized === "1" || normalized === "true";
  }

  function productsHref(categorySlug, searchTerm, pageNumber, dealsOnly) {
    var params = new URLSearchParams();
    var category = typeof categorySlug === "string" ? categorySlug.trim() : "";
    var search = typeof searchTerm === "string" ? searchTerm.trim() : "";
    var page = Number.parseInt(pageNumber, 10);
    var deals = dealsOnly === true;
    if (deals) {
      category = "";
    }

    if (category) {
      params.set("category", category);
    }

    if (deals) {
      params.set("deals", "1");
    }

    if (search) {
      params.set("search", search);
    }

    if (Number.isFinite(page) && page > 1) {
      params.set("page", String(page));
    }

    var queryString = params.toString();
    return queryString ? "/products?" + queryString : "/products";
  }

  function categoryHref(slug, searchTerm, dealsOnly) {
    return productsHref(slug, searchTerm, undefined, dealsOnly);
  }

  function productHref(slug) {
    return "/products/" + encodeURIComponent(slug);
  }

  function decodeURIComponentSafe(value) {
    try {
      return decodeURIComponent(value);
    } catch (_error) {
      return value;
    }
  }

  function readDetailProductSlug() {
    var pathMatch = String(window.location.pathname || "").match(
      /\/(?:detail_(?:product|sku)|products)\/([^/?#]+)/i
    );
    if (pathMatch && pathMatch[1]) {
      return decodeURIComponentSafe(pathMatch[1]).trim();
    }

    var search = new URLSearchParams(window.location.search);
    return String(search.get("slug") || "").trim();
  }

  function readProductsSearchTerm() {
    var search = new URLSearchParams(window.location.search);
    return String(search.get("search") || "").trim();
  }

  function readProductsDealsOnly() {
    var search = new URLSearchParams(window.location.search);
    return isDealsQueryEnabled(search.get("deals"));
  }

  function readProductsPage() {
    var search = new URLSearchParams(window.location.search);
    var parsed = Number.parseInt(search.get("page"), 10);
    if (!Number.isFinite(parsed) || parsed < 1) {
      return 1;
    }

    return parsed;
  }

  function isPrimaryActionClick(event) {
    if (!event || event.defaultPrevented) {
      return false;
    }

    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return false;
    }

    if (typeof event.button === "number" && event.button !== 0) {
      return false;
    }

    return true;
  }

  function normalizeQuantity(value) {
    var parsed = Number.parseInt(value, 10);

    if (!Number.isFinite(parsed)) {
      return 1;
    }

    return Math.min(MAX_CART_QUANTITY, Math.max(1, parsed));
  }

  function normalizeMoney(value) {
    var parsed = typeof value === "number" ? value : Number.parseFloat(value);
    if (!Number.isFinite(parsed)) {
      return 0;
    }

    return Math.round(parsed * 100) / 100;
  }

  function normalizeMoneyOrNull(value) {
    var parsed = typeof value === "number" ? value : Number.parseFloat(value);
    if (!Number.isFinite(parsed)) {
      return null;
    }

    return Math.round(parsed * 100) / 100;
  }

  function normalizeBoolean(value) {
    return value === true;
  }

  function normalizeIdentifierValue(value) {
    if (typeof value !== "string") {
      return "";
    }

    return value.replace(/\s+/g, " ").trim();
  }

  function isStockTrackingEnabled(product) {
    return normalizeBoolean(product && product.stock_tracking_enabled);
  }

  function getProductAvailableQuantity(product) {
    if (!product || typeof product !== "object") {
      return 0;
    }

    var parsed = Number.parseInt(product.available_quantity, 10);
    if (!Number.isFinite(parsed)) {
      return 0;
    }

    return Math.max(0, parsed);
  }

  function isProductSoldOut(product) {
    return isStockTrackingEnabled(product) && getProductAvailableQuantity(product) <= 0;
  }

  function getProductAvailabilityText(product) {
    if (!isStockTrackingEnabled(product)) {
      return "";
    }

    return getAvailabilityTextForQuantity(getProductAvailableQuantity(product));
  }

  function getAvailabilityStateForQuantity(quantity) {
    if (quantity <= 0) {
      return "out";
    }

    if (quantity <= LOW_STOCK_THRESHOLD) {
      return "low";
    }

    return "in";
  }

  function getAvailabilityTextForQuantity(quantity) {
    var state = getAvailabilityStateForQuantity(quantity);
    if (state === "out") {
      return currentLanguage === LANGUAGE_EN ? "Out of stock" : "Nema na stanju";
    }

    if (state === "low") {
      return currentLanguage === LANGUAGE_EN
        ? "Only " + quantity + " left in stock"
        : "Ostalo samo " + quantity + " na stanju";
    }

    return currentLanguage === LANGUAGE_EN ? "In stock" : "Na stanju";
  }

  function getAvailabilityCountTextForQuantity(quantity) {
    var state = getAvailabilityStateForQuantity(quantity);
    if (state !== "in") {
      return getAvailabilityTextForQuantity(quantity);
    }

    return currentLanguage === LANGUAGE_EN ? quantity + " in stock" : "Na stanju: " + quantity;
  }

  function getProductAvailabilityCountText(product) {
    if (!isStockTrackingEnabled(product)) {
      return "";
    }

    return getAvailabilityCountTextForQuantity(getProductAvailableQuantity(product));
  }

  function getProductAvailabilityFeedbackClass(product) {
    if (!isStockTrackingEnabled(product)) {
      return "";
    }

    var state = getAvailabilityStateForQuantity(getProductAvailableQuantity(product));
    return state === "in" ? "success" : "error";
  }

  function getStoreAvailabilityQuantity(entry) {
    if (!entry || typeof entry !== "object") {
      return 0;
    }

    var parsed = Number.parseInt(entry.available_quantity, 10);
    if (!Number.isFinite(parsed)) {
      return 0;
    }

    return Math.max(0, parsed);
  }

  function getStoreAvailabilityText(entry) {
    return getAvailabilityTextForQuantity(getStoreAvailabilityQuantity(entry));
  }

  function getStoreAvailabilityCountText(entry) {
    return getAvailabilityCountTextForQuantity(getStoreAvailabilityQuantity(entry));
  }

  function getStoreAvailabilityName(entry) {
    if (!entry || typeof entry !== "object") {
      return "";
    }

    return normalizeIdentifierValue(entry.store_name) || normalizeIdentifierValue(entry.store_slug);
  }

  function getStoreAvailabilityDisplayName(entry, compact) {
    var name = getStoreAvailabilityName(entry);
    if (!compact) {
      return name;
    }

    return name.replace(/^vape\s+/i, "").trim() || name;
  }

  function getProductStoreAvailabilityEntries(product) {
    var entries = Array.isArray(product && product.store_availability) ? product.store_availability : [];
    return entries.filter(function filterVisibleStoreAvailability(entry) {
      return isStockTrackingEnabled(entry) && getStoreAvailabilityName(entry);
    });
  }

  function createProductStoreStockList(product, options) {
    var entries = getProductStoreAvailabilityEntries(product);
    if (!entries.length) {
      return null;
    }

    var config = options && typeof options === "object" ? options : {};
    var isDetail = config.detail === true;
    var showExactCounts = config.showExactCounts === true;
    var root = document.createElement("div");
    root.className = "vr-product-store-stock" + (isDetail ? " is-detail" : " is-compact");
    root.setAttribute(
      "aria-label",
      currentLanguage === LANGUAGE_EN ? "Live stock by store" : "Stanje po radnjama"
    );

    var title = document.createElement("div");
    title.className = "vr-product-store-stock-title";
    title.textContent = isDetail
      ? currentLanguage === LANGUAGE_EN
        ? "Live stock by store"
        : "Stanje po radnjama"
      : currentLanguage === LANGUAGE_EN
        ? "Stock"
        : "Stanje";
    root.appendChild(title);

    var list = document.createElement("div");
    list.className = "vr-product-store-stock-list";

    entries.forEach(function appendStoreAvailability(entry) {
      var quantity = getStoreAvailabilityQuantity(entry);
      var availabilityState = getAvailabilityStateForQuantity(quantity);
      var row = document.createElement("div");
      row.className =
        "vr-product-store-stock-row" +
        (availabilityState === "out" ? " is-empty" : availabilityState === "low" ? " is-low" : " is-in-stock");

      var name = document.createElement("span");
      name.className = "vr-product-store-stock-name";
      name.textContent = getStoreAvailabilityDisplayName(entry, !isDetail);

      var value = document.createElement("span");
      value.className = "vr-product-store-stock-status";
      value.textContent = showExactCounts ? getStoreAvailabilityCountText(entry) : getStoreAvailabilityText(entry);

      row.appendChild(name);
      row.appendChild(value);
      list.appendChild(row);
    });

    root.appendChild(list);
    return root;
  }

  function createProductReviewSessionId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }

    return "review-" + String(Date.now()) + "-" + String(Math.random()).slice(2);
  }

  function readProductReviewerId() {
    try {
      var existing = window.localStorage.getItem(PRODUCT_REVIEWER_KEY);
      if (typeof existing === "string" && existing.trim()) {
        return existing.trim();
      }

      var nextId = createProductReviewSessionId();
      window.localStorage.setItem(PRODUCT_REVIEWER_KEY, nextId);
      return nextId;
    } catch (_error) {
      return createProductReviewSessionId();
    }
  }

  function readStoredProductReviewRatings() {
    try {
      var raw = window.localStorage.getItem(PRODUCT_REVIEW_RATINGS_KEY);
      if (!raw) {
        return {};
      }

      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
    } catch (_error) {
      return {};
    }
  }

  function normalizeProductReviewRating(value) {
    var parsed = Number(value);
    if (!Number.isInteger(parsed) || parsed < 1 || parsed > 5) {
      return null;
    }

    return parsed;
  }

  function readStoredProductReviewRating(productSlug) {
    var slug = typeof productSlug === "string" ? productSlug.trim() : "";
    if (!slug) {
      return null;
    }

    return normalizeProductReviewRating(readStoredProductReviewRatings()[slug]);
  }

  function writeStoredProductReviewRating(productSlug, rating) {
    var slug = typeof productSlug === "string" ? productSlug.trim() : "";
    var normalizedRating = normalizeProductReviewRating(rating);
    if (!slug || normalizedRating === null) {
      return;
    }

    try {
      var ratings = readStoredProductReviewRatings();
      ratings[slug] = normalizedRating;
      window.localStorage.setItem(PRODUCT_REVIEW_RATINGS_KEY, JSON.stringify(ratings));
    } catch (_error) {
      // Local review storage is only a convenience; the server still stores the rating.
    }
  }

  function normalizeProductReviewSummary(product) {
    var summary = product && product.review_summary && typeof product.review_summary === "object"
      ? product.review_summary
      : {};
    var average = Number.parseFloat(summary.average_rating);
    var count = Number.parseInt(summary.review_count, 10);
    var userRating = normalizeProductReviewRating(summary.user_rating);
    var productSlug = typeof product.slug === "string" ? product.slug.trim() : "";

    if (userRating === null) {
      userRating = readStoredProductReviewRating(productSlug);
    }

    return {
      average_rating: Number.isFinite(average) && average > 0 ? Math.round(average * 10) / 10 : null,
      review_count: Number.isFinite(count) && count > 0 ? count : 0,
      user_rating: userRating
    };
  }

  function getProductReviewSummaryText(summary) {
    var count = Number.parseInt(summary && summary.review_count, 10);
    if (!Number.isFinite(count) || count <= 0) {
      return "(0)";
    }

    return "(" + count.toLocaleString(currentLanguage === LANGUAGE_EN ? "en-US" : "bs-BA") + ")";
  }

  function productReviewApiPath(productSlug) {
    return "/products/" + encodeURIComponent(productSlug) + "/review";
  }

  function productDetailApiPath(productSlug) {
    var reviewerId = readProductReviewerId();
    var path = "/products/" + encodeURIComponent(productSlug);
    if (!reviewerId) {
      return path;
    }

    return path + "?reviewerId=" + encodeURIComponent(reviewerId);
  }

  function renderProductReviewWidget(root) {
    var state = root && root.__vrReviewState ? root.__vrReviewState : null;
    if (!root || !state) {
      return;
    }

    var isInteractive = state.interactive !== false;
    clearChildren(root);
    root.classList.toggle("is-submitting", state.submitting === true);
    root.classList.toggle("is-interactive", isInteractive);
    root.classList.toggle("is-readonly", !isInteractive);
    root.classList.toggle("is-unrated", isInteractive && normalizeProductReviewRating(state.userRating) === null);
    root.removeAttribute("data-vr-hover-rating");

    var title = document.createElement("div");
    title.className = "vr-product-review-title";
    title.textContent = isInteractive
      ? currentLanguage === LANGUAGE_EN ? "Rate this vape" : "Ocijeni proizvod"
      : currentLanguage === LANGUAGE_EN ? "Product rating" : "Ocjena proizvoda";

    var row = document.createElement("div");
    row.className = "vr-product-review-row";

    var stars = document.createElement("div");
    stars.className = "vr-product-review-stars";
    stars.setAttribute("role", isInteractive ? "group" : "img");
    stars.setAttribute("aria-label", title.textContent);

    var selectedRating =
      (isInteractive ? normalizeProductReviewRating(state.userRating) : null) ||
      (state.summary && state.summary.average_rating ? Math.round(Number(state.summary.average_rating)) : 0);

    for (var rating = 1; rating <= 5; rating += 1) {
      var star = document.createElement(isInteractive ? "button" : "span");
      if (isInteractive) {
        star.type = "button";
      }
      star.className = "vr-product-review-star" + (rating <= selectedRating ? " is-active" : "");
      star.textContent = "\u2605";
      star.setAttribute("data-vr-review-rating", String(rating));

      if (isInteractive) {
        star.setAttribute(
          "aria-label",
          currentLanguage === LANGUAGE_EN
            ? "Rate " + rating + " out of 5"
            : "Ocijeni " + rating + " od 5"
        );
        star.disabled = state.submitting === true;
        star.addEventListener("click", onProductReviewStarClick);
        star.addEventListener("mouseenter", onProductReviewStarPreview);
        star.addEventListener("mouseover", onProductReviewStarPreview);
        star.addEventListener("focus", onProductReviewStarPreview);
        star.addEventListener("mouseleave", onProductReviewStarPreviewClear);
        star.addEventListener("mouseout", onProductReviewStarPreviewClear);
        star.addEventListener("blur", onProductReviewStarPreviewClear);
      } else {
        star.setAttribute("aria-hidden", "true");
      }
      stars.appendChild(star);
    }

    var summaryText = document.createElement("span");
    summaryText.className = "vr-product-review-summary";
    summaryText.textContent = getProductReviewSummaryText(state.summary);

    row.appendChild(stars);
    row.appendChild(summaryText);

    root.appendChild(title);
    root.appendChild(row);

    if (state.feedback) {
      var feedback = document.createElement("div");
      feedback.className = "vr-product-review-feedback " + (state.feedbackType || "info");
      feedback.setAttribute("aria-live", "polite");
      feedback.textContent = state.feedback;
      root.appendChild(feedback);
    }
  }

  function launchProductReviewConfetti(root, sourceRect) {
    if (!document.body || !(root instanceof Element) || !root.isConnected) {
      return;
    }

    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    var rect =
      sourceRect &&
      Number.isFinite(Number(sourceRect.left)) &&
      Number.isFinite(Number(sourceRect.top)) &&
      Number.isFinite(Number(sourceRect.width)) &&
      Number.isFinite(Number(sourceRect.height))
        ? sourceRect
        : null;

    if (!rect) {
      var sourceElement = root.querySelector(".vr-product-review-stars") || root;
      rect = sourceElement.getBoundingClientRect();
    }

    if (rect.width < 2 || rect.height < 2) {
      return;
    }

    var centerX = rect.left + rect.width / 2;
    var centerY = rect.top + rect.height / 2;
    var colors = ["#f59e0b", "#fbbf24", "#facc15", "#fde68a", "#d97706", "#fff7cc"];
    var totalPieces = 18;

    for (var index = 0; index < totalPieces; index += 1) {
      var piece = document.createElement("span");
      piece.className = "vr-rating-confetti";

      var angle = (Math.PI * 2 * index) / totalPieces + (Math.random() - 0.5) * 0.32;
      var distance = 38 + Math.random() * 48;
      var driftX = Math.cos(angle) * distance;
      var driftY = Math.sin(angle) * distance - (20 + Math.random() * 24);
      var rotate = Math.round(Math.random() * 520 - 260) + "deg";

      piece.style.left = centerX + "px";
      piece.style.top = centerY + "px";
      piece.style.width = 5 + Math.floor(Math.random() * 5) + "px";
      piece.style.height = 9 + Math.floor(Math.random() * 7) + "px";
      piece.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      piece.style.setProperty("--vr-rating-confetti-x", driftX.toFixed(1) + "px");
      piece.style.setProperty("--vr-rating-confetti-y", driftY.toFixed(1) + "px");
      piece.style.setProperty("--vr-rating-confetti-rot", rotate);

      if (Math.random() > 0.62) {
        piece.style.borderRadius = "999px";
      }

      document.body.appendChild(piece);

      (function removeRatingConfetti(node) {
        window.setTimeout(function cleanupRatingConfettiPiece() {
          if (node.parentNode) {
            node.parentNode.removeChild(node);
          }
        }, 920);
      })(piece);
    }
  }

  function updateProductReviewWidgets(productSlug, summary, userRating, feedback, feedbackType) {
    var slug = typeof productSlug === "string" ? productSlug.trim() : "";
    if (!slug) {
      return;
    }

    document.querySelectorAll(".vr-product-review").forEach(function updateProductReviewRoot(root) {
      if (!root || root.getAttribute("data-vr-review-slug") !== slug || !root.__vrReviewState) {
        return;
      }

      var nextAverage = Number.parseFloat(summary && summary.average_rating);
      var nextCount = Number.parseInt(summary && summary.review_count, 10);
      root.__vrReviewState.summary = {
        average_rating: Number.isFinite(nextAverage) && nextAverage > 0 ? Math.round(nextAverage * 10) / 10 : null,
        review_count: Number.isFinite(nextCount) && nextCount > 0 ? nextCount : 0,
        user_rating: normalizeProductReviewRating(userRating)
      };
      root.__vrReviewState.userRating = normalizeProductReviewRating(userRating);
      root.__vrReviewState.submitting = false;
      root.__vrReviewState.feedback = root.__vrReviewState.interactive === false ? "" : feedback || "";
      root.__vrReviewState.feedbackType = root.__vrReviewState.interactive === false ? "info" : feedbackType || "success";
      renderProductReviewWidget(root);
    });
  }

  function createOptimisticProductReviewSummary(summary, rating, previousRating) {
    var normalizedRating = normalizeProductReviewRating(rating);
    var normalizedPreviousRating = normalizeProductReviewRating(previousRating);
    var previousAverage = Number.parseFloat(summary && summary.average_rating);
    var previousCount = Number.parseInt(summary && summary.review_count, 10);
    var hasAverage = Number.isFinite(previousAverage) && previousAverage > 0;
    var count = Number.isFinite(previousCount) && previousCount > 0 ? previousCount : 0;
    var nextCount = count;
    var nextAverage = normalizedRating || 0;

    if (normalizedRating === null) {
      return normalizeProductReviewSummary(summary);
    }

    if (count > 0 && hasAverage) {
      if (normalizedPreviousRating !== null) {
        nextAverage = ((previousAverage * count) - normalizedPreviousRating + normalizedRating) / count;
      } else {
        nextCount = count + 1;
        nextAverage = ((previousAverage * count) + normalizedRating) / nextCount;
      }
    } else {
      nextCount = 1;
      nextAverage = normalizedRating;
    }

    return {
      average_rating: Math.round(nextAverage * 10) / 10,
      review_count: nextCount,
      user_rating: normalizedRating
    };
  }

  function submitProductReview(root, rating, confettiRect) {
    var state = root && root.__vrReviewState ? root.__vrReviewState : null;
    var normalizedRating = normalizeProductReviewRating(rating);
    if (!state || state.interactive === false || !state.slug || normalizedRating === null) {
      return;
    }

    var previousRating = state.userRating;
    var optimisticSummary = createOptimisticProductReviewSummary(state.summary, normalizedRating, previousRating);
    var requestId = (productReviewSaveRequestIds[state.slug] || 0) + 1;
    productReviewSaveRequestIds[state.slug] = requestId;

    writeStoredProductReviewRating(state.slug, normalizedRating);
    updateProductReviewWidgets(state.slug, optimisticSummary, normalizedRating, "", "success");
    launchProductReviewConfetti(root, confettiRect);

    requestJson(productReviewApiPath(state.slug), {
        method: "POST",
        keepalive: true,
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          rating: normalizedRating,
          reviewerId: readProductReviewerId()
        })
      })
      .then(function syncProductReviewSummary(payload) {
        if (productReviewSaveRequestIds[state.slug] !== requestId) {
          return;
        }

        var product = payload && payload.product ? payload.product : {};
        var summary = product.review_summary || optimisticSummary;
        updateProductReviewWidgets(state.slug, summary, normalizedRating, "", "success");
      })
      .catch(function ignoreProductReviewSaveError() {
        // Rating saves are intentionally quiet; the optimistic UI should not interrupt browsing.
      });
  }

  function onProductReviewStarClick(event) {
    var button = event && event.currentTarget ? event.currentTarget : null;
    var root = button && typeof button.closest === "function" ? button.closest(".vr-product-review") : null;
    var rating = normalizeProductReviewRating(button && button.getAttribute("data-vr-review-rating"));
    var confettiRect =
      button && typeof button.getBoundingClientRect === "function" ? button.getBoundingClientRect() : null;

    if (event && typeof event.preventDefault === "function") {
      event.preventDefault();
    }

    if (event && typeof event.stopPropagation === "function") {
      event.stopPropagation();
    }

    if (event && typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }

    submitProductReview(root, rating, confettiRect);
  }

  function setProductReviewPreview(root, rating) {
    var state = root && root.__vrReviewState ? root.__vrReviewState : null;
    var previewRating = normalizeProductReviewRating(rating);
    var shouldPreview =
      !!state &&
      state.submitting !== true &&
      state.interactive !== false &&
      previewRating !== null;

    if (!root) {
      return;
    }

    root.classList.toggle("is-previewing", shouldPreview);
    if (shouldPreview) {
      root.setAttribute("data-vr-hover-rating", String(previewRating));
    } else {
      root.removeAttribute("data-vr-hover-rating");
    }

    root.querySelectorAll(".vr-product-review-star").forEach(function updatePreviewStar(star) {
      var starRating = normalizeProductReviewRating(star && star.getAttribute("data-vr-review-rating"));
      var isPreviewStar = shouldPreview && starRating !== null && starRating <= previewRating;
      var isPreviewTarget = shouldPreview && starRating === previewRating;

      star.classList.toggle("is-preview", isPreviewStar);
      star.classList.toggle("is-preview-target", isPreviewTarget);

      if (shouldPreview && starRating !== null) {
        star.style.color = isPreviewStar ? "#f59e0b" : "#d0d5dd";
      } else {
        star.style.removeProperty("color");
      }

      if (isPreviewTarget) {
        star.style.transform = "translateY(-1px) scale(1.08)";
      } else {
        star.style.removeProperty("transform");
      }
    });
  }

  function onProductReviewStarPreview(event) {
    var button = event && event.currentTarget ? event.currentTarget : null;
    var root = button && typeof button.closest === "function" ? button.closest(".vr-product-review") : null;
    setProductReviewPreview(root, button && button.getAttribute("data-vr-review-rating"));
  }

  function onProductReviewStarPreviewClear(event) {
    var button = event && event.currentTarget ? event.currentTarget : null;
    var root = button && typeof button.closest === "function" ? button.closest(".vr-product-review") : null;
    setProductReviewPreview(root, null);
  }

  function createProductReviewWidget(product, options) {
    var productSlug = typeof product.slug === "string" ? product.slug.trim() : "";
    if (!productSlug) {
      return null;
    }

    var config = options && typeof options === "object" ? options : {};
    var summary = normalizeProductReviewSummary(product);
    var root = document.createElement("div");
    root.className =
      "vr-product-review" +
      (config.compact === true ? " is-compact" : "") +
      (config.detail === true ? " is-detail" : "");
    root.setAttribute("data-vr-review-slug", productSlug);
    root.__vrReviewState = {
      slug: productSlug,
      summary: summary,
      userRating: summary.user_rating,
      submitting: false,
      feedback: "",
      feedbackType: "info",
      interactive: config.interactive !== false
    };

    renderProductReviewWidget(root);
    return root;
  }

  function renderDetailProductReview(product) {
    var main = document.querySelector(".product-detail-main-details");
    if (!main) {
      return;
    }

    var existing = main.querySelector(".vr-detail-review-host");
    if (existing) {
      existing.remove();
    }

    var widget = createProductReviewWidget(product, {
      detail: true
    });
    if (!widget) {
      return;
    }

    var host = document.createElement("div");
    host.className = "vr-detail-review-host";
    host.appendChild(widget);

    var price = main.querySelector(".product-detail-price");
    if (price && price.parentNode === main) {
      price.insertAdjacentElement("afterend", host);
    } else {
      main.appendChild(host);
    }
  }

  function getCartItemMaxQuantity(item) {
    if (!isStockTrackingEnabled(item)) {
      return MAX_CART_QUANTITY;
    }

    return Math.min(MAX_CART_QUANTITY, getProductAvailableQuantity(item));
  }

  function getWholesaleComparePrice(product) {
    if (!product || typeof product !== "object") {
      return null;
    }

    var currentPrice = normalizeMoneyOrNull(product.price_bam);
    var retailPrice = normalizeMoneyOrNull(product.retail_price_bam);

    if (currentPrice === null || retailPrice === null || retailPrice <= currentPrice) {
      return null;
    }

    return retailPrice;
  }

  function getCompareAtSalePrice(product) {
    if (!product || typeof product !== "object") {
      return null;
    }

    var price = normalizeMoneyOrNull(product.price_bam);
    var compareAt = normalizeMoneyOrNull(product.compare_at_price_bam);

    if (price === null || compareAt === null || compareAt <= 0 || compareAt <= price) {
      return null;
    }

    return compareAt;
  }

  function normalizeCartItem(item) {
    if (!item || typeof item !== "object") {
      return null;
    }

    var slug = typeof item.slug === "string" ? item.slug.trim() : "";
    var name = typeof item.name === "string" ? item.name.trim() : "";

    if (!slug || !name) {
      return null;
    }

    return {
      slug: slug,
      name: name,
      image_url: typeof item.image_url === "string" ? item.image_url : "",
      price_bam: normalizeMoney(item.price_bam),
      retail_price_bam: normalizeMoneyOrNull(item.retail_price_bam),
      stock_tracking_enabled: normalizeBoolean(item.stock_tracking_enabled),
      available_quantity: getProductAvailableQuantity(item),
      quantity: normalizeQuantity(item.quantity)
    };
  }

  function getCartItemRetailPrice(item) {
    if (!item || typeof item !== "object") {
      return null;
    }

    var currentPrice = normalizeMoneyOrNull(item.price_bam);
    var retailPrice = normalizeMoneyOrNull(item.retail_price_bam);

    if (currentPrice === null || retailPrice === null || retailPrice <= currentPrice) {
      return null;
    }

    return retailPrice;
  }

  function getCartUnitPriceHtml(item) {
    var currentPrice = formatPrice(item && item.price_bam);
    var retailPrice = getCartItemRetailPrice(item);

    if (retailPrice === null) {
      return escapeHtml(currentPrice);
    }

    return (
      '<span class="vr-cart-price-current">' +
      escapeHtml(currentPrice) +
      '</span><span class="vr-cart-price-compare">' +
      escapeHtml(formatPrice(retailPrice)) +
      "</span>"
    );
  }

  function getCartLineTotalHtml(item) {
    var currentTotal = normalizeMoney(normalizeMoney(item && item.price_bam) * normalizeQuantity(item && item.quantity));
    var currentTotalLabel = formatPrice(currentTotal);
    var retailPrice = getCartItemRetailPrice(item);

    if (retailPrice === null) {
      return escapeHtml(currentTotalLabel);
    }

    var retailTotal = normalizeMoney(retailPrice * normalizeQuantity(item && item.quantity));
    return (
      '<span class="vr-cart-price-current">' +
      escapeHtml(currentTotalLabel) +
      '</span><span class="vr-cart-price-compare">' +
      escapeHtml(formatPrice(retailTotal)) +
      "</span>"
    );
  }

  function readCart() {
    try {
      var raw = window.localStorage.getItem(CART_STORAGE_KEY);
      if (!raw) {
        return [];
      }

      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) {
        return [];
      }

      return parsed.map(normalizeCartItem).filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  function writeCart(cart) {
    var normalized = Array.isArray(cart) ? cart.map(normalizeCartItem).filter(Boolean) : [];
    window.localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(normalized));
    window.dispatchEvent(
      new CustomEvent(CART_UPDATE_EVENT, {
        detail: {
          cart: normalized
        }
      })
    );
  }

  function clearCart() {
    writeCart([]);
  }

  function getShippingFee(subtotal, itemCount) {
    if (!Number.isFinite(itemCount) || itemCount <= 0) {
      return 0;
    }

    return subtotal >= FREE_DELIVERY_THRESHOLD_BAM ? 0 : DELIVERY_FEE_BAM;
  }

  function getRemainingUntilFreeDelivery(subtotal) {
    return Math.max(0, normalizeMoney(FREE_DELIVERY_THRESHOLD_BAM - subtotal));
  }

  function getDeliveryNoticeText(subtotal) {
    var thresholdLabel = formatPrice(FREE_DELIVERY_THRESHOLD_BAM);
    var feeLabel = formatPrice(DELIVERY_FEE_BAM);

    if (subtotal >= FREE_DELIVERY_THRESHOLD_BAM) {
      return currentLanguage === LANGUAGE_EN
        ? "Free delivery unlocked for this order (" + thresholdLabel + "+)."
        : "Besplatna dostava je aktivna za ovu narudzbu (" + thresholdLabel + "+).";
    }

    var remainingLabel = formatPrice(getRemainingUntilFreeDelivery(subtotal));

    return currentLanguage === LANGUAGE_EN
      ? "Add " +
          remainingLabel +
          " more for free delivery. Orders below " +
          thresholdLabel +
          " have a " +
          feeLabel +
          " delivery fee."
      : "Dodajte jos " +
          remainingLabel +
          " za besplatnu dostavu. Za narudzbe ispod " +
          thresholdLabel +
          " dostava je " +
          feeLabel +
          ".";
  }

  function isFreeDeliveryActive(subtotal) {
    return Number.isFinite(subtotal) && subtotal >= FREE_DELIVERY_THRESHOLD_BAM;
  }

  function getDeliveryNoticeHtml(subtotal) {
    if (!isFreeDeliveryActive(subtotal)) {
      var remainingLabel = escapeHtml(formatPrice(getRemainingUntilFreeDelivery(subtotal)));
      var thresholdLabelInactive = escapeHtml(formatPrice(FREE_DELIVERY_THRESHOLD_BAM));
      var feeLabelInactive = escapeHtml(formatPrice(DELIVERY_FEE_BAM));

      if (currentLanguage === LANGUAGE_EN) {
        return (
          "Add <strong>" +
          remainingLabel +
          "</strong> more for free delivery. Orders below " +
          thresholdLabelInactive +
          " have a " +
          feeLabelInactive +
          " delivery fee."
        );
      }

      return (
        "Dodajte jos <strong>" +
        remainingLabel +
        "</strong> za besplatnu dostavu. Za narudzbe ispod " +
        thresholdLabelInactive +
        " dostava je " +
        feeLabelInactive +
        "."
      );
    }

    var thresholdLabel = escapeHtml(formatPrice(FREE_DELIVERY_THRESHOLD_BAM));
    if (currentLanguage === LANGUAGE_EN) {
      return (
        '<span class="vr-delivery-note-highlight">Free delivery <strong>unlocked</strong></span> for this order (' +
        thresholdLabel +
        "+)."
      );
    }

    return (
      '<span class="vr-delivery-note-highlight">Besplatna dostava je <strong>aktivna</strong></span> za ovu narudzbu (' +
      thresholdLabel +
      "+)."
    );
  }

  function renderDeliveryNotice(element, subtotal) {
    if (!element) {
      return;
    }

    element.innerHTML = getDeliveryNoticeHtml(subtotal);
    element.classList.toggle("vr-delivery-note-free", isFreeDeliveryActive(subtotal));
  }

  function getCartSummary(cart) {
    var items = Array.isArray(cart) ? cart : [];
    var count = 0;
    var subtotal = 0;

    items.forEach(function sumCart(item) {
      count += item.quantity;
      subtotal += normalizeMoney(item.price_bam) * item.quantity;
    });

    subtotal = normalizeMoney(subtotal);
    var shipping = getShippingFee(subtotal, count);
    var total = normalizeMoney(subtotal + shipping);

    return {
      count: count,
      subtotal: subtotal,
      shipping: shipping,
      total: total
    };
  }

  async function refreshCartPricingFromCatalog() {
    var cart = readCart();
    if (!cart.length) {
      return;
    }

    var refreshed = await Promise.all(
      cart.map(async function refreshCartItemPrice(item) {
        var slug = typeof item.slug === "string" ? item.slug.trim() : "";
        if (!slug) {
          return item;
        }

        try {
          var payload = await requestJson("/products/" + encodeURIComponent(slug));
          var product = payload && payload.product ? payload.product : null;
          if (!product || typeof product !== "object") {
            return item;
          }

          return normalizeCartItem({
            slug: slug,
            name: typeof product.name === "string" && product.name.trim() ? product.name : item.name,
            image_url:
              typeof product.image_url === "string" && product.image_url.trim()
                ? product.image_url
                : item.image_url,
            price_bam: normalizeMoney(product.price_bam),
            retail_price_bam: normalizeMoneyOrNull(product.retail_price_bam),
            stock_tracking_enabled: normalizeBoolean(product.stock_tracking_enabled),
            available_quantity: getProductAvailableQuantity(product),
            quantity: item.quantity
          });
        } catch (_error) {
          return item;
        }
      })
    );

    writeCart(refreshed.filter(Boolean));
  }

  function addToCart(product, quantity, options) {
    var config = options && typeof options === "object" ? options : {};
    var shouldNotify = config.notify !== false;
    var cart = readCart();
    var targetSlug = product.slug;
    var qty = normalizeQuantity(quantity);
    var maxAllowedQuantity = getCartItemMaxQuantity(product);
    var existingIndex = cart.findIndex(function findItem(item) {
      return item.slug === targetSlug;
    });

    if (maxAllowedQuantity <= 0) {
      throw new Error("OUT_OF_STOCK");
    }

    if (existingIndex >= 0) {
      if (cart[existingIndex].quantity + qty > maxAllowedQuantity) {
        throw new Error("OUT_OF_STOCK");
      }
      cart[existingIndex].quantity = Math.min(MAX_CART_QUANTITY, cart[existingIndex].quantity + qty);
      cart[existingIndex].price_bam = normalizeMoney(product.price_bam);
      cart[existingIndex].retail_price_bam = normalizeMoneyOrNull(product.retail_price_bam);
      cart[existingIndex].stock_tracking_enabled = normalizeBoolean(product.stock_tracking_enabled);
      cart[existingIndex].available_quantity = getProductAvailableQuantity(product);
      cart[existingIndex].name = product.name;
      cart[existingIndex].image_url = product.image_url || "";
    } else {
      if (qty > maxAllowedQuantity) {
        throw new Error("OUT_OF_STOCK");
      }
      cart.push({
        slug: targetSlug,
        name: product.name,
        image_url: product.image_url || "",
        price_bam: normalizeMoney(product.price_bam),
        retail_price_bam: normalizeMoneyOrNull(product.retail_price_bam),
        stock_tracking_enabled: normalizeBoolean(product.stock_tracking_enabled),
        available_quantity: getProductAvailableQuantity(product),
        quantity: qty
      });
    }

    writeCart(cart);
    if (shouldNotify) {
      window.dispatchEvent(
        new CustomEvent(CART_ITEM_ADDED_EVENT, {
          detail: {
            slug: targetSlug,
            quantity: qty
          }
        })
      );
    }
  }

  function setCartItemQuantity(slug, quantity) {
    var cart = readCart();

    for (var i = 0; i < cart.length; i += 1) {
      if (cart[i].slug === slug) {
        var maxAllowedQuantity = getCartItemMaxQuantity(cart[i]);
        if (maxAllowedQuantity <= 0) {
          cart.splice(i, 1);
          break;
        }
        cart[i].quantity = Math.max(1, Math.min(normalizeQuantity(quantity), maxAllowedQuantity));
        break;
      }
    }

    writeCart(cart);
  }

  function adjustCartItemQuantity(slug, delta) {
    var targetSlug = typeof slug === "string" ? slug.trim() : "";
    var step = Number.parseInt(delta, 10);
    if (!targetSlug || !Number.isFinite(step) || step === 0) {
      return;
    }

    var cart = readCart();
    var item = cart.find(function findCartItem(entry) {
      return entry.slug === targetSlug;
    });

    if (!item) {
      return;
    }

    setCartItemQuantity(targetSlug, item.quantity + step);
  }

  function removeCartItem(slug) {
    var cart = readCart().filter(function filterItem(item) {
      return item.slug !== slug;
    });

    writeCart(cart);
  }

  function saveCheckoutDraft(draft) {
    window.localStorage.setItem(CHECKOUT_DRAFT_KEY, JSON.stringify(draft || {}));
  }

  function readCheckoutDraft() {
    try {
      var raw = window.localStorage.getItem(CHECKOUT_DRAFT_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (error) {
      return {};
    }
  }

  function clearCheckoutDraft() {
    window.localStorage.removeItem(CHECKOUT_DRAFT_KEY);
  }

  function sanitizeLegacyCommerceNodes() {
    document.querySelectorAll("a.navigation-item.cart-icon").forEach(function patchLink(link) {
      link.setAttribute("href", "/checkout");
    });

    document.querySelectorAll(".w-commerce-commercecartwrapper").forEach(function removeWrapper(wrapper) {
      wrapper.remove();
    });
  }

  function ensureCustomStyles() {
    if (document.getElementById("vr-custom-commerce-styles")) {
      return;
    }

    var style = document.createElement("style");
    style.id = "vr-custom-commerce-styles";
    style.textContent = [
      "body.vr-page-checkout .w-commerce-commercecheckoutformcontainer.full-width-form{background:linear-gradient(180deg,#f4f7fb 0%,#eef3f8 100%);border-top:1px solid #dbe3ec;border-bottom:1px solid #dbe3ec;padding:34px 18px 52px;}",
      "body.vr-page-order-confirmation .w-commerce-commerceorderconfirmationcontainer{background:linear-gradient(180deg,#f4f7fb 0%,#eef3f8 100%);padding:34px 18px 52px;}",
      ".vr-lang-switch{position:relative;display:inline-flex;align-items:center;margin-left:12px;margin-right:auto;}",
      ".vr-lang-switch-select{appearance:none;-webkit-appearance:none;box-sizing:border-box;min-width:102px;height:60px;padding:4px 28px 4px 6px;border:none;border-radius:0;background-color:transparent;color:var(--vr-lang-color,#111827);-webkit-text-fill-color:var(--vr-lang-color,#111827);accent-color:#de0000;font-size:20px;font-weight:700;line-height:1;letter-spacing:.04em;text-transform:uppercase;cursor:pointer;transition:color .2s ease,opacity .2s ease;}",
      ".vr-lang-switch-select:focus{outline:none;}",
      ".vr-lang-switch-select:focus-visible{outline:2px solid rgba(29,79,145,.35);outline-offset:2px;border-radius:4px;}",
      ".vr-lang-switch-chevron{pointer-events:none;position:absolute;right:5px;top:50%;width:20px;height:20px;transform:translateY(-50%);color:var(--vr-lang-color,#111827);opacity:.8;}",
      ".vr-lang-switch-chevron svg{display:block;width:100%;height:100%;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}",
      "@media (max-width:991px){:root{--vr-mobile-nav-height:94px;}.navigation.w-nav{position:fixed;top:0;left:0;right:0;height:var(--vr-mobile-nav-height);z-index:1000;padding:0;background-color:rgba(255,255,255,.86);-webkit-backdrop-filter:blur(9px);backdrop-filter:blur(9px);border-bottom:1px solid rgba(15,23,42,.08);box-shadow:0 8px 24px rgba(15,23,42,.06);}.navigation .navigation-items{position:relative;justify-content:center;align-items:center;height:var(--vr-mobile-nav-height);min-height:var(--vr-mobile-nav-height);padding:0 6px;background:transparent;}.navigation .navigation-items>a.logo-link.w-nav-brand{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);margin:0;padding:0;z-index:3;}.navigation .navigation-items>.vr-lang-switch{position:absolute;left:6px;top:50%;transform:translateY(-50%);margin:0;z-index:4;}.navigation .navigation-items>.navigation-wrap{position:absolute;right:6px;top:50%;transform:translateY(-50%);display:flex;align-items:center;margin:0;z-index:4;}.navigation .navigation-items>.navigation-wrap>.menu-button.w-nav-button,.navigation .navigation-items>.navigation-wrap>.menu-button.w-nav-button.w--open{display:flex!important;align-items:center;justify-content:center;width:52px;height:52px;position:relative;float:none;right:auto;top:auto;transform:none;margin:0;padding:0;background:transparent;color:#111827;border-radius:12px;}.navigation .navigation-items>.navigation-wrap>.menu-button.w-nav-button .menu-icon,.navigation .navigation-items>.navigation-wrap>.menu-button.w-nav-button.w--open .menu-icon{display:block!important;width:24px;height:auto;}.navigation .navigation-wrap>nav.w-nav-menu,.navigation .w-nav-overlay,.navigation [data-nav-menu-open]{display:none!important;}.vr-lang-switch-select{height:54px;min-width:92px;padding:4px 24px 4px 4px;font-size:17px;}.vr-lang-switch-chevron{right:4px;width:17px;height:17px;}body{padding-top:var(--vr-mobile-nav-height);}.section.cc-store-home-wrap{margin-top:0!important;padding-top:0!important;}}",
      "@media (max-width:991px){body{padding-top:var(--vr-mobile-nav-height);padding-bottom:calc(92px + env(safe-area-inset-bottom));}.navigation .navigation-items>.navigation-wrap{position:absolute;right:6px;top:0;bottom:0;transform:none;display:flex;align-items:center;margin:0;z-index:4;}.navigation .navigation-wrap>nav.w-nav-menu{display:flex!important;position:relative;left:auto;right:auto;top:auto;bottom:auto;width:auto;min-width:0;height:auto;max-height:none;padding:0;margin:0;background:transparent!important;box-shadow:none!important;overflow:visible;align-items:center;justify-content:flex-end;}.navigation .navigation-wrap>nav.w-nav-menu>a.navigation-item:not(.cart-icon){display:none!important;}.navigation .navigation-wrap [data-vr-cart-admin-wrap]{display:inline-flex;align-items:center;}.navigation .navigation-wrap [data-vr-cart-admin-wrap]>.vr-admin-link{display:none!important;}.navigation .navigation-wrap>nav.w-nav-menu>.div-block-6,.navigation .navigation-wrap [data-vr-cart-admin-wrap]>.div-block-6{position:relative;display:inline-flex!important;align-items:center;justify-content:center;width:58px;height:58px;min-height:58px;padding:0;border-radius:14px;gap:0;background:rgba(255,255,255,.82);border:1px solid rgba(148,163,184,.32);box-shadow:0 8px 18px rgba(15,23,42,.14);}.navigation .navigation-wrap>nav.w-nav-menu>.div-block-6 .navigation-item.cart-icon,.navigation .navigation-wrap [data-vr-cart-admin-wrap]>.div-block-6 .navigation-item.cart-icon{position:absolute;inset:0;opacity:0;margin:0!important;padding:0!important;font-size:0!important;line-height:0!important;min-width:0!important;}.navigation .navigation-wrap>nav.w-nav-menu>.div-block-6 .image-3,.navigation .navigation-wrap [data-vr-cart-admin-wrap]>.div-block-6 .image-3{width:30px;height:30px;}.navigation .navigation-wrap>nav.w-nav-menu>.div-block-6:hover,.navigation .navigation-wrap [data-vr-cart-admin-wrap]>.div-block-6:hover{transform:none;}.navigation .navigation-wrap>nav.w-nav-menu>.div-block-6 .vr-cart-icon-wrap,.navigation .navigation-wrap [data-vr-cart-admin-wrap]>.div-block-6 .vr-cart-icon-wrap{position:relative;display:inline-flex;align-items:center;justify-content:center;}.navigation .navigation-wrap>nav.w-nav-menu>.div-block-6 .vr-cart-count-badge,.navigation .navigation-wrap [data-vr-cart-admin-wrap]>.div-block-6 .vr-cart-count-badge{top:-6px;right:-7px;}.navigation .navigation-items>.navigation-wrap>.menu-button.w-nav-button,.navigation .navigation-items>.navigation-wrap>.menu-button.w-nav-button.w--open{position:fixed!important;left:50%!important;right:auto!important;top:auto!important;bottom:calc(12px + env(safe-area-inset-bottom));transform:translateX(-50%)!important;width:68px;height:68px;border-radius:999px;background:#0f172a!important;color:#fff!important;box-shadow:0 14px 34px rgba(15,23,42,.42);z-index:1005;}.navigation .navigation-items>.navigation-wrap>.menu-button.w-nav-button .menu-icon,.navigation .navigation-items>.navigation-wrap>.menu-button.w-nav-button.w--open .menu-icon{width:26px;height:auto;filter:brightness(0) invert(1);}.navigation .navigation-items>.navigation-wrap>.menu-button.w-nav-button.w--open,.navigation.w-nav.vr-mobile-menu-open .navigation-items>.navigation-wrap>.menu-button.w-nav-button{background:#1f2937!important;}}",
      ".vr-mobile-bottom-menu-button{display:none;-webkit-appearance:none;appearance:none;-webkit-tap-highlight-color:transparent;outline:none;}",
      ".vr-mobile-bottom-menu-button .vr-mobile-bottom-menu-icon{display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;}",
      ".vr-mobile-bottom-menu-button .vr-mobile-bottom-menu-icon svg{display:block;width:100%;height:100%;fill:none;stroke:currentColor;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;}",
      ".navigation .menu-button.w-nav-button,.vr-mobile-bottom-menu-button{-webkit-tap-highlight-color:transparent;}",
      ".navigation .menu-button.w-nav-button:focus,.navigation .menu-button.w-nav-button:focus-visible,.vr-mobile-bottom-menu-button:focus,.vr-mobile-bottom-menu-button:focus-visible{outline:none!important;box-shadow:none!important;}",
      "@media (max-width:991px){.navigation .menu-button.w-nav-button,.navigation .menu-button.w-nav-button.w--open{display:none!important;}.vr-mobile-bottom-menu-button{position:fixed;left:50%;right:auto;top:auto;bottom:calc(12px + env(safe-area-inset-bottom));transform:translateX(-50%);display:inline-flex!important;align-items:center;justify-content:center;width:68px;height:68px;border:none;border-radius:999px;padding:0;background:#0f172a;color:#fff;box-shadow:0 14px 34px rgba(15,23,42,.42);cursor:pointer;z-index:1006;}.vr-mobile-bottom-menu-button.w--open{background:#1f2937;}}",
      "@media (max-width:991px){.vr-mobile-nav-menu-sheet{bottom:calc(92px + env(safe-area-inset-bottom));max-height:min(calc(82dvh - 96px),640px);padding-bottom:calc(12px + env(safe-area-inset-bottom));border-radius:18px;}}",
      "@media (max-width:991px){.vr-mobile-nav-menu-sheet{bottom:calc(92px + env(safe-area-inset-bottom))!important;max-height:min(calc(82dvh - 96px),640px)!important;padding-bottom:calc(12px + env(safe-area-inset-bottom))!important;border-radius:18px!important;}}",
      "@media (max-width:991px){.navigation .navigation-wrap>nav.w-nav-menu>.div-block-6,.navigation .navigation-wrap [data-vr-cart-admin-wrap]>.div-block-6{background:transparent!important;border:0!important;box-shadow:none!important;}.navigation .navigation-wrap>nav.w-nav-menu>.div-block-6 .image-3,.navigation .navigation-wrap [data-vr-cart-admin-wrap]>.div-block-6 .image-3{filter:none!important;padding-left:0!important;padding-right:0!important;}}",
      "@media (min-width:992px){.vr-mobile-bottom-menu-button{display:none!important;}}",
      ".vr-mobile-nav-menu-root{position:fixed;inset:0;display:none;pointer-events:none;z-index:1002;}",
      ".vr-mobile-nav-menu-root.is-open{display:block;pointer-events:auto;}",
      ".vr-mobile-nav-menu-backdrop{position:absolute;inset:0;border:none;background:rgba(15,23,42,.34);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);opacity:0;transition:opacity .24s ease;}",
      ".vr-mobile-nav-menu-root.is-open .vr-mobile-nav-menu-backdrop{opacity:1;}",
      ".vr-mobile-nav-menu-sheet{position:absolute;left:0;right:0;bottom:0;max-height:min(82dvh,640px);overflow:auto;background:#fff;border-radius:20px 20px 0 0;box-shadow:0 -24px 54px rgba(15,23,42,.24);padding:16px 0 calc(24px + env(safe-area-inset-bottom));transform:translateY(106%);transition:transform .34s cubic-bezier(.22,.61,.36,1);}",
      ".vr-mobile-nav-menu-root.is-open .vr-mobile-nav-menu-sheet{transform:translateY(0);}",
      ".vr-mobile-nav-menu-list{display:block;}",
      ".vr-mobile-nav-menu-link{position:relative;display:flex;align-items:center;gap:12px;padding:16px 24px;color:#0f172a;text-decoration:none;background:#fff;font-weight:700;line-height:1.3;text-transform:uppercase;letter-spacing:.03em;}",
      ".vr-mobile-nav-menu-icon{display:inline-flex;align-items:center;justify-content:center;flex:0 0 22px;width:22px;height:22px;color:#0f172a;}",
      ".vr-mobile-nav-menu-icon svg{display:block;width:100%;height:100%;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}",
      ".vr-mobile-nav-menu-label{display:block;min-width:0;}",
      ".vr-mobile-nav-menu-cart-badge{margin-left:auto;display:inline-flex;align-items:center;justify-content:center;min-width:20px;height:20px;padding:0 6px;border-radius:999px;background:#e11d48;color:#fff;font-size:11px;font-weight:700;line-height:1;letter-spacing:.01em;}",
      ".vr-mobile-nav-menu-link--cart{padding-right:40px;}",
      ".vr-mobile-nav-menu-link:hover,.vr-mobile-nav-menu-link:active,.vr-mobile-nav-menu-link.is-current{background:#f8fafc;color:#0f172a;}",
      "body.vr-mobile-menu-open{overflow:hidden;}",
      "@media (min-width:992px){.vr-mobile-nav-menu-root{display:none!important;}}",
      ".vr-checkout-layout{display:grid;gap:20px;align-items:start;}",
      ".vr-checkout-layout > div{display:grid;gap:16px;min-width:0;}",
      "@media (min-width:992px){.vr-checkout-layout{grid-template-columns:minmax(0,1fr) 350px;gap:24px;}}",
      ".vr-card{background:#fff;border:1px solid #d9e1ec;border-radius:16px;padding:20px;box-shadow:0 14px 34px rgba(15,23,42,.06);}",
      ".vr-card + .vr-card{margin-top:0;}",
      ".vr-card .heading-jumbo-tiny{margin:0 0 12px;line-height:1.25;font-size:18px;letter-spacing:.03em;color:#0f172a;}",
      ".vr-checkout-cart-card{padding:16px 16px 20px;}",
      ".vr-checkout-cart-card .heading-jumbo-tiny{margin-bottom:14px;font-size:15px;letter-spacing:.1em;color:#334155;}",
      "#vr-checkout-items{display:grid;row-gap:12px;padding-bottom:2px;}",
      ".vr-cart-row{display:grid;grid-template-columns:minmax(0,1fr) 24px 64px auto;gap:12px;align-items:center;padding:14px 0;border-bottom:1px solid #e9eef5;}",
      ".vr-cart-row:last-child{border-bottom:none;padding-bottom:4px;}",
      ".vr-checkout-item-row{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:14px;border:1px solid #dbe4f0;border-radius:14px;background:linear-gradient(180deg,#fff 0%,#f8fbff 100%);box-shadow:0 10px 20px rgba(15,23,42,.05);margin-bottom:0;}",
      ".vr-checkout-item-row .vr-cart-item-head{flex:1 1 auto;min-width:0;}",
      ".vr-checkout-item-actions{display:flex;align-items:center;gap:10px;flex:0 0 auto;}",
      ".vr-cart-item-head{display:flex;gap:12px;align-items:center;min-width:0;}",
      ".vr-cart-item-info{display:grid;gap:4px;min-width:0;}",
      ".vr-cart-item-line{display:flex;align-items:flex-start;gap:10px;}",
      ".vr-cart-item-unit-price .vr-cart-price-current,.vr-cart-drawer-item-unit .vr-cart-price-current,.vr-cart-row-total .vr-cart-price-current{color:#1d4ed8;font-weight:700;}",
      ".vr-cart-item-unit-price .vr-cart-price-compare,.vr-cart-drawer-item-unit .vr-cart-price-compare,.vr-cart-row-total .vr-cart-price-compare{display:inline-block;margin-left:8px;color:#98a2b3;font-weight:500;text-decoration:line-through;text-decoration-thickness:2px;white-space:nowrap;}",
      ".vr-cart-item-image{width:74px;height:74px;border-radius:12px;background:#fff;border:1px solid #dbe2ec;flex:0 0 auto;overflow:hidden;display:flex;align-items:center;justify-content:center;}",
      ".vr-cart-item-image-img{width:100%;height:100%;object-fit:contain;display:block;}",
      ".vr-cart-item-image-btn{padding:0;cursor:zoom-in;transition:transform .16s ease,box-shadow .16s ease;}",
      ".vr-cart-item-image-btn:hover{transform:translateY(-1px);box-shadow:0 10px 18px rgba(15,23,42,.12);}",
      ".vr-cart-item-image-btn:focus-visible{outline:2px solid #1d4f91;outline-offset:2px;}",
      "body.vr-cart-image-preview-open{overflow:hidden;}",
      ".vr-cart-image-preview{position:fixed;inset:0;z-index:10070;display:none;}",
      ".vr-cart-image-preview.is-open{display:block;}",
      ".vr-cart-image-preview-backdrop{position:absolute;inset:0;border:none;background:rgba(15,23,42,.74);cursor:zoom-out;}",
      ".vr-cart-image-preview-dialog{position:relative;display:grid;place-items:center;min-height:100%;padding:22px 14px;}",
      ".vr-cart-image-preview-panel{position:relative;max-width:min(920px,96vw);max-height:92vh;background:#fff;border:1px solid #e4e9f2;border-radius:14px;padding:12px 12px 10px;box-shadow:0 24px 48px rgba(15,23,42,.35);display:grid;gap:8px;}",
      ".vr-cart-image-preview-media{display:block;max-width:min(880px,92vw);max-height:78vh;width:auto;height:auto;object-fit:contain;border-radius:10px;background:#f8fafc;}",
      ".vr-cart-image-preview-caption{margin:0;font-size:14px;line-height:1.4;color:#334155;}",
      ".vr-cart-image-preview-close{position:absolute;top:8px;right:8px;display:inline-flex;align-items:center;justify-content:center;width:36px;height:36px;border:none;border-radius:0;background:transparent;color:#111827;font-size:26px;line-height:1;cursor:pointer;}",
      ".vr-cart-image-preview-close:hover{background:transparent;color:#475467;}",
      ".vr-cart-image-preview-close:focus-visible{outline:2px solid #1d4f91;outline-offset:2px;}",
      "body.vr-product-quick-view-open{overflow:hidden;}",
      ".vr-product-quick-view-modal{position:fixed;inset:0;z-index:9997;display:none;}",
      ".vr-product-quick-view-modal.is-open{display:block;}",
      ".vr-product-quick-view-modal.is-open .vr-product-quick-view-backdrop{animation:vr-quick-view-backdrop-in .34s cubic-bezier(.2,.72,.2,1) both;}",
      ".vr-product-quick-view-modal.is-open .vr-product-quick-view-panel{animation:vr-quick-view-panel-pop .46s cubic-bezier(.16,.88,.22,1.24) both;transform-origin:50% 52%;will-change:transform,opacity,box-shadow;}",
      ".vr-product-quick-view-backdrop{position:absolute;inset:0;border:none;background:rgba(15,23,42,.62);backdrop-filter:saturate(1.06) blur(0);-webkit-backdrop-filter:saturate(1.06) blur(0);}",
      ".vr-product-quick-view-dialog{position:relative;display:grid;place-items:center;min-height:100%;padding:14px 10px;perspective:1300px;}",
      ".vr-product-quick-view-panel{position:relative;width:min(var(--vr-product-quick-view-panel-width,1360px),96vw,calc(92vh * 2));aspect-ratio:2 / 1;height:auto;overflow:hidden;background:#fff;border:1px solid #dbe2ec;border-radius:20px;box-shadow:0 24px 48px rgba(15,23,42,.28);}",
      ".vr-product-quick-view-panel.vr-quick-view-portrait-media{width:min(var(--vr-product-quick-view-panel-width,1360px),96vw);height:var(--vr-product-quick-view-panel-height,auto);aspect-ratio:auto;}",
      "@keyframes vr-quick-view-backdrop-in{0%{opacity:0;backdrop-filter:saturate(1) blur(0);-webkit-backdrop-filter:saturate(1) blur(0);}100%{opacity:1;backdrop-filter:saturate(1.08) blur(3px);-webkit-backdrop-filter:saturate(1.08) blur(3px);}}",
      "@keyframes vr-quick-view-panel-pop{0%{opacity:0;transform:translateY(64px) scale(.78) rotateX(10deg);box-shadow:0 8px 20px rgba(15,23,42,.08);}58%{opacity:1;transform:translateY(-8px) scale(1.045) rotateX(0deg);box-shadow:0 34px 68px rgba(15,23,42,.34);}76%{opacity:1;transform:translateY(2px) scale(.992);}100%{opacity:1;transform:translateY(0) scale(1);box-shadow:0 24px 48px rgba(15,23,42,.28);}}",
      "@media (prefers-reduced-motion: reduce){.vr-product-quick-view-modal.is-open .vr-product-quick-view-backdrop,.vr-product-quick-view-modal.is-open .vr-product-quick-view-panel{animation:none!important;}}",
      ".vr-product-quick-view-close{position:absolute;top:20px;right:24px;display:inline-flex;align-items:center;justify-content:center;width:auto;height:auto;border:none;background:transparent;color:var(--vr-product-quick-view-close-color,#0f172a);text-shadow:var(--vr-product-quick-view-close-shadow,none);font-size:44px;font-weight:300;line-height:1;cursor:pointer;z-index:8;padding:0;transition:color .18s ease,text-shadow .18s ease,opacity .18s ease;}",
      ".vr-product-quick-view-close:hover{opacity:.7;transform:none;}",
      ".vr-product-quick-view-close:focus-visible{outline:2px solid rgba(15,23,42,.35);outline-offset:3px;}",
      ".vr-product-quick-view-layout{display:grid;grid-template-columns:minmax(260px,var(--vr-product-quick-view-media-width,1fr)) minmax(0,1fr);height:100%;align-items:stretch;}",
      ".vr-product-quick-view-image{width:100%!important;height:100%!important;min-height:0!important;max-height:none!important;margin:0!important;border-radius:0;background:#eef2f6;background-size:contain!important;background-position:50% 50%!important;background-repeat:no-repeat!important;}",
      ".vr-product-quick-view-image.vr-detail-zoom-enabled{cursor:zoom-in;}",
      ".vr-product-quick-view-image .vr-detail-zoom-lens{position:absolute;left:0;top:0;z-index:4;width:clamp(120px,14vw,172px);height:clamp(120px,14vw,172px);border-radius:999px;border:2px solid rgba(255,255,255,.94);box-shadow:0 12px 30px rgba(15,23,42,.26),0 0 0 1px rgba(15,23,42,.24);background-color:#f8fafc;pointer-events:none;opacity:0;transform:translate(-50%,-50%) scale(.88);transition:opacity .16s ease,transform .16s ease;}",
      ".vr-product-quick-view-image.vr-detail-zoom-active .vr-detail-zoom-lens{opacity:1;transform:translate(-50%,-50%) scale(1);}",
      ".vr-product-quick-view-content{display:grid;align-content:center;gap:14px;height:100%;padding:28px 38px 24px 32px;overflow:auto;}",
      ".vr-product-quick-view-main{display:grid;gap:10px;}",
      ".vr-product-quick-view-main .product-detail-name{margin:0;}",
      ".vr-product-quick-view-main .product-detail-price{margin:0;}",
      ".vr-product-quick-view-main .paragraph-light{margin:0;line-height:1.6;}",
      ".vr-product-quick-view-price .vr-product-price-whole{font-size:36px;}",
      ".vr-product-quick-view-price .vr-product-price-cents{font-size:18px;transform:translateY(-7px);}",
      ".vr-product-quick-view-name,.vr-product-quick-view-price,.vr-product-quick-view-description{min-height:0;}",
      ".vr-product-quick-view-skeleton-line{display:block;border-radius:9px;}",
      ".vr-product-quick-view-skeleton-name{height:44px;width:min(94%,24ch);}",
      ".vr-product-quick-view-skeleton-price{height:42px;width:min(66%,15ch);}",
      ".vr-product-quick-view-description .vr-product-quick-view-skeleton-copy{height:16px;width:100%;margin-top:8px;}",
      ".vr-product-quick-view-description .vr-product-quick-view-skeleton-copy:first-child{margin-top:0;}",
      ".vr-product-quick-view-description .vr-product-quick-view-skeleton-copy.short{width:82%;}",
      ".vr-product-quick-view-form-skeleton{display:grid;gap:10px;}",
      ".vr-product-quick-view-skeleton-label{display:block;height:11px;width:86px;border-radius:7px;}",
      ".vr-product-quick-view-form-skeleton-controls{display:grid;grid-template-columns:96px minmax(0,1fr);gap:10px;align-items:center;}",
      ".vr-product-quick-view-skeleton-input{display:block;height:46px;border-radius:10px;}",
      ".vr-product-quick-view-skeleton-btn{display:block;height:48px;border-radius:10px;}",
      ".vr-product-quick-view-status{margin-top:2px;}",
      ".vr-product-quick-view-cart-host{background:transparent!important;border-radius:0!important;padding:0!important;font-weight:inherit!important;}",
      ".vr-product-quick-view-cart-host .vr-detail-form{gap:10px;}",
      ".vr-product-quick-view-cart-host .vr-detail-controls{gap:10px;}",
      "@media (hover: none), (pointer: coarse){.vr-product-quick-view-image .vr-detail-zoom-lens{display:none!important;}}",
      "@media (max-width:991px){.vr-product-quick-view-dialog{padding:14px 10px;}.vr-product-quick-view-panel,.vr-product-quick-view-panel.vr-quick-view-portrait-media{width:min(860px,100%);height:auto;max-height:94vh;aspect-ratio:auto;border-radius:16px;}.vr-product-quick-view-layout{grid-template-columns:minmax(0,1fr);height:auto;}.vr-product-quick-view-image{width:100%!important;height:320px!important;min-height:320px!important;}.vr-product-quick-view-content{align-content:start;height:auto;padding:18px 18px 18px;gap:12px;}.vr-product-quick-view-close{top:14px;right:16px;font-size:34px;}.vr-product-quick-view-form-skeleton-controls{grid-template-columns:minmax(0,110px) minmax(0,1fr);}}",
      "@media (max-width:767px){.vr-product-quick-view-dialog{padding:6px;}.vr-product-quick-view-panel,.vr-product-quick-view-panel.vr-quick-view-portrait-media{width:100%;height:calc(100dvh - 12px);max-height:none;}.vr-product-quick-view-layout{height:100%;grid-template-rows:auto minmax(0,1fr);}.vr-product-quick-view-image{height:clamp(210px,34vh,320px)!important;min-height:clamp(210px,34vh,320px)!important;}.vr-product-quick-view-content{display:grid;grid-template-rows:minmax(0,1fr) auto auto;align-content:stretch;height:100%;min-height:0;overflow:hidden;padding:16px 16px calc(18px + env(safe-area-inset-bottom));gap:10px;}.vr-product-quick-view-main{display:grid;grid-template-rows:auto auto minmax(0,1fr);gap:8px;min-height:0;}.vr-product-quick-view-main .product-detail-name{font-size:clamp(18px,6.8vw,30px);line-height:1.18;}.vr-product-quick-view-main .paragraph-light{font-size:clamp(14px,3.8vw,18px);line-height:1.5;max-height:none;min-height:0;overflow:auto;padding-right:4px;}.vr-product-quick-view-price .vr-product-price-whole{font-size:28px;}.vr-product-quick-view-price .vr-product-price-cents{font-size:14px;transform:translateY(-4px);}.vr-product-quick-view-skeleton-name{height:36px;width:min(95%,18ch);}.vr-product-quick-view-skeleton-price{height:32px;width:min(74%,13ch);}.vr-product-quick-view-description .vr-product-quick-view-skeleton-copy{height:14px;}.vr-product-quick-view-content .divider{margin:0;}.vr-product-quick-view-cart-host{position:relative;z-index:2;background:#fff;}.vr-product-quick-view-status{display:none;}.vr-product-quick-view-form-skeleton-controls,.vr-product-quick-view-cart-host .vr-detail-form .vr-detail-controls{display:grid!important;grid-template-columns:1fr;gap:8px;align-items:stretch;}.vr-product-quick-view-skeleton-input,.vr-product-quick-view-cart-host .vr-detail-form .vr-detail-controls input[type='number']{width:100%!important;max-width:none!important;height:46px!important;}.vr-product-quick-view-skeleton-btn,.vr-product-quick-view-cart-host .vr-detail-form .vr-detail-controls .primary-button{width:100%!important;min-height:48px;}.vr-product-quick-view-close{top:12px;right:12px;font-size:32px;}}",
      "@media (max-width:479px){.vr-product-quick-view-dialog{padding:0;}.vr-product-quick-view-panel,.vr-product-quick-view-panel.vr-quick-view-portrait-media{width:100vw;height:100dvh;max-height:none;aspect-ratio:auto;border-radius:0;border:none;}.vr-product-quick-view-layout{height:100%;grid-template-rows:auto minmax(0,1fr);}.vr-product-quick-view-image{width:100%!important;height:auto!important;min-height:0!important;aspect-ratio:1 / 1;border-radius:0;background-size:contain!important;background-position:50% 50%!important;}.vr-product-quick-view-content{padding:12px 14px calc(14px + env(safe-area-inset-bottom));gap:10px;}.vr-product-quick-view-main .product-detail-name{font-size:clamp(17px,7.4vw,25px);line-height:1.18;}.vr-product-quick-view-main .paragraph-light{font-size:clamp(13px,4.4vw,16px);}.vr-product-quick-view-close{top:12px;right:14px;font-size:30px;}}",
      ".vr-cart-item-name{font-weight:700;line-height:1.25;font-size:16px;}",
      ".vr-cart-qty{appearance:textfield;-moz-appearance:textfield;width:56px!important;min-width:56px;max-width:56px;height:38px!important;min-height:38px!important;margin:0!important;padding:0 8px!important;border:1px solid #d0d5dd!important;border-radius:10px!important;background:#fff!important;color:#111827;font-size:16px!important;line-height:1!important;text-align:center;font-weight:600;}",
      ".vr-cart-qty::-webkit-outer-spin-button,.vr-cart-qty::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}",
      ".vr-cart-remove-btn{display:inline-flex;align-items:center;justify-content:center;justify-self:center;flex:0 0 auto;width:32px;height:32px;min-width:32px;min-height:32px;border:none;border-radius:0;background:transparent;color:#667085;cursor:pointer!important;pointer-events:auto;position:relative;z-index:2;-webkit-appearance:none;appearance:none;font-size:22px;line-height:1;padding:0;transition:color .2s ease;}",
      ".vr-cart-remove-btn:hover{color:#be123c;background:transparent;cursor:pointer!important;}",
      ".vr-cart-remove-btn:focus-visible{outline:none;color:#be123c;cursor:pointer!important;}",
      ".vr-cart-row-total{font-weight:800;color:#0f172a;font-size:20px;white-space:nowrap;}",
      ".vr-checkout-item-actions .vr-cart-remove-btn{width:30px;height:30px;border-radius:0;background:transparent;color:#667085;}",
      ".vr-checkout-item-actions .vr-cart-remove-btn:hover{background:transparent;color:#b42318;transform:none;}",
      ".vr-checkout-item-actions .vr-cart-row-total{font-size:19px;min-width:130px;text-align:right;padding-left:8px;}",
      ".vr-summary-row{display:grid;grid-template-columns:minmax(148px,40%) minmax(0,1fr);column-gap:18px;align-items:start;padding:8px 0;font-size:15px;line-height:1.35;color:#344054;}",
      ".vr-summary-row>:first-child{min-width:0;}",
      ".vr-summary-row>:last-child{min-width:0;justify-self:end;text-align:right;}",
      ".vr-summary-subtotal{font-weight:600;color:#1f2937;}",
      ".vr-summary-total{font-weight:800;border-top:1px solid #e9eef5;padding-top:14px;margin-top:8px;color:#0f172a;font-size:20px;}",
      ".vr-form-grid{display:grid;gap:12px;}",
      ".vr-form-grid > div{min-width:0;}",
      "@media (min-width:768px){.vr-form-grid.cols-2{grid-template-columns:repeat(2,minmax(0,1fr));column-gap:14px;}}",
      ".vr-form-grid .text-field{width:100%;height:46px!important;min-height:46px!important;margin:0!important;padding:0 14px!important;border:1px solid #d0d5dd!important;border-radius:10px!important;background:#fff!important;line-height:1.2!important;font-size:15px!important;transition:border-color .2s ease,box-shadow .2s ease;}",
      ".vr-form-grid .text-field::placeholder{color:#98a2b3;}",
      ".vr-form-grid .text-field:hover{border-color:#b7c3d4!important;}",
      ".vr-form-grid .text-field:focus,.vr-form-grid .text-field.-wfp-focus{outline:none;border-color:#1d4f91!important;box-shadow:0 0 0 3px rgba(29,79,145,.16);}",
      ".vr-form-grid .text-field[aria-invalid='true']{border-color:#d92d20!important;box-shadow:0 0 0 3px rgba(217,45,32,.14)!important;}",
      ".vr-form-grid .text-field.vr-fixed-field,.vr-form-grid .text-field.vr-fixed-field:hover,.vr-form-grid .text-field.vr-fixed-field:focus,.vr-form-grid .text-field.vr-fixed-field.-wfp-focus{border-color:#d0d5dd!important;background:#f3f6fa!important;box-shadow:none!important;cursor:default!important;pointer-events:none!important;}",
      ".vr-form-grid .text-field.vr-fixed-field:disabled{opacity:1!important;color:#475467!important;-webkit-text-fill-color:#475467!important;}",
      ".vr-feedback{margin-top:6px;font-size:13px;line-height:1.35;}",
      ".vr-feedback.info{color:#475467;}",
      ".vr-feedback.error{color:#b42318;}",
      ".vr-feedback.success{color:#027a48;}",
      ".vr-field-error{font-size:12px;line-height:1.35;color:#b42318;margin-top:6px;}",
      ".vr-empty{padding:16px;border:1px dashed #c7d3e3;border-radius:12px;background:#f8fbff;}",
      ".vr-empty p{margin:0 0 14px;font-size:20px;line-height:1.35;}",
      ".vr-empty .primary-button{width:100%;min-height:56px;padding:0 18px;border-radius:10px;font-size:17px;}",
      ".vr-checkout-layout > aside.vr-card{position:sticky;top:24px;}",
      ".vr-checkout-layout .primary-button{display:inline-flex!important;align-items:center;justify-content:center;min-height:48px;padding:0 16px;border-radius:12px;}",
      "#vr-place-order{width:100%;margin-top:4px;}",
      "@media (max-width:991px){.vr-checkout-layout > aside.vr-card{position:static;}}",
      "@media (max-width:767px){body.vr-page-checkout .w-commerce-commercecheckoutformcontainer.full-width-form,body.vr-page-order-confirmation .w-commerce-commerceorderconfirmationcontainer{padding:22px 10px 34px;}.vr-card{padding:16px;border-radius:14px;}.vr-checkout-layout>div{display:contents;}.vr-checkout-layout .vr-checkout-cart-card{order:1;}.vr-checkout-layout .vr-checkout-summary-card{order:2;}.vr-checkout-layout .vr-checkout-details-card{order:3;}.vr-checkout-item-row{display:block;padding:12px;}.vr-checkout-item-actions{margin-top:10px;justify-content:flex-end;}.vr-checkout-item-actions .vr-cart-row-total{font-size:18px;min-width:auto;}.vr-cart-item-name{font-size:15px;}.vr-cart-item-image{width:64px;height:64px;}.vr-cart-qty{width:52px!important;min-width:52px;max-width:52px;height:34px!important;min-height:34px!important;font-size:15px!important;}.vr-checkout-layout .primary-button{width:100%;}.vr-cart-image-preview-dialog{padding:14px 10px;}.vr-cart-image-preview-panel{width:100%;max-width:100%;padding:10px;}.vr-cart-image-preview-media{max-width:100%;max-height:72vh;}}",
      ".vr-detail-cart-host{background:transparent!important;border-radius:0!important;padding:0!important;}",
      ".vr-detail-form{display:grid;gap:12px;}",
      ".vr-detail-form .vr-detail-controls{display:flex;gap:10px;flex-wrap:wrap;align-items:center;}",
      ".vr-detail-form input[type='number']{width:96px;}",
      ".vr-detail-form .primary-button,.vr-checkout-layout .primary-button,.vr-empty .primary-button{display:inline-flex!important;align-items:center;justify-content:center;}",
      ".vr-detail-form .primary-button{border-radius:10px;gap:8px;}",
      ".vr-detail-form .cc-add-to-cart-btn,.vr-detail-form .vr-buy-now-btn{margin:0!important;border:none;cursor:pointer;}",
      ".vr-detail-form .cc-add-to-cart-btn.w--disabled,.vr-detail-form .vr-buy-now-btn.w--disabled{opacity:.56;pointer-events:none;box-shadow:none;cursor:default;}",
      ".vr-detail-form .cc-add-to-cart-btn::before,.vr-detail-form .vr-buy-now-btn::before{content:'';display:inline-block;width:14px;height:14px;flex:0 0 14px;background-repeat:no-repeat;background-position:50% 50%;background-size:14px 14px;}",
      ".vr-detail-form .cc-add-to-cart-btn::before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M12 5v14'/%3E%3Cpath d='M5 12h14'/%3E%3C/svg%3E\");}",
      ".vr-detail-form .vr-buy-now-btn::before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='9' cy='20' r='1.4'/%3E%3Ccircle cx='18' cy='20' r='1.4'/%3E%3Cpath d='M3 4h2l2.2 10.2a1 1 0 0 0 1 .8h9.6a1 1 0 0 0 1-.8L20 8H6.2'/%3E%3C/svg%3E\");}",
      ".vr-cart-drawer-root{position:fixed;inset:0;pointer-events:none;z-index:9998;}",
      ".vr-cart-drawer-backdrop{position:absolute;inset:0;border:none;opacity:0;background:rgba(17,24,39,.45);transition:opacity .22s ease;}",
      ".vr-cart-drawer{position:absolute;top:0;right:0;width:min(430px,100vw);height:100%;background:#f8fafc;display:flex;flex-direction:column;transform:translateX(108%);transition:transform .28s cubic-bezier(.2,.8,.2,1),box-shadow .28s ease;box-shadow:-16px 0 32px rgba(15,23,42,.08);}",
      "body.vr-cart-drawer-open{overflow:hidden;}",
      "body.vr-cart-drawer-open .vr-cart-drawer-root{pointer-events:auto;}",
      "body.vr-cart-drawer-open .vr-cart-drawer-backdrop{opacity:1;}",
      "body.vr-cart-drawer-open .vr-cart-drawer{transform:translateX(0);box-shadow:-20px 0 42px rgba(15,23,42,.22);}",
      ".vr-cart-drawer.vr-cart-drawer-fly-in{animation:vrCartDrawerFlyIn .38s cubic-bezier(.2,.8,.2,1);}",
      "@keyframes vrCartDrawerFlyIn{0%{transform:translateX(116%);}70%{transform:translateX(-2.5%);}100%{transform:translateX(0);}}",
      ".vr-fly-to-cart-clone{position:fixed;left:0;top:0;pointer-events:none;border-radius:12px;background-color:#eef2f6;background-size:cover;background-position:50% 50%;background-repeat:no-repeat;box-shadow:0 12px 28px rgba(15,23,42,.22);z-index:10050;will-change:transform,opacity;}",
      ".vr-cart-icon-pop{animation:vrCartIconPop .32s ease;}",
      "@keyframes vrCartIconPop{0%{transform:scale(1);}45%{transform:scale(1.18);}100%{transform:scale(1);}}",
      ".vr-cart-drawer-head{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:16px 18px;border-bottom:1px solid #e5e7eb;background:linear-gradient(180deg,#fff 0%,#f8fafc 100%);}",
      ".vr-cart-drawer-title{margin:0;font-size:20px;line-height:1.2;}",
      ".vr-cart-drawer-close{border:none;background:transparent;cursor:pointer;padding:0;color:#111827;display:inline-flex;align-items:center;justify-content:center;transition:color .2s ease,transform .2s ease;width:32px;height:32px;}",
      ".vr-cart-drawer-close:hover{color:#475467;transform:scale(1.06);}",
      ".vr-cart-drawer-close:focus-visible{outline:none;color:#475467;}",
      ".vr-cart-drawer-close-icon{display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;}",
      ".vr-cart-drawer-close-icon svg{display:block;width:100%;height:100%;stroke:currentColor;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;fill:none;}",
      ".vr-cart-drawer-items{flex:1 1 auto;overflow:auto;padding:14px 16px;background:#f8fafc;}",
      ".vr-cart-drawer-row{background:#fff;border:1px solid #e4e7ec;border-radius:14px;padding:12px;display:grid;grid-template-columns:72px minmax(0,1fr);gap:12px;align-items:flex-start;margin-bottom:10px;}",
      ".vr-cart-drawer-row:last-child{margin-bottom:0;}",
      ".vr-cart-drawer-main{display:grid;gap:10px;min-width:0;}",
      ".vr-cart-drawer-item-top{display:grid;grid-template-columns:minmax(0,1fr) auto;align-items:flex-start;gap:10px;min-width:0;}",
      ".vr-cart-drawer-item-copy{min-width:0;}",
      ".vr-cart-drawer-item-name{font-weight:600;line-height:1.25;}",
      ".vr-cart-drawer-item-unit{font-size:13px;color:#667085;margin-top:4px;}",
      ".vr-cart-drawer-row-meta{display:flex;align-items:center;justify-content:space-between;gap:10px;}",
      ".vr-cart-drawer-qty-stepper{display:inline-flex;align-items:center;gap:6px;padding:3px;border:1px solid #d0d5dd;border-radius:999px;background:#fff;}",
      ".vr-cart-drawer-qty-btn{width:30px;height:30px;min-width:30px;min-height:30px;border:none;border-radius:999px;background:#f2f4f7;color:#111827;display:inline-flex;align-items:center;justify-content:center;font-size:20px;line-height:1;cursor:pointer;transition:background-color .2s ease,color .2s ease;}",
      ".vr-cart-drawer-qty-btn:hover{background:#e4e7ec;}",
      ".vr-cart-drawer-qty-btn:focus-visible{outline:none;background:#dbe3ec;}",
      ".vr-cart-drawer-qty{appearance:textfield;-moz-appearance:textfield;width:40px!important;min-width:40px;max-width:40px;height:30px!important;min-height:30px!important;margin:0!important;padding:0 4px!important;border:none!important;border-radius:8px!important;background:transparent!important;color:#111827;font-size:15px!important;line-height:1!important;text-align:center;font-weight:700;}",
      ".vr-cart-drawer-qty::-webkit-outer-spin-button,.vr-cart-drawer-qty::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}",
      ".vr-cart-drawer-row-total{font-weight:600;}",
      ".vr-cart-drawer-footer{border-top:1px solid #e5e7eb;padding:14px 16px 18px;background:#fff;position:sticky;bottom:0;}",
      ".vr-cart-drawer-footer .primary-button{display:inline-flex!important;align-items:center;justify-content:center;width:100%;margin-top:12px;min-height:102px;border-radius:14px;padding:0 22px;background:#22c55e;color:#fff;box-shadow:0 10px 22px rgba(34,197,94,.34);transition:background-color .2s ease,transform .2s ease,box-shadow .2s ease;will-change:transform;}",
      ".vr-cart-drawer-checkout-btn{display:inline-flex!important;align-items:center;justify-content:center;gap:10px;font-size:22px!important;line-height:1.12!important;font-weight:700;letter-spacing:0;text-transform:none;}",
      ".vr-cart-drawer-checkout-btn::before{content:'';display:inline-block;width:20px;height:20px;flex:0 0 20px;background-repeat:no-repeat;background-position:50% 50%;background-size:20px 20px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='9' cy='20' r='1.5'/%3E%3Ccircle cx='17' cy='20' r='1.5'/%3E%3Cpath d='M3 4h2l2.2 10.2a2 2 0 0 0 2 1.6h7.6a2 2 0 0 0 2-1.6L21 7H7'/%3E%3C/svg%3E\");}",
      ".vr-cart-drawer-footer .primary-button:hover{background:#16a34a;transform:translateY(-2px);box-shadow:0 16px 30px rgba(22,163,74,.4);}",
      ".vr-cart-drawer-footer .primary-button.w--disabled{opacity:.55;pointer-events:none;box-shadow:none;}",
      "@media (max-width:479px){.vr-cart-drawer-head,.vr-cart-drawer-items,.vr-cart-drawer-footer{padding-left:12px;padding-right:12px;}.vr-cart-drawer-row{grid-template-columns:64px minmax(0,1fr);padding:10px;}.vr-cart-item-image{width:64px;height:64px;}.vr-cart-drawer-qty-btn{width:28px;height:28px;min-width:28px;min-height:28px;font-size:18px;}.vr-cart-drawer-qty{width:36px!important;min-width:36px;max-width:36px;height:28px!important;min-height:28px!important;font-size:14px!important;}.vr-cart-drawer-checkout-btn{min-height:92px!important;font-size:20px!important;letter-spacing:0;}.vr-cart-drawer-checkout-btn::before{width:18px;height:18px;flex-basis:18px;background-size:18px 18px;}}",
      ".vr-products-catalog-layout{display:grid;grid-template-columns:minmax(200px,230px) minmax(0,1fr);gap:20px;align-items:start;max-width:1320px;margin:0 auto;padding:0 20px;}",
      ".vr-products-filters-panel{display:grid;gap:12px;align-self:start;position:sticky;top:104px;}",
      ".vr-products-filters-panel .store-categories-wrap{display:block;margin:0;}",
      ".vr-products-filters-panel .collection-list.w-dyn-items{display:grid;gap:8px;justify-content:stretch;}",
      ".vr-products-filters-panel .collection-list.w-dyn-items>.w-dyn-item{width:100%;}",
      ".vr-products-filters-panel .products-category-link{display:block;margin:0;opacity:.86;letter-spacing:.03em;text-transform:none;font-size:14px;line-height:1.3;padding:10px 12px;border:1px solid #e4e7ec;border-radius:10px;background:#fff;color:#111827;transition:background-color .2s ease,border-color .2s ease,color .2s ease;}",
      ".vr-products-filters-panel .products-category-link:hover{opacity:1;background:#f8fafc;border-color:#d0d5dd;}",
      ".vr-products-filters-panel .products-category-link.w--current{opacity:1;color:#fff;background:#111827;border-color:#111827;font-weight:700;}",
      ".vr-products-content-panel{min-width:0;}",
      "@media (max-width:991px){.vr-products-catalog-layout{grid-template-columns:1fr;gap:14px;padding:0 12px;}.vr-products-filters-panel{position:static;}.vr-products-catalog-layout>.vr-products-search-wrap{position:-webkit-sticky;position:sticky;top:calc(var(--vr-mobile-nav-height,94px) + env(safe-area-inset-top) + 6px);z-index:995;align-self:start;max-width:none;margin:0 0 4px;padding:0;border:none;box-shadow:none;background:transparent;grid-template-columns:minmax(0,1fr);gap:0;}.vr-products-catalog-layout>.vr-products-search-wrap .vr-products-search-btn{display:none!important;}.vr-products-catalog-layout>.vr-products-search-wrap .vr-products-search-input{min-height:50px;border:1px solid rgba(15,23,42,.08);border-radius:12px;background-color:rgba(255,255,255,.86);-webkit-backdrop-filter:blur(9px) saturate(1.08);backdrop-filter:blur(9px) saturate(1.08);box-shadow:0 8px 24px rgba(15,23,42,.08);}.vr-products-catalog-layout>.vr-products-search-wrap .vr-products-search-input:focus{border-color:rgba(15,23,42,.22);box-shadow:0 0 0 2px rgba(255,255,255,.5),0 0 0 4px rgba(15,23,42,.16);}.vr-products-catalog-layout>.vr-products-search-wrap .vr-products-search-input-clear:hover{background:transparent;}.vr-products-filters-panel .store-categories-wrap{display:flex;margin-top:0;}.vr-products-filters-panel .collection-list.w-dyn-items{display:flex;flex-wrap:wrap;gap:8px;}.vr-products-filters-panel .collection-list.w-dyn-items>.w-dyn-item{width:auto;}.vr-products-filters-panel .products-category-link{padding:8px 12px;border-radius:999px;}}",
      "@media (max-width:767px){.vr-products-catalog-layout{padding:0 10px;gap:12px;}.vr-products-filters-panel{gap:10px;}.vr-products-filters-panel .store-categories-wrap{display:block;width:100%;}.vr-products-filters-panel .collection-list.w-dyn-items{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;align-items:stretch;}.vr-products-filters-panel .collection-list.w-dyn-items>.w-dyn-item{width:100%;display:flex;align-items:stretch;}.vr-products-filters-panel .products-category-link{display:flex;align-items:center;justify-content:center;text-align:center;border-radius:10px;padding:9px 8px;min-height:72px;width:100%;height:100%;box-sizing:border-box;}}",
      ".vr-products-search-wrap{display:grid;grid-template-columns:minmax(0,1fr) auto;align-items:center;gap:10px;width:100%;max-width:760px;margin:18px auto 6px;padding:10px;border:1px solid #e5e7eb;border-radius:14px;background:#fff;box-shadow:0 8px 20px rgba(15,23,42,.05);}",
      ".vr-products-filters-panel .vr-products-search-wrap{max-width:none;margin:0 0 2px;padding:0;border:none;box-shadow:none;background:transparent;grid-template-columns:minmax(0,1fr);gap:0;}",
      ".vr-products-filters-panel .vr-products-search-btn{display:none!important;}",
      ".vr-products-filters-panel .vr-products-search-input{display:block;width:100%;box-sizing:border-box;}",
      ".vr-products-search-field{position:relative;min-width:0;}",
      ".vr-products-search-input{width:100%;min-height:46px;margin:0!important;padding:0 42px 0 14px;border:1px solid #d0d5dd;border-radius:10px;background:#fff;font-size:16px;line-height:1.25;-webkit-appearance:none;appearance:none;}",
      ".vr-products-search-input::-webkit-search-cancel-button{-webkit-appearance:none;appearance:none;display:none;}",
      ".vr-products-search-input:focus{outline:none;border-color:#111827;box-shadow:0 0 0 3px rgba(17,24,39,.14);}",
      ".vr-products-search-input-clear{position:absolute;right:8px;top:50%;transform:translateY(-50%);display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;border:none;border-radius:0;background:transparent;color:#667085;font-size:20px;line-height:1;cursor:pointer;transition:color .2s ease,opacity .2s ease;}",
      ".vr-products-search-input-clear:hover{background:transparent;color:#111827;}",
      ".vr-products-search-input-clear:focus-visible{outline:none;box-shadow:0 0 0 3px rgba(17,24,39,.2);}",
      ".vr-products-search-btn{border:none;cursor:pointer;min-height:46px;padding:0 18px;border-radius:10px;white-space:nowrap;}",
      ".vr-products-search-wrap[data-has-query='0'] .vr-products-search-input-clear{opacity:0;pointer-events:none;}",
      ".vr-products-search-wrap[data-loading='1'] .vr-products-search-btn{opacity:.68;pointer-events:none;}",
      ".vr-products-feedback{display:none;margin:8px 0 2px;padding:10px 12px;border-radius:10px;border:1px solid #fecaca;background:#fff7f7;color:#b42318;font-size:13px;line-height:1.4;}",
      ".vr-products-feedback.is-visible{display:block;}",
      ".vr-products-wholesale-indicator{display:inline-flex;align-items:center;gap:8px;margin:8px 0 0;padding:7px 8px 7px 12px;border-radius:999px;border:1px solid rgba(124,58,237,.34);background:rgba(124,58,237,.12);color:#6d28d9;font-size:11px;font-weight:800;letter-spacing:.1em;text-transform:uppercase;line-height:1.2;}",
      ".vr-products-wholesale-indicator::before{content:'';width:8px;height:8px;border-radius:999px;background:#7c3aed;box-shadow:0 0 0 4px rgba(124,58,237,.18);}",
      ".vr-products-wholesale-indicator-label{display:inline-flex;align-items:center;min-width:0;}",
      ".vr-products-wholesale-indicator-close{display:inline-flex;align-items:center;justify-content:center;flex:0 0 22px;width:22px;height:22px;padding:0;border:none;border-radius:0;background:transparent;color:#5b21b6;font-size:16px;font-weight:800;line-height:1;cursor:pointer;transition:color .2s ease;}",
      ".vr-products-wholesale-indicator-close:hover{background:transparent;color:#4c1d95;transform:none;}",
      ".vr-products-wholesale-indicator-close:focus-visible{outline:none;box-shadow:0 0 0 3px rgba(91,33,182,.22);}",
      "@media (max-width:767px){.vr-products-search-wrap{grid-template-columns:minmax(0,1fr) auto;gap:8px;padding:0;border:none;box-shadow:none;background:transparent;margin:0;max-width:none;}.vr-products-search-btn{width:auto;min-width:102px;padding:0 14px;}.vr-products-filters-panel .vr-products-search-wrap{grid-template-columns:minmax(0,1fr);gap:0;}.vr-products-filters-panel .vr-products-search-btn{display:none!important;}}",
      "body.vr-page-products .actual-products .collection-wrap.w-dyn-items{display:grid!important;grid-template-columns:repeat(auto-fit,minmax(min(100%,240px),1fr));column-gap:16px;row-gap:18px;align-items:stretch;justify-content:initial;place-content:initial;}",
      "body.vr-page-products .actual-products .collection-wrap.w-dyn-items>.collection-item.w-dyn-item{width:auto!important;max-width:none!important;margin:0!important;padding:0!important;}",
      "@media (max-width:991px){body.vr-page-products .actual-products .collection-wrap.w-dyn-items{column-gap:10px;row-gap:16px;}}",
      "@media (max-width:767px){body.vr-page-products .actual-products .collection-wrap.w-dyn-items{column-gap:10px;row-gap:16px;}}",
      ".vr-products-pagination{display:grid;grid-template-columns:max-content max-content max-content;align-items:center;justify-content:center;column-gap:10px;width:100%;max-width:none;margin:12px 0 2px;}",
      ".vr-products-filters-panel .vr-products-pagination,.vr-products-content-panel .vr-products-pagination{width:100%;max-width:none;margin:12px 0 2px;}",
      ".vr-products-pagination[hidden]{display:none!important;}",
      ".vr-products-page-btn{display:inline-flex!important;align-items:center;justify-content:center;width:52px;min-width:52px;height:52px;min-height:52px;padding:0;border-radius:999px;border:none;background:transparent!important;color:#111827!important;box-shadow:none!important;cursor:pointer;white-space:nowrap;}",
      ".vr-products-page-btn:hover{background:#f2f4f7!important;color:#0f172a!important;}",
      ".vr-products-page-btn.w--disabled,.vr-products-page-btn:disabled{opacity:.45;cursor:not-allowed;pointer-events:none;}",
      ".vr-products-page-icon{display:block;width:20px;height:20px;}",
      ".vr-products-page-status{font-size:26px;font-weight:700;color:#344054;min-width:0;text-align:center;letter-spacing:.01em;}",
      "@media (max-width:767px){.vr-products-pagination{grid-template-columns:max-content max-content max-content;column-gap:6px;}.vr-products-page-btn{width:46px;min-width:46px;height:46px;min-height:46px;}.vr-products-page-icon{width:18px;height:18px;}.vr-products-page-status{font-size:22px;}}",
      ".vr-product-price-row{display:flex;align-items:flex-end;gap:8px;flex-wrap:wrap;padding-left:0;margin-top:0;}",
      "body.vr-page-products .actual-products .product-name-text{font-size:16px!important;line-height:1.24!important;overflow-wrap:anywhere;word-break:break-word;padding-left:0!important;width:100%;}",
      "body.vr-page-products .actual-products .product-description{padding-top:8px;}",
      "@media (max-width:767px){body.vr-page-products .actual-products .product-name-text{font-size:14px!important;line-height:1.2!important;}}",
      ".vr-product-price-row .product-price-text{margin:0!important;padding-left:0!important;opacity:1!important;line-height:1!important;}",
      ".vr-product-now-label{font-size:14px;font-weight:700;line-height:1;align-self:center;color:#2a8703;}",
      ".vr-product-price-main{display:inline-flex;align-items:flex-start;color:#101828;font-weight:800;line-height:1;}",
      ".vr-product-price-row.vr-product-price-sale .vr-product-price-main{color:#2a8703;}",
      ".vr-product-price-row.vr-product-price-wholesale .vr-product-price-main{color:#1d4ed8;}",
      ".vr-product-price-row.vr-product-price-wholesale .vr-product-now-label{color:#1d4ed8;}",
      ".vr-product-price-currency{font-size:14px;line-height:1;padding-top:4px;margin-right:2px;}",
      ".vr-product-price-whole{font-size:36px;line-height:.92;letter-spacing:-.02em;}",
      ".vr-product-price-cents{font-size:18px;line-height:1;transform:translateY(-7px);}",
      ".vr-product-compare-price{color:#6b7280;font-weight:500;text-decoration:line-through;text-decoration-thickness:2px;font-size:18px;line-height:1;}",
      ".product-detail-price .vr-product-price-row{margin-top:2px;}",
      "@media (max-width:767px){.vr-product-price-whole{font-size:32px;}.vr-product-price-cents{font-size:16px;transform:translateY(-6px);}.vr-product-compare-price{font-size:16px;}}",
      ".vr-product-review{position:relative;display:grid;gap:4px;margin-top:8px;color:#344054;}",
      ".vr-product-review-title{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;}",
      ".vr-product-review-row{display:flex;align-items:center;gap:5px;flex-wrap:wrap;min-width:0;}",
      ".vr-product-review-stars{display:inline-flex;align-items:center;gap:1px;}",
      ".vr-product-review-star{position:relative;display:inline-flex;align-items:center;justify-content:center;width:18px;height:20px;padding:0;border:none;border-radius:0;background:transparent;color:#d0d5dd;font-size:15px;line-height:1;cursor:pointer;transition:color .16s ease,transform .16s ease;}",
      ".vr-product-review-star:hover,.vr-product-review-star:focus-visible,.vr-product-review-star.is-active{color:#f59e0b;}",
      ".vr-product-review-star:hover{transform:translateY(-1px);}",
      ".vr-product-review-star:focus-visible{outline:none;}",
      ".vr-product-review.is-previewing .vr-product-review-star{color:#d0d5dd;}",
      ".vr-product-review.is-previewing .vr-product-review-star.is-preview{color:#f59e0b;}",
      ".vr-product-review.is-interactive .vr-product-review-star.is-preview-target{outline:none;box-shadow:none;transform:translateY(-1px) scale(1.08);}",
      ".vr-product-review.is-interactive .vr-product-review-stars:has(.vr-product-review-star:nth-child(1):is(:hover,:focus-visible,:focus)) .vr-product-review-star:nth-child(-n+1),.vr-product-review.is-interactive .vr-product-review-stars:has(.vr-product-review-star:nth-child(2):is(:hover,:focus-visible,:focus)) .vr-product-review-star:nth-child(-n+2),.vr-product-review.is-interactive .vr-product-review-stars:has(.vr-product-review-star:nth-child(3):is(:hover,:focus-visible,:focus)) .vr-product-review-star:nth-child(-n+3),.vr-product-review.is-interactive .vr-product-review-stars:has(.vr-product-review-star:nth-child(4):is(:hover,:focus-visible,:focus)) .vr-product-review-star:nth-child(-n+4),.vr-product-review.is-interactive .vr-product-review-stars:has(.vr-product-review-star:nth-child(5):is(:hover,:focus-visible,:focus)) .vr-product-review-star:nth-child(-n+5){color:#f59e0b;}",
      ".vr-product-review.is-interactive .vr-product-review-star:is(:hover,:focus-visible,:focus){outline:none;box-shadow:none;}",
      ".vr-product-review.is-interactive .vr-product-review-star:is(:hover,:focus-visible,:focus)::after,.vr-product-review.is-interactive .vr-product-review-star.is-preview-target::after{content:'';position:absolute;left:50%;bottom:-1px;width:11px;height:2px;border-radius:999px;background:#111827;transform:translateX(-50%);}",
      ".vr-product-review.is-readonly .vr-product-review-star{cursor:default;pointer-events:none;}",
      ".vr-product-review-star:disabled{cursor:default;transform:none;}",
      ".vr-product-review-summary{font-size:12px;font-weight:700;line-height:1.2;color:#475467;white-space:nowrap;}",
      ".vr-product-review-feedback{font-size:12px;font-weight:700;line-height:1.3;}",
      ".vr-product-review-feedback.info{color:#475467;}",
      ".vr-product-review-feedback.success{color:#027a48;}",
      ".vr-product-review-feedback.error{color:#b42318;}",
      ".vr-product-review.is-submitting .vr-product-review-star{opacity:.68;}",
      ".vr-rating-confetti{position:fixed;left:0;top:0;pointer-events:none;z-index:10060;border-radius:1px;box-shadow:0 0 10px rgba(250,204,21,.22);transform:translate(-50%,-50%);opacity:0;animation:vrRatingConfettiBurst .86s cubic-bezier(.2,.8,.2,1) forwards;}",
      "@keyframes vrRatingConfettiBurst{0%{opacity:1;transform:translate(-50%,-50%) scale(1) rotate(0deg);}78%{opacity:1;}100%{opacity:0;transform:translate(calc(-50% + var(--vr-rating-confetti-x)),calc(-50% + var(--vr-rating-confetti-y))) scale(.55) rotate(var(--vr-rating-confetti-rot));}}",
      "@media (prefers-reduced-motion:reduce){.vr-rating-confetti{display:none;}.vr-product-review-star{transition:none!important;}}",
      ".vr-product-review.is-compact{gap:4px;margin-top:8px;}",
      ".vr-product-review.is-compact .vr-product-review-title{display:none;}",
      ".vr-product-review.is-compact .vr-product-review-row{gap:4px;}",
      ".vr-product-review.is-compact .vr-product-review-star{width:16px;height:18px;font-size:14px;}",
      ".vr-product-review.is-interactive .vr-product-review-star{width:28px;height:28px;min-width:28px;min-height:28px;}",
      ".vr-product-review.is-interactive .vr-product-review-star:focus-visible{outline:2px solid #1a1b1f;outline-offset:2px;}",
      ".vr-product-review.is-detail{margin-top:8px;}",
      ".vr-product-quick-view-review .vr-product-review{margin-top:0;}",
      ".vr-detail-review-host{margin-top:2px;}",
      ".vr-product-card-actions{margin-top:12px;padding-top:10px;display:flex;gap:8px;align-items:center;}",
      ".vr-product-stock-note{margin-top:8px;font-size:12px;font-weight:700;line-height:1.3;color:#475467;}",
      ".vr-product-stock-note.is-sold-out{color:#b42318;}",
      ".vr-product-store-stock{display:grid;gap:7px;margin-top:10px;color:#344054;}",
      ".vr-product-store-stock-title{font-size:10px;font-weight:800;line-height:1.2;letter-spacing:.08em;text-transform:uppercase;color:#667085;}",
      ".vr-product-store-stock-list{display:grid;gap:6px;min-width:0;}",
      ".vr-product-store-stock-row{display:grid;grid-template-columns:minmax(0,1fr) auto;align-items:center;gap:8px;font-size:12px;line-height:1.25;min-width:0;}",
      ".vr-product-store-stock-name{display:block;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}",
      ".vr-product-store-stock-status{font-weight:800;color:#027a48;text-align:right;font-variant-numeric:tabular-nums;}",
      ".vr-product-store-stock-row.is-low .vr-product-store-stock-status,.vr-product-store-stock-row.is-empty .vr-product-store-stock-status{color:#b42318;}",
      ".vr-product-store-stock.is-compact{padding:8px 9px;border:1px solid #e6eaf0;border-radius:10px;background:#f8fafc;box-shadow:inset 0 1px 0 rgba(255,255,255,.72);}",
      ".vr-product-store-stock.is-compact .vr-product-store-stock-list{grid-template-columns:repeat(2,minmax(0,1fr));gap:6px 8px;}",
      ".vr-product-store-stock.is-compact .vr-product-store-stock-row{gap:5px;font-size:11px;}",
      ".vr-product-store-stock.is-compact .vr-product-store-stock-title{color:#475467;}",
      ".vr-product-store-stock.is-detail{margin-top:10px;padding-top:12px;border-top:1px solid #eaecf0;}",
      ".vr-product-store-stock.is-detail .vr-product-store-stock-list{gap:4px;}",
      ".vr-product-store-stock.is-detail .vr-product-store-stock-row{font-size:13px;padding:2px 0;}",
      ".vr-product-add-btn{border:none;border-radius:10px;cursor:pointer;display:inline-flex!important;align-items:center;justify-content:center;gap:8px;white-space:nowrap;transform:scale(1);transform-origin:center;transition:transform .18s cubic-bezier(.2,.8,.2,1),box-shadow .18s ease;will-change:transform;}",
      ".vr-product-add-btn.w--disabled{opacity:.56;pointer-events:none;box-shadow:none;cursor:default;}",
      ".actual-products .vr-product-card-actions .vr-product-add-btn:hover,.actual-products .vr-product-card-actions .vr-product-add-btn:focus-visible{transform:scale(1.035);}",
      ".actual-products .vr-product-card-actions .vr-product-add-btn:active{transform:scale(1.015);}",
      ".vr-product-add-btn::before{content:'';display:inline-block;width:14px;height:14px;flex:0 0 14px;background-repeat:no-repeat;background-position:50% 50%;background-size:14px 14px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M12 5v14'/%3E%3Cpath d='M5 12h14'/%3E%3C/svg%3E\");}",
      ".vr-product-add-btn.vr-added-success::before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='2.7' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M20 6L9 17l-5-5'/%3E%3C/svg%3E\");}",
      ".vr-product-add-btn.vr-added-success{background:#22c55e!important;color:#fff!important;box-shadow:0 10px 20px rgba(34,197,94,.32);animation:vrAddToCartPop .32s cubic-bezier(.2,.8,.2,1);}",
      "@keyframes vrAddToCartPop{0%{transform:scale(1);}45%{transform:scale(1.08);}100%{transform:scale(1);}}",
      ".vr-add-confetti{position:fixed;left:0;top:0;pointer-events:none;z-index:10060;transform:translate(-50%,-50%);opacity:0;animation:vrAddConfettiBurst .72s cubic-bezier(.2,.8,.2,1) forwards;}",
      "@keyframes vrAddConfettiBurst{0%{opacity:1;transform:translate(-50%,-50%) scale(1) rotate(0deg);}80%{opacity:1;}100%{opacity:0;transform:translate(calc(-50% + var(--vr-confetti-x)),calc(-50% + var(--vr-confetti-y))) scale(.55) rotate(var(--vr-confetti-rot));}}",
      "@media (max-width:767px){.vr-product-card-actions{width:100%;}.vr-product-add-btn{width:100%;}}",
      ".vr-product-image-shell{position:relative;overflow:hidden;background-color:#eceff3;}",
      ".vr-product-image-shell::before,.vr-product-image-shell::after{content:'';position:absolute;inset:0;pointer-events:none;z-index:0;transition:opacity .34s cubic-bezier(.2,.8,.2,1);}",
      ".vr-product-image-shell::before{opacity:0;background:linear-gradient(100deg,rgba(236,240,246,0) 20%,rgba(255,255,255,.72) 50%,rgba(236,240,246,0) 80%);transform:translateX(-120%);}",
      ".vr-product-image-shell::after{opacity:1;background:#eceff3;}",
      ".vr-product-image-shell > *{position:relative;z-index:1;}",
      ".vr-product-image-shell.vr-image-loaded::after{opacity:0;}",
      ".vr-product-image-shell.vr-image-pending,.vr-product-image-shell.vr-image-loading{background-image:none!important;}",
      ".vr-product-image-shell.vr-image-loading::before{opacity:1;animation:vrSkeletonSweep 1.25s ease-in-out infinite;}",
      ".vr-skeleton{position:relative;overflow:hidden;background:#e8edf4;animation:vrSkeletonPulse 1.8s ease-in-out infinite;animation-delay:var(--vr-skeleton-delay,0s);color:transparent!important;}",
      ".vr-skeleton::after{content:'';position:absolute;inset:0;background:linear-gradient(100deg,rgba(232,237,244,0) 20%,rgba(255,255,255,.78) 48%,rgba(232,237,244,0) 80%);transform:translateX(-120%);animation:vrSkeletonSweep 1.25s ease-in-out infinite;animation-delay:var(--vr-skeleton-delay,0s);}",
      "@keyframes vrSkeletonSweep{0%{transform:translateX(-120%);}100%{transform:translateX(120%);}}",
      "@keyframes vrSkeletonPulse{0%,100%{opacity:.94;}50%{opacity:.78;}}",
      ".vr-skeleton-chip{display:inline-flex;min-width:96px;height:38px;border-radius:999px;pointer-events:none;}",
      ".vr-filter-skeleton-item{display:flex;align-items:center;min-width:0;}",
      ".vr-filter-skeleton-item .vr-skeleton-chip{height:40px;min-width:0;border-radius:10px;border:1px solid #d8e1ee;background:#e8edf4;box-shadow:inset 0 1px 0 rgba(255,255,255,.72);}",
      ".vr-filter-skeleton-item .vr-skeleton-chip.vr-skeleton-chip-active{border-color:#cbd6e7;background:#dfe7f3;}",
      ".vr-products-filters-panel .vr-filter-skeleton-item .vr-skeleton-chip{width:100%;}",
      "@media (max-width:991px){.vr-filter-skeleton-item .vr-skeleton-chip{height:38px;border-radius:999px;}}",
      ".vr-skeleton-card{display:flex;flex-direction:column;}",
      ".vr-skeleton-card .product-image-wrap.vr-skeleton{display:block;pointer-events:none;background-image:none!important;border-radius:14px;border:1px solid #dbe3ef;aspect-ratio:1 / 1;min-height:0;}",
      ".vr-skeleton-card .product-description{display:grid;gap:9px;padding-top:12px;}",
      ".vr-skeleton-line{display:block;height:13px;border-radius:7px;}",
      ".vr-skeleton-line.lg{width:88%;height:15px;}",
      ".vr-skeleton-line.md{width:68%;}",
      ".vr-skeleton-line.sm{width:44%;}",
      ".vr-skeleton-line.price{width:52%;height:22px;border-radius:9px;margin-top:2px;}",
      ".vr-skeleton-line.btn{width:100%;height:42px;border-radius:10px;margin-top:3px;}",
      "@media (max-width:767px){.vr-skeleton-card .product-description{gap:8px;padding-top:10px;}.vr-skeleton-line.btn{height:38px;}}",
      ".vr-detail-skeleton-name{height:32px;width:min(92%,22ch);margin-bottom:4px;}",
      ".vr-detail-skeleton-price{height:38px;width:min(58%,12ch);margin-bottom:4px;}",
      ".vr-detail-skeleton-desc{display:block;height:14px;width:100%;border-radius:7px;margin-top:10px;}",
      ".vr-detail-skeleton-desc:first-child{margin-top:0;}",
      "@media (max-width:767px){.vr-detail-skeleton-name{height:26px;}.vr-detail-skeleton-price{height:32px;}}",
      ".vr-order-items .vr-cart-row{grid-template-columns:minmax(0,1fr) 72px auto;column-gap:14px;}",
      "body.vr-page-order-confirmation #vr-order-content{display:grid;gap:14px;}",
      "body.vr-page-order-confirmation #vr-order-content > p{margin:0;}",
      "body.vr-page-order-confirmation #vr-order-content .vr-order-meta,body.vr-page-order-confirmation #vr-order-content .vr-order-items{padding:18px 20px;border-radius:14px;}",
      "body.vr-page-order-confirmation #vr-order-content .vr-order-meta .vr-summary-row{padding:5px 0;}",
      "body.vr-page-order-confirmation #vr-order-content .vr-order-items .vr-summary-row,body.vr-page-order-confirmation #vr-order-summary .vr-summary-row{padding:6px 0;}",
      "body.vr-page-order-confirmation #vr-order-content .vr-order-items .heading-jumbo-tiny{margin-bottom:10px;}",
      "body.vr-page-order-confirmation #vr-order-content > .primary-button{margin-top:6px;}",
      ".vr-order-loading-copy{margin:0;}",
      ".vr-order-skeleton-block{display:grid;gap:8px;}",
      ".vr-order-skeleton-row{display:grid;grid-template-columns:minmax(148px,40%) minmax(0,1fr);column-gap:18px;align-items:center;padding:5px 0;}",
      ".vr-order-skeleton-label{display:block;height:12px;width:102px;border-radius:7px;}",
      ".vr-order-skeleton-value{display:block;height:14px;width:188px;max-width:100%;border-radius:7px;justify-self:end;}",
      ".vr-order-item-skeleton{display:grid;grid-template-columns:74px minmax(0,1fr) auto;column-gap:12px;align-items:center;padding:8px 0;}",
      ".vr-order-item-thumb{display:block;width:74px;height:74px;border-radius:12px;}",
      ".vr-order-item-copy{display:grid;gap:8px;min-width:0;}",
      ".vr-order-item-line{display:block;height:13px;border-radius:7px;}",
      ".vr-order-item-line.lg{width:min(340px,92%);}",
      ".vr-order-item-line.md{width:min(210px,64%);}",
      ".vr-order-item-price{display:block;width:110px;height:18px;border-radius:8px;justify-self:end;}",
      ".vr-order-button-skeleton{display:block;width:190px;height:54px;border-radius:12px;}",
      ".vr-order-summary-skeleton{display:grid;gap:4px;}",
      ".vr-order-summary-skeleton-row{display:grid;grid-template-columns:minmax(110px,1fr) auto;column-gap:14px;align-items:center;padding:6px 0;}",
      ".vr-order-summary-skeleton-label{display:block;height:12px;width:84px;border-radius:7px;}",
      ".vr-order-summary-skeleton-value{display:block;height:14px;width:108px;border-radius:7px;justify-self:end;}",
      ".vr-order-summary-skeleton-row.vr-order-summary-skeleton-total{margin-top:8px;padding-top:12px;border-top:1px solid #e9eef5;}",
      ".vr-order-summary-skeleton-total .vr-order-summary-skeleton-label{height:16px;width:96px;}",
      ".vr-order-summary-skeleton-total .vr-order-summary-skeleton-value{height:20px;width:126px;}",
      ".vr-order-ready{animation:vrOrderConfirmationReveal .28s ease both;}",
      "@keyframes vrOrderConfirmationReveal{from{opacity:0;transform:translateY(6px);}to{opacity:1;transform:translateY(0);}}",
      "@media (max-width:767px){.vr-order-skeleton-row{grid-template-columns:minmax(106px,44%) minmax(0,1fr);column-gap:12px;}.vr-order-skeleton-value{width:140px;}.vr-order-item-skeleton{grid-template-columns:64px minmax(0,1fr);row-gap:8px;}.vr-order-item-thumb{width:64px;height:64px;}.vr-order-item-price{grid-column:2;}}",
      ".vr-muted{color:#667085;font-size:13px;line-height:1.45;}",
      ".vr-delivery-note{margin:10px 0 0;padding:10px 12px;border:1px solid #dbe5f0;border-radius:10px;background:#f7fbff;color:#334155;font-weight:500;}",
      ".vr-delivery-note strong{font-weight:800;}",
      ".vr-delivery-note-highlight{color:inherit;font-weight:800;}",
      ".vr-delivery-note.vr-delivery-note-free{border-color:#a6f4c5;background:#ecfdf3;color:#027a48;}",
      ".vr-label{font-size:11px;letter-spacing:.07em;text-transform:uppercase;color:#667085;margin-bottom:6px;display:block;font-weight:700;}",
      ".vr-wholesale-auth-card{margin-top:0;padding:24px 24px 14px;border-radius:20px;border:1px solid #d8cfff;background:#f6f1ff;display:grid;gap:14px;box-shadow:0 16px 34px rgba(70,43,143,.12);}",
      "body.vr-page-wholesale .section.wholesale-hero .vr-wholesale-auth-card{margin-top:0;position:sticky;top:96px;}",
      ".vr-wholesale-auth-title{margin:0;font-size:32px;line-height:1.08;letter-spacing:.01em;color:#101828;}",
      ".vr-wholesale-auth-note{margin:0;color:#475467;font-size:15px;line-height:1.5;max-width:36ch;}",
      ".vr-wholesale-auth-form{display:grid;gap:12px;margin-top:2px;}",
      ".vr-wholesale-auth-form .text-field{width:100%;height:56px!important;min-height:56px!important;margin:0!important;padding:0 16px!important;border:1px solid #d0d5dd!important;border-radius:12px!important;background:#fff!important;color:#101828!important;font-size:16px!important;line-height:1.2!important;box-shadow:inset 0 1px 0 rgba(16,24,40,.04);transition:border-color .2s ease,box-shadow .2s ease,background-color .2s ease;}",
      ".vr-wholesale-auth-form .text-field::placeholder{color:#98a2b3;}",
      ".vr-wholesale-auth-form .text-field:hover{border-color:#b8c5d6!important;}",
      ".vr-wholesale-auth-form .text-field:focus,.vr-wholesale-auth-form .text-field.-wfp-focus{outline:none!important;border-color:#111827!important;box-shadow:0 0 0 4px rgba(17,24,39,.12)!important;}",
      ".vr-wholesale-auth-row{display:flex;align-items:center;gap:12px;}",
      ".vr-wholesale-auth-row .primary-button{display:inline-flex!important;align-items:center;justify-content:center;width:100%;min-height:50px;padding:0 24px;border:none;border-radius:12px;cursor:pointer;letter-spacing:.12em;background:#6d28d9!important;color:#fff!important;box-shadow:0 10px 22px rgba(91,33,182,.32);transition:background-color .2s ease,transform .2s ease,box-shadow .2s ease;}",
      ".vr-wholesale-auth-row .primary-button:hover{background:#5b21b6!important;transform:translateY(-1px);box-shadow:0 14px 26px rgba(76,29,149,.36);}",
      ".vr-wholesale-auth-row .primary-button[disabled]{opacity:.62;cursor:default;}",
      ".vr-wholesale-auth-active{display:grid;gap:10px;padding:12px;border:1px solid #d0fae5;border-radius:12px;background:#f6fffa;}",
      ".vr-wholesale-auth-badge{display:inline-flex;align-items:center;width:max-content;padding:4px 10px;border-radius:999px;background:#ecfdf3;color:#067647;font-weight:700;font-size:12px;line-height:1.2;border:1px solid #a6f4c5;}",
      ".vr-wholesale-auth-feedback{font-size:13px;line-height:1.45;min-height:0;padding-top:0;margin:0;}",
      ".vr-wholesale-auth-feedback:empty{display:none;}",
      ".vr-wholesale-auth-feedback.success{color:#067647;}",
      ".vr-wholesale-auth-feedback.error{color:#b42318;}",
      ".vr-wholesale-auth-request-toggle{display:inline-flex;align-items:center;justify-content:center;width:100%;min-height:46px;padding:0 14px;margin-top:2px;border:1px solid rgba(109,40,217,.28);border-radius:12px;background:rgba(255,255,255,.72);color:#5b21b6;font-size:14px;font-weight:700;line-height:1.35;cursor:pointer;text-decoration:none;transition:border-color .2s ease,background-color .2s ease,color .2s ease,box-shadow .2s ease;}",
      ".vr-wholesale-auth-request-toggle:hover{border-color:rgba(91,33,182,.42);background:#fff;color:#4c1d95;box-shadow:0 8px 18px rgba(76,29,149,.12);}",
      ".vr-wholesale-auth-request-toggle:focus-visible{outline:none;border-color:#5b21b6;box-shadow:0 0 0 4px rgba(91,33,182,.16);}",
      "body.vr-wholesale-request-modal-open{overflow:hidden;}",
      "body.vr-wholesale-logout-confirm-open{overflow:hidden;}",
      ".vr-wholesale-request-modal{position:fixed;inset:0;z-index:10085;display:none;align-items:center;justify-content:center;padding:clamp(12px,2.6vw,28px);}",
      ".vr-wholesale-request-modal.is-open{display:flex;}",
      ".vr-wholesale-request-backdrop{position:absolute;inset:0;border:none;background:rgba(8,18,40,.74);backdrop-filter:blur(3px);padding:0;cursor:pointer;}",
      ".vr-wholesale-request-dialog{position:relative;z-index:1;display:grid;align-content:start;gap:14px;width:min(500px,100%);max-height:min(92vh,900px);overflow:auto;margin:0;padding:18px 14px 14px;border-radius:18px;border:1px solid #d4def0;background:linear-gradient(180deg,#ffffff 0%,#f7faff 100%);box-shadow:0 26px 52px rgba(15,23,42,.34);}",
      ".vr-wholesale-request-close{position:absolute;top:10px;right:10px;display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;padding:0;border:none;background:transparent;color:#344054;font-size:30px;line-height:1;cursor:pointer;}",
      ".vr-wholesale-request-close:hover{color:#101828;}",
      ".vr-wholesale-request-close:focus-visible{outline:none;box-shadow:0 0 0 3px rgba(29,79,145,.16);border-radius:0;}",
      ".vr-wholesale-request-back{display:none;align-items:center;justify-content:center;gap:8px;width:100%;min-height:46px;padding:0 14px;border:1px solid #d0d5dd;border-radius:12px;background:#fff;color:#344054;font-size:13px;font-weight:700;line-height:1.2;cursor:pointer;transition:border-color .2s ease,background-color .2s ease,box-shadow .2s ease;}",
      ".vr-wholesale-request-back:hover{border-color:#98a2b3;background:#f9fafb;}",
      ".vr-wholesale-request-back:focus-visible{outline:none;border-color:#1d4f91;box-shadow:0 0 0 3px rgba(29,79,145,.16);}",
      ".vr-wholesale-request-back svg{width:16px;height:16px;display:block;fill:none;stroke:currentColor;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round;}",
      ".vr-wholesale-request-title{margin:0;padding:0 44px 0 0;font-size:clamp(20px,1.9vw,30px);line-height:1.14;letter-spacing:-.02em;color:#0f172a;text-align:left;}",
      ".vr-wholesale-request-note{margin:0;color:#475467;font-size:16px;line-height:1.52;max-width:64ch;}",
      ".vr-wholesale-request-dialog .vr-wholesale-auth-feedback{min-height:0;padding-top:0;margin:0;}",
      ".vr-wholesale-request-dialog .vr-wholesale-auth-feedback:empty{display:none;}",
      ".vr-wholesale-request-progress-shell{display:grid;gap:10px;margin:2px 0 2px;}",
      ".vr-wholesale-request-progress-track{position:relative;height:8px;border-radius:999px;background:#e7eef9;overflow:hidden;}",
      ".vr-wholesale-request-progress-fill{position:absolute;inset:0 auto 0 0;width:0%;background:linear-gradient(90deg,#6d28d9 0%,#2563eb 100%);transition:width .24s ease;}",
      ".vr-wholesale-request-form{display:grid;gap:14px;}",
      ".vr-wholesale-request-step{display:none;gap:12px;}",
      ".vr-wholesale-request-step.is-active{display:grid;}",
      ".vr-wholesale-request-step-header{display:grid;gap:4px;}",
      ".vr-wholesale-request-step-title{margin:0;font-size:18px;line-height:1.25;color:#101828;font-weight:800;}",
      ".vr-wholesale-request-step-copy{margin:0;color:#667085;font-size:13px;line-height:1.45;}",
      ".vr-wholesale-request-step-grid{display:grid;grid-template-columns:minmax(0,1fr);row-gap:10px;}",
      ".vr-wholesale-request-field{display:grid;gap:6px;min-width:0;}",
      ".vr-wholesale-request-field-row{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:10px;}",
      ".vr-wholesale-request-label{font-size:12px;line-height:1.25;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#475467;}",
      ".vr-wholesale-request-form .text-field{width:100%;height:50px!important;min-height:50px!important;margin:0!important;padding:0 14px!important;border:1px solid #d0d5dd!important;border-radius:10px!important;background:#fff!important;color:#101828!important;font-size:15px!important;line-height:1.2!important;transition:border-color .2s ease,box-shadow .2s ease;}",
      ".vr-wholesale-request-form .text-field::placeholder{color:#98a2b3;}",
      ".vr-wholesale-request-form .text-field:hover{border-color:#b8c5d6!important;}",
      ".vr-wholesale-request-form .text-field:focus,.vr-wholesale-request-form .text-field.-wfp-focus{outline:none!important;border-color:#1d4f91!important;box-shadow:0 0 0 3px rgba(29,79,145,.16)!important;}",
      ".vr-wholesale-request-form .text-field[aria-invalid='true']{border-color:#d92d20!important;box-shadow:0 0 0 3px rgba(217,45,32,.14)!important;}",
      ".vr-wholesale-request-form textarea.text-field{height:142px!important;min-height:142px!important;padding:12px 14px!important;resize:vertical;}",
      ".vr-wholesale-request-actions{display:grid;gap:10px;padding-top:2px;}",
      ".vr-wholesale-request-next,.vr-wholesale-request-submit{display:inline-flex;align-items:center;justify-content:center;width:100%;min-height:52px;padding:0 18px;border:none;border-radius:12px;letter-spacing:.06em;text-transform:uppercase;font-size:12px;font-weight:800;}",
      ".vr-wholesale-request-next{background:#4f46e5!important;color:#fff!important;box-shadow:0 10px 20px rgba(79,70,229,.26);}",
      ".vr-wholesale-request-next:hover{background:#4338ca!important;}",
      ".vr-wholesale-request-submit{display:none;background:#6d28d9!important;color:#fff!important;box-shadow:0 10px 22px rgba(91,33,182,.3);}",
      ".vr-wholesale-request-submit:hover{background:#5b21b6!important;}",
      ".vr-wholesale-request-next[disabled],.vr-wholesale-request-submit[disabled],.vr-wholesale-request-back[disabled]{opacity:.62;cursor:default;box-shadow:none;}",
      ".vr-wholesale-logout-confirm-modal{position:fixed;inset:0;z-index:10086;display:none;align-items:center;justify-content:center;padding:clamp(12px,2.6vw,28px);}",
      ".vr-wholesale-logout-confirm-modal.is-open{display:flex;}",
      ".vr-wholesale-logout-confirm-backdrop{position:absolute;inset:0;border:none;background:rgba(8,18,40,.68);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);padding:0;cursor:pointer;}",
      ".vr-wholesale-logout-confirm-dialog{position:relative;z-index:1;display:grid;gap:14px;width:min(430px,100%);margin:0;padding:22px 18px 16px;border-radius:16px;border:1px solid #d4def0;background:linear-gradient(180deg,#ffffff 0%,#f7faff 100%);box-shadow:0 24px 48px rgba(15,23,42,.3);}",
      ".vr-wholesale-logout-confirm-title{margin:0;font-size:24px;line-height:1.15;letter-spacing:-.01em;color:#101828;}",
      ".vr-wholesale-logout-confirm-note{margin:0;color:#475467;font-size:15px;line-height:1.5;}",
      ".vr-wholesale-logout-confirm-actions{display:grid;grid-template-columns:1fr 1fr;gap:10px;}",
      ".vr-wholesale-logout-confirm-cancel,.vr-wholesale-logout-confirm-submit{display:inline-flex;align-items:center;justify-content:center;min-height:46px;padding:0 14px;border-radius:12px;letter-spacing:.06em;text-transform:uppercase;font-size:13px;font-weight:700;}",
      ".vr-wholesale-logout-confirm-cancel{border:1px solid #d0d5dd;background:#fff;color:#344054;}",
      ".vr-wholesale-logout-confirm-cancel:hover{border-color:#98a2b3;background:#f9fafb;}",
      ".vr-wholesale-logout-confirm-submit{border:none;background:#b42318!important;color:#fff!important;box-shadow:0 10px 20px rgba(180,35,24,.28);}",
      ".vr-wholesale-logout-confirm-submit:hover{background:#912018!important;}",
      ".vr-wholesale-logout-confirm-cancel:focus-visible,.vr-wholesale-logout-confirm-submit:focus-visible{outline:none;box-shadow:0 0 0 3px rgba(29,79,145,.16);}",
      ".vr-wholesale-logout-confirm-submit[disabled],.vr-wholesale-logout-confirm-cancel[disabled]{opacity:.65;cursor:default;box-shadow:none;}",
      "@media (max-width:767px){.vr-wholesale-request-modal{padding:8px;}.vr-wholesale-request-dialog{width:100%;max-height:calc(100vh - 16px);padding:14px 10px 10px;border-radius:14px;}.vr-wholesale-request-title{font-size:20px;line-height:1.16;}.vr-wholesale-request-note{font-size:14px;}.vr-wholesale-request-actions .primary-button{width:100%;}}",
      "@media (max-width:767px){.vr-wholesale-logout-confirm-dialog{padding:18px 14px 12px;border-radius:14px;}.vr-wholesale-logout-confirm-title{font-size:21px;}.vr-wholesale-logout-confirm-actions{grid-template-columns:1fr;}}",
      "@media (max-width:1200px){.vr-wholesale-auth-title{font-size:28px;}}",
      "@media (max-width:991px){body.vr-page-wholesale .section.wholesale-hero .vr-wholesale-auth-card{position:static;top:auto;}.vr-wholesale-auth-title{font-size:26px;}.vr-wholesale-auth-note{max-width:none;}}",
      "@media (max-width:767px){.vr-wholesale-auth-card{padding:18px;border-radius:16px;}.vr-wholesale-auth-title{font-size:24px;}.vr-wholesale-auth-note{font-size:14px;}.vr-wholesale-auth-row{flex-direction:column;align-items:stretch;}.vr-wholesale-auth-row .primary-button{width:100%;}}"
    ].join("\n");

    document.head.appendChild(style);
  }

  function isMobileViewport() {
    if (typeof window === "undefined") {
      return false;
    }

    if (typeof window.matchMedia === "function") {
      return window.matchMedia("(max-width: 991px)").matches;
    }

    return window.innerWidth <= 991;
  }

  function getMobileMenuIconSvg(href) {
    var normalizedHref = String(href || "")
      .split("#")[0]
      .split("?")[0]
      .trim()
      .toLowerCase();

    if (normalizedHref === "/products") {
      return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="3" y="7" width="18" height="13" rx="2"></rect><path d="M8 7V5a4 4 0 0 1 8 0v2"></path></svg>';
    }

    if (normalizedHref === "/radnje") {
      return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 21s7-5.2 7-11a7 7 0 1 0-14 0c0 5.8 7 11 7 11Z"></path><circle cx="12" cy="10" r="2.5"></circle></svg>';
    }

    if (normalizedHref === "/veleprodaja") {
      return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 21v-9l9-4 9 4v9"></path><path d="M9 21v-5h6v5"></path><path d="M12 8V3"></path></svg>';
    }

    if (normalizedHref === "/contact") {
      return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2Z"></path><path d="M8 9h8"></path><path d="M8 13h5"></path></svg>';
    }

    if (normalizedHref === "/checkout") {
      return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="9" cy="20" r="1.5"></circle><circle cx="17" cy="20" r="1.5"></circle><path d="M3 4h2l2.2 10.2a2 2 0 0 0 2 1.6h7.6a2 2 0 0 0 2-1.6L21 7H7"></path></svg>';
    }

    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 12h16"></path><path d="m14 6 6 6-6 6"></path></svg>';
  }

  function syncMobileNavMenuContent() {
    if (!mobileNavMenuList) {
      return;
    }

    var sourceMenu = document.querySelector(".navigation .navigation-wrap > nav.w-nav-menu");
    if (!sourceMenu) {
      return;
    }

    var links = Array.prototype.slice.call(sourceMenu.querySelectorAll("a.navigation-item"));
    var cartSummary = getCartSummary(readCart());
    var cartCount = Number.isFinite(cartSummary.count) ? Math.max(0, cartSummary.count) : 0;

    var entries = links
      .map(function mapMobileMenuLink(link) {
        var href = String(link.getAttribute("href") || "").trim() || "#";
        var label = String(link.textContent || "").replace(/\s+/g, " ").trim();

        if (!label) {
          return "";
        }

        var classes = ["vr-mobile-nav-menu-link"];
        var cartBadge = "";
        if (link.classList.contains("w--current")) {
          classes.push("is-current");
        }

        if (link.classList.contains("cart-icon")) {
          classes.push("vr-mobile-nav-menu-link--cart");
          cartBadge = cartCount > 0 ? '<span class="vr-mobile-nav-menu-cart-badge" aria-label="Cart items">' + escapeHtml(String(cartCount)) + "</span>" : "";
        }

        return (
          '<a class="' +
          escapeHtml(classes.join(" ")) +
          '" href="' +
          escapeHtml(href) +
          '"><span class="vr-mobile-nav-menu-icon" aria-hidden="true">' +
          getMobileMenuIconSvg(href) +
          '</span><span class="vr-mobile-nav-menu-label">' +
          escapeHtml(label) +
          "</span>" +
          cartBadge +
          "</a>"
        );
      })
      .filter(Boolean);

    mobileNavMenuList.innerHTML = entries.join("\n");
  }

  function setMobileNavMenuState(navRoot, menuButton, isOpen, options) {
    var config = options && typeof options === "object" ? options : {};
    if (!navRoot || !menuButton || !mobileNavMenuRoot) {
      return;
    }

    if (isOpen && !isMobileViewport()) {
      isOpen = false;
    }

    navRoot.classList.toggle("vr-mobile-menu-open", isOpen);
    document.body.classList.toggle("vr-mobile-menu-open", isOpen);
    mobileNavMenuRoot.classList.toggle("is-open", isOpen);
    menuButton.classList.toggle("w--open", isOpen);
    menuButton.setAttribute("aria-expanded", isOpen ? "true" : "false");
    if (mobileBottomMenuButton) {
      mobileBottomMenuButton.classList.toggle("w--open", isOpen);
      mobileBottomMenuButton.setAttribute("aria-expanded", isOpen ? "true" : "false");
      mobileBottomMenuButton.setAttribute("aria-label", isOpen ? "Close menu" : "Open menu");
    }
    mobileNavMenuRoot.setAttribute("aria-hidden", isOpen ? "false" : "true");

    if (isOpen) {
      mobileNavMenuLastFocusedElement = document.activeElement instanceof Element ? document.activeElement : null;
      var menuSheet = mobileNavMenuRoot.querySelector(".vr-mobile-nav-menu-sheet");
      if (!focusFirstInteractive(menuSheet) && menuSheet) {
        menuSheet.setAttribute("tabindex", "-1");
        menuSheet.focus();
      }
    } else if (config.restoreFocus !== false) {
      restoreFocusIfPossible(
        mobileNavMenuLastFocusedElement && mobileNavMenuLastFocusedElement !== document.body
          ? mobileNavMenuLastFocusedElement
          : menuButton
      );
      mobileNavMenuLastFocusedElement = null;
    }
  }

  function ensureMobileNavMenu() {
    if (mobileNavMenuInitialized || !document.body) {
      return;
    }

    var navRoot = document.querySelector(".navigation.w-nav");
    if (!navRoot) {
      return;
    }

    var menuButton = navRoot.querySelector(".navigation-wrap .menu-button.w-nav-button");
    var sourceMenu = navRoot.querySelector(".navigation-wrap > nav.w-nav-menu");

    if (!menuButton || !sourceMenu) {
      return;
    }

    mobileNavMenuRoot = document.getElementById("vr-mobile-nav-menu-root");
    if (!mobileNavMenuRoot) {
      mobileNavMenuRoot = document.createElement("div");
      mobileNavMenuRoot.id = "vr-mobile-nav-menu-root";
      mobileNavMenuRoot.className = "vr-mobile-nav-menu-root";
      mobileNavMenuRoot.setAttribute("aria-hidden", "true");
      mobileNavMenuRoot.innerHTML = [
        '<button type="button" class="vr-mobile-nav-menu-backdrop" data-action="close-mobile-menu" aria-label="Close menu"></button>',
        '<div id="vr-mobile-nav-menu-sheet" class="vr-mobile-nav-menu-sheet" role="dialog" aria-modal="true" aria-label="Menu">',
        '  <nav class="vr-mobile-nav-menu-list"></nav>',
        "</div>"
      ].join("");
      document.body.appendChild(mobileNavMenuRoot);
    }

    var backdrop = mobileNavMenuRoot.querySelector(".vr-mobile-nav-menu-backdrop");
    mobileNavMenuList = mobileNavMenuRoot.querySelector(".vr-mobile-nav-menu-list");

    if (!backdrop || !mobileNavMenuList) {
      return;
    }

    mobileNavMenuInitialized = true;

    if (!mobileBottomMenuButton) {
      mobileBottomMenuButton = document.getElementById("vr-mobile-bottom-menu-button");
    }

    if (!mobileBottomMenuButton) {
      mobileBottomMenuButton = document.createElement("button");
      mobileBottomMenuButton.type = "button";
      mobileBottomMenuButton.id = "vr-mobile-bottom-menu-button";
      mobileBottomMenuButton.className = "vr-mobile-bottom-menu-button";
      mobileBottomMenuButton.innerHTML = [
        '<span class="vr-mobile-bottom-menu-icon" aria-hidden="true">',
        '  <svg viewBox="0 0 24 24" focusable="false">',
        "    <path d=\"M4 6h16\"></path>",
        "    <path d=\"M4 12h16\"></path>",
        "    <path d=\"M4 18h16\"></path>",
        "  </svg>",
        "</span>"
      ].join("");
      document.body.appendChild(mobileBottomMenuButton);
    }

    menuButton.setAttribute("aria-haspopup", "dialog");
    menuButton.setAttribute("aria-controls", "vr-mobile-nav-menu-sheet");
    menuButton.setAttribute("aria-expanded", "false");
    menuButton.setAttribute("aria-label", "Open menu");
    if (mobileBottomMenuButton) {
      mobileBottomMenuButton.setAttribute("aria-haspopup", "dialog");
      mobileBottomMenuButton.setAttribute("aria-controls", "vr-mobile-nav-menu-sheet");
      mobileBottomMenuButton.setAttribute("aria-expanded", "false");
      mobileBottomMenuButton.setAttribute("aria-label", "Open menu");
    }

    function syncNativeMenuButtonVisibility() {
      if (!menuButton) {
        return;
      }

      if (isMobileViewport()) {
        menuButton.hidden = true;
        menuButton.style.setProperty("display", "none", "important");
        menuButton.style.setProperty("visibility", "hidden", "important");
        menuButton.style.setProperty("pointer-events", "none", "important");
        menuButton.setAttribute("aria-hidden", "true");
        menuButton.setAttribute("tabindex", "-1");
        return;
      }

      menuButton.hidden = false;
      menuButton.style.removeProperty("display");
      menuButton.style.removeProperty("visibility");
      menuButton.style.removeProperty("pointer-events");
      menuButton.removeAttribute("aria-hidden");
      menuButton.removeAttribute("tabindex");
    }

    function syncMobileBottomMenuButtonVisibility() {
      if (!mobileBottomMenuButton) {
        return;
      }

      var isMobile = isMobileViewport();
      mobileBottomMenuButton.hidden = !isMobile;
      mobileBottomMenuButton.setAttribute("aria-hidden", isMobile ? "false" : "true");
    }

    function suppressNativeNavToggle(event) {
      if (!isMobileViewport()) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }
    }

    document.addEventListener(
      "click",
      function onMobileMenuButtonClick(event) {
        if (!isMobileViewport()) {
          return;
        }

        var target = event.target;
        if (!target || typeof target.closest !== "function") {
          return;
        }

        var trigger = target.closest(".navigation .menu-button.w-nav-button");
        if (!trigger) {
          return;
        }

        suppressNativeNavToggle(event);
        syncMobileNavMenuContent();
        var shouldOpen = !navRoot.classList.contains("vr-mobile-menu-open");
        setMobileNavMenuState(navRoot, menuButton, shouldOpen, {
          restoreFocus: false
        });

        if (trigger && typeof trigger.blur === "function") {
          trigger.blur();
        }
      },
      true
    );

    if (mobileBottomMenuButton) {
      mobileBottomMenuButton.addEventListener("click", function onMobileBottomMenuButtonClick(event) {
        if (!isMobileViewport()) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        mobileNavMenuLastFocusedElement = mobileBottomMenuButton;
        syncMobileNavMenuContent();
        var shouldOpen = !navRoot.classList.contains("vr-mobile-menu-open");
        setMobileNavMenuState(navRoot, menuButton, shouldOpen, {
          restoreFocus: false
        });

        if (mobileBottomMenuButton && typeof mobileBottomMenuButton.blur === "function") {
          mobileBottomMenuButton.blur();
        }
      });
    }

    backdrop.addEventListener("click", function onMobileMenuBackdropClick(event) {
      event.preventDefault();
      setMobileNavMenuState(navRoot, menuButton, false);
    });

    mobileNavMenuRoot.addEventListener("click", function onMobileMenuItemClick(event) {
      var target = event.target;
      if (!target || typeof target.closest !== "function") {
        return;
      }

      if (target.closest(".vr-mobile-nav-menu-link")) {
        setMobileNavMenuState(navRoot, menuButton, false);
      }
    });

    document.addEventListener("keydown", function onMobileMenuKeydown(event) {
      if (!navRoot.classList.contains("vr-mobile-menu-open")) {
        return;
      }

      if (event.key === "Escape") {
        setMobileNavMenuState(navRoot, menuButton, false);
        return;
      }

      var menuSheet = mobileNavMenuRoot.querySelector(".vr-mobile-nav-menu-sheet");
      trapFocusInContainer(event, menuSheet);
    });

    window.addEventListener("resize", function onMobileMenuResize() {
      syncNativeMenuButtonVisibility();
      syncMobileBottomMenuButtonVisibility();
      if (!isMobileViewport()) {
        setMobileNavMenuState(navRoot, menuButton, false, {
          restoreFocus: false
        });
      }
    });

    syncNativeMenuButtonVisibility();
    syncMobileBottomMenuButtonVisibility();
    syncMobileNavMenuContent();
    setMobileNavMenuState(navRoot, menuButton, false, {
      restoreFocus: false
    });
  }

  function ensureNavCartCountBadge(link) {
    var cartContainer = link && typeof link.closest === "function" ? link.closest(".div-block-6") : null;
    if (!cartContainer) {
      return null;
    }

    var icon = cartContainer.querySelector(".image-3");
    var iconWrap = cartContainer.querySelector(".vr-cart-icon-wrap");

    if (!iconWrap && icon) {
      iconWrap = document.createElement("span");
      iconWrap.className = "vr-cart-icon-wrap";
      icon.parentNode.insertBefore(iconWrap, icon);
      iconWrap.appendChild(icon);
    } else if (iconWrap && icon && icon.parentNode !== iconWrap) {
      iconWrap.appendChild(icon);
    }

    if (!iconWrap) {
      return null;
    }

    var badge = iconWrap.querySelector(".vr-cart-count-badge");
    if (!badge) {
      badge = document.createElement("span");
      badge.className = "vr-cart-count-badge";
      badge.setAttribute("aria-hidden", "true");
      iconWrap.appendChild(badge);
    }

    return badge;
  }

  function refreshCartLinks() {
    var cart = readCart();
    var count = getCartSummary(cart).count;
    var safeCount = Number.isFinite(count) ? Math.max(0, count) : 0;
    var badgeCount = safeCount > 99 ? "99+" : String(safeCount);
    var linkLabel = currentLanguage === LANGUAGE_EN ? "Cart" : "korpa";
    var titleLabel = currentLanguage === LANGUAGE_EN ? "Cart" : "Korpa";

    document.querySelectorAll("a.navigation-item.cart-icon").forEach(function updateCartLink(link) {
      var badge = ensureNavCartCountBadge(link);

      link.setAttribute("href", "/checkout");
      link.setAttribute("data-vr-cart-trigger", "1");
      link.textContent = linkLabel;

      if (badge) {
        badge.textContent = badgeCount;
        badge.classList.toggle("is-empty", safeCount === 0);
      }

      link.setAttribute("title", safeCount > 0 ? titleLabel + " (" + safeCount + ")" : titleLabel);
      link.setAttribute("aria-label", safeCount > 0 ? titleLabel + " (" + safeCount + ")" : titleLabel);
    });

    syncMobileNavMenuContent();
    requestDesktopProductsStickyCartSync();
  }

  function isDesktopProductsStickyCartPage() {
    return byPathname(window.location.pathname) === "products" && !isMobileViewport();
  }

  function findDesktopProductsStickyCartSource() {
    if (
      desktopProductsStickyCartSource &&
      document.body &&
      document.body.contains(desktopProductsStickyCartSource)
    ) {
      return desktopProductsStickyCartSource;
    }

    var source = null;
    document.querySelectorAll(".navigation .navigation-wrap .div-block-6").forEach(function findSource(candidate) {
      if (source) {
        return;
      }

      if (!candidate || candidate.getAttribute("data-vr-sticky-cart-clone") === "1") {
        return;
      }

      if (!candidate.querySelector("a.navigation-item.cart-icon")) {
        return;
      }

      source = candidate;
    });

    desktopProductsStickyCartSource = source;
    return source;
  }

  function setDesktopProductsStickyCartSourceVisibility(source, hidden) {
    if (desktopProductsStickyCartHiddenSource && desktopProductsStickyCartHiddenSource !== source) {
      desktopProductsStickyCartHiddenSource.style.visibility = "";
      desktopProductsStickyCartHiddenSource.style.pointerEvents = "";
      desktopProductsStickyCartHiddenSource = null;
    }

    if (!source) {
      if (desktopProductsStickyCartHiddenSource) {
        desktopProductsStickyCartHiddenSource.style.visibility = "";
        desktopProductsStickyCartHiddenSource.style.pointerEvents = "";
        desktopProductsStickyCartHiddenSource = null;
      }
      return;
    }

    if (hidden) {
      source.style.visibility = "hidden";
      source.style.pointerEvents = "none";
      desktopProductsStickyCartHiddenSource = source;
      return;
    }

    source.style.visibility = "";
    source.style.pointerEvents = "";

    if (desktopProductsStickyCartHiddenSource === source) {
      desktopProductsStickyCartHiddenSource = null;
    }
  }

  function removeDesktopProductsStickyCartClone() {
    if (desktopProductsStickyCartClone && desktopProductsStickyCartClone.parentNode) {
      desktopProductsStickyCartClone.parentNode.removeChild(desktopProductsStickyCartClone);
    }

    desktopProductsStickyCartClone = null;
    setDesktopProductsStickyCartSourceVisibility(null, false);
  }

  function findDesktopProductsStickyLogoSource() {
    if (
      desktopProductsStickyLogoSource &&
      document.body &&
      document.body.contains(desktopProductsStickyLogoSource)
    ) {
      return desktopProductsStickyLogoSource;
    }

    var source = null;
    document.querySelectorAll(".navigation .navigation-items > a.logo-link.w-nav-brand").forEach(function findSource(candidate) {
      if (source) {
        return;
      }

      if (!candidate || candidate.getAttribute("data-vr-sticky-logo-clone") === "1") {
        return;
      }

      source = candidate;
    });

    desktopProductsStickyLogoSource = source;
    return source;
  }

  function setDesktopProductsStickyLogoSourceVisibility(source, hidden) {
    if (desktopProductsStickyLogoHiddenSource && desktopProductsStickyLogoHiddenSource !== source) {
      desktopProductsStickyLogoHiddenSource.style.visibility = "";
      desktopProductsStickyLogoHiddenSource.style.pointerEvents = "";
      desktopProductsStickyLogoHiddenSource = null;
    }

    if (!source) {
      if (desktopProductsStickyLogoHiddenSource) {
        desktopProductsStickyLogoHiddenSource.style.visibility = "";
        desktopProductsStickyLogoHiddenSource.style.pointerEvents = "";
        desktopProductsStickyLogoHiddenSource = null;
      }
      return;
    }

    if (hidden) {
      source.style.visibility = "hidden";
      source.style.pointerEvents = "none";
      desktopProductsStickyLogoHiddenSource = source;
      return;
    }

    source.style.visibility = "";
    source.style.pointerEvents = "";

    if (desktopProductsStickyLogoHiddenSource === source) {
      desktopProductsStickyLogoHiddenSource = null;
    }
  }

  function removeDesktopProductsStickyLogoClone() {
    if (desktopProductsStickyLogoClone && desktopProductsStickyLogoClone.parentNode) {
      desktopProductsStickyLogoClone.parentNode.removeChild(desktopProductsStickyLogoClone);
    }

    desktopProductsStickyLogoClone = null;
    setDesktopProductsStickyLogoSourceVisibility(null, false);
  }

  function canDisplayDesktopProductsStickyLogo(sourceRect) {
    if (!sourceRect || !(sourceRect.width > 0) || !(sourceRect.height > 0)) {
      return false;
    }

    if (window.innerWidth < DESKTOP_PRODUCTS_STICKY_LOGO_MIN_WIDTH) {
      return false;
    }

    var contentContainer = document.querySelector(".our-products-section .container");
    if (!contentContainer) {
      return true;
    }

    var containerRect = contentContainer.getBoundingClientRect();
    var logoRight = sourceRect.left + sourceRect.width;
    return containerRect.left - logoRight >= DESKTOP_PRODUCTS_STICKY_LOGO_GUTTER_PX;
  }

  function syncDesktopProductsStickyLogo() {
    if (!isDesktopProductsStickyCartPage() || !(window.scrollY > 0)) {
      removeDesktopProductsStickyLogoClone();
      return;
    }

    var source = findDesktopProductsStickyLogoSource();
    if (!source) {
      removeDesktopProductsStickyLogoClone();
      return;
    }

    var rect = source.getBoundingClientRect();
    if (!canDisplayDesktopProductsStickyLogo(rect)) {
      removeDesktopProductsStickyLogoClone();
      return;
    }

    if (!desktopProductsStickyLogoClone) {
      desktopProductsStickyLogoClone = source.cloneNode(true);
      desktopProductsStickyLogoClone.setAttribute("data-vr-sticky-logo-clone", "1");
      desktopProductsStickyLogoClone.style.willChange = "auto";

      if (document.body) {
        document.body.appendChild(desktopProductsStickyLogoClone);
      }
    }

    var sourceTop = Math.round(rect.top + window.scrollY);
    var sourceLeft = Math.max(0, Math.round(rect.left));

    desktopProductsStickyLogoClone.style.position = "fixed";
    desktopProductsStickyLogoClone.style.top = Math.max(0, sourceTop) + "px";
    desktopProductsStickyLogoClone.style.left = sourceLeft + "px";
    desktopProductsStickyLogoClone.style.right = "auto";
    desktopProductsStickyLogoClone.style.bottom = "auto";
    desktopProductsStickyLogoClone.style.zIndex = "1003";
    desktopProductsStickyLogoClone.style.margin = "0";
    desktopProductsStickyLogoClone.style.width = Math.round(rect.width) + "px";
    desktopProductsStickyLogoClone.style.height = Math.round(rect.height) + "px";
    desktopProductsStickyLogoClone.style.transform = "none";
    desktopProductsStickyLogoClone.style.visibility = "visible";
    desktopProductsStickyLogoClone.style.pointerEvents = "auto";

    setDesktopProductsStickyLogoSourceVisibility(source, true);
  }

  function syncDesktopProductsStickyCart() {
    if (!isDesktopProductsStickyCartPage() || !(window.scrollY > 0)) {
      removeDesktopProductsStickyCartClone();
      return;
    }

    var source = findDesktopProductsStickyCartSource();
    if (!source) {
      removeDesktopProductsStickyCartClone();
      return;
    }

    var rect = source.getBoundingClientRect();
    if (!(rect.width > 0) || !(rect.height > 0)) {
      removeDesktopProductsStickyCartClone();
      return;
    }

    if (!desktopProductsStickyCartClone) {
      desktopProductsStickyCartClone = source.cloneNode(true);
      desktopProductsStickyCartClone.setAttribute("data-vr-sticky-cart-clone", "1");
      desktopProductsStickyCartClone.style.willChange = "auto";

      if (document.body) {
        document.body.appendChild(desktopProductsStickyCartClone);
      }
    }

    var sourceTop = Math.round(rect.top + window.scrollY);
    var sourceRight = Math.max(0, Math.round(window.innerWidth - rect.right));

    desktopProductsStickyCartClone.style.position = "fixed";
    desktopProductsStickyCartClone.style.top = Math.max(0, sourceTop) + "px";
    desktopProductsStickyCartClone.style.right = sourceRight + "px";
    desktopProductsStickyCartClone.style.left = "auto";
    desktopProductsStickyCartClone.style.bottom = "auto";
    desktopProductsStickyCartClone.style.zIndex = "1004";
    desktopProductsStickyCartClone.style.margin = "0";
    desktopProductsStickyCartClone.style.width = Math.round(rect.width) + "px";
    desktopProductsStickyCartClone.style.height = Math.round(rect.height) + "px";
    desktopProductsStickyCartClone.style.transform = "none";
    desktopProductsStickyCartClone.style.visibility = "visible";
    desktopProductsStickyCartClone.style.pointerEvents = "auto";

    setDesktopProductsStickyCartSourceVisibility(source, true);
  }

  function syncDesktopProductsStickyElements() {
    desktopProductsStickyCartSyncFrameId = 0;
    syncDesktopProductsStickyCart();
    syncDesktopProductsStickyLogo();
  }

  function requestDesktopProductsStickyCartSync() {
    if (desktopProductsStickyCartSyncFrameId) {
      return;
    }

    if (typeof window.requestAnimationFrame === "function") {
      desktopProductsStickyCartSyncFrameId = window.requestAnimationFrame(syncDesktopProductsStickyElements);
      return;
    }

    syncDesktopProductsStickyElements();
  }

  function bindDesktopProductsStickyCart() {
    if (desktopProductsStickyCartBound || typeof window === "undefined") {
      return;
    }

    desktopProductsStickyCartBound = true;
    window.addEventListener("scroll", requestDesktopProductsStickyCartSync, { passive: true });
    window.addEventListener("resize", requestDesktopProductsStickyCartSync);
    window.addEventListener("orientationchange", requestDesktopProductsStickyCartSync);
    requestDesktopProductsStickyCartSync();
  }

  function bindCartItemImageFallback(container) {
    if (!container) {
      return;
    }

    container.querySelectorAll(".vr-cart-item-image-img").forEach(function handleCartImageLoadErrors(img) {
      img.addEventListener("error", function onCartImageError() {
        var originalSrc = typeof img.getAttribute === "function" ? img.getAttribute("data-original-src") : "";
        var hasOriginalFallback = !!(originalSrc && originalSrc.trim());
        var alreadyRetried = img.getAttribute("data-original-retried") === "1";
        if (hasOriginalFallback && !alreadyRetried) {
          img.setAttribute("data-original-retried", "1");
          img.removeAttribute("srcset");
          img.src = originalSrc;
          return;
        }

        if (img.parentNode) {
          img.parentNode.removeChild(img);
        }
      });
    });
  }

  function closeCartImagePreview() {
    var previewRoot = document.getElementById("vr-cart-image-preview");
    if (!previewRoot) {
      if (document.body) {
        document.body.classList.remove("vr-cart-image-preview-open");
      }
      return;
    }

    if (typeof previewRoot.__cleanup === "function") {
      previewRoot.__cleanup();
      previewRoot.__cleanup = null;
    }

    if (previewRoot.parentNode) {
      previewRoot.parentNode.removeChild(previewRoot);
    }

    if (document.body) {
      document.body.classList.remove("vr-cart-image-preview-open");
    }
  }

  function openCartImagePreview(imageUrl, imageAlt) {
    var src = typeof imageUrl === "string" ? imageUrl.trim() : "";
    if (!src || !document.body) {
      return;
    }

    closeCartImagePreview();

    var alt = typeof imageAlt === "string" ? imageAlt.trim() : "";
    var dialogLabel = currentLanguage === LANGUAGE_EN ? "Product image preview" : "Pregled slike proizvoda";
    var closeLabel = currentLanguage === LANGUAGE_EN ? "Close image preview" : "Zatvori pregled slike";

    var previewRoot = document.createElement("div");
    previewRoot.id = "vr-cart-image-preview";
    previewRoot.className = "vr-cart-image-preview is-open";
    previewRoot.innerHTML = [
      '<button type="button" class="vr-cart-image-preview-backdrop" data-action="close-image-preview" aria-label="' +
        escapeHtml(closeLabel) +
        '"></button>',
      '<div class="vr-cart-image-preview-dialog" role="dialog" aria-modal="true" aria-label="' +
        escapeHtml(dialogLabel) +
        '">',
      '  <figure class="vr-cart-image-preview-panel">',
      '    <button type="button" class="vr-cart-image-preview-close" data-action="close-image-preview" aria-label="' +
        escapeHtml(closeLabel) +
        '">&times;</button>',
      '    <img class="vr-cart-image-preview-media" src="' +
        escapeHtml(src) +
        '" alt="' +
        escapeHtml(alt) +
        '" loading="eager" decoding="async" />',
      alt ? '    <figcaption class="vr-cart-image-preview-caption">' + escapeHtml(alt) + "</figcaption>" : "",
      "  </figure>",
      "</div>"
    ].join("\n");

    var handlePreviewClick = function handlePreviewClick(event) {
      var target = event.target;
      if (!target || typeof target.closest !== "function") {
        return;
      }

      var closeButton = target.closest('[data-action="close-image-preview"]');
      if (!closeButton) {
        return;
      }

      event.preventDefault();
      closeCartImagePreview();
    };

    var handlePreviewKeydown = function handlePreviewKeydown(event) {
      if (event.key !== "Escape") {
        return;
      }

      event.preventDefault();
      closeCartImagePreview();
    };

    previewRoot.addEventListener("click", handlePreviewClick);
    document.addEventListener("keydown", handlePreviewKeydown);
    previewRoot.__cleanup = function cleanupPreviewEvents() {
      previewRoot.removeEventListener("click", handlePreviewClick);
      document.removeEventListener("keydown", handlePreviewKeydown);
    };

    document.body.appendChild(previewRoot);
    document.body.classList.add("vr-cart-image-preview-open");

    var closeButton = previewRoot.querySelector(".vr-cart-image-preview-close");
    if (closeButton && typeof closeButton.focus === "function") {
      closeButton.focus();
    }
  }

  function isProductQuickViewOpen() {
    return !!(document.body && document.body.classList.contains(PRODUCT_QUICK_VIEW_OPEN_CLASS));
  }

  function closeProductQuickViewModal(options) {
    var config = options && typeof options === "object" ? options : {};
    var modalRoot = document.getElementById("vr-product-quick-view-modal");
    var modalImage = modalRoot ? modalRoot.querySelector(".vr-product-quick-view-image") : null;
    productQuickViewRequestId += 1;

    clearDetailImageZoom(modalImage);

    if (modalRoot) {
      if (typeof modalRoot.__cleanup === "function") {
        modalRoot.__cleanup();
        modalRoot.__cleanup = null;
      }

      if (modalRoot.parentNode) {
        modalRoot.parentNode.removeChild(modalRoot);
      }
    }

    if (document.body) {
      document.body.classList.remove(PRODUCT_QUICK_VIEW_OPEN_CLASS);
    }

    if (
      !config.skipFocusRestore &&
      productQuickViewLastFocusedElement &&
      typeof productQuickViewLastFocusedElement.focus === "function"
    ) {
      try {
        productQuickViewLastFocusedElement.focus();
      } catch (_error) {
        // Ignore detached node focus failures.
      }
    }

    productQuickViewLastFocusedElement = null;
  }

  function renderProductQuickViewCartControls(container, product, fallbackSlug, detailImage) {
    var currentProduct = product && typeof product === "object" ? product : {};
    var quantityLabel = currentLanguage === LANGUAGE_EN ? "Quantity" : "Kolicina";
    var addToCartLabel = currentLanguage === LANGUAGE_EN ? "Add to cart" : "Dodaj u korpu";
    var buyNowLabel = currentLanguage === LANGUAGE_EN ? "Buy now" : "Kupi sad";
    var unavailableMessage =
      currentLanguage === LANGUAGE_EN
        ? "This product is unavailable for ordering."
        : "Proizvod nije dostupan za narudzbu.";
    var addErrorMessage =
      currentLanguage === LANGUAGE_EN
        ? "Adding to cart is currently unavailable."
        : "Dodavanje u korpu trenutno nije dostupno.";
    var buyNowErrorMessage =
      currentLanguage === LANGUAGE_EN
        ? "Checkout is currently unavailable. Please try again."
        : "Kupovina trenutno nije dostupna. Pokusajte ponovo.";
    var quantityInputId =
      "vr-product-quick-view-quantity-" + String(Date.now()) + "-" + String(Math.floor(Math.random() * 1000));

    if (!container) {
      return;
    }

    container.classList.add("vr-detail-cart-host");
    container.innerHTML = [
      '<form class="vr-detail-form" data-vr-role="quick-view-cart-form" novalidate>',
      '  <label class="cc-quantity-field-label" for="' + quantityInputId + '">' + quantityLabel + "</label>",
      '  <div class="vr-detail-controls">',
      '    <input class="text-field cc-quantity-field" id="' +
        quantityInputId +
        '" data-vr-role="quick-view-quantity" type="number" min="1" max="99" value="1" />',
      '    <button type="submit" data-vr-role="quick-view-add-btn" class="primary-button cc-add-to-cart-btn vr-product-add-btn">' +
        addToCartLabel +
        "</button>",
      '    <a href="/checkout" data-vr-role="quick-view-buy-now" class="primary-button vr-buy-now-btn">' +
        buyNowLabel +
        "</a>",
      "  </div>",
      '  <div data-vr-role="quick-view-store-stock" class="vr-detail-store-stock-host"></div>',
      '  <div data-vr-role="quick-view-feedback" class="vr-feedback" aria-live="polite"></div>',
      "</form>"
    ].join("\n");

    var form = container.querySelector('[data-vr-role="quick-view-cart-form"]');
    var quantityInput = container.querySelector('[data-vr-role="quick-view-quantity"]');
    var feedback = container.querySelector('[data-vr-role="quick-view-feedback"]');
    var addButton = container.querySelector('[data-vr-role="quick-view-add-btn"]');
    var buyNowButton = container.querySelector('[data-vr-role="quick-view-buy-now"]');
    var storeStockHost = container.querySelector('[data-vr-role="quick-view-store-stock"]');

    if (!form || !quantityInput || !feedback || !addButton) {
      return;
    }

    var productSlug = typeof currentProduct.slug === "string" ? currentProduct.slug.trim() : "";
    var fallback = typeof fallbackSlug === "string" ? fallbackSlug.trim() : "";
    var productName = typeof currentProduct.name === "string" ? currentProduct.name.trim() : "";
    var cartProduct = {
      slug: productSlug || fallback,
      name: productName,
      image_url: typeof currentProduct.image_url === "string" ? currentProduct.image_url : "",
      price_bam: normalizeMoney(currentProduct.price_bam),
      retail_price_bam: normalizeMoneyOrNull(currentProduct.retail_price_bam),
      stock_tracking_enabled: normalizeBoolean(currentProduct.stock_tracking_enabled),
      available_quantity: getProductAvailableQuantity(currentProduct)
    };
    var availabilityText = getProductAvailabilityCountText(currentProduct);
    var soldOut = isProductSoldOut(currentProduct);
    var availableQuantity = getProductAvailableQuantity(currentProduct);
    var storeStockList = createProductStoreStockList(currentProduct, {
      detail: true,
      showExactCounts: true
    });

    if (storeStockHost) {
      clearChildren(storeStockHost);
      if (storeStockList) {
        storeStockHost.appendChild(storeStockList);
      } else {
        storeStockHost.remove();
      }
    }

    if (!cartProduct.slug || !cartProduct.name) {
      addButton.setAttribute("disabled", "disabled");
      if (buyNowButton) {
        buyNowButton.classList.add("w--disabled");
        buyNowButton.setAttribute("aria-disabled", "true");
        buyNowButton.setAttribute("tabindex", "-1");
      }
      feedback.className = "vr-feedback error";
      feedback.textContent = unavailableMessage;
      return;
    }

    if (isStockTrackingEnabled(currentProduct)) {
      quantityInput.max = String(Math.max(1, Math.min(MAX_CART_QUANTITY, availableQuantity)));
      feedback.className = "vr-feedback " + getProductAvailabilityFeedbackClass(currentProduct);
      feedback.textContent = availabilityText;
      if (soldOut) {
        addButton.setAttribute("disabled", "disabled");
        addButton.classList.add("w--disabled");
        addButton.textContent = currentLanguage === LANGUAGE_EN ? "Sold out" : "Rasprodato";
        if (buyNowButton) {
          buyNowButton.classList.add("w--disabled");
          buyNowButton.setAttribute("aria-disabled", "true");
          buyNowButton.setAttribute("tabindex", "-1");
        }
        return;
      }
    }

    form.addEventListener("submit", function onQuickViewAddToCart(event) {
      event.preventDefault();

      if (isStockTrackingEnabled(currentProduct) && normalizeQuantity(quantityInput.value) > availableQuantity) {
        feedback.className = "vr-feedback error";
        feedback.textContent = availabilityText;
        return;
      }

      try {
        addToCart(cartProduct, quantityInput.value);
        refreshCartLinks();
        animateImageToCart({
          sourceElement: detailImage,
          imageUrl: cartProduct.image_url
        });
        closeProductQuickViewModal();
      } catch (_error) {
        addButton.classList.remove("vr-added-success");
        addButton.textContent = currentLanguage === LANGUAGE_EN ? "Try again" : "Pokusaj ponovo";
        addButton.disabled = false;
        window.setTimeout(function restoreQuickViewAddButtonAfterError() {
          addButton.textContent = currentLanguage === LANGUAGE_EN ? "Add to cart" : "Dodaj u korpu";
        }, 1000);
        feedback.className = "vr-feedback error";
        feedback.textContent = isStockTrackingEnabled(currentProduct) ? availabilityText : addErrorMessage;
      }
    });

    if (buyNowButton) {
      buyNowButton.addEventListener("click", function onQuickViewBuyNow(event) {
        event.preventDefault();

        if (isStockTrackingEnabled(currentProduct) && normalizeQuantity(quantityInput.value) > availableQuantity) {
          feedback.className = "vr-feedback error";
          feedback.textContent = availabilityText;
          return;
        }

        try {
          addToCart(cartProduct, quantityInput.value, {
            notify: false
          });
          refreshCartLinks();
          window.location.href = "/checkout";
        } catch (_error) {
          feedback.className = "vr-feedback error";
          feedback.textContent = isStockTrackingEnabled(currentProduct) ? availabilityText : buyNowErrorMessage;
        }
      });
    }
  }

  function renderProductQuickViewLoadingSkeleton(modalRoot, loadingMessage) {
    if (!modalRoot) {
      return;
    }

    var image = modalRoot.querySelector(".vr-product-quick-view-image");
    var name = modalRoot.querySelector(".vr-product-quick-view-name");
    var price = modalRoot.querySelector(".vr-product-quick-view-price");
    var description = modalRoot.querySelector(".vr-product-quick-view-description");
    var cartHost = modalRoot.querySelector(".vr-product-quick-view-cart-host");
    var status = modalRoot.querySelector(".vr-product-quick-view-status");

    if (image) {
      clearDetailImageZoom(image);
      image.style.backgroundImage = "none";
      image.classList.add("vr-product-image-shell");
      image.classList.add("vr-image-loading");
      image.classList.remove("vr-image-pending");
      image.classList.remove("vr-image-loaded");
    }

    if (name) {
      name.innerHTML =
        '<span class="vr-skeleton vr-product-quick-view-skeleton-line vr-product-quick-view-skeleton-name" aria-hidden="true"></span>';
    }

    if (price) {
      price.innerHTML =
        '<span class="vr-skeleton vr-product-quick-view-skeleton-line vr-product-quick-view-skeleton-price" aria-hidden="true"></span>';
    }

    if (description) {
      description.innerHTML = [
        '<span class="vr-skeleton vr-product-quick-view-skeleton-line vr-product-quick-view-skeleton-copy" aria-hidden="true"></span>',
        '<span class="vr-skeleton vr-product-quick-view-skeleton-line vr-product-quick-view-skeleton-copy" aria-hidden="true"></span>',
        '<span class="vr-skeleton vr-product-quick-view-skeleton-line vr-product-quick-view-skeleton-copy short" aria-hidden="true"></span>'
      ].join("");
    }

    if (cartHost) {
      cartHost.innerHTML = [
        '<div class="vr-product-quick-view-form-skeleton" aria-hidden="true">',
        '  <span class="vr-skeleton vr-product-quick-view-skeleton-label"></span>',
        '  <div class="vr-product-quick-view-form-skeleton-controls">',
        '    <span class="vr-skeleton vr-product-quick-view-skeleton-input"></span>',
        '    <span class="vr-skeleton vr-product-quick-view-skeleton-btn"></span>',
        "  </div>",
        "</div>"
      ].join("\n");
    }

    if (status) {
      status.className = "vr-feedback vr-product-quick-view-status";
      status.textContent = loadingMessage || "";
      status.style.display = "none";
    }
  }

  async function openProductQuickViewModal(slug, options) {
    var normalizedSlug = typeof slug === "string" ? slug.trim() : "";
    if (!normalizedSlug || !document.body) {
      return;
    }

    var config = options && typeof options === "object" ? options : {};
    var closeLabel = currentLanguage === LANGUAGE_EN ? "Close product details" : "Zatvori detalje proizvoda";
    var dialogLabel = currentLanguage === LANGUAGE_EN ? "Product details" : "Detalji proizvoda";
    var loadingMessage = currentLanguage === LANGUAGE_EN ? "Loading product..." : "Ucitavanje proizvoda...";
    var unavailableMessage =
      currentLanguage === LANGUAGE_EN
        ? "This product is currently unavailable."
        : "Proizvod trenutno nije dostupan.";

    closeProductQuickViewModal({
      skipFocusRestore: true
    });
    productQuickViewLastFocusedElement = config.triggerElement || document.activeElement;

    var modalRoot = document.createElement("div");
    modalRoot.id = "vr-product-quick-view-modal";
    modalRoot.className = "vr-product-quick-view-modal is-open";
    modalRoot.innerHTML = [
      '<button type="button" class="vr-product-quick-view-backdrop" data-action="close-product-quick-view" aria-label="' +
        escapeHtml(closeLabel) +
        '"></button>',
      '<div class="vr-product-quick-view-dialog" role="dialog" aria-modal="true" aria-label="' +
        escapeHtml(dialogLabel) +
        '">',
      '  <div class="vr-product-quick-view-panel">',
      '    <button type="button" class="vr-product-quick-view-close" data-action="close-product-quick-view" aria-label="' +
        escapeHtml(closeLabel) +
        '">&times;</button>',
      '    <div class="vr-product-quick-view-layout">',
      '      <div class="vr-product-quick-view-image product-image"></div>',
      '      <div class="vr-product-quick-view-content">',
      '        <div class="product-detail-main-details vr-product-quick-view-main">',
      '          <h2 class="product-detail-name vr-product-quick-view-name"></h2>',
      '          <div class="product-detail-price vr-product-quick-view-price"></div>',
      '          <div class="vr-product-quick-view-review"></div>',
      '          <div class="paragraph-light vr-product-quick-view-description"></div>',
      "        </div>",
      '        <div class="divider cc-dark-divider"></div>',
      '        <div class="w-embed vr-product-quick-view-cart-host"></div>',
      '        <div class="vr-feedback vr-product-quick-view-status" aria-live="polite">' +
        escapeHtml(loadingMessage) +
        "</div>",
      "      </div>",
      "    </div>",
      "  </div>",
      "</div>"
    ].join("\n");

    var quickViewActiveImageUrl = "";
    var quickViewCloseToneFrameId = 0;
    var quickViewImageSizingFrameId = 0;
    var scheduleQuickViewCloseButtonTone = function scheduleQuickViewCloseButtonTone() {
      if (!modalRoot || !modalRoot.isConnected) {
        return;
      }

      if (quickViewCloseToneFrameId) {
        window.cancelAnimationFrame(quickViewCloseToneFrameId);
      }

      quickViewCloseToneFrameId = window.requestAnimationFrame(function onQuickViewCloseToneFrame() {
        quickViewCloseToneFrameId = 0;
        updateProductQuickViewCloseButtonContrast(modalRoot, quickViewActiveImageUrl);
      });
    };
    var scheduleQuickViewImageSizing = function scheduleQuickViewImageSizing() {
      if (!modalRoot || !modalRoot.isConnected) {
        return;
      }

      if (quickViewImageSizingFrameId) {
        window.cancelAnimationFrame(quickViewImageSizingFrameId);
      }

      quickViewImageSizingFrameId = window.requestAnimationFrame(function onQuickViewImageSizingFrame() {
        quickViewImageSizingFrameId = 0;
        applyProductQuickViewImageAspectRatio(modalRoot, modalRoot.__vrQuickViewImageAspectRatio || 0);
        scheduleQuickViewCloseButtonTone();
      });
    };
    var handleQuickViewResize = function handleQuickViewResize() {
      scheduleQuickViewImageSizing();
      scheduleQuickViewCloseButtonTone();
    };

    var handleQuickViewClick = function handleQuickViewClick(event) {
      var target = event.target;
      if (!target || typeof target.closest !== "function") {
        return;
      }

      var panel = modalRoot.querySelector(".vr-product-quick-view-panel");
      var eventPath = typeof event.composedPath === "function" ? event.composedPath() : [];
      var clickedInsidePanel =
        !!panel &&
        (panel.contains(target) || (Array.isArray(eventPath) && eventPath.indexOf(panel) !== -1));
      if (panel && !clickedInsidePanel) {
        event.preventDefault();
        closeProductQuickViewModal();
        return;
      }

      var closeButton = target.closest('[data-action="close-product-quick-view"]');
      if (!closeButton) {
        return;
      }

      event.preventDefault();
      closeProductQuickViewModal();
    };

    var handleQuickViewKeydown = function handleQuickViewKeydown(event) {
      if (!isProductQuickViewOpen()) {
        return;
      }

      var dialog = modalRoot.querySelector(".vr-product-quick-view-dialog");
      if (!dialog) {
        return;
      }

      if (event.key === "Escape") {
        event.preventDefault();
        closeProductQuickViewModal();
        return;
      }

      trapFocusInContainer(event, dialog);
    };

    modalRoot.addEventListener("click", handleQuickViewClick);
    document.addEventListener("keydown", handleQuickViewKeydown);
    window.addEventListener("resize", handleQuickViewResize);
    modalRoot.__cleanup = function cleanupQuickViewEvents() {
      modalRoot.removeEventListener("click", handleQuickViewClick);
      document.removeEventListener("keydown", handleQuickViewKeydown);
      window.removeEventListener("resize", handleQuickViewResize);
      if (quickViewCloseToneFrameId) {
        window.cancelAnimationFrame(quickViewCloseToneFrameId);
        quickViewCloseToneFrameId = 0;
      }
      if (quickViewImageSizingFrameId) {
        window.cancelAnimationFrame(quickViewImageSizingFrameId);
        quickViewImageSizingFrameId = 0;
      }
    };

    document.body.appendChild(modalRoot);
    document.body.classList.add(PRODUCT_QUICK_VIEW_OPEN_CLASS);

    var closeButton = modalRoot.querySelector(".vr-product-quick-view-close");
    setQuickViewCloseButtonTone(closeButton, false);
    if (closeButton && typeof closeButton.focus === "function") {
      closeButton.focus();
    }
    renderProductQuickViewLoadingSkeleton(modalRoot, loadingMessage);

    var requestId = (productQuickViewRequestId += 1);

    try {
      var payload = await requestJson(productDetailApiPath(normalizedSlug));
      if (requestId !== productQuickViewRequestId) {
        return;
      }

      var currentModal = document.getElementById("vr-product-quick-view-modal");
      if (!currentModal) {
        return;
      }

      var product = payload && payload.product ? payload.product : null;
      var image = currentModal.querySelector(".vr-product-quick-view-image");
      var name = currentModal.querySelector(".vr-product-quick-view-name");
      var price = currentModal.querySelector(".vr-product-quick-view-price");
      var reviewHost = currentModal.querySelector(".vr-product-quick-view-review");
      var description = currentModal.querySelector(".vr-product-quick-view-description");
      var cartHost = currentModal.querySelector(".vr-product-quick-view-cart-host");
      var status = currentModal.querySelector(".vr-product-quick-view-status");

      if (!product) {
        clearDetailImageZoom(image);
        scheduleQuickViewCloseButtonTone();
        if (status) {
          status.className = "vr-feedback vr-product-quick-view-status error";
          status.textContent = unavailableMessage;
          status.style.display = "";
        }
        return;
      }

      if (image) {
        image.classList.remove("vr-image-loading");
        setProductCardImage(image, product.image_url, {
          role: "quick-view",
          productName: product.name || ""
        });
        initDetailImageZoom(image, product.image_url);
      }

      quickViewActiveImageUrl = typeof product.image_url === "string" ? product.image_url.trim() : "";
      updateProductQuickViewImageSizing(currentModal, quickViewActiveImageUrl)
        .then(function rescheduleQuickViewToneAfterSizing() {
          scheduleQuickViewCloseButtonTone();
        })
        .catch(function ignoreQuickViewImageSizingError() {
          scheduleQuickViewCloseButtonTone();
        });
      scheduleQuickViewCloseButtonTone();

      if (name) {
        name.textContent = product.name || "";
      }

      if (price) {
        clearChildren(price);
        price.appendChild(createProductPriceRow(product));
      }

      if (reviewHost) {
        clearChildren(reviewHost);
        var reviewWidget = createProductReviewWidget(product, {
          detail: true
        });
        if (reviewWidget) {
          reviewHost.appendChild(reviewWidget);
        } else {
          reviewHost.remove();
        }
      }

      if (description) {
        description.textContent = product.description || "";
      }

      if (cartHost) {
        renderProductQuickViewCartControls(cartHost, product, normalizedSlug, image);
      }

      if (status) {
        status.className = "vr-feedback vr-product-quick-view-status";
        status.textContent = "";
        status.style.display = "none";
      }
    } catch (_error) {
      if (requestId !== productQuickViewRequestId) {
        return;
      }

      var fallbackModal = document.getElementById("vr-product-quick-view-modal");
      if (!fallbackModal) {
        return;
      }

      var fallbackStatus = fallbackModal.querySelector(".vr-product-quick-view-status");
      if (fallbackStatus) {
        fallbackStatus.className = "vr-feedback vr-product-quick-view-status error";
        fallbackStatus.textContent = unavailableMessage;
        fallbackStatus.style.display = "";
      }
    }
  }

  function renderCartDrawerRows(container, cart) {
    if (!container) {
      return;
    }

    if (!cart.length) {
      container.innerHTML =
        '<div class="vr-empty"><p>Korpa je prazna.</p><a class="primary-button" href="/products">Pogledaj proizvode</a></div>';
      return;
    }

    container.innerHTML = cart
      .map(function mapItem(item) {
        var unitPriceMarkup = getCartUnitPriceHtml(item);
        var lineTotalMarkup = getCartLineTotalHtml(item);
        var itemImageUrl = buildResponsiveImageUrl(item.image_url, {
          role: "cart"
        }) || item.image_url;
        var itemImageSrcset = buildResponsiveImageSrcset(item.image_url, "cart");

        return [
          '<div class="vr-cart-drawer-row" data-slug="' + escapeHtml(item.slug) + '">',
          itemImageUrl
            ? '    <div class="vr-cart-item-image"><img class="vr-cart-item-image-img" src="' +
              escapeHtml(itemImageUrl) +
              '" ' +
              (itemImageSrcset ? 'srcset="' + escapeHtml(itemImageSrcset) + '" sizes="72px" ' : "") +
              'data-original-src="' +
              escapeHtml(item.image_url || itemImageUrl) +
              '" ' +
              'alt="' +
              escapeHtml(item.name || "") +
              '" loading="lazy" decoding="async" /></div>'
            : '    <div class="vr-cart-item-image"></div>',
          '  <div class="vr-cart-drawer-main">',
          '    <div class="vr-cart-drawer-item-top">',
          '      <div class="vr-cart-drawer-item-copy">',
          '        <div class="vr-cart-drawer-item-name">' + escapeHtml(item.name) + "</div>",
          '        <div class="vr-cart-drawer-item-unit">' + unitPriceMarkup + "</div>",
          "      </div>",
          '      <button class="vr-cart-remove-btn" type="button" data-action="remove" aria-label="Ukloni proizvod">&times;</button>',
          "    </div>",
          '    <div class="vr-cart-drawer-row-meta">',
          '      <div class="vr-cart-drawer-qty-stepper">',
          '        <button class="vr-cart-drawer-qty-btn" type="button" data-action="quantity-decrement" aria-label="Smanji kolicinu">-</button>',
          '        <input class="text-field vr-cart-drawer-qty" type="number" min="1" max="99" data-action="quantity" value="' +
            escapeHtml(item.quantity) +
            '" />',
          '        <button class="vr-cart-drawer-qty-btn" type="button" data-action="quantity-increment" aria-label="Povecaj kolicinu">+</button>',
          "      </div>",
          '    <div class="vr-cart-drawer-row-total">' + lineTotalMarkup + "</div>",
          "    </div>",
          "  </div>",
          "</div>"
        ].join("\n");
      })
      .join("\n");

    bindCartItemImageFallback(container);
  }

  function syncCartDrawer() {
    var itemsContainer = document.getElementById("vr-cart-drawer-items");
    if (!itemsContainer) {
      return;
    }

    var cart = readCart();
    var summary = getCartSummary(cart);
    var countElement = document.getElementById("vr-cart-drawer-count");
    var subtotalElement = document.getElementById("vr-cart-drawer-subtotal");
    var shippingElement = document.getElementById("vr-cart-drawer-shipping");
    var totalElement = document.getElementById("vr-cart-drawer-total");
    var deliveryNoticeElement = document.getElementById("vr-cart-drawer-delivery-note");
    var checkoutButton = document.getElementById("vr-cart-drawer-checkout");

    renderCartDrawerRows(itemsContainer, cart);

    if (countElement) {
      countElement.textContent = String(summary.count);
    }

    if (subtotalElement) {
      subtotalElement.textContent = formatPrice(summary.subtotal);
    }

    if (shippingElement) {
      shippingElement.textContent = formatPrice(summary.shipping);
    }

    if (totalElement) {
      totalElement.textContent = formatPrice(summary.total);
    }

    renderDeliveryNotice(deliveryNoticeElement, summary.subtotal);

    if (checkoutButton) {
      if (!cart.length) {
        checkoutButton.classList.add("w--disabled");
        checkoutButton.setAttribute("aria-disabled", "true");
        checkoutButton.setAttribute("tabindex", "-1");
      } else {
        checkoutButton.classList.remove("w--disabled");
        checkoutButton.removeAttribute("aria-disabled");
        checkoutButton.removeAttribute("tabindex");
      }
    }
  }

  function closeCartDrawer(options) {
    var config = options && typeof options === "object" ? options : {};
    if (document.body) {
      document.body.classList.remove(CART_DRAWER_OPEN_CLASS);
    }

    var drawer = document.getElementById("vr-cart-drawer");
    if (drawer) {
      drawer.setAttribute("aria-hidden", "true");
      drawer.setAttribute("inert", "");
    }

    if (config.restoreFocus !== false) {
      restoreFocusIfPossible(cartDrawerLastFocusedElement);
      cartDrawerLastFocusedElement = null;
    }
  }

  function openCartDrawer(options) {
    var config = options && typeof options === "object" ? options : {};
    ensureCartDrawer();
    syncCartDrawer();

    if (config.triggerElement instanceof Element) {
      cartDrawerLastFocusedElement = config.triggerElement;
    } else if (!cartDrawerLastFocusedElement && document.activeElement instanceof Element) {
      cartDrawerLastFocusedElement = document.activeElement;
    }

    if (document.body) {
      document.body.classList.add(CART_DRAWER_OPEN_CLASS);
    }

    var drawer = document.getElementById("vr-cart-drawer");
    if (!drawer) {
      return;
    }

    drawer.setAttribute("aria-hidden", "false");
    drawer.removeAttribute("inert");
    var closeButton = drawer.querySelector(".vr-cart-drawer-close");
    if (closeButton && typeof closeButton.focus === "function") {
      closeButton.focus();
    }

    if (config.flyIn) {
      drawer.classList.remove(CART_DRAWER_FLY_IN_CLASS);
      drawer.offsetWidth;
      drawer.classList.add(CART_DRAWER_FLY_IN_CLASS);

      if (cartDrawerFlyTimeoutId) {
        window.clearTimeout(cartDrawerFlyTimeoutId);
      }

      cartDrawerFlyTimeoutId = window.setTimeout(function clearDrawerFlyInClass() {
        drawer.classList.remove(CART_DRAWER_FLY_IN_CLASS);
        cartDrawerFlyTimeoutId = null;
      }, 420);
    }
  }

  function ensureCartDrawer() {
    if (!document.body || document.getElementById("vr-cart-drawer-root")) {
      return;
    }

    var root = document.createElement("div");
    root.id = "vr-cart-drawer-root";
    root.className = "vr-cart-drawer-root";
    root.innerHTML = [
      '<button type="button" class="vr-cart-drawer-backdrop" aria-label="Zatvori korpu" data-action="close-cart-drawer"></button>',
      '<aside id="vr-cart-drawer" class="vr-cart-drawer" role="dialog" aria-modal="true" aria-hidden="true" aria-labelledby="vr-cart-drawer-title" inert>',
      '  <div class="vr-cart-drawer-head">',
      '    <h4 id="vr-cart-drawer-title" class="vr-cart-drawer-title">Korpa</h4>',
      '    <button type="button" class="vr-cart-drawer-close" aria-label="Zatvori korpu" data-action="close-cart-drawer">',
      '      <span class="vr-cart-drawer-close-icon" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></span>',
      "    </button>",
      "  </div>",
      '  <div id="vr-cart-drawer-items" class="vr-cart-drawer-items"></div>',
      '  <div class="vr-cart-drawer-footer">',
      '    <div class="vr-summary-row"><span>Stavke</span><span id="vr-cart-drawer-count">0</span></div>',
      '    <div class="vr-summary-row vr-summary-subtotal"><span>Subtotal</span><span id="vr-cart-drawer-subtotal"></span></div>',
      '    <div class="vr-summary-row"><span>Dostava</span><span id="vr-cart-drawer-shipping"></span></div>',
      '    <p id="vr-cart-drawer-delivery-note" class="vr-muted vr-delivery-note"></p>',
      '    <div class="vr-summary-row vr-summary-total"><span>Ukupno</span><span id="vr-cart-drawer-total"></span></div>',
      '    <a id="vr-cart-drawer-checkout" href="/checkout" class="primary-button vr-cart-drawer-checkout-btn">Nastavi na pla\u0107anje</a>',
      "  </div>",
      "</aside>"
    ].join("\n");

    document.body.appendChild(root);

    root.addEventListener("click", function onCartDrawerClick(event) {
      var target = event.target;
      if (!target || typeof target.closest !== "function") {
        return;
      }

      var closeButton = target.closest('[data-action="close-cart-drawer"]');
      if (closeButton) {
        event.preventDefault();
        closeCartDrawer();
        return;
      }

      var quantityButton = target.closest(
        'button[data-action="quantity-decrement"],button[data-action="quantity-increment"]'
      );
      if (quantityButton) {
        var quantityRow = quantityButton.closest("[data-slug]");
        if (!quantityRow) {
          return;
        }

        adjustCartItemQuantity(
          quantityRow.getAttribute("data-slug"),
          quantityButton.getAttribute("data-action") === "quantity-decrement" ? -1 : 1
        );
        return;
      }

      var removeButton = target.closest('button[data-action="remove"]');
      if (!removeButton) {
        return;
      }

      var row = removeButton.closest("[data-slug]");
      if (!row) {
        return;
      }

      removeCartItem(row.getAttribute("data-slug"));
    });

    var itemsContainer = root.querySelector("#vr-cart-drawer-items");
    if (itemsContainer) {
      itemsContainer.addEventListener("change", function onCartDrawerQuantityChange(event) {
        var target = event.target;
        if (!target || typeof target.closest !== "function") {
          return;
        }

        var input = target.closest('input[data-action="quantity"]');
        if (!input) {
          return;
        }

        var row = input.closest("[data-slug]");
        if (!row) {
          return;
        }

        setCartItemQuantity(row.getAttribute("data-slug"), input.value);
      });
    }
  }

  function bindCartDrawerInteractions() {
    if (cartDrawerInteractionsBound) {
      return;
    }

    cartDrawerInteractionsBound = true;

    document.addEventListener("click", function onCartTriggerClick(event) {
      var target = event.target;
      if (!target || typeof target.closest !== "function") {
        return;
      }

      var cartTrigger = target.closest("a.navigation-item.cart-icon, .div-block-6");
      if (!cartTrigger) {
        return;
      }

      if (cartTrigger.classList.contains("div-block-6")) {
        var cartLinkInside = cartTrigger.querySelector("a.navigation-item.cart-icon");
        if (!cartLinkInside) {
          return;
        }

        cartTrigger = cartLinkInside;
      }

      if (!isPrimaryActionClick(event)) {
        return;
      }

      event.preventDefault();
      openCartDrawer({
        flyIn: true,
        triggerElement: cartTrigger
      });
    });

    document.addEventListener("keydown", function onCartDrawerKeydown(event) {
      if (event.key === "Escape" && isProductQuickViewOpen()) {
        event.preventDefault();
        closeProductQuickViewModal();
        return;
      }

      var drawer = document.getElementById("vr-cart-drawer");
      if (!drawer || !document.body || !document.body.classList.contains(CART_DRAWER_OPEN_CLASS)) {
        return;
      }

      if (event.key === "Escape") {
        closeCartDrawer();
        return;
      }

      trapFocusInContainer(event, drawer);
    });

    window.addEventListener(CART_UPDATE_EVENT, syncCartDrawer);
    window.addEventListener(CART_ITEM_ADDED_EVENT, function onCartItemAdded() {
      if (isMobileViewport()) {
        return;
      }

      openCartDrawer({
        flyIn: true
      });
    });
  }

  function ensureAdminLoginShortcut() {
    document.querySelectorAll(".div-block-6").forEach(function appendAdminLink(container) {
      var cartLink = container.querySelector("a.navigation-item.cart-icon");
      if (!cartLink) {
        return;
      }

      var parent = container.parentElement;
      if (!parent) {
        return;
      }

      var wrap = null;
      if (parent.classList && parent.classList.contains("vr-cart-admin-wrap")) {
        wrap = parent;
      } else {
        wrap = document.createElement("span");
        wrap.className = "vr-cart-admin-wrap";
        wrap.setAttribute("data-vr-cart-admin-wrap", "1");
        parent.insertBefore(wrap, container);
        wrap.appendChild(container);
      }

      var adminLink = wrap.querySelector("a.vr-admin-link[data-vr-admin-shortcut='1']");
      if (!adminLink) {
        // Backward-compat: move previously injected link into the wrapper.
        adminLink =
          container.querySelector("a.vr-admin-link") ||
          parent.querySelector("a.vr-admin-link[data-vr-admin-shortcut='1']");
      }

      if (!adminLink) {
        adminLink = document.createElement("a");
        adminLink.href = "/admin";
        adminLink.className = "vr-admin-link";
        adminLink.setAttribute("aria-label", "Admin login");
        adminLink.setAttribute("title", "Admin login");
        adminLink.setAttribute("data-vr-admin-shortcut", "1");
        adminLink.innerHTML = [
          '<svg class="vr-admin-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">',
          '  <circle cx="12" cy="8" r="4"></circle>',
          '  <path d="M4 20c1.5-3.6 4.2-5.5 8-5.5s6.5 1.9 8 5.5"></path>',
          "</svg>",
          '<span class="vr-sr-only">Admin</span>'
        ].join("");
      } else {
        adminLink.setAttribute("data-vr-admin-shortcut", "1");
      }

      if (adminLink.parentElement !== wrap) {
        wrap.appendChild(adminLink);
      }

      if (container.nextSibling !== adminLink && container.parentElement === wrap) {
        wrap.insertBefore(adminLink, container.nextSibling);
      }
    });
  }

  function buildFooterCategoryLink(category) {
    var link = document.createElement("a");
    link.className = "footer-link";
    link.href = categoryHref(category.slug);
    link.textContent = category.name;
    return link;
  }

  function normalizeFooterCurrentStates() {
    document.querySelectorAll(".footer a.footer-link[aria-current='page']").forEach(function normalizeLinkState(link) {
      var href = String(link.getAttribute("href") || "").trim();
      if (!href || href === "#") {
        link.removeAttribute("aria-current");
        link.classList.remove("w--current");
        return;
      }

      if (/^https?:\/\//i.test(href)) {
        link.removeAttribute("aria-current");
        link.classList.remove("w--current");
        return;
      }

      var normalizedHref = href.replace(/\.html$/i, "").replace(/\/+$/, "") || "/";
      if (normalizedHref === "index") {
        normalizedHref = "/";
      } else if (normalizedHref.charAt(0) !== "/") {
        normalizedHref = "/" + normalizedHref;
      }
      var normalizedPath = String(window.location.pathname || "").replace(/\/+$/, "") || "/";
      if (normalizedHref !== normalizedPath) {
        link.removeAttribute("aria-current");
        link.classList.remove("w--current");
      }
    });
  }

  function buildFooterTrustLink(label, href) {
    var link = document.createElement("a");
    link.className = "footer-link";
    link.href = href;
    link.textContent = label;
    return link;
  }

  function normalizeFooterTrustLinks() {
    var replacementItems =
      currentLanguage === LANGUAGE_EN
        ? [
            { label: "Email", href: "mailto:" + CONTACT_EMAIL },
            { label: "Phone", href: "tel:" + CONTACT_PHONE },
            { label: "Stores", href: "/radnje" }
          ]
        : [
            { label: "Email", href: "mailto:" + CONTACT_EMAIL },
            { label: "Telefon", href: "tel:" + CONTACT_PHONE },
            { label: "Radnje", href: "/radnje" }
          ];

    document.querySelectorAll(".footer").forEach(function patchFooter(footer) {
      footer.setAttribute("role", "contentinfo");
      var labels = Array.prototype.slice.call(footer.querySelectorAll(".label"));
      var followLabel = labels.find(function findFollowLabel(label) {
        var text = String(label.textContent || "")
          .trim()
          .toLowerCase();
        return text === "follow" || text === "kontakt" || text === "contact";
      });

      if (!followLabel) {
        return;
      }

      var followSection = followLabel.nextElementSibling;
      if (!followSection || !followSection.classList.contains("links-section-footer")) {
        return;
      }

      var links = Array.prototype.slice.call(followSection.querySelectorAll("a.footer-link"));
      if (!links.length) {
        return;
      }

      var hasWebflowPlaceholders = links.some(function hasPlaceholder(link) {
        var href = String(link.getAttribute("href") || "").toLowerCase();
        return (
          href.indexOf(TRUST_INSTAGRAM_PLACEHOLDER) >= 0 ||
          href.indexOf(TRUST_FACEBOOK_PLACEHOLDER) >= 0 ||
          href.indexOf(TRUST_TWITTER_PLACEHOLDER) >= 0
        );
      });

      if (!hasWebflowPlaceholders) {
        links.forEach(function normalizeExternalAttributes(link) {
          if (link.target === "_blank") {
            link.setAttribute("rel", "noopener noreferrer");
          }
        });
        return;
      }

      followLabel.textContent = currentLanguage === LANGUAGE_EN ? "Contact" : "Kontakt";
      clearChildren(followSection);
      replacementItems.forEach(function appendReplacement(item) {
        followSection.appendChild(buildFooterTrustLink(item.label, item.href));
      });
    });

    normalizeFooterCurrentStates();
  }

  function normalizeCoreImageAltText() {
    document.querySelectorAll("img.logo-image, img.logo-footer").forEach(function patchLogoAlt(img) {
      if (!String(img.getAttribute("alt") || "").trim()) {
        img.setAttribute("alt", "Vape Republic logo");
      }
    });

    document.querySelectorAll("img.menu-icon").forEach(function patchMenuAlt(img) {
      if (!String(img.getAttribute("alt") || "").trim()) {
        img.setAttribute("alt", "Open menu");
      }
    });
  }

  function normalizeDynamicListSemantics(root) {
    var scope = root && typeof root.querySelectorAll === "function" ? root : document;

    scope.querySelectorAll(".w-dyn-items").forEach(function patchDynamicList(list) {
      list.setAttribute("role", "list");

      Array.prototype.forEach.call(list.children, function patchDynamicListItem(item) {
        if (item.classList && item.classList.contains("w-dyn-item")) {
          item.setAttribute("role", "listitem");
        }
      });
    });
  }

  function renderFooterCategories(categories) {
    var footerDynLists = Array.prototype.slice.call(
      document.querySelectorAll(".footer .links-section-footer .w-dyn-list .w-dyn-items")
    );

    footerDynLists.forEach(function renderSingleFooterDynList(list) {
      var hasFooterLink = !!list.querySelector("a.footer-link");
      if (!hasFooterLink) {
        return;
      }

      clearChildren(list);

      categories.slice(0, 8).forEach(function appendCategory(category) {
        var item = document.createElement("div");
        item.className = "w-dyn-item";
        item.appendChild(buildFooterCategoryLink(category));
        list.appendChild(item);
      });

      setDynEmptyVisibility(list, categories.length > 0);
    });

    normalizeDynamicListSemantics();
    normalizeFooterTrustLinks();
  }

  function appendProductsCategoryFilterSkeletonItems(categoryList, options) {
    if (!categoryList) {
      return;
    }

    var config = options && typeof options === "object" ? options : {};
    var viewportWidth =
      typeof window !== "undefined" && window.innerWidth
        ? window.innerWidth
        : document.documentElement && document.documentElement.clientWidth
          ? document.documentElement.clientWidth
          : 1200;
    var chipWidths = [118, 96, 132, 88, 110, 104, 124, 92, 116];
    var filtersPanel = categoryList.closest('[data-vr-products-filters="1"]');
    var skeletonCount = Number.parseInt(config.skeletonCount, 10);
    if (!Number.isFinite(skeletonCount) || skeletonCount < 1) {
      skeletonCount = filtersPanel ? (viewportWidth <= 991 ? 6 : 7) : 4;
    }

    var startIndex = Number.parseInt(config.startIndex, 10);
    if (!Number.isFinite(startIndex) || startIndex < 0) {
      startIndex = 0;
    }

    for (var i = 0; i < skeletonCount; i += 1) {
      var categoryItem = document.createElement("div");
      categoryItem.className = "w-dyn-item vr-skeleton-item vr-filter-skeleton-item";
      categoryItem.style.setProperty(
        "--vr-skeleton-delay",
        ((startIndex + i) * 0.05).toFixed(2) + "s"
      );

      var categoryChip = document.createElement("span");
      categoryChip.className = "products-category-link vr-skeleton vr-skeleton-chip";
      categoryChip.setAttribute("aria-hidden", "true");

      if (filtersPanel) {
        categoryChip.style.width = "100%";
      } else {
        categoryChip.style.width = chipWidths[i % chipWidths.length] + "px";
      }

      categoryItem.appendChild(categoryChip);
      categoryList.appendChild(categoryItem);
    }
  }

  function renderProductsCategoryFilters(categories, activeSlug, activeSearch, dealsOnly, options) {
    var config = options && typeof options === "object" ? options : {};
    var showCategorySkeleton = config.showCategorySkeleton === true;
    var keepStaticVisibleWhileLoading = config.keepStaticVisibleWhileLoading !== false;
    var isDealsOnly = dealsOnly === true;
    var categoryList = document.querySelector(".store-categories-wrap .collection-list.w-dyn-items");
    if (!categoryList) {
      return;
    }

    clearChildren(categoryList);

    var allItem = document.createElement("div");
    allItem.className = "w-dyn-item";
    if (showCategorySkeleton && keepStaticVisibleWhileLoading) {
      allItem.className += " vr-skeleton-item";
    }

    var allLink = document.createElement("a");
    allLink.className = "products-category-link" + (activeSlug || isDealsOnly ? "" : " w--current");
    allLink.href = productsHref("", activeSearch, undefined, false);
    allLink.setAttribute("data-vr-category-slug", "");
    allLink.setAttribute("data-vr-deals-only", "0");
    allLink.textContent = "Sve 🛒";
    allItem.appendChild(allLink);
    categoryList.appendChild(allItem);

    var dealsItem = document.createElement("div");
    dealsItem.className = "w-dyn-item";
    if (showCategorySkeleton && keepStaticVisibleWhileLoading) {
      dealsItem.className += " vr-skeleton-item";
    }

    var dealsLink = document.createElement("a");
    dealsLink.className = "products-category-link" + (isDealsOnly ? " w--current" : "");
    dealsLink.href = productsHref("", activeSearch, undefined, true);
    dealsLink.setAttribute("data-vr-category-slug", "");
    dealsLink.setAttribute("data-vr-deals-only", "1");
    dealsLink.textContent = "Akcije 👀";
    dealsItem.appendChild(dealsLink);
    categoryList.appendChild(dealsItem);

    var normalizedCategories = Array.isArray(categories) ? categories : [];
    normalizedCategories.forEach(function appendCategory(category) {
      var categorySlug = category && typeof category.slug === "string" ? category.slug.trim() : "";
      var item = document.createElement("div");
      item.className = "w-dyn-item";

      var link = document.createElement("a");
      link.className =
        "products-category-link" + (!isDealsOnly && activeSlug === categorySlug ? " w--current" : "");
      link.href = categoryHref(categorySlug, activeSearch, false);
      link.setAttribute("data-vr-category-slug", categorySlug);
      link.setAttribute("data-vr-deals-only", "0");
      link.textContent = category.name;

      item.appendChild(link);
      categoryList.appendChild(item);
    });

    if (showCategorySkeleton && !normalizedCategories.length) {
      appendProductsCategoryFilterSkeletonItems(categoryList, {
        skeletonCount: config.skeletonCount,
        startIndex: 2
      });
    }

    setDynEmptyVisibility(categoryList, true);
  }

  function syncProductsGridCardHeights() {
    var productsList = document.querySelector(".actual-products .collection-wrap.w-dyn-items");
    if (!productsList) {
      return;
    }

    var cards = Array.prototype.slice
      .call(productsList.children)
      .filter(function filterProductCard(node) {
        return (
          node &&
          node.classList &&
          node.classList.contains("collection-item") &&
          node.classList.contains("w-dyn-item") &&
          !node.classList.contains("vr-skeleton-card")
        );
      });

    if (!cards.length) {
      return;
    }

    cards.forEach(function prepareProductCard(card) {
      card.style.minHeight = "";
      card.style.display = "flex";
      card.style.flexDirection = "column";

      var description = card.querySelector(".product-description");
      if (description) {
        description.style.display = "flex";
        description.style.flexDirection = "column";
        description.style.flex = "1 1 auto";
      }

      var priceRow = card.querySelector(".vr-product-price-row");
      if (priceRow) {
        priceRow.style.marginTop = "auto";
      }

      var actions = card.querySelector(".vr-product-card-actions");
      if (actions) {
        actions.style.marginTop = "10px";
      }
    });

    if (window.innerWidth < 768) {
      return;
    }

    var maxCardHeight = 0;
    cards.forEach(function measureProductCard(card) {
      var cardHeight = card.getBoundingClientRect().height;
      if (cardHeight > maxCardHeight) {
        maxCardHeight = cardHeight;
      }
    });

    if (!maxCardHeight) {
      return;
    }

    cards.forEach(function setProductCardHeight(card) {
      card.style.minHeight = Math.ceil(maxCardHeight) + "px";
    });
  }

  function scheduleProductsGridCardHeightSync() {
    if (productsCardHeightSyncFrameId) {
      window.cancelAnimationFrame(productsCardHeightSyncFrameId);
      productsCardHeightSyncFrameId = null;
    }

    productsCardHeightSyncFrameId = window.requestAnimationFrame(function onProductCardHeightSyncFrame() {
      productsCardHeightSyncFrameId = null;
      syncProductsGridCardHeights();
    });
  }

  function bindProductsGridHeightSyncOnResize() {
    if (productsGridResizeBound) {
      return;
    }

    productsGridResizeBound = true;
    window.addEventListener("resize", function onProductsGridResize() {
      if (productsGridResizeTimeoutId) {
        window.clearTimeout(productsGridResizeTimeoutId);
      }

      productsGridResizeTimeoutId = window.setTimeout(function onProductsGridResizeSettled() {
        productsGridResizeTimeoutId = null;
        scheduleProductsGridCardHeightSync();
      }, 120);
    });

    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === "function") {
      document.fonts.ready
        .then(function onProductsFontsReady() {
          scheduleProductsGridCardHeightSync();
        })
        .catch(function ignoreProductsFontError() {
          return null;
        });
    }
  }

  function renderProductsGrid(products, options) {
    var config = options && typeof options === "object" ? options : {};
    var appendMode = config.append === true;
    var productsList = document.querySelector(".actual-products .collection-wrap.w-dyn-items");
    if (!productsList) {
      return;
    }

    var viewportWidth =
      typeof window !== "undefined" && window.innerWidth
        ? window.innerWidth
        : document.documentElement && document.documentElement.clientWidth
          ? document.documentElement.clientWidth
          : 1200;
    var columns = viewportWidth <= 767 ? 2 : viewportWidth <= 991 ? 3 : 4;
    var columnGap = columns >= 4 ? "16px" : columns === 3 ? "12px" : "10px";
    var rowGap = columns >= 4 ? "18px" : "16px";
    productsList.style.display = "grid";
    productsList.style.gridTemplateColumns = "repeat(" + columns + ", minmax(0,1fr))";
    productsList.style.columnGap = columnGap;
    productsList.style.rowGap = rowGap;
    productsList.style.alignItems = "stretch";
    productsList.style.justifyContent = "initial";
    productsList.style.placeContent = "initial";

    if (appendMode) {
      clearProductsGridAppendLoadingSkeleton(productsList);
    } else {
      clearChildren(productsList);
    }

    products.forEach(function appendProduct(product) {
      var item = document.createElement("div");
      item.className = "collection-item w-dyn-item";
      item.style.width = "auto";
      item.style.maxWidth = "none";
      item.style.margin = "0";

      var link = document.createElement("a");
      link.className = "product-image-wrap w-inline-block";
      link.href = productHref(product.slug);
      link.setAttribute("aria-label", product.name || "Proizvod");

      var description = document.createElement("div");
      description.className = "product-description";

      var name = document.createElement("div");
      name.className = "product-name-text";
      name.style.fontSize = "16px";
      name.style.lineHeight = "1.24";
      name.textContent = product.name;

      var category = document.createElement("div");
      category.className = "text-block-8";
      category.textContent = product.category_name || "";

      var priceRow = createProductPriceRow(product);
      var reviewWidget = createProductReviewWidget(product, {
        compact: true,
        interactive: false
      });
      var actions = document.createElement("div");
      actions.className = "vr-product-card-actions";

      var addButton = document.createElement("button");
      addButton.type = "button";
      addButton.className = "primary-button vr-product-add-btn";
      addButton.textContent = currentLanguage === LANGUAGE_EN ? "Add to cart" : "Dodaj u korpu";

      var productSlug = typeof product.slug === "string" ? product.slug.trim() : "";
      var productName = typeof product.name === "string" ? product.name.trim() : "";
      if (productSlug) {
        link.setAttribute("data-vr-product-slug", productSlug);
        item.setAttribute("data-vr-product-slug", productSlug);

        var isDesktopQuickView = function isDesktopQuickView() {
          if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
            return false;
          }

          return window.matchMedia("(min-width: 992px)").matches;
        };

        link.addEventListener("click", function onGridProductImageClick(event) {
          if (!isPrimaryActionClick(event)) {
            return;
          }

          if (!isDesktopQuickView()) {
            return;
          }

          if (link.target && link.target !== "_self") {
            return;
          }

          if (link.hasAttribute("download")) {
            return;
          }

          event.preventDefault();
          openProductQuickViewModal(productSlug, {
            triggerElement: link
          });
        });

        item.addEventListener("click", function onGridProductCardClick(event) {
          if (!isPrimaryActionClick(event)) {
            return;
          }

          var target = event.target;
          if (!target || typeof target.closest !== "function") {
            return;
          }

          if (target.closest("button, input, select, textarea, label, [role='button'], [data-action]")) {
            return;
          }

          if (target.closest("a")) {
            return;
          }

          if (isDesktopQuickView()) {
            event.preventDefault();
            openProductQuickViewModal(productSlug, {
              triggerElement: item
            });
            return;
          }

          window.location.assign(link.href);
        });
      }

      var cartProduct = {
        slug: productSlug,
        name: productName,
        image_url: typeof product.image_url === "string" ? product.image_url : "",
        price_bam: normalizeMoney(product.price_bam),
        retail_price_bam: normalizeMoneyOrNull(product.retail_price_bam),
        stock_tracking_enabled: normalizeBoolean(product.stock_tracking_enabled),
        available_quantity: getProductAvailableQuantity(product)
      };

      if (!cartProduct.slug || !cartProduct.name) {
        addButton.disabled = true;
        addButton.classList.add("w--disabled");
        addButton.textContent = currentLanguage === LANGUAGE_EN ? "Unavailable" : "Nedostupno";
      } else if (isProductSoldOut(product)) {
        addButton.disabled = true;
        addButton.classList.add("w--disabled");
        addButton.textContent = currentLanguage === LANGUAGE_EN ? "Sold out" : "Rasprodato";
      } else {
        addButton.addEventListener("click", function onGridAddToCart(event) {
          event.preventDefault();
          var confettiOrigin = null;
          if (
            event &&
            typeof event.clientX === "number" &&
            typeof event.clientY === "number" &&
            (event.detail !== 0 || event.clientX !== 0 || event.clientY !== 0)
          ) {
            confettiOrigin = {
              x: event.clientX,
              y: event.clientY
            };
          }

          try {
            addToCart(cartProduct, 1);
            refreshCartLinks();
            animateImageToCart({
              sourceElement: link,
              imageUrl: cartProduct.image_url
            });

            addButton.disabled = true;
            addButton.classList.add("vr-added-success");
            launchAddToCartConfetti(addButton, confettiOrigin);
            addButton.textContent = "Dodato";
            window.setTimeout(function restoreGridAddButtonState() {
              addButton.classList.remove("vr-added-success");
              addButton.textContent = "Dodaj u korpu";
              addButton.disabled = false;
            }, 650);
          } catch (_error) {
            addButton.classList.remove("vr-added-success");
            addButton.textContent = "Pokusaj ponovo";
            window.setTimeout(function restoreGridAddButtonAfterError() {
              addButton.textContent = "Dodaj u korpu";
            }, 1000);
          }
        });
      }

      actions.appendChild(addButton);

      description.appendChild(name);
      description.appendChild(category);
      description.appendChild(priceRow);
      if (reviewWidget) {
        description.appendChild(reviewWidget);
      }
      description.appendChild(actions);

      item.appendChild(link);
      item.appendChild(description);
      productsList.appendChild(item);
      setProductCardImage(link, product.image_url);
    });

    if (appendMode) {
      setDynEmptyVisibility(productsList, productsList.children.length > 0);
    } else {
      setDynEmptyVisibility(productsList, products.length > 0);
    }
    scheduleProductsGridCardHeightSync();
  }

  function ensureProductsPaginationContainer() {
    var productsRoot = document.querySelector(".actual-products");
    if (!productsRoot) {
      return null;
    }

    var filtersHost = productsRoot.querySelector('[data-vr-products-filters="1"]');
    var contentHost = productsRoot.querySelector('[data-vr-products-content="1"]');
    var preferContentHost = false;

    if (typeof window !== "undefined" && typeof window.matchMedia === "function") {
      preferContentHost = window.matchMedia("(max-width: 767px)").matches;
    }

    var host = preferContentHost
      ? contentHost || filtersHost || productsRoot
      : filtersHost || contentHost || productsRoot;
    var pagination = productsRoot.querySelector('[data-vr-products-pagination="1"]');
    if (!pagination) {
      pagination = document.createElement("div");
      pagination.className = "vr-products-pagination";
      pagination.setAttribute("data-vr-products-pagination", "1");
      pagination.setAttribute("hidden", "hidden");
      host.appendChild(pagination);
    } else if (pagination.parentElement !== host) {
      host.appendChild(pagination);
    }

    return pagination;
  }

  function renderProductsPagination(totalItems, pageNumber, pageSize, onPageChange) {
    var pagination = ensureProductsPaginationContainer();
    if (!pagination) {
      return;
    }

    var safePageSize = Number.parseInt(pageSize, 10);
    if (!Number.isFinite(safePageSize) || safePageSize < 1) {
      safePageSize = PRODUCTS_PAGE_SIZE;
    }

    var total = Number.parseInt(totalItems, 10);
    if (!Number.isFinite(total) || total < 0) {
      total = 0;
    }

    var totalPages = Math.max(1, Math.ceil(total / safePageSize));
    var currentPage = Number.parseInt(pageNumber, 10);
    if (!Number.isFinite(currentPage) || currentPage < 1) {
      currentPage = 1;
    } else if (currentPage > totalPages) {
      currentPage = totalPages;
    }

    if (total <= safePageSize) {
      pagination.innerHTML = "";
      pagination.setAttribute("hidden", "hidden");
      pagination._vrOnPageChange = null;
      return;
    }

    pagination.removeAttribute("hidden");
    pagination._vrOnPageChange = typeof onPageChange === "function" ? onPageChange : null;

    if (!pagination._vrPaginationBound) {
      pagination._vrPaginationBound = true;
      pagination.addEventListener("click", function onProductsPaginationClick(event) {
        var target = event.target;
        if (!target || typeof target.closest !== "function") {
          return;
        }

        var button = target.closest("button[data-page]");
        if (!button || button.disabled) {
          return;
        }

        event.preventDefault();

        var nextPage = Number.parseInt(button.getAttribute("data-page"), 10);
        if (!Number.isFinite(nextPage) || nextPage < 1) {
          return;
        }

        var onPageChangeHandler =
          typeof pagination._vrOnPageChange === "function" ? pagination._vrOnPageChange : null;
        if (onPageChangeHandler) {
          onPageChangeHandler(nextPage);
        }
      });
    }

    var previousPage = currentPage - 1;
    var nextPage = currentPage + 1;
    var previousDisabled = currentPage <= 1;
    var nextDisabled = currentPage >= totalPages;

    pagination.innerHTML = [
      '<button type="button" class="vr-products-page-btn' +
        (previousDisabled ? " w--disabled" : "") +
        '" data-page="' +
        previousPage +
        '"' +
        (previousDisabled ? " disabled" : "") +
        ' aria-label="Prethodna stranica"><svg class="vr-products-page-icon" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M12.5 4.5L7 10l5.5 5.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      '<span class="vr-products-page-status">' + currentPage + " / " + totalPages + "</span>",
      '<button type="button" class="vr-products-page-btn' +
        (nextDisabled ? " w--disabled" : "") +
        '" data-page="' +
        nextPage +
        '"' +
        (nextDisabled ? " disabled" : "") +
        ' aria-label="Sljedeca stranica"><svg class="vr-products-page-icon" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M7.5 4.5L13 10l-5.5 5.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
    ].join("");
  }

  function clearProductsGridAppendLoadingSkeleton(productsList) {
    var list = productsList || document.querySelector(".actual-products .collection-wrap.w-dyn-items");
    if (!list) {
      return;
    }

    var nodes = Array.prototype.slice.call(
      list.querySelectorAll(".vr-skeleton-card[data-vr-products-append-skeleton='1']")
    );
    nodes.forEach(function removeAppendSkeletonNode(node) {
      if (node && node.parentNode === list) {
        list.removeChild(node);
      }
    });
  }

  function appendProductsGridLoadingSkeletonRows(count) {
    var productsList = document.querySelector(".actual-products .collection-wrap.w-dyn-items");
    if (!productsList) {
      return;
    }

    clearProductsGridAppendLoadingSkeleton(productsList);

    var viewportWidth =
      typeof window !== "undefined" && window.innerWidth
        ? window.innerWidth
        : document.documentElement && document.documentElement.clientWidth
          ? document.documentElement.clientWidth
          : 1200;
    var columns = viewportWidth <= 767 ? 2 : viewportWidth <= 991 ? 3 : 4;
    var skeletonCount = Number.parseInt(count, 10);
    if (!Number.isFinite(skeletonCount) || skeletonCount < 1) {
      skeletonCount = columns >= 4 ? 8 : columns === 3 ? 6 : 6;
    }

    for (var j = 0; j < skeletonCount; j += 1) {
      var item = document.createElement("div");
      item.className = "collection-item w-dyn-item vr-skeleton-card";
      item.setAttribute("data-vr-products-append-skeleton", "1");
      item.style.setProperty(
        "--vr-skeleton-delay",
        (j % columns * 0.08 + Math.floor(j / columns) * 0.03).toFixed(2) + "s"
      );
      item.style.width = "auto";
      item.style.maxWidth = "none";
      item.style.margin = "0";

      var image = document.createElement("div");
      image.className = "product-image-wrap w-inline-block vr-skeleton";
      image.setAttribute("aria-hidden", "true");

      var description = document.createElement("div");
      description.className = "product-description";

      var lineBadge = document.createElement("span");
      lineBadge.className = "vr-skeleton vr-skeleton-line sm";
      lineBadge.setAttribute("aria-hidden", "true");

      var linePrimary = document.createElement("span");
      linePrimary.className = "vr-skeleton vr-skeleton-line lg";
      linePrimary.setAttribute("aria-hidden", "true");

      var lineSecondary = document.createElement("span");
      lineSecondary.className = "vr-skeleton vr-skeleton-line md";
      lineSecondary.setAttribute("aria-hidden", "true");

      var linePrice = document.createElement("span");
      linePrice.className = "vr-skeleton vr-skeleton-line price";
      linePrice.setAttribute("aria-hidden", "true");

      var lineButton = document.createElement("span");
      lineButton.className = "vr-skeleton vr-skeleton-line btn";
      lineButton.setAttribute("aria-hidden", "true");

      description.appendChild(lineBadge);
      description.appendChild(linePrimary);
      description.appendChild(lineSecondary);
      description.appendChild(linePrice);
      description.appendChild(lineButton);

      item.appendChild(image);
      item.appendChild(description);
      productsList.appendChild(item);
    }
  }

  function renderProductsGridLoadingSkeleton() {
    var productsList = document.querySelector(".actual-products .collection-wrap.w-dyn-items");
    if (!productsList) {
      return;
    }

    var viewportWidth =
      typeof window !== "undefined" && window.innerWidth
        ? window.innerWidth
        : document.documentElement && document.documentElement.clientWidth
          ? document.documentElement.clientWidth
          : 1200;
    var columns = viewportWidth <= 767 ? 2 : viewportWidth <= 991 ? 3 : 4;
    var columnGap = columns >= 4 ? "16px" : columns === 3 ? "12px" : "10px";
    var rowGap = columns >= 4 ? "18px" : "16px";
    productsList.style.display = "grid";
    productsList.style.gridTemplateColumns = "repeat(" + columns + ", minmax(0,1fr))";
    productsList.style.columnGap = columnGap;
    productsList.style.rowGap = rowGap;
    productsList.style.alignItems = "stretch";
    productsList.style.justifyContent = "initial";
    productsList.style.placeContent = "initial";

    clearProductsGridAppendLoadingSkeleton(productsList);
    clearChildren(productsList);

    var skeletonCount = columns >= 4 ? 8 : columns === 3 ? 6 : 6;

    for (var j = 0; j < skeletonCount; j += 1) {
      var item = document.createElement("div");
      item.className = "collection-item w-dyn-item vr-skeleton-card";
      item.style.setProperty(
        "--vr-skeleton-delay",
        (j % columns * 0.08 + Math.floor(j / columns) * 0.03).toFixed(2) + "s"
      );
      item.style.width = "auto";
      item.style.maxWidth = "none";
      item.style.margin = "0";

      var image = document.createElement("div");
      image.className = "product-image-wrap w-inline-block vr-skeleton";
      image.setAttribute("aria-hidden", "true");

      var description = document.createElement("div");
      description.className = "product-description";

      var lineBadge = document.createElement("span");
      lineBadge.className = "vr-skeleton vr-skeleton-line sm";
      lineBadge.setAttribute("aria-hidden", "true");

      var linePrimary = document.createElement("span");
      linePrimary.className = "vr-skeleton vr-skeleton-line lg";
      linePrimary.setAttribute("aria-hidden", "true");

      var lineSecondary = document.createElement("span");
      lineSecondary.className = "vr-skeleton vr-skeleton-line md";
      lineSecondary.setAttribute("aria-hidden", "true");

      var linePrice = document.createElement("span");
      linePrice.className = "vr-skeleton vr-skeleton-line price";
      linePrice.setAttribute("aria-hidden", "true");

      var lineButton = document.createElement("span");
      lineButton.className = "vr-skeleton vr-skeleton-line btn";
      lineButton.setAttribute("aria-hidden", "true");

      description.appendChild(lineBadge);
      description.appendChild(linePrimary);
      description.appendChild(lineSecondary);
      description.appendChild(linePrice);
      description.appendChild(lineButton);

      item.appendChild(image);
      item.appendChild(description);
      productsList.appendChild(item);
    }

    setDynEmptyVisibility(productsList, true);
  }

  function renderProductsLoadingSkeleton() {
    var categoryList = document.querySelector(".store-categories-wrap .collection-list.w-dyn-items");

    if (categoryList) {
      var loadingSearchParams = new URLSearchParams(window.location.search);
      var loadingCategory = String(loadingSearchParams.get("category") || "").trim();
      var loadingDealsOnly = readProductsDealsOnly();
      if (loadingDealsOnly) {
        loadingCategory = "";
      }

      renderProductsCategoryFilters(
        [],
        loadingCategory,
        readProductsSearchTerm(),
        loadingDealsOnly,
        {
          showCategorySkeleton: true,
          keepStaticVisibleWhileLoading: true
        }
      );
    }
    renderProductsGridLoadingSkeleton();
  }

  function ensureProductsCatalogLayout() {
    var productsSection = document.querySelector(".actual-products");
    var productsDynList = productsSection ? productsSection.querySelector(".w-dyn-list") : null;
    var categoriesWrap = document.querySelector(".our-products-section .store-categories-wrap");

    if (!productsSection || !productsDynList || !categoriesWrap) {
      return null;
    }

    var layout = productsSection.querySelector('[data-vr-products-layout="1"]');
    if (!layout) {
      layout = document.createElement("div");
      layout.className = "vr-products-catalog-layout";
      layout.setAttribute("data-vr-products-layout", "1");

      var filtersPanel = document.createElement("aside");
      filtersPanel.className = "vr-products-filters-panel";
      filtersPanel.setAttribute("data-vr-products-filters", "1");

      var contentPanel = document.createElement("div");
      contentPanel.className = "vr-products-content-panel";
      contentPanel.setAttribute("data-vr-products-content", "1");

      layout.appendChild(filtersPanel);
      layout.appendChild(contentPanel);
      productsSection.appendChild(layout);
    }

    var filtersHost = layout.querySelector('[data-vr-products-filters="1"]');
    var contentHost = layout.querySelector('[data-vr-products-content="1"]');

    if (filtersHost && categoriesWrap.parentElement !== filtersHost) {
      filtersHost.appendChild(categoriesWrap);
    }

    if (contentHost && productsDynList.parentElement !== contentHost) {
      contentHost.appendChild(productsDynList);
    }

    if (contentHost && !contentHost.querySelector('[data-vr-products-feedback="1"]')) {
      var feedback = document.createElement("div");
      feedback.className = "vr-products-feedback";
      feedback.setAttribute("data-vr-products-feedback", "1");
      feedback.setAttribute("role", "status");
      feedback.setAttribute("aria-live", "polite");
      contentHost.insertBefore(feedback, contentHost.firstChild);
    }

    return {
      layout: layout,
      filtersHost: filtersHost,
      contentHost: contentHost
    };
  }

  function updateProductsSearchUiState(form, query) {
    if (!form) {
      return;
    }

    var hasQuery = typeof query === "string" && query.trim() !== "";
    var clearButton = form.querySelector('[data-action="clear-search-input"]');

    form.setAttribute("data-has-query", hasQuery ? "1" : "0");

    if (clearButton) {
      clearButton.disabled = !hasQuery;
      clearButton.setAttribute("aria-disabled", hasQuery ? "false" : "true");
    }
  }

  function setProductsSearchLoadingState(isLoading) {
    var form = document.getElementById("vr-products-search-form");
    if (!form) {
      return;
    }

    form.setAttribute("data-loading", isLoading ? "1" : "0");
  }

  function setProductsFeedbackMessage(message) {
    var feedback = document.querySelector('[data-vr-products-feedback="1"]');
    if (!feedback) {
      return;
    }

    var normalizedMessage = String(message || "").trim();
    if (!normalizedMessage) {
      feedback.textContent = "";
      feedback.classList.remove("is-visible");
      return;
    }

    feedback.textContent = normalizedMessage;
    feedback.classList.add("is-visible");
  }

  function getWholesaleLogoutConfirmCopy() {
    if (currentLanguage === LANGUAGE_EN) {
      return {
        title: "Sign out of wholesale account?",
        note: "You will lose wholesale pricing until you sign in again.",
        confirm: "Sign out",
        cancel: "Cancel",
        closeLabel: "Close sign-out dialog",
        triggerLabel: "Sign out of wholesale account"
      };
    }

    return {
      title: "Odjaviti veleprodajni nalog?",
      note: "Izgubicete veleprodajne cijene dok se ponovo ne prijavite.",
      confirm: "Odjavi se",
      cancel: "Odustani",
      closeLabel: "Zatvori potvrdu odjave",
      triggerLabel: "Odjavi veleprodajni nalog"
    };
  }

  function syncWholesaleLogoutConfirmModalCopy() {
    var modal = document.getElementById(WHOLESALE_LOGOUT_CONFIRM_MODAL_ID);
    if (!modal) {
      return;
    }

    var copy = getWholesaleLogoutConfirmCopy();
    var title = modal.querySelector("[data-vr-wholesale-logout-confirm-title]");
    var note = modal.querySelector("[data-vr-wholesale-logout-confirm-note]");
    var cancelButton = modal.querySelector("[data-vr-wholesale-logout-confirm-cancel]");
    var confirmButton = modal.querySelector("[data-vr-wholesale-logout-confirm-submit]");
    var backdrop = modal.querySelector("[data-vr-wholesale-logout-confirm-backdrop]");

    if (title) {
      title.textContent = copy.title;
    }
    if (note) {
      note.textContent = copy.note;
    }
    if (cancelButton) {
      cancelButton.textContent = copy.cancel;
      cancelButton.setAttribute("aria-label", copy.cancel);
      cancelButton.setAttribute("title", copy.cancel);
    }
    if (confirmButton) {
      confirmButton.textContent = copy.confirm;
      confirmButton.setAttribute("aria-label", copy.confirm);
      confirmButton.setAttribute("title", copy.confirm);
    }
    if (backdrop) {
      backdrop.setAttribute("aria-label", copy.closeLabel);
      backdrop.setAttribute("title", copy.closeLabel);
    }
  }

  function closeWholesaleLogoutConfirmModal(options) {
    var config = options && typeof options === "object" ? options : {};
    var restoreFocus = !config.skipRestoreFocus;
    var modal = document.getElementById(WHOLESALE_LOGOUT_CONFIRM_MODAL_ID);

    if (modal && typeof modal.__cleanup === "function") {
      modal.__cleanup();
      modal.__cleanup = null;
    }

    if (modal && modal.parentNode) {
      modal.parentNode.removeChild(modal);
    }

    if (document.body) {
      document.body.classList.remove(WHOLESALE_LOGOUT_CONFIRM_MODAL_OPEN_CLASS);
    }

    if (restoreFocus) {
      restoreFocusIfPossible(wholesaleLogoutConfirmModalLastFocusedElement);
    }
    wholesaleLogoutConfirmModalLastFocusedElement = null;
  }

  function openWholesaleLogoutConfirmModal(options) {
    if (!document.body || !isWholesaleClientAuthenticated()) {
      return;
    }

    closeWholesaleLogoutConfirmModal({
      skipRestoreFocus: true
    });

    var config = options && typeof options === "object" ? options : {};
    wholesaleLogoutConfirmModalLastFocusedElement =
      config.triggerElement ||
      (document.activeElement && typeof document.activeElement.focus === "function"
        ? document.activeElement
        : null);

    var modal = document.createElement("div");
    modal.id = WHOLESALE_LOGOUT_CONFIRM_MODAL_ID;
    modal.className = "vr-wholesale-logout-confirm-modal is-open";
    modal.innerHTML = [
      '<button type="button" class="vr-wholesale-logout-confirm-backdrop" data-vr-wholesale-logout-confirm-backdrop data-action="close-wholesale-logout-confirm"></button>',
      '<div class="vr-wholesale-logout-confirm-dialog" role="dialog" aria-modal="true" aria-labelledby="vr-wholesale-logout-confirm-title" data-vr-wholesale-logout-confirm-dialog>',
      '  <h3 id="vr-wholesale-logout-confirm-title" class="vr-wholesale-logout-confirm-title" data-vr-wholesale-logout-confirm-title></h3>',
      '  <p class="vr-wholesale-logout-confirm-note" data-vr-wholesale-logout-confirm-note></p>',
      '  <div class="vr-wholesale-logout-confirm-actions">',
      '    <button type="button" class="vr-wholesale-logout-confirm-cancel" data-vr-wholesale-logout-confirm-cancel data-action="close-wholesale-logout-confirm"></button>',
      '    <button type="button" class="primary-button vr-wholesale-logout-confirm-submit" data-vr-wholesale-logout-confirm-submit></button>',
      "  </div>",
      "</div>"
    ].join("\n");
    document.body.appendChild(modal);
    document.body.classList.add(WHOLESALE_LOGOUT_CONFIRM_MODAL_OPEN_CLASS);
    syncWholesaleLogoutConfirmModalCopy();

    var dialog = modal.querySelector("[data-vr-wholesale-logout-confirm-dialog]");
    var closeButtons = modal.querySelectorAll('[data-action="close-wholesale-logout-confirm"]');
    var confirmButton = modal.querySelector("[data-vr-wholesale-logout-confirm-submit]");
    var isSubmitting = false;

    function handleClose(event) {
      event.preventDefault();
      if (isSubmitting) {
        return;
      }
      closeWholesaleLogoutConfirmModal();
    }

    function handleKeydown(event) {
      if (!document.getElementById(WHOLESALE_LOGOUT_CONFIRM_MODAL_ID)) {
        return;
      }

      if (event.key === "Escape") {
        if (isSubmitting) {
          return;
        }
        event.preventDefault();
        closeWholesaleLogoutConfirmModal();
        return;
      }

      if (event.key === "Tab" && dialog) {
        trapFocusInContainer(event, dialog);
      }
    }

    function setSubmittingState(submitting) {
      isSubmitting = submitting;
      closeButtons.forEach(function updateCloseButton(button) {
        button.disabled = submitting;
      });
      if (confirmButton) {
        confirmButton.disabled = submitting;
      }
    }

    async function handleConfirm(event) {
      event.preventDefault();
      if (isSubmitting) {
        return;
      }

      setSubmittingState(true);

      clearWholesaleSession();
      refreshCartLinks();
      syncCartDrawer();
      closeWholesaleLogoutConfirmModal({
        skipRestoreFocus: true
      });

      var fallbackHref = window.location.pathname + window.location.search;
      if (
        runGuardedPageReload(
          WHOLESALE_LOGOUT_RELOAD_GUARD_STORAGE_KEY,
          WHOLESALE_LOGOUT_RELOAD_GUARD_WINDOW_MS,
          fallbackHref
        )
      ) {
        return;
      }
    }

    closeButtons.forEach(function bindCloseButton(button) {
      button.addEventListener("click", handleClose);
    });
    if (confirmButton) {
      confirmButton.addEventListener("click", handleConfirm);
    }
    document.addEventListener("keydown", handleKeydown);

    modal.__cleanup = function cleanupWholesaleLogoutConfirmModal() {
      closeButtons.forEach(function unbindCloseButton(button) {
        button.removeEventListener("click", handleClose);
      });
      if (confirmButton) {
        confirmButton.removeEventListener("click", handleConfirm);
      }
      document.removeEventListener("keydown", handleKeydown);
    };

    if (!focusFirstElementInContainer(dialog)) {
      var backdrop = modal.querySelector("[data-vr-wholesale-logout-confirm-backdrop]");
      if (backdrop && typeof backdrop.focus === "function") {
        backdrop.focus();
      }
    }
  }

  function syncProductsWholesaleIndicator() {
    var headingWrap = document.querySelector(".our-products-section .container.cc-heading-wrap");
    if (!headingWrap) {
      return;
    }

    var heading = headingWrap.querySelector("h1, h2, .heading-2, .heading-jumbo");
    if (!heading) {
      return;
    }

    var indicator = headingWrap.querySelector('[data-vr-products-wholesale-indicator="1"]');
    var shouldShow = isWholesaleClientAuthenticated();

    if (!shouldShow) {
      closeWholesaleLogoutConfirmModal({
        skipRestoreFocus: true
      });
      if (indicator && indicator.parentNode) {
        indicator.parentNode.removeChild(indicator);
      }
      return;
    }

    if (!indicator) {
      indicator = document.createElement("span");
      indicator.className = "vr-products-wholesale-indicator";
      indicator.setAttribute("data-vr-products-wholesale-indicator", "1");
      indicator.innerHTML = [
        '<span class="vr-products-wholesale-indicator-label" data-vr-products-wholesale-indicator-label></span>',
        '<button type="button" class="vr-products-wholesale-indicator-close" data-vr-products-wholesale-indicator-close>&times;</button>'
      ].join("");

      var indicatorCloseButton = indicator.querySelector("[data-vr-products-wholesale-indicator-close]");
      if (indicatorCloseButton) {
        indicatorCloseButton.addEventListener("click", function onProductsWholesaleIndicatorCloseClick(event) {
          event.preventDefault();
          event.stopPropagation();
          openWholesaleLogoutConfirmModal({
            triggerElement: indicatorCloseButton
          });
        });
      }
    }

    var indicatorLabel = indicator.querySelector("[data-vr-products-wholesale-indicator-label]");
    var closeButton = indicator.querySelector("[data-vr-products-wholesale-indicator-close]");
    var copy = getWholesaleLogoutConfirmCopy();

    if (indicatorLabel) {
      indicatorLabel.textContent =
        currentLanguage === LANGUAGE_EN
          ? "Wholesale Discount Active"
          : "Veleprodajni Popust Aktivan";
    }
    if (closeButton) {
      closeButton.setAttribute("aria-label", copy.triggerLabel);
      closeButton.setAttribute("title", copy.triggerLabel);
    }

    if (heading.nextSibling !== indicator) {
      heading.parentNode.insertBefore(indicator, heading.nextSibling);
    }
  }

  function ensureProductsSearchControls(searchTerm, options) {
    var headingWrap = document.querySelector(".our-products-section .container.cc-heading-wrap");
    var filtersPanel = document.querySelector('[data-vr-products-filters="1"]');
    var layoutHost = filtersPanel ? filtersPanel.closest('[data-vr-products-layout="1"]') : null;
    var host = filtersPanel || headingWrap;
    if (!host) {
      return;
    }

    var config = options && typeof options === "object" ? options : {};
    var onSearchChange = typeof config.onSearchChange === "function" ? config.onSearchChange : null;
    var form = document.getElementById("vr-products-search-form");
    var input = document.getElementById("vr-products-search-input");
    var normalizedSearch = typeof searchTerm === "string" ? searchTerm.trim() : "";
    var headingElement = headingWrap
      ? headingWrap.querySelector("h1, h2, .heading-2, .heading-jumbo")
      : null;

    function placeProductsSearchForm() {
      if (!form || !host) {
        return;
      }

      if (headingWrap && host === headingWrap && headingElement && headingElement.parentElement === headingWrap) {
        if (form.parentElement !== headingWrap) {
          headingWrap.appendChild(form);
        }

        if (headingElement.nextSibling !== form) {
          headingWrap.insertBefore(form, headingElement.nextSibling);
        }
        return;
      }

      if (filtersPanel && host === filtersPanel) {
        if (layoutHost && isMobileViewport()) {
          if (form.parentElement !== layoutHost || form.nextSibling !== filtersPanel) {
            layoutHost.insertBefore(form, filtersPanel);
          }
          return;
        }

        var categoriesWrap = filtersPanel.querySelector(".store-categories-wrap");

        if (categoriesWrap && categoriesWrap.parentElement === filtersPanel) {
          if (form.parentElement !== filtersPanel || form.nextSibling !== categoriesWrap) {
            filtersPanel.insertBefore(form, categoriesWrap);
          }
          return;
        }

        if (form.parentElement !== filtersPanel) {
          filtersPanel.insertBefore(form, filtersPanel.firstChild);
          return;
        }

        if (filtersPanel.firstElementChild !== form) {
          filtersPanel.insertBefore(form, filtersPanel.firstChild);
        }
        return;
      }

      if (form.parentElement !== host) {
        host.appendChild(form);
      }
    }

    if (!form) {
      form = document.createElement("form");
      form.id = "vr-products-search-form";
      form.className = "vr-products-search-wrap";
      form.setAttribute("role", "search");
      form._vrOnSearchChange = onSearchChange;
      form.innerHTML = [
        '<div class="vr-products-search-field">',
        '  <input id="vr-products-search-input" class="text-field vr-products-search-input" type="search" placeholder="Pretrazi proizvode..." aria-label="Pretrazi proizvode..." />',
        '  <button type="button" class="vr-products-search-input-clear" data-action="clear-search-input" aria-label="Ocisti pretragu" title="Ocisti pretragu">&times;</button>',
        "</div>",
        '<button type="submit" class="primary-button vr-products-search-btn">Pretrazi</button>'
      ].join("");
      placeProductsSearchForm();

      form.addEventListener("submit", function onProductsSearchSubmit(event) {
        event.preventDefault();

        var params = new URLSearchParams(window.location.search);
        var currentCategory = String(params.get("category") || "").trim();
        var currentDealsOnly = isDealsQueryEnabled(params.get("deals"));
        var searchInput = document.getElementById("vr-products-search-input");
        var nextSearch = searchInput ? String(searchInput.value || "").trim() : "";
        var liveSearchHandler = typeof form._vrOnSearchChange === "function" ? form._vrOnSearchChange : null;

        if (liveSearchHandler) {
          liveSearchHandler(nextSearch, {
            immediate: true,
            historyMode: "push"
          });
          return;
        }

        window.location.href = productsHref(currentCategory, nextSearch, undefined, currentDealsOnly);
      });

      form.addEventListener("click", function onProductsSearchClear(event) {
        var target = event.target;
        if (!target || typeof target.closest !== "function") {
          return;
        }

        var clearButton = target.closest('[data-action="clear-search-input"]');
        if (!clearButton) {
          return;
        }

        event.preventDefault();

        var liveSearchHandler = typeof form._vrOnSearchChange === "function" ? form._vrOnSearchChange : null;
        var inputNode = document.getElementById("vr-products-search-input");
        if (inputNode) {
          inputNode.value = "";
          inputNode.focus();
        }
        updateProductsSearchUiState(form, "");

        if (liveSearchHandler) {
          liveSearchHandler("", {
            immediate: true,
            historyMode: "push"
          });
          return;
        }

        var params = new URLSearchParams(window.location.search);
        var currentCategory = String(params.get("category") || "").trim();
        var currentDealsOnly = isDealsQueryEnabled(params.get("deals"));
        window.location.href = productsHref(currentCategory, "", undefined, currentDealsOnly);
      });

      form.addEventListener("input", function onProductsSearchInput(event) {
        var target = event.target;
        if (!target || target.id !== "vr-products-search-input") {
          return;
        }

        var nextSearch = String(target.value || "");
        updateProductsSearchUiState(form, nextSearch);

        var liveSearchHandler = typeof form._vrOnSearchChange === "function" ? form._vrOnSearchChange : null;
        if (liveSearchHandler) {
          liveSearchHandler(nextSearch, {
            immediate: false
          });
        }
      });

      input = document.getElementById("vr-products-search-input");
    } else {
      form._vrOnSearchChange = onSearchChange;
      placeProductsSearchForm();
    }

    if (input) {
      input.value = normalizedSearch;
    }

    if (!form.hasAttribute("data-loading")) {
      form.setAttribute("data-loading", "0");
    }

    updateProductsSearchUiState(form, normalizedSearch);
  }

  function loadDeferredIndexCategoryImages() {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    document.querySelectorAll("[data-vr-index-category-image]").forEach(function loadVisibleCard(card) {
      var bounds = card.getBoundingClientRect();
      if (bounds.top > viewportHeight + 40 || bounds.bottom < -40) {
        return;
      }

      var imageUrl = card.getAttribute("data-vr-index-category-image");
      card.removeAttribute("data-vr-index-category-image");
      if (imageUrl) {
        setProductCardImage(card, imageUrl, {
          eager: true
        });
      }
    });
  }

  function bindDeferredIndexCategoryImages() {
    if (window.__vrIndexCategoryImagesBound) {
      return;
    }

    window.__vrIndexCategoryImagesBound = true;
    var frameScheduled = false;
    function scheduleVisibleCategoryImages() {
      if (frameScheduled) {
        return;
      }

      frameScheduled = true;
      window.requestAnimationFrame(function loadVisibleCategoryImagesFrame() {
        frameScheduled = false;
        loadDeferredIndexCategoryImages();
      });
    }

    window.addEventListener("scroll", scheduleVisibleCategoryImages, {
      passive: true
    });
    window.addEventListener("resize", scheduleVisibleCategoryImages);
  }

  function renderIndexCategories(categories) {
    var indexCategoryList = document.querySelector(".section-2 .collection-list-2.w-dyn-items");
    if (!indexCategoryList) {
      return;
    }

    clearChildren(indexCategoryList);
    categories.slice(0, 6).forEach(function appendCategory(category, categoryIndex) {
      var item = document.createElement("div");
      item.className = "collection-item-2 w-dyn-item";

      var link = document.createElement("a");
      link.className = "link-block w-inline-block";
      link.href = categoryHref(category.slug);
      link.setAttribute("aria-label", category.name || "Kategorija");

      var brandedImageUrl =
        category && typeof category.slug === "string"
          ? INDEX_CATEGORY_BRAND_IMAGE_BY_SLUG[category.slug.trim()] || ""
          : "";
      var categoryImageUrl = brandedImageUrl || (category && category.image_url ? category.image_url : "");

      var text = document.createElement("div");
      text.className = "text-block";
      text.textContent = category.name;

      link.appendChild(text);
      item.appendChild(link);
      indexCategoryList.appendChild(item);

      if (categoryImageUrl) {
        var shouldLoadCategoryImageEagerly = categoryIndex < (isMobileViewport() ? 2 : 6);
        if (!shouldLoadCategoryImageEagerly) {
          setProductCardImagePlaceholder(link);
          link.classList.add("vr-product-image-shell", "vr-image-pending");
          link.setAttribute("data-vr-index-category-image", categoryImageUrl);
        } else {
          setProductCardImage(link, categoryImageUrl, {
            eager: true
          });
        }
      }
    });

    setDynEmptyVisibility(indexCategoryList, categories.length > 0);
    bindDeferredIndexCategoryImages();
    loadDeferredIndexCategoryImages();
  }

  function renderIndexCategoryLoadingSkeleton() {
    var indexCategoryList = document.querySelector(".section-2 .collection-list-2.w-dyn-items");
    if (!indexCategoryList) {
      return;
    }

    clearChildren(indexCategoryList);

    var viewportWidth =
      typeof window !== "undefined" && window.innerWidth
        ? window.innerWidth
        : document.documentElement && document.documentElement.clientWidth
          ? document.documentElement.clientWidth
          : 1200;
    var skeletonCount = viewportWidth <= 767 ? 2 : viewportWidth <= 991 ? 4 : 6;

    for (var i = 0; i < skeletonCount; i += 1) {
      var item = document.createElement("div");
      item.className = "collection-item-2 w-dyn-item vr-index-skeleton-item";
      item.style.setProperty("--vr-skeleton-delay", (i * 0.06).toFixed(2) + "s");

      var card = document.createElement("div");
      card.className = "link-block w-inline-block vr-index-category-skeleton vr-skeleton";
      card.setAttribute("aria-hidden", "true");

      var label = document.createElement("div");
      label.className = "text-block vr-index-category-skeleton-text vr-skeleton";
      label.setAttribute("aria-hidden", "true");

      card.appendChild(label);
      item.appendChild(card);
      indexCategoryList.appendChild(item);
    }

    setDynEmptyVisibility(indexCategoryList, true);
  }

  function renderIndexProductsLoadingSkeleton() {
    var indexProductList = document.querySelector(".section-2 .collection-list-wrapper-2 .collection-wrap.w-dyn-items");
    if (!indexProductList) {
      return;
    }

    clearChildren(indexProductList);

    var viewportWidth =
      typeof window !== "undefined" && window.innerWidth
        ? window.innerWidth
        : document.documentElement && document.documentElement.clientWidth
          ? document.documentElement.clientWidth
          : 1200;
    var skeletonCount = viewportWidth <= 767 ? 2 : viewportWidth <= 991 ? 4 : 8;

    for (var i = 0; i < skeletonCount; i += 1) {
      var item = document.createElement("div");
      item.className = "collection-item w-dyn-item vr-skeleton-card";
      item.style.setProperty("--vr-skeleton-delay", (i * 0.06).toFixed(2) + "s");

      var image = document.createElement("div");
      image.className = "product-image-wrap w-inline-block vr-skeleton";
      image.setAttribute("aria-hidden", "true");

      var description = document.createElement("div");
      description.className = "product-description";

      var lineName = document.createElement("span");
      lineName.className = "vr-skeleton vr-skeleton-line lg";
      lineName.setAttribute("aria-hidden", "true");

      var linePrice = document.createElement("span");
      linePrice.className = "vr-skeleton vr-skeleton-line price";
      linePrice.setAttribute("aria-hidden", "true");

      description.appendChild(lineName);
      description.appendChild(linePrice);
      item.appendChild(image);
      item.appendChild(description);
      indexProductList.appendChild(item);
    }

    setDynEmptyVisibility(indexProductList, true);
  }

  function renderIndexProducts(products) {
    var indexProductList = document.querySelector(".section-2 .collection-list-wrapper-2 .collection-wrap.w-dyn-items");
    if (!indexProductList) {
      return;
    }

    clearChildren(indexProductList);

    products.forEach(function appendProduct(product) {
      var item = document.createElement("div");
      item.className = "collection-item w-dyn-item";

      var link = document.createElement("a");
      link.className = "product-image-wrap w-inline-block";
      link.href = productHref(product.slug);
      link.setAttribute("aria-label", product.name || "Proizvod");

      var description = document.createElement("div");
      description.className = "product-description";

      var name = document.createElement("div");
      name.className = "product-name-text";
      name.textContent = product.name;

      var priceRow = createProductPriceRow(product);

      description.appendChild(name);
      description.appendChild(priceRow);
      link.appendChild(description);
      item.appendChild(link);
      indexProductList.appendChild(item);
      setProductCardImage(link, product.image_url);
    });

    setDynEmptyVisibility(indexProductList, products.length > 0);
  }

  function renderDetailProductLoadingSkeleton() {
    var image = document.querySelector(".product-image");
    var name = document.querySelector(".product-detail-name");
    var price = document.querySelector(".product-detail-price");
    var description = document.querySelector(".product-detail-main-details .paragraph-light");
    var identifiers = document.querySelector(".vr-product-identifiers");
    var reviewHost = document.querySelector(".vr-detail-review-host");

    if (image) {
      image.classList.add("vr-product-image-shell", "vr-image-loading");
      image.style.backgroundImage = "none";
    }

    if (name) {
      name.innerHTML =
        '<span class="vr-skeleton vr-detail-skeleton-name" aria-hidden="true"></span>';
    }

    if (price) {
      price.innerHTML =
        '<span class="vr-skeleton vr-detail-skeleton-price" aria-hidden="true"></span>';
    }

    if (description) {
      description.innerHTML = [
        '<span class="vr-skeleton vr-detail-skeleton-desc" style="width:100%" aria-hidden="true"></span>',
        '<span class="vr-skeleton vr-detail-skeleton-desc" style="width:92%" aria-hidden="true"></span>',
        '<span class="vr-skeleton vr-detail-skeleton-desc" style="width:84%" aria-hidden="true"></span>',
        '<span class="vr-skeleton vr-detail-skeleton-desc" style="width:66%" aria-hidden="true"></span>'
      ].join("");
    }

    if (identifiers) {
      clearChildren(identifiers);
      identifiers.hidden = true;
      identifiers.setAttribute("aria-hidden", "true");
    }

    if (reviewHost) {
      reviewHost.remove();
    }
  }

  function renderDetailProductIdentifiers(product) {
    var container = document.querySelector(".vr-product-identifiers");
    if (!container) {
      return;
    }

    clearChildren(container);
    container.hidden = true;
    container.setAttribute("aria-hidden", "true");

    var identifiers = [
      {
        label: "SKU",
        value: normalizeIdentifierValue(product && product.sku)
      },
      {
        label: "GTIN",
        value: normalizeIdentifierValue(product && product.gtin).replace(/\s+/g, "")
      }
    ].filter(function filterIdentifier(identifier) {
      return Boolean(identifier.value);
    });

    if (!identifiers.length) {
      return;
    }

    identifiers.forEach(function appendIdentifier(identifier) {
      var row = document.createElement("div");
      row.className = "vr-product-identifiers__item";

      var label = document.createElement("span");
      label.className = "vr-product-identifiers__label";
      label.textContent = identifier.label;

      var value = document.createElement("span");
      value.className = "vr-product-identifiers__value";
      value.textContent = identifier.value;

      row.appendChild(label);
      row.appendChild(value);
      container.appendChild(row);
    });

    container.hidden = false;
    container.removeAttribute("aria-hidden");
  }

  function renderDetailCartControls(product, fallbackSlug) {
    var codeEmbedContainer = document.querySelector(".code-embed");
    var legacyAddToCart = document.querySelector(".add-to-cart");
    var container = codeEmbedContainer || legacyAddToCart;
    var currentProduct = product && typeof product === "object" ? product : {};
    if (!container) {
      return;
    }

    if (legacyAddToCart && container !== legacyAddToCart) {
      legacyAddToCart.style.display = "none";
    }

    if (container.style.display === "none") {
      container.style.display = "";
    }

    container.classList.add("vr-detail-cart-host");

    container.innerHTML = [
      '<form class="vr-detail-form" id="vr-detail-cart-form" novalidate>',
      '  <label class="cc-quantity-field-label" for="vr-detail-quantity">Kolicina</label>',
      '  <div class="vr-detail-controls">',
      '    <input class="text-field cc-quantity-field" id="vr-detail-quantity" type="number" min="1" max="99" value="1" />',
      '    <button type="submit" id="vr-detail-add-btn" class="primary-button cc-add-to-cart-btn vr-product-add-btn">Dodaj u korpu</button>',
      '    <a href="/checkout" class="primary-button vr-buy-now-btn">Kupi sad</a>',
      "  </div>",
      '  <div data-vr-role="detail-store-stock" class="vr-detail-store-stock-host"></div>',
      '  <div id="vr-detail-feedback" class="vr-feedback" aria-live="polite"></div>',
      "</form>"
    ].join("\n");

    var form = document.getElementById("vr-detail-cart-form");
    var quantityInput = document.getElementById("vr-detail-quantity");
    var feedback = document.getElementById("vr-detail-feedback");

    var addButton = document.getElementById("vr-detail-add-btn");
    var buyNowButton = form.querySelector(".vr-buy-now-btn");
    var detailImage = document.querySelector(".product-image");
    var storeStockHost = container.querySelector('[data-vr-role="detail-store-stock"]');

    if (!form || !quantityInput || !feedback || !addButton) {
      return;
    }

    var productSlug = typeof currentProduct.slug === "string" ? currentProduct.slug.trim() : "";
    var fallback = typeof fallbackSlug === "string" ? fallbackSlug.trim() : "";
    var productName = typeof currentProduct.name === "string" ? currentProduct.name.trim() : "";
    var cartProduct = {
      slug: productSlug || fallback,
      name: productName,
      image_url: typeof currentProduct.image_url === "string" ? currentProduct.image_url : "",
      price_bam: normalizeMoney(currentProduct.price_bam),
      retail_price_bam: normalizeMoneyOrNull(currentProduct.retail_price_bam),
      stock_tracking_enabled: normalizeBoolean(currentProduct.stock_tracking_enabled),
      available_quantity: getProductAvailableQuantity(currentProduct)
    };
    var availabilityText = getProductAvailabilityText(currentProduct);
    var soldOut = isProductSoldOut(currentProduct);
    var availableQuantity = getProductAvailableQuantity(currentProduct);
    var storeStockList = createProductStoreStockList(currentProduct, {
      detail: true
    });

    if (storeStockHost) {
      clearChildren(storeStockHost);
      if (storeStockList) {
        storeStockHost.appendChild(storeStockList);
      } else {
        storeStockHost.remove();
      }
    }

    if (!cartProduct.slug || !cartProduct.name) {
      addButton.setAttribute("disabled", "disabled");
      if (buyNowButton) {
        buyNowButton.classList.add("w--disabled");
        buyNowButton.setAttribute("aria-disabled", "true");
        buyNowButton.setAttribute("tabindex", "-1");
      }
      feedback.className = "vr-feedback error";
      feedback.textContent = "Proizvod nije dostupan za narudzbu.";
      return;
    }

    if (isStockTrackingEnabled(currentProduct)) {
      quantityInput.max = String(Math.max(1, Math.min(MAX_CART_QUANTITY, availableQuantity)));
      feedback.className = "vr-feedback " + getProductAvailabilityFeedbackClass(currentProduct);
      feedback.textContent = availabilityText;
      if (soldOut) {
        addButton.setAttribute("disabled", "disabled");
        addButton.classList.add("w--disabled");
        addButton.textContent = currentLanguage === LANGUAGE_EN ? "Sold out" : "Rasprodato";
        if (buyNowButton) {
          buyNowButton.classList.add("w--disabled");
          buyNowButton.setAttribute("aria-disabled", "true");
          buyNowButton.setAttribute("tabindex", "-1");
        }
        return;
      }
    }

    function onAddToCart(event) {
      event.preventDefault();

      if (isStockTrackingEnabled(currentProduct) && normalizeQuantity(quantityInput.value) > availableQuantity) {
        feedback.className = "vr-feedback error";
        feedback.textContent = availabilityText;
        return;
      }

      try {
        addToCart(cartProduct, quantityInput.value);
        refreshCartLinks();
        animateImageToCart({
          sourceElement: detailImage,
          imageUrl: cartProduct.image_url
        });
        addButton.disabled = true;
        addButton.classList.add("vr-added-success");
        launchAddToCartConfetti(addButton);
        addButton.textContent = "Dodato";
        feedback.className = "vr-feedback";
        feedback.textContent = "";
        window.setTimeout(function restoreDetailAddButtonState() {
          addButton.classList.remove("vr-added-success");
          addButton.textContent = "Dodaj u korpu";
          addButton.disabled = false;
        }, 650);
      } catch (_error) {
        addButton.classList.remove("vr-added-success");
        addButton.textContent = "Pokusaj ponovo";
        addButton.disabled = false;
        window.setTimeout(function restoreDetailAddButtonAfterError() {
          addButton.textContent = "Dodaj u korpu";
        }, 1000);
        feedback.className = "vr-feedback error";
        feedback.textContent = isStockTrackingEnabled(currentProduct) ? availabilityText : "Dodavanje u korpu trenutno nije dostupno.";
      }
    }

    form.addEventListener("submit", onAddToCart);

    if (buyNowButton) {
      buyNowButton.addEventListener("click", function onBuyNowClick(event) {
        event.preventDefault();

        if (isStockTrackingEnabled(currentProduct) && normalizeQuantity(quantityInput.value) > availableQuantity) {
          feedback.className = "vr-feedback error";
          feedback.textContent = availabilityText;
          return;
        }

        try {
          addToCart(cartProduct, quantityInput.value, {
            notify: false
          });
          refreshCartLinks();
          window.location.href = "/checkout";
        } catch (_error) {
          feedback.className = "vr-feedback error";
          feedback.textContent = isStockTrackingEnabled(currentProduct) ? availabilityText : "Kupovina trenutno nije dostupna. Pokusajte ponovo.";
        }
      });
    }
  }

  async function hydrateProductsPage() {
    var search = new URLSearchParams(window.location.search);
    var activeCategory = String(search.get("category") || "").trim();
    var activeDealsOnly = readProductsDealsOnly();
    if (activeDealsOnly) {
      activeCategory = "";
    }
    var activeSearch = readProductsSearchTerm();
    var activePage = readProductsPage();
    var categories = [];
    var currentProducts = [];
    var totalProducts = 0;
    var liveSearchDebounceTimeoutId = null;
    var liveSearchRequestId = 0;
    var liveSearchAbortController = null;
    var productsResponseCache = {};
    var productsRequestsInFlight = Object.create(null);
    var desktopInfiniteScrollBound = false;
    var desktopInfiniteScrollInFlight = false;
    var productsTabPrefetchQueue = [];
    var productsTabPrefetchInFlight = false;
    var productsTabPrefetchTimerId = null;
    var productsTabPrefetchOrder = 0;
    var productsTabPrefetchSeenPaths = Object.create(null);
    var productsTabPrefetchWarmScheduled = false;
    var productsInitialRenderCompleted = false;
    var categoriesRequestSettled = false;
    bindProductsGridHeightSyncOnResize();
    ensureProductsCatalogLayout();
    syncProductsWholesaleIndicator();
    if (isProductsInfiniteScrollMode()) {
      activePage = 1;
    }

    function buildProductsRequestPath(searchTerm, categorySlug, dealsOnly, pageNumber) {
      var resolvedCategory = typeof categorySlug === "string" ? categorySlug.trim() : activeCategory;
      var resolvedDealsOnly = dealsOnly === true;
      var resolvedPage = Number.parseInt(pageNumber, 10);
      if (resolvedDealsOnly) {
        resolvedCategory = "";
      }

      if (!Number.isFinite(resolvedPage) || resolvedPage < 1) {
        resolvedPage = 1;
      }

      var params = new URLSearchParams();
      if (resolvedCategory) {
        params.set("category", resolvedCategory);
      }
      if (resolvedDealsOnly) {
        params.set("deals", "1");
      }
      if (searchTerm) {
        params.set("search", searchTerm);
      }
      params.set("page", String(resolvedPage));
      params.set("pageSize", String(PRODUCTS_PAGE_SIZE));

      return "/products" + (params.toString() ? "?" + params.toString() : "");
    }

    function readCategorySlugFromFilterLink(link) {
      if (!link) {
        return "";
      }

      var attrValue = link.getAttribute("data-vr-category-slug");
      if (typeof attrValue === "string") {
        return attrValue.trim();
      }

      var href = link.getAttribute("href");
      if (!href) {
        return "";
      }

      try {
        var parsedUrl = new URL(href, window.location.origin);
        return String(parsedUrl.searchParams.get("category") || "").trim();
      } catch (_error) {
        return "";
      }
    }

    function readDealsOnlyFromFilterLink(link) {
      if (!link) {
        return false;
      }

      var attrValue = link.getAttribute("data-vr-deals-only");
      if (typeof attrValue === "string") {
        return attrValue.trim() === "1";
      }

      var href = link.getAttribute("href");
      if (!href) {
        return false;
      }

      try {
        var parsedUrl = new URL(href, window.location.origin);
        return isDealsQueryEnabled(parsedUrl.searchParams.get("deals"));
      } catch (_error) {
        return false;
      }
    }

    async function getProductsPayload(requestPath, options) {
      var config = options && typeof options === "object" ? options : {};
      var useCache = config.useCache !== false;
      var retryCount = Number.parseInt(config.retryCount, 10);
      if (!Number.isFinite(retryCount) || retryCount < 0) {
        retryCount = 0;
      }

      if (useCache && productsResponseCache[requestPath]) {
        return productsResponseCache[requestPath];
      }

      if (useCache && productsRequestsInFlight[requestPath]) {
        return productsRequestsInFlight[requestPath];
      }

      var requestOptions = {};
      if (config.signal) {
        requestOptions.signal = config.signal;
      }
      if (typeof config.priority === "string" && config.priority.trim()) {
        requestOptions.priority = config.priority.trim();
      }

      var requestPromise = (async function executeProductsPayloadRequest() {
        var lastError = null;
        for (var attempt = 0; attempt <= retryCount; attempt += 1) {
          try {
            var payload = await requestJson(requestPath, requestOptions);
            if (useCache) {
              productsResponseCache[requestPath] = payload;
            }
            return payload;
          } catch (error) {
            lastError = error;
            if (error && error.name === "AbortError") {
              throw error;
            }

            if (attempt >= retryCount) {
              throw error;
            }

            await new Promise(function waitBeforeProductsRetry(resolve) {
              window.setTimeout(resolve, 140);
            });
          }
        }

        throw lastError || new Error("Failed to load products");
      })();

      if (useCache) {
        productsRequestsInFlight[requestPath] = requestPromise;
      }

      try {
        return await requestPromise;
      } finally {
        if (useCache && productsRequestsInFlight[requestPath] === requestPromise) {
          delete productsRequestsInFlight[requestPath];
        }
      }
    }

    function shouldWarmProductsTabsInBackground() {
      var connection = readNetworkInformation();
      if (!connection) {
        return true;
      }

      if (connection.saveData) {
        return false;
      }

      var effectiveType = typeof connection.effectiveType === "string" ? connection.effectiveType : "";
      return effectiveType !== "slow-2g" && effectiveType !== "2g";
    }

    function readProductsTabPrefetchDelayMs() {
      var connection = readNetworkInformation();
      if (!connection) {
        return 620;
      }

      if (connection.saveData) {
        return 1200;
      }

      var effectiveType = typeof connection.effectiveType === "string" ? connection.effectiveType : "";
      if (effectiveType === "slow-2g" || effectiveType === "2g") {
        return 1400;
      }

      if (effectiveType === "3g") {
        return 980;
      }

      return 620;
    }

    function readProductsTabPrefetchFollowupDelayMs() {
      var connection = readNetworkInformation();
      if (!connection) {
        return 110;
      }

      if (connection.saveData) {
        return 900;
      }

      var effectiveType = typeof connection.effectiveType === "string" ? connection.effectiveType : "";
      if (effectiveType === "slow-2g" || effectiveType === "2g") {
        return 1100;
      }

      if (effectiveType === "3g") {
        return 360;
      }

      return 110;
    }

    function readProductsTabPrefetchImageLoadHoldLimit() {
      var connection = readNetworkInformation();
      if (!connection) {
        return 2;
      }

      if (connection.saveData) {
        return 0;
      }

      var effectiveType = typeof connection.effectiveType === "string" ? connection.effectiveType : "";
      if (effectiveType === "slow-2g" || effectiveType === "2g") {
        return 0;
      }

      if (effectiveType === "3g") {
        return 1;
      }

      return 2;
    }

    function queueProductsTabPrefetch(path, priority, options) {
      var normalizedPath = typeof path === "string" ? path.trim() : "";
      if (!normalizedPath) {
        return;
      }

      if (
        productsResponseCache[normalizedPath] ||
        productsRequestsInFlight[normalizedPath] ||
        productsTabPrefetchSeenPaths[normalizedPath]
      ) {
        return;
      }

      productsTabPrefetchSeenPaths[normalizedPath] = true;
      productsTabPrefetchQueue.push({
        path: normalizedPath,
        priority: Number.isFinite(priority) ? priority : 1,
        order: productsTabPrefetchOrder
      });
      productsTabPrefetchOrder += 1;

      scheduleProductsTabPrefetchPump(options && options.immediate === true);
    }

    function scheduleProductsTabPrefetchPump(immediate, customDelayMs) {
      if (productsTabPrefetchInFlight) {
        return;
      }

      if (productsTabPrefetchTimerId) {
        return;
      }

      var delay = Number.isFinite(customDelayMs) && customDelayMs >= 0
        ? customDelayMs
        : immediate
          ? 24
          : readProductsTabPrefetchDelayMs();
      productsTabPrefetchTimerId = window.setTimeout(function onProductsTabPrefetchTimer() {
        productsTabPrefetchTimerId = null;
        void processProductsTabPrefetchQueue();
      }, delay);
    }

    async function processProductsTabPrefetchQueue() {
      if (productsTabPrefetchInFlight || !productsTabPrefetchQueue.length) {
        return;
      }

      if (liveSearchAbortController || desktopInfiniteScrollInFlight) {
        scheduleProductsTabPrefetchPump(false);
        return;
      }
      if (productCardImageLoadsInFlight > readProductsTabPrefetchImageLoadHoldLimit()) {
        scheduleProductsTabPrefetchPump(false);
        return;
      }

      productsTabPrefetchQueue.sort(function compareProductsTabPrefetchQueue(a, b) {
        if (b.priority !== a.priority) {
          return b.priority - a.priority;
        }

        return a.order - b.order;
      });

      var nextEntry = productsTabPrefetchQueue.shift();
      if (!nextEntry || !nextEntry.path || productsResponseCache[nextEntry.path]) {
        if (productsTabPrefetchQueue.length) {
          scheduleProductsTabPrefetchPump(false);
        }
        return;
      }

      productsTabPrefetchInFlight = true;

      try {
        await getProductsPayload(nextEntry.path, {
          useCache: true,
          retryCount: 0,
          priority: "low"
        });
      } catch (_error) {
        // Silent warm-cache failure. Primary tab click still performs normal load.
        delete productsTabPrefetchSeenPaths[nextEntry.path];
      } finally {
        productsTabPrefetchInFlight = false;
        if (productsTabPrefetchQueue.length) {
          scheduleProductsTabPrefetchPump(false, readProductsTabPrefetchFollowupDelayMs());
        }
      }
    }

    function prefetchProductsTabFromLink(link, priority) {
      if (!link) {
        return;
      }

      var nextDealsOnly = readDealsOnlyFromFilterLink(link);
      var nextCategory = nextDealsOnly ? "" : readCategorySlugFromFilterLink(link);
      var nextPath = buildProductsRequestPath(activeSearch, nextCategory, nextDealsOnly, 1);
      var currentPath = buildProductsRequestPath(activeSearch, activeCategory, activeDealsOnly, 1);

      if (nextPath === currentPath) {
        return;
      }

      queueProductsTabPrefetch(nextPath, priority, {
        immediate: priority >= 2
      });
    }

    function scheduleBackgroundProductsTabsWarmup() {
      if (
        !productsInitialRenderCompleted ||
        productsTabPrefetchWarmScheduled ||
        !shouldWarmProductsTabsInBackground()
      ) {
        return;
      }

      productsTabPrefetchWarmScheduled = true;
      var runWarmup = function runProductsTabsWarmup() {
        productsTabPrefetchWarmScheduled = false;

        if (!activeDealsOnly) {
          queueProductsTabPrefetch(buildProductsRequestPath(activeSearch, "", true, 1), 1);
        }

        for (var i = 0; i < categories.length; i += 1) {
          var category = categories[i];
          var categorySlug = category && typeof category.slug === "string" ? category.slug.trim() : "";
          if (!categorySlug || categorySlug === activeCategory) {
            continue;
          }

          queueProductsTabPrefetch(buildProductsRequestPath(activeSearch, categorySlug, false, 1), 1);
        }

        scheduleProductsTabPrefetchPump(true);
      };

      window.setTimeout(function deferProductsTabsWarmupStart() {
        if (typeof window.requestIdleCallback === "function") {
          window.requestIdleCallback(
            function onProductsTabsWarmupIdle() {
              runWarmup();
            },
            {
              timeout: 3200
            }
          );
          return;
        }

        runWarmup();
      }, 1800);
    }

    function shouldShowProductsCategorySkeleton() {
      return !categoriesRequestSettled && !categories.length;
    }

    function clampProductsPage(pageNumber, totalItems) {
      var total = Number.parseInt(totalItems, 10);
      if (!Number.isFinite(total) || total < 0) {
        total = 0;
      }

      var totalPages = Math.max(1, Math.ceil(total / PRODUCTS_PAGE_SIZE));
      var parsed = Number.parseInt(pageNumber, 10);
      if (!Number.isFinite(parsed) || parsed < 1) {
        return 1;
      }

      if (parsed > totalPages) {
        return totalPages;
      }

      return parsed;
    }

    function readProductsTotal(payload) {
      if (!payload || typeof payload !== "object") {
        return 0;
      }

      var parsedTotal = Number.parseInt(payload.total, 10);
      if (Number.isFinite(parsedTotal) && parsedTotal >= 0) {
        return parsedTotal;
      }

      if (Array.isArray(payload.products)) {
        return payload.products.length;
      }

      return 0;
    }

    function isProductsInfiniteScrollMode() {
      return true;
    }

    function readProductsTotalPages() {
      return Math.max(1, Math.ceil(Math.max(0, Number(totalProducts) || 0) / PRODUCTS_PAGE_SIZE));
    }

    function canLoadMoreProductsOnDesktop() {
      if (!isProductsInfiniteScrollMode()) {
        return false;
      }

      if (desktopInfiniteScrollInFlight) {
        return false;
      }

      return activePage < readProductsTotalPages();
    }

    function readProductsInfiniteScrollTriggerDistancePx(viewportHeight) {
      if (!isMobileViewport()) {
        return 640;
      }

      var safeViewportHeight =
        Number.isFinite(viewportHeight) && viewportHeight > 0 ? viewportHeight : 0;
      if (!safeViewportHeight) {
        return 1400;
      }

      return Math.max(1400, Math.round(safeViewportHeight * 1.9));
    }

    function maybeLoadMoreProductsOnDesktopScroll() {
      if (!canLoadMoreProductsOnDesktop()) {
        return;
      }

      var scrollTop =
        typeof window.pageYOffset === "number"
          ? window.pageYOffset
          : document.documentElement && typeof document.documentElement.scrollTop === "number"
            ? document.documentElement.scrollTop
            : 0;
      var viewportHeight =
        typeof window.innerHeight === "number"
          ? window.innerHeight
          : document.documentElement && typeof document.documentElement.clientHeight === "number"
            ? document.documentElement.clientHeight
            : 0;
      var documentHeight =
        document.documentElement && typeof document.documentElement.scrollHeight === "number"
          ? document.documentElement.scrollHeight
          : 0;
      var triggerDistance = readProductsInfiniteScrollTriggerDistancePx(viewportHeight);

      if (scrollTop + viewportHeight < documentHeight - triggerDistance) {
        return;
      }

      var nextPage = clampProductsPage(activePage + 1, totalProducts);
      if (nextPage <= activePage) {
        return;
      }

      desktopInfiniteScrollInFlight = true;
      runLiveProductsSearch(activeSearch, {
        category: activeCategory,
        dealsOnly: activeDealsOnly,
        page: nextPage,
        appendResults: true,
        showSkeleton: false,
        useCache: true,
        retryCount: 1,
        historyMode: "replace"
      }).finally(function onDesktopProductsAppendSettled() {
        desktopInfiniteScrollInFlight = false;
        window.setTimeout(function triggerDesktopProductsAppendCheck() {
          maybeLoadMoreProductsOnDesktopScroll();
        }, 0);
      });
    }

    function bindDesktopProductsInfiniteScroll() {
      if (desktopInfiniteScrollBound) {
        return;
      }

      desktopInfiniteScrollBound = true;

      var onDesktopProductsScroll = function onDesktopProductsScroll() {
        maybeLoadMoreProductsOnDesktopScroll();
      };

      window.addEventListener("scroll", onDesktopProductsScroll, {
        passive: true
      });
      window.addEventListener("resize", onDesktopProductsScroll);
    }

    function syncProductsSearchUrl(searchTerm, pageNumber, historyMode) {
      var safePage = clampProductsPage(pageNumber, totalProducts);
      if (isProductsInfiniteScrollMode()) {
        safePage = 1;
      }
      var nextPath = productsHref(activeCategory, searchTerm, safePage, activeDealsOnly);
      var currentPath = window.location.pathname + window.location.search;
      if (currentPath === nextPath) {
        return;
      }

      if (!window.history) {
        return;
      }

      if (historyMode === "push" && typeof window.history.pushState === "function") {
        window.history.pushState({}, "", nextPath);
        return;
      }

      if (typeof window.history.replaceState === "function") {
        window.history.replaceState({}, "", nextPath);
      }
    }

    function renderCurrentProductsPage(options) {
      var config = options && typeof options === "object" ? options : {};
      var requestedPage =
        config.page === undefined ? activePage : Number.parseInt(config.page, 10);
      var safePage = clampProductsPage(requestedPage, totalProducts);
      var appendMode = config.append === true;
      var productsForGrid = Array.isArray(config.products)
        ? config.products
        : Array.isArray(currentProducts)
          ? currentProducts
          : [];

      activePage = safePage;

      renderProductsGrid(productsForGrid, {
        append: appendMode
      });

      if (isProductsInfiniteScrollMode()) {
        renderProductsPagination(0, 1, PRODUCTS_PAGE_SIZE, null);
      } else {
        renderProductsPagination(
          totalProducts,
          activePage,
          PRODUCTS_PAGE_SIZE,
          function onProductsPageChange(nextPage) {
            var safeNextPage = clampProductsPage(nextPage, totalProducts);
            if (safeNextPage === activePage) {
              return;
            }

            runLiveProductsSearch(activeSearch, {
              category: activeCategory,
              dealsOnly: activeDealsOnly,
              page: safeNextPage,
              showSkeleton: false,
              useCache: true,
              retryCount: 1,
              historyMode: "push"
            });
          }
        );
      }

      if (config.syncUrl !== false) {
        syncProductsSearchUrl(activeSearch, activePage, config.historyMode);
      }

      if (isProductsInfiniteScrollMode()) {
        maybeLoadMoreProductsOnDesktopScroll();
      }
    }

    async function runLiveProductsSearch(searchTerm, options) {
      var normalizedSearch = typeof searchTerm === "string" ? searchTerm.trim() : "";
      var config = options && typeof options === "object" ? options : {};
      var nextCategory =
        typeof config.category === "string" ? config.category.trim() : activeCategory;
      var nextDealsOnly =
        typeof config.dealsOnly === "boolean" ? config.dealsOnly : activeDealsOnly;
      if (nextDealsOnly) {
        nextCategory = "";
      }
      var requestedPage = Number.parseInt(config.page, 10);
      if (!Number.isFinite(requestedPage) || requestedPage < 1) {
        requestedPage = 1;
      }
      var shouldAppendResults =
        config.appendResults === true && isProductsInfiniteScrollMode() && requestedPage > 1;
      var requestPath = buildProductsRequestPath(
        normalizedSearch,
        nextCategory,
        nextDealsOnly,
        requestedPage
      );
      var requestId = (liveSearchRequestId += 1);
      var abortController = null;

      if (liveSearchAbortController) {
        liveSearchAbortController.abort();
        liveSearchAbortController = null;
      }

      if (typeof window.AbortController === "function") {
        abortController = new window.AbortController();
        liveSearchAbortController = abortController;
      }

      if (!shouldAppendResults) {
        setProductsSearchLoadingState(true);
        setProductsFeedbackMessage("");
      }

      if (shouldAppendResults) {
        var appendViewportWidth =
          typeof window !== "undefined" && window.innerWidth
            ? window.innerWidth
            : document.documentElement && document.documentElement.clientWidth
              ? document.documentElement.clientWidth
              : 1200;
        var appendColumns = appendViewportWidth <= 767 ? 2 : appendViewportWidth <= 991 ? 3 : 4;
        var appendSkeletonCount = Math.min(PRODUCTS_PAGE_SIZE, Math.max(appendColumns * 2, appendColumns));
        appendProductsGridLoadingSkeletonRows(appendSkeletonCount);
      }

      if (!shouldAppendResults && config.showSkeleton !== false && !currentProducts.length) {
        renderProductsGridLoadingSkeleton();
        renderProductsPagination(0, 1, PRODUCTS_PAGE_SIZE, null);
      }

      try {
        var payload = await getProductsPayload(requestPath, {
          signal: abortController ? abortController.signal : null,
          useCache: config.useCache !== false,
          retryCount: config.retryCount
        });
        if (requestId !== liveSearchRequestId) {
          return;
        }

        activeCategory = nextCategory;
        activeDealsOnly = nextDealsOnly;
        activeSearch = normalizedSearch;
        var nextProducts = Array.isArray(payload.products) ? payload.products : [];
        if (shouldAppendResults) {
          currentProducts = currentProducts.concat(nextProducts);
        } else {
          currentProducts = nextProducts;
        }
        totalProducts = readProductsTotal(payload);
        var safePage = clampProductsPage(requestedPage, totalProducts);
        if (safePage !== requestedPage && totalProducts > 0) {
          runLiveProductsSearch(normalizedSearch, {
            category: nextCategory,
            dealsOnly: nextDealsOnly,
            page: safePage,
            appendResults: false,
            showSkeleton: false,
            useCache: true,
            retryCount: config.retryCount,
            historyMode: config.historyMode || "replace"
          });
          return;
        }

        activePage = safePage;
        renderProductsCategoryFilters(categories, activeCategory, activeSearch, activeDealsOnly, {
          showCategorySkeleton: shouldShowProductsCategorySkeleton(),
          keepStaticVisibleWhileLoading: true
        });
        renderCurrentProductsPage({
          page: activePage,
          append: shouldAppendResults,
          products: shouldAppendResults ? nextProducts : currentProducts,
          syncUrl: true,
          historyMode: config.historyMode || "replace"
        });
        if (!shouldAppendResults) {
          scheduleBackgroundProductsTabsWarmup();
        }
      } catch (error) {
        if (requestId !== liveSearchRequestId) {
          return;
        }

        if (error && error.name === "AbortError") {
          return;
        }

        console.error("Products live search failed", error);
        setProductsFeedbackMessage(
          currentLanguage === LANGUAGE_EN
            ? "Products could not be refreshed. Please try again."
            : "Ne mozemo osvjeziti proizvode. Pokusajte ponovo."
        );
        renderProductsCategoryFilters(categories, activeCategory, activeSearch, activeDealsOnly, {
          showCategorySkeleton: shouldShowProductsCategorySkeleton(),
          keepStaticVisibleWhileLoading: true
        });
        renderCurrentProductsPage({
          page: activePage,
          syncUrl: false
        });
      } finally {
        if (shouldAppendResults) {
          clearProductsGridAppendLoadingSkeleton();
        }
        if (!shouldAppendResults && requestId === liveSearchRequestId) {
          setProductsSearchLoadingState(false);
        }
        if (liveSearchAbortController === abortController) {
          liveSearchAbortController = null;
        }
      }
    }

    function scheduleLiveProductsSearch(searchTerm, options) {
      var normalizedSearch = typeof searchTerm === "string" ? searchTerm.trim() : "";
      var config = options && typeof options === "object" ? options : {};

      if (liveSearchDebounceTimeoutId) {
        window.clearTimeout(liveSearchDebounceTimeoutId);
        liveSearchDebounceTimeoutId = null;
      }

      if (normalizedSearch === activeSearch) {
        liveSearchRequestId += 1;
        if (liveSearchAbortController) {
          liveSearchAbortController.abort();
          liveSearchAbortController = null;
        }
        syncProductsSearchUrl(normalizedSearch, activePage, config.historyMode || "replace");
        return;
      }

      if (config.immediate) {
        runLiveProductsSearch(normalizedSearch, {
          page: config.page,
          showSkeleton: config.showSkeleton !== false,
          useCache: true,
          retryCount: 1,
          historyMode: config.historyMode || "replace",
          category: config.category,
          dealsOnly: config.dealsOnly
        });
        return;
      }

      liveSearchDebounceTimeoutId = window.setTimeout(function onLiveSearchDebounced() {
        runLiveProductsSearch(normalizedSearch, {
          page: 1,
          showSkeleton: false,
          useCache: true,
          retryCount: 1,
          historyMode: "replace",
          category: config.category,
          dealsOnly: config.dealsOnly
        });
      }, 220);
    }

    function bindProductsCategoryFilters() {
      var categoryList = document.querySelector(".store-categories-wrap .collection-list.w-dyn-items");
      if (!categoryList || categoryList._vrCategoryFiltersBound) {
        return;
      }

      categoryList._vrCategoryFiltersBound = true;
      categoryList.addEventListener(
        "pointerdown",
        function onProductsCategoryFilterPointerDown(event) {
          var target = event.target;
          if (!target || typeof target.closest !== "function") {
            return;
          }

          var link = target.closest("a.products-category-link");
          if (!link || !categoryList.contains(link)) {
            return;
          }

          prefetchProductsTabFromLink(link, 3);
        },
        {
          passive: true
        }
      );
      categoryList.addEventListener(
        "touchstart",
        function onProductsCategoryFilterTouchStart(event) {
          var target = event.target;
          if (!target || typeof target.closest !== "function") {
            return;
          }

          var link = target.closest("a.products-category-link");
          if (!link || !categoryList.contains(link)) {
            return;
          }

          prefetchProductsTabFromLink(link, 3);
        },
        {
          passive: true
        }
      );
      categoryList.addEventListener(
        "mouseover",
        function onProductsCategoryFilterHover(event) {
          var target = event.target;
          if (!target || typeof target.closest !== "function") {
            return;
          }

          var link = target.closest("a.products-category-link");
          if (!link || !categoryList.contains(link)) {
            return;
          }

          prefetchProductsTabFromLink(link, 2);
        },
        {
          passive: true
        }
      );
      categoryList.addEventListener("focusin", function onProductsCategoryFilterFocus(event) {
        var target = event.target;
        if (!target || typeof target.closest !== "function") {
          return;
        }

        var link = target.closest("a.products-category-link");
        if (!link || !categoryList.contains(link)) {
          return;
        }

        prefetchProductsTabFromLink(link, 2);
      });
      categoryList.addEventListener("click", function onProductsCategoryFilterClick(event) {
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }

        var target = event.target;
        if (!target || typeof target.closest !== "function") {
          return;
        }

        var link = target.closest("a.products-category-link");
        if (!link || !categoryList.contains(link)) {
          return;
        }

        if (link.target && link.target !== "_self") {
          return;
        }

        if (link.hasAttribute("download")) {
          return;
        }

        var nextDealsOnly = readDealsOnlyFromFilterLink(link);
        var nextCategory = nextDealsOnly ? "" : readCategorySlugFromFilterLink(link);
        if (nextCategory === activeCategory && nextDealsOnly === activeDealsOnly) {
          event.preventDefault();
          syncProductsSearchUrl(activeSearch, 1, "push");
          return;
        }

        event.preventDefault();
        runLiveProductsSearch(activeSearch, {
          category: nextCategory,
          dealsOnly: nextDealsOnly,
          page: 1,
          showSkeleton: false,
          useCache: true,
          retryCount: 1,
          historyMode: "push"
        });
      });
    }

    ensureProductsSearchControls(activeSearch, {
      onSearchChange: scheduleLiveProductsSearch
    });
    bindProductsCategoryFilters();
    bindDesktopProductsInfiniteScroll();
    renderProductsLoadingSkeleton();
    renderProductsPagination(0, 1, PRODUCTS_PAGE_SIZE, null);
    setProductsSearchLoadingState(true);
    setProductsFeedbackMessage("");
    renderProductsCategoryFilters([], activeCategory, activeSearch, activeDealsOnly, {
      showCategorySkeleton: true,
      keepStaticVisibleWhileLoading: true
    });

    var initialProductsRequestPath = buildProductsRequestPath(
      activeSearch,
      activeCategory,
      activeDealsOnly,
      activePage
    );
    var categoriesRequestPromise = requestJson("/categories", {
      priority: "low"
    });
    void categoriesRequestPromise
      .then(function onInitialCategoriesLoaded(result) {
        categoriesRequestSettled = true;
        categories =
          result &&
          typeof result === "object" &&
          Array.isArray(result.categories)
            ? result.categories
            : [];
        renderProductsCategoryFilters(categories, activeCategory, activeSearch, activeDealsOnly, {
          showCategorySkeleton: false
        });
        renderFooterCategories(categories);
        scheduleBackgroundProductsTabsWarmup();
      })
      .catch(function onInitialCategoriesLoadFailed(error) {
        categoriesRequestSettled = true;
        categories = [];
        console.error("Failed to load product categories", error);
        setProductsFeedbackMessage(
          currentLanguage === LANGUAGE_EN
            ? "Categories are temporarily unavailable."
            : "Kategorije trenutno nisu dostupne."
        );
        renderProductsCategoryFilters(categories, activeCategory, activeSearch, activeDealsOnly);
      });

    var productsPayload = null;
    try {
      productsPayload = await getProductsPayload(initialProductsRequestPath, {
        useCache: true,
        retryCount: 1,
        priority: "high"
      });
    } catch (initialProductsError) {
      var cachedProductsPayload = productsResponseCache[initialProductsRequestPath];
      productsPayload = cachedProductsPayload || null;
      console.error("Failed to load products", initialProductsError);

      if (!productsPayload || !Array.isArray(productsPayload.products)) {
        try {
          var recoveredProductsPayload = await getProductsPayload(initialProductsRequestPath, {
            useCache: false,
            retryCount: 2
          });
          productsPayload = recoveredProductsPayload || null;
        } catch (recoveryError) {
          console.error("Failed to recover products after initial load error", recoveryError);
        }
      }
    }

    currentProducts =
      productsPayload && Array.isArray(productsPayload.products) ? productsPayload.products : [];
    totalProducts = readProductsTotal(productsPayload);
    activePage = clampProductsPage(activePage, totalProducts);

    if (!currentProducts.length && totalProducts === 0 && !productsPayload) {
      setProductsFeedbackMessage(
        currentLanguage === LANGUAGE_EN
          ? "Products are temporarily unavailable. Please refresh the page."
          : "Proizvodi trenutno nisu dostupni. Osvjezite stranicu."
      );
    }

    if (liveSearchDebounceTimeoutId) {
      window.clearTimeout(liveSearchDebounceTimeoutId);
      liveSearchDebounceTimeoutId = null;
    }

    renderProductsCategoryFilters(categories, activeCategory, activeSearch, activeDealsOnly, {
      showCategorySkeleton: shouldShowProductsCategorySkeleton(),
      keepStaticVisibleWhileLoading: true
    });
    renderCurrentProductsPage({
      page: activePage,
      syncUrl: true,
      historyMode: "replace"
    });
    productsInitialRenderCompleted = true;
    if (categories.length) {
      renderFooterCategories(categories);
    }
    setProductsSearchLoadingState(false);
    scheduleBackgroundProductsTabsWarmup();

    if (!window.__vrProductsPopstateBound) {
      window.__vrProductsPopstateBound = true;
      window.addEventListener("popstate", function onProductsPopstate() {
        var nextCategory = String(new URLSearchParams(window.location.search).get("category") || "").trim();
        var nextDealsOnly = readProductsDealsOnly();
        if (nextDealsOnly) {
          nextCategory = "";
        }
        var nextSearch = readProductsSearchTerm();
        var nextPage = isProductsInfiniteScrollMode() ? 1 : readProductsPage();
        var searchInput = document.getElementById("vr-products-search-input");
        if (searchInput) {
          searchInput.value = nextSearch;
          updateProductsSearchUiState(searchInput.form, nextSearch);
        }

        runLiveProductsSearch(nextSearch, {
          category: nextCategory,
          dealsOnly: nextDealsOnly,
          page: nextPage,
          showSkeleton: false,
          useCache: true,
          retryCount: 1,
          historyMode: "replace"
        });
      });
    }
  }

  async function hydrateIndexPage() {
    var loadFeedback = document.getElementById("vr-index-load-feedback");
    if (loadFeedback && loadFeedback.parentNode) {
      loadFeedback.parentNode.removeChild(loadFeedback);
    }

    renderIndexCategoryLoadingSkeleton();

    var categories = [];
    var categoriesRequestPromise = requestJson("/categories");
    var categoryLoadPromise = categoriesRequestPromise
      .then(function onHomepageCategoriesLoaded(payload) {
        categories = payload && Array.isArray(payload.categories) ? payload.categories : [];
        renderIndexCategories(categories);
        renderFooterCategories(categories);
        return true;
      })
      .catch(function onHomepageCategoriesFailed(error) {
        console.error("Failed to load homepage categories", error);
        renderIndexCategories([]);
        return false;
      });
    var categoriesLoaded = await categoryLoadPromise;

    if (!categoriesLoaded) {
      var host = document.querySelector(".section-2 .container");
      if (host) {
        var feedback = document.createElement("p");
        feedback.id = "vr-index-load-feedback";
        feedback.className = "vr-feedback error";
        feedback.textContent =
          currentLanguage === LANGUAGE_EN
            ? "Some homepage content is temporarily unavailable."
            : "Dio naslovnog sadrzaja trenutno nije dostupan.";
        host.appendChild(feedback);
      }
    }
  }

  function preloadDetailProductImage() {
    var image = document.querySelector(".product-image");
    var metadata = document.querySelector('meta[property="og:image"]');
    if (!image || !metadata || !isResponsiveTransformSupportedUrl(metadata.content)) {
      return;
    }

    var imageUrls = resolveResponsiveBackgroundImageUrls(metadata.content, {
      role: "detail",
      element: image
    });
    if (!imageUrls.primary || document.getElementById("vr-detail-image-preload")) {
      return;
    }

    var preload = document.createElement("link");
    preload.id = "vr-detail-image-preload";
    preload.rel = "preload";
    preload.as = "image";
    preload.setAttribute("fetchpriority", "high");
    preload.href = imageUrls.primary;
    document.head.appendChild(preload);
  }

  async function hydrateProductDetailPage() {
    var slug = readDetailProductSlug();

    try {
      if (!slug) {
        renderDetailCartControls({}, "");
        return;
      }

      renderDetailProductLoadingSkeleton();

      preloadDetailProductImage();

      var payload = await requestJson(productDetailApiPath(slug));
      var product = payload.product;

      if (!product) {
        renderDetailCartControls({}, slug);
        return;
      }

      var image = document.querySelector(".product-image");
      var name = document.querySelector(".product-detail-name");
      var price = document.querySelector(".product-detail-price");
      var description = document.querySelector(".product-detail-main-details .paragraph-light");

      setProductCardImage(image, product.image_url, {
        role: "detail",
        productName: product.name || ""
      });
      initDetailImageZoom(image, product.image_url);

      if (name) {
        name.textContent = product.name || "";
      }

      if (price) {
        clearChildren(price);
        price.appendChild(createProductPriceRow(product));
      }

      if (description) {
        description.textContent = product.description || "";
      }

      renderDetailProductIdentifiers(product);
      renderDetailProductReview(product);

      if (product.name) {
        document.title = product.name + " | Vape Republic";
      }

      renderDetailCartControls(product, slug);
    } finally {
      markDetailProductReady();
    }
  }

  async function hydrateDetailCategoryPage() {
    var search = new URLSearchParams(window.location.search);
    var activeCategory = search.get("slug") || search.get("category") || "";

    renderProductsCategoryFilters([], activeCategory, "", false, {
      showCategorySkeleton: true
    });
    renderProductsGridLoadingSkeleton();

    var categoryPromise = requestJson("/categories");
    var productPromise = requestJson(
      "/products" +
        (activeCategory
          ? "?category=" + encodeURIComponent(activeCategory) + "&limit=2000"
          : "?limit=2000")
    );

    var results = await Promise.all([categoryPromise, productPromise]);
    var categories = results[0].categories || [];
    var products = results[1].products || [];

    renderProductsCategoryFilters(categories, activeCategory, "");
    renderProductsGrid(products);
    renderFooterCategories(categories);
  }

  function collectCheckoutCustomerData(form) {
    var formData = new FormData(form);

    return {
      name: String(formData.get("name") || "").trim(),
      email: String(formData.get("email") || "").trim(),
      phone: String(formData.get("phone") || "").trim(),
      addressLine1: String(formData.get("address_line1") || "").trim(),
      addressLine2: String(formData.get("address_line2") || "").trim(),
      city: String(formData.get("city") || "").trim(),
      zip: String(formData.get("zip") || "").trim(),
      country: "BA",
      paymentMethod: CHECKOUT_PAYMENT_METHOD,
      notes: String(formData.get("notes") || "").trim()
    };
  }

  function clearCheckoutFieldErrors(form) {
    if (!form) {
      return;
    }

    form.querySelectorAll(".vr-field-error").forEach(function removeFieldError(node) {
      if (node.parentNode) {
        node.parentNode.removeChild(node);
      }
    });

    form.querySelectorAll(".text-field[aria-invalid='true']").forEach(function resetInvalidState(input) {
      input.removeAttribute("aria-invalid");
      input.removeAttribute("aria-describedby");
    });
  }

  function setCheckoutFieldError(form, fieldName, message) {
    if (!form || !fieldName || !message) {
      return;
    }

    var field = form.elements[fieldName];
    if (!field || !(field instanceof Element)) {
      return;
    }

    var errorId = "vr-field-error-" + String(fieldName).replace(/[^a-z0-9_-]/gi, "");
    field.setAttribute("aria-invalid", "true");
    field.setAttribute("aria-describedby", errorId);

    var messageNode = document.createElement("div");
    messageNode.id = errorId;
    messageNode.className = "vr-field-error";
    messageNode.textContent = message;

    if (field.parentNode) {
      field.parentNode.appendChild(messageNode);
    }
  }

  function validateCheckoutCustomer(customer, form) {
    var errors = {};
    var requiredMessage = currentLanguage === LANGUAGE_EN ? "This field is required." : "Obavezno polje.";
    if (!customer.name) {
      errors.name = requiredMessage;
    }
    if (!customer.email) {
      errors.email = requiredMessage;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(customer.email)) {
      errors.email =
        currentLanguage === LANGUAGE_EN ? "Enter a valid email address." : "Unesite ispravnu email adresu.";
    }
    if (!customer.phone) {
      errors.phone = requiredMessage;
    } else if (!isPhoneValid(customer.phone)) {
      errors.phone =
        currentLanguage === LANGUAGE_EN
          ? "Enter a valid phone number."
          : "Unesite ispravan broj telefona.";
    }
    if (!customer.addressLine1) {
      errors.address_line1 = requiredMessage;
    }
    if (!customer.city) {
      errors.city = requiredMessage;
    }
    if (!customer.zip) {
      errors.zip = requiredMessage;
    }

    clearCheckoutFieldErrors(form);
    Object.keys(errors).forEach(function applyFieldError(fieldName) {
      setCheckoutFieldError(form, fieldName, errors[fieldName]);
    });

    return {
      valid: Object.keys(errors).length === 0,
      errors: errors
    };
  }

  function renderCheckoutCartRows(container, cart) {
    if (!container) {
      return;
    }

    if (!cart.length) {
      container.innerHTML =
        '<div class="vr-empty"><p>Korpa je prazna.</p><a class="primary-button" href="/products">Pogledaj proizvode</a></div>';
      return;
    }

    var rows = cart
      .map(function mapItem(item) {
        var unitPriceMarkup = getCartUnitPriceHtml(item);
        var lineTotalMarkup = getCartLineTotalHtml(item);
        var previewImageLabel = currentLanguage === LANGUAGE_EN ? "View product image" : "Pogledaj sliku proizvoda";
        var imageMarkup = '    <div class="vr-cart-item-image"></div>';
        var itemImageUrl = buildResponsiveImageUrl(item.image_url, {
          role: "checkout"
        }) || item.image_url;
        var itemImageSrcset = buildResponsiveImageSrcset(item.image_url, "checkout");

        if (itemImageUrl) {
          imageMarkup = [
            '    <button class="vr-cart-item-image vr-cart-item-image-btn" type="button" data-action="preview-image" data-image-src="' +
              escapeHtml(item.image_url || itemImageUrl) +
              '" data-image-alt="' +
              escapeHtml(item.name || "") +
              '" aria-label="' +
              escapeHtml(previewImageLabel) +
              '">',
            '      <img class="vr-cart-item-image-img" src="' +
              escapeHtml(itemImageUrl) +
              '" ' +
              (itemImageSrcset ? 'srcset="' + escapeHtml(itemImageSrcset) + '" sizes="96px" ' : "") +
              'data-original-src="' +
              escapeHtml(item.image_url || itemImageUrl) +
              '" ' +
              'alt="' +
              escapeHtml(item.name || "") +
              '" loading="lazy" decoding="async" />',
            "    </button>"
          ].join("\n");
        }

        return [
          '<div class="vr-cart-row vr-checkout-item-row" data-slug="' + escapeHtml(item.slug) + '">',
          '  <div class="vr-cart-item-head">',
          imageMarkup,
          '    <div class="vr-cart-item-info">',
          '      <div class="vr-cart-item-line">',
          '        <div class="vr-cart-item-name">' + escapeHtml(item.name) + "</div>",
          "      </div>",
          '      <div class="vr-muted vr-cart-item-unit-price">' + unitPriceMarkup + "</div>",
          "    </div>",
          "  </div>",
          '  <div class="vr-checkout-item-actions">',
          '    <button class="vr-cart-remove-btn" type="button" data-action="remove" aria-label="Ukloni proizvod">&times;</button>',
          '    <input class="text-field vr-cart-qty" type="number" min="1" max="99" data-action="quantity" value="' +
            escapeHtml(item.quantity) +
            '" />',
          '    <div class="vr-cart-row-total">' + lineTotalMarkup + "</div>",
          "  </div>",
          "</div>"
        ].join("\n");
      })
      .join("\n");

    container.innerHTML = rows;
    bindCartItemImageFallback(container);
  }

  function renderCheckoutSummary(summary) {
    var subtotalEl = document.getElementById("vr-summary-subtotal");
    var shippingEl = document.getElementById("vr-summary-shipping");
    var totalEl = document.getElementById("vr-summary-total");
    var deliveryNoteEl = document.getElementById("vr-checkout-delivery-note");

    if (subtotalEl) {
      subtotalEl.textContent = formatPrice(summary.subtotal);
    }

    if (shippingEl) {
      shippingEl.textContent = formatPrice(summary.shipping);
    }

    if (totalEl) {
      totalEl.textContent = formatPrice(summary.total);
    }

    renderDeliveryNotice(deliveryNoteEl, summary.subtotal);
  }

  function renderCheckoutPage() {
    var root = document.querySelector('[data-node-type="commerce-checkout-form-container"]');
    if (!root) {
      return;
    }

    root.innerHTML = [
      '<div class="container cc-full-width-form-wrap">',
      '  <div class="vr-checkout-layout">',
      '    <div>',
      '      <section class="vr-card vr-checkout-cart-card">',
      '        <h1 class="heading-jumbo-tiny">Korpa</h1>',
      '        <div id="vr-checkout-items"></div>',
      "      </section>",
      '      <section class="vr-card vr-checkout-details-card">',
      '        <h2 class="heading-jumbo-tiny">Podaci za narudzbu</h2>',
      '        <form id="vr-checkout-form" class="vr-form-grid">',
      '          <div class="vr-form-grid cols-2">',
      '            <div><label class="vr-label" for="vr-name">Ime i prezime</label><input id="vr-name" class="text-field" name="name" required /></div>',
      '            <div><label class="vr-label" for="vr-email">Email</label><input id="vr-email" class="text-field" name="email" type="email" required /></div>',
      "          </div>",
      '          <div class="vr-form-grid cols-2">',
      '            <div><label class="vr-label" for="vr-phone">Telefon</label><input id="vr-phone" class="text-field" name="phone" type="tel" required autocomplete="tel" /></div>',
      '            <div><label class="vr-label" for="vr-country-display">Drzava</label><input id="vr-country-display" class="text-field vr-fixed-field" value="\ud83c\udde7\ud83c\udde6 Bosna i Hercegovina" disabled aria-disabled="true" /></div>',
      "          </div>",
      '          <div><label class="vr-label" for="vr-address1">Adresa</label><input id="vr-address1" class="text-field" name="address_line1" required /></div>',
      '          <div><label class="vr-label" for="vr-address2">Adresa 2 (opcionalno)</label><input id="vr-address2" class="text-field" name="address_line2" /></div>',
      '          <div class="vr-form-grid cols-2">',
      '            <div><label class="vr-label" for="vr-city">Grad</label><input id="vr-city" class="text-field" name="city" required /></div>',
      '            <div><label class="vr-label" for="vr-zip">Postanski broj</label><input id="vr-zip" class="text-field" name="zip" required /></div>',
      "          </div>",
      '          <div class="vr-form-grid cols-2">',
      '            <div><label class="vr-label" for="vr-delivery-method">Dostava i placanje</label><input id="vr-delivery-method" class="text-field vr-fixed-field" value="' +
        CHECKOUT_PAYMENT_METHOD_LABEL +
        '" disabled aria-disabled="true" /></div>',
      '            <div><label class="vr-label" for="vr-notes">Napomena</label><input id="vr-notes" class="text-field" name="notes" /></div>',
      "          </div>",
      '          <input type="hidden" name="country" value="BA" />',
      '          <input type="hidden" name="payment_method" value="' + CHECKOUT_PAYMENT_METHOD + '" />',
      '          <button id="vr-place-order" type="submit" class="primary-button">Potvrdi narudzbu</button>',
      '          <div id="vr-checkout-feedback" class="vr-feedback" aria-live="polite"></div>',
      "        </form>",
      "      </section>",
      "    </div>",
      '    <aside class="vr-card vr-checkout-summary-card">',
      '      <h2 class="heading-jumbo-tiny">Pregled narudzbe</h2>',
      '      <div class="vr-summary-row vr-summary-subtotal"><span>Subtotal</span><span id="vr-summary-subtotal"></span></div>',
      '      <div class="vr-summary-row"><span>Dostava</span><span id="vr-summary-shipping"></span></div>',
      '      <p id="vr-checkout-delivery-note" class="vr-muted vr-delivery-note"></p>',
      '      <div class="vr-summary-row vr-summary-total"><span>Ukupno</span><span id="vr-summary-total"></span></div>',
      '      <p class="vr-muted">Dostava i placanje se vrse putem Brze Poste. Nakon potvrde narudzbe, dobicete broj narudzbe i potvrdu.</p>',
      "    </aside>",
      "  </div>",
      "</div>"
    ].join("\n");

    var draft = readCheckoutDraft();
    var form = document.getElementById("vr-checkout-form");
    var itemsContainer = document.getElementById("vr-checkout-items");
    var feedback = document.getElementById("vr-checkout-feedback");
    var placeOrderButton = document.getElementById("vr-place-order");

    if (!form || !itemsContainer || !feedback || !placeOrderButton) {
      return;
    }

    ["name", "email", "phone", "address_line1", "address_line2", "city", "zip", "notes"].forEach(
      function applyDraftValue(fieldName) {
        var input = form.elements[fieldName];
        if (input && draft[fieldName]) {
          input.value = draft[fieldName];
        }
      }
    );

    function syncCheckoutUI() {
      var cart = readCart();
      var summary = getCartSummary(cart);

      renderCheckoutCartRows(itemsContainer, cart);
      renderCheckoutSummary(summary);
      placeOrderButton.disabled = cart.length === 0;

      if (!cart.length) {
        feedback.className = "vr-feedback";
        feedback.textContent = "";
      }
    }

    itemsContainer.addEventListener("click", function onItemsClick(event) {
      var previewButton = event.target.closest('button[data-action="preview-image"]');
      if (previewButton) {
        event.preventDefault();
        openCartImagePreview(
          previewButton.getAttribute("data-image-src"),
          previewButton.getAttribute("data-image-alt")
        );
        return;
      }

      var removeButton = event.target.closest('button[data-action="remove"]');
      if (!removeButton) {
        return;
      }

      var row = removeButton.closest("[data-slug]");
      if (!row) {
        return;
      }

      removeCartItem(row.getAttribute("data-slug"));
      syncCheckoutUI();
    });

    itemsContainer.addEventListener("change", function onItemsChange(event) {
      var input = event.target.closest('input[data-action="quantity"]');
      if (!input) {
        return;
      }

      var row = input.closest("[data-slug]");
      if (!row) {
        return;
      }

      setCartItemQuantity(row.getAttribute("data-slug"), input.value);
      syncCheckoutUI();
    });

    form.addEventListener("input", function onFormInput(event) {
      var target = event ? event.target : null;
      if (target && target instanceof Element && target.classList.contains("text-field")) {
        target.removeAttribute("aria-invalid");
        target.removeAttribute("aria-describedby");
        var parent = target.parentNode;
        if (parent) {
          parent.querySelectorAll(".vr-field-error").forEach(function removeErrorNode(node) {
            if (node.parentNode) {
              node.parentNode.removeChild(node);
            }
          });
        }
      }

      var formData = new FormData(form);
      saveCheckoutDraft({
        name: String(formData.get("name") || ""),
        email: String(formData.get("email") || ""),
        phone: String(formData.get("phone") || ""),
        address_line1: String(formData.get("address_line1") || ""),
        address_line2: String(formData.get("address_line2") || ""),
        city: String(formData.get("city") || ""),
        zip: String(formData.get("zip") || ""),
        notes: String(formData.get("notes") || "")
      });
    });

    form.addEventListener("submit", async function onCheckoutSubmit(event) {
      event.preventDefault();

      var cart = readCart();
      var customer = collectCheckoutCustomerData(form);

      if (!cart.length) {
        feedback.className = "vr-feedback error";
        feedback.textContent = "Korpa je prazna.";
        return;
      }

      var validation = validateCheckoutCustomer(customer, form);
      if (!validation.valid) {
        feedback.className = "vr-feedback error";
        feedback.textContent = "Provjerite obavezna polja, email i broj telefona.";
        return;
      }

      placeOrderButton.disabled = true;
      feedback.className = "vr-feedback";
      feedback.textContent = "Slanje narudzbe...";

      try {
        var response = await requestJson("/orders", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            customer: customer,
            items: cart.map(function mapCartItem(item) {
              return {
                slug: item.slug,
                quantity: item.quantity
              };
            })
          })
        });

        clearCheckoutDraft();
        clearCart();

        var orderPublicId = response && response.order && response.order.public_id;
        if (!orderPublicId) {
          throw new Error("Order reference missing in response");
        }

        window.location.href = "/order-confirmation?order=" + encodeURIComponent(orderPublicId);
      } catch (error) {
        var missingSlugs =
          error &&
          error.apiPayload &&
          Array.isArray(error.apiPayload.missingSlugs) &&
          error.apiPayload.missingSlugs.length
            ? error.apiPayload.missingSlugs.map(function mapMissingSlug(slug) {
                return String(slug || "").trim();
              })
            : [];

        if (missingSlugs.length) {
          var currentCart = readCart();
          var filteredCart = currentCart.filter(function keepAvailableItems(item) {
            return missingSlugs.indexOf(String(item.slug || "").trim()) === -1;
          });

          writeCart(filteredCart);
          feedback.className = "vr-feedback error";
          feedback.textContent = "Neki proizvodi vise nisu dostupni i uklonjeni su iz korpe.";
          placeOrderButton.disabled = filteredCart.length === 0;
          return;
        }

        feedback.className = "vr-feedback error";
        feedback.textContent = error.message || "Narudzba nije uspjesno kreirana.";
        placeOrderButton.disabled = false;
      }
    });

    window.addEventListener(CART_UPDATE_EVENT, syncCheckoutUI);

    syncCheckoutUI();
  }

  function buildOrderConfirmationLoadingContent() {
    return [
      '<p class="vr-muted vr-order-loading-copy">Provjeravamo narudzbu...</p>',
      '<div class="vr-card vr-order-meta vr-order-skeleton-block" aria-hidden="true">',
      '  <div class="vr-order-skeleton-row"><span class="vr-skeleton vr-order-skeleton-label"></span><span class="vr-skeleton vr-order-skeleton-value" style="width:220px"></span></div>',
      '  <div class="vr-order-skeleton-row"><span class="vr-skeleton vr-order-skeleton-label"></span><span class="vr-skeleton vr-order-skeleton-value" style="width:162px"></span></div>',
      '  <div class="vr-order-skeleton-row"><span class="vr-skeleton vr-order-skeleton-label"></span><span class="vr-skeleton vr-order-skeleton-value" style="width:184px"></span></div>',
      '  <div class="vr-order-skeleton-row"><span class="vr-skeleton vr-order-skeleton-label"></span><span class="vr-skeleton vr-order-skeleton-value" style="width:252px"></span></div>',
      '  <div class="vr-order-skeleton-row"><span class="vr-skeleton vr-order-skeleton-label"></span><span class="vr-skeleton vr-order-skeleton-value" style="width:146px"></span></div>',
      '  <div class="vr-order-skeleton-row"><span class="vr-skeleton vr-order-skeleton-label"></span><span class="vr-skeleton vr-order-skeleton-value" style="width:318px"></span></div>',
      "</div>",
      '<div class="vr-card vr-order-items vr-order-skeleton-block" aria-hidden="true">',
      '  <h2 class="heading-jumbo-tiny">Stavke</h2>',
      '  <div class="vr-order-item-skeleton">',
      '    <span class="vr-skeleton vr-order-item-thumb"></span>',
      '    <div class="vr-order-item-copy"><span class="vr-skeleton vr-order-item-line lg"></span><span class="vr-skeleton vr-order-item-line md"></span></div>',
      '    <span class="vr-skeleton vr-order-item-price"></span>',
      "  </div>",
      '  <div class="vr-order-item-skeleton">',
      '    <span class="vr-skeleton vr-order-item-thumb"></span>',
      '    <div class="vr-order-item-copy"><span class="vr-skeleton vr-order-item-line lg"></span><span class="vr-skeleton vr-order-item-line md"></span></div>',
      '    <span class="vr-skeleton vr-order-item-price"></span>',
      "  </div>",
      "</div>",
      '<span class="vr-skeleton vr-order-button-skeleton" aria-hidden="true"></span>'
    ].join("\n");
  }

  function buildOrderConfirmationLoadingSummary() {
    return [
      '<div class="vr-order-summary-skeleton" aria-hidden="true">',
      '  <div class="vr-order-summary-skeleton-row"><span class="vr-skeleton vr-order-summary-skeleton-label"></span><span class="vr-skeleton vr-order-summary-skeleton-value"></span></div>',
      '  <div class="vr-order-summary-skeleton-row"><span class="vr-skeleton vr-order-summary-skeleton-label"></span><span class="vr-skeleton vr-order-summary-skeleton-value"></span></div>',
      '  <div class="vr-order-summary-skeleton-row"><span class="vr-skeleton vr-order-summary-skeleton-label"></span><span class="vr-skeleton vr-order-summary-skeleton-value"></span></div>',
      '  <div class="vr-order-summary-skeleton-row"><span class="vr-skeleton vr-order-summary-skeleton-label"></span><span class="vr-skeleton vr-order-summary-skeleton-value"></span></div>',
      '  <div class="vr-order-summary-skeleton-row vr-order-summary-skeleton-total"><span class="vr-skeleton vr-order-summary-skeleton-label"></span><span class="vr-skeleton vr-order-summary-skeleton-value"></span></div>',
      "</div>"
    ].join("\n");
  }

  async function renderOrderConfirmationPage() {
    var root = document.querySelector('[data-node-type="commerce-order-confirmation-wrapper"]');
    if (!root) {
      return;
    }

    root.innerHTML = [
      '<div class="container cc-full-width-form-wrap">',
      '  <div class="vr-checkout-layout">',
      '    <section class="vr-card">',
      '      <h1 class="heading-jumbo-tiny">Potvrda narudzbe</h1>',
      '      <div id="vr-order-content"><p class="vr-muted">Ucitavanje narudzbe...</p></div>',
      "    </section>",
      '    <aside class="vr-card">',
      '      <h2 class="heading-jumbo-tiny">Status</h2>',
      '      <div id="vr-order-summary"></div>',
      "    </aside>",
      "  </div>",
      "</div>"
    ].join("\n");

    var content = document.getElementById("vr-order-content");
    var summary = document.getElementById("vr-order-summary");
    var orderRef = new URLSearchParams(window.location.search).get("order") || "";

    if (!orderRef) {
      if (content) {
        content.classList.remove("vr-order-ready");
        content.innerHTML = '<p class="vr-feedback error">Nedostaje referenca narudzbe.</p>';
      }
      if (summary) {
        summary.classList.remove("vr-order-ready");
        summary.innerHTML = "";
      }
      return;
    }

    if (content) {
      content.classList.remove("vr-order-ready");
      content.innerHTML = buildOrderConfirmationLoadingContent();
    }

    if (summary) {
      summary.classList.remove("vr-order-ready");
      summary.innerHTML = buildOrderConfirmationLoadingSummary();
    }

    try {
      var minimumLoadingDelay = new Promise(function ensureSkeletonVisibility(resolve) {
        window.setTimeout(resolve, 220);
      });
      var response = await requestJson("/orders/" + encodeURIComponent(orderRef));
      await minimumLoadingDelay;
      var order = response.order;
      var items = response.items || [];

      var itemsHtml = items
        .map(function mapOrderItem(item) {
          var itemImageUrl = buildResponsiveImageUrl(item.image_url, {
            role: "checkout"
          }) || item.image_url;
          var itemImageSrcset = buildResponsiveImageSrcset(item.image_url, "checkout");
          return [
            '<div class="vr-cart-row">',
            '  <div class="vr-cart-item-head">',
            itemImageUrl
              ? '    <div class="vr-cart-item-image"><img class="vr-cart-item-image-img" src="' +
                escapeHtml(itemImageUrl) +
                '" ' +
                (itemImageSrcset ? 'srcset="' + escapeHtml(itemImageSrcset) + '" sizes="96px" ' : "") +
                'data-original-src="' +
                escapeHtml(item.image_url || itemImageUrl) +
                '" ' +
                'alt="' +
                escapeHtml(item.product_name || "") +
                '" loading="lazy" decoding="async" /></div>'
              : '    <div class="vr-cart-item-image"></div>',
            '    <div><div class="vr-cart-item-name">' + escapeHtml(item.product_name) + "</div></div>",
            "  </div>",
            '  <div>x' + escapeHtml(item.quantity) + "</div>",
            '  <div>' + escapeHtml(formatPrice(item.line_total_bam)) + "</div>",
            "</div>"
          ].join("\n");
        })
        .join("\n");

      if (content) {
        content.innerHTML = [
          '<p>Hvala vam. Narudzba je uspjesno evidentirana.</p>',
          '<div class="vr-card vr-order-meta">',
          '  <div class="vr-summary-row"><span>Broj narudzbe</span><strong>' + escapeHtml(order.order_number) + "</strong></div>",
          '  <div class="vr-summary-row"><span>Datum</span><span>' + escapeHtml(formatDate(order.created_at)) + "</span></div>",
          '  <div class="vr-summary-row"><span>Kupac</span><span>' + escapeHtml(order.customer_name) + "</span></div>",
          '  <div class="vr-summary-row"><span>Email</span><span>' + escapeHtml(order.customer_email) + "</span></div>",
          '  <div class="vr-summary-row"><span>Telefon</span><span>' + escapeHtml(order.customer_phone || "-") + "</span></div>",
          '  <div class="vr-summary-row"><span>Adresa</span><span>' +
            escapeHtml(order.shipping_address_line1) +
            (order.shipping_address_line2 ? ", " + escapeHtml(order.shipping_address_line2) : "") +
            ", " +
            escapeHtml(order.shipping_city) +
            " " +
            escapeHtml(order.shipping_zip) +
            "</span></div>",
          "</div>",
          '<div class="vr-card vr-order-items">',
          '  <h2 class="heading-jumbo-tiny">Stavke</h2>',
          itemsHtml || '<p class="vr-muted">Nema stavki.</p>',
          "</div>",
          '<a href="/products" class="primary-button">Nastavi kupovinu</a>'
        ].join("\n");
        bindCartItemImageFallback(content);
        content.classList.add("vr-order-ready");
      }

      if (summary) {
        summary.innerHTML = [
          '<div class="vr-summary-row"><span>Status</span><strong>' + escapeHtml(order.status) + "</strong></div>",
          '<div class="vr-summary-row"><span>Nacin placanja</span><span>' +
            escapeHtml(formatPaymentMethod(order.payment_method)) +
            "</span></div>",
          '<div class="vr-summary-row"><span>Subtotal</span><span>' + escapeHtml(formatPrice(order.subtotal_bam)) + "</span></div>",
          '<div class="vr-summary-row"><span>Dostava</span><span>' + escapeHtml(formatPrice(order.shipping_bam)) + "</span></div>",
          '<div class="vr-summary-row vr-summary-total"><span>Ukupno</span><strong>' +
            escapeHtml(formatPrice(order.total_bam)) +
            "</strong></div>"
        ].join("\n");
        summary.classList.add("vr-order-ready");
      }
    } catch (error) {
      if (content) {
        content.classList.remove("vr-order-ready");
        content.innerHTML = '<p class="vr-feedback error">' + escapeHtml(error.message || "Narudzba nije pronadjena.") + "</p>";
        content.classList.add("vr-order-ready");
      }
      if (summary) {
        summary.classList.remove("vr-order-ready");
        summary.innerHTML = "";
      }
    }
  }

  function setContactFormState(doneElement, failElement, state, message) {
    if (doneElement) {
      doneElement.style.display = state === "success" ? "block" : "none";
    }

    if (failElement) {
      failElement.style.display = state === "error" ? "block" : "none";
      if (state === "error" && message) {
        var failText = failElement.querySelector("div");
        if (failText) {
          failText.textContent = message;
        }
      }
    }
  }

  function normalizeCaptchaFeedbackMessage(error) {
    var message = String((error && error.message) || "").trim().toLowerCase();
    if (!message) {
      return "";
    }

    var mentionsCaptcha =
      message.indexOf("security check") !== -1 ||
      message.indexOf("captcha") !== -1 ||
      message.indexOf("recaptcha") !== -1;

    if (
      mentionsCaptcha &&
      (message.indexOf("service is unavailable") !== -1 ||
        message.indexOf("failed to load google recaptcha") !== -1 ||
        message.indexOf("not configured") !== -1 ||
        message.indexOf("incomplete") !== -1)
    ) {
      return currentLanguage === LANGUAGE_EN
        ? "Security check is unavailable. Please try again shortly."
        : "Sigurnosna provjera trenutno nije dostupna. Pokusajte uskoro.";
    }

    if (mentionsCaptcha) {
      return currentLanguage === LANGUAGE_EN
        ? "Security check failed. Please try again."
        : "Sigurnosna provjera nije uspjela. Pokusajte ponovo.";
    }

    return "";
  }

  function hydrateContactForm() {
    var form = document.getElementById("wf-form-Get-In-Touch-Form");
    if (!form) {
      return;
    }

    var wrapper = form.closest(".w-form");
    var doneElement = wrapper ? wrapper.querySelector(".w-form-done") : null;
    var failElement = wrapper ? wrapper.querySelector(".w-form-fail") : null;

    setContactFormState(doneElement, failElement, "idle");
    primePublicRecaptcha();

    form.addEventListener("submit", async function onContactSubmit(event) {
      event.preventDefault();

      var nameInput = form.querySelector('input[name="name"], input[name="Name"]');
      var emailInput = form.querySelector('input[name="Email"], input[type="email"]');
      var phoneInput = form.querySelector('input[name="phone"], input[type="tel"]');
      var messageInput = form.querySelector('textarea[name="field"], textarea');
      var submitButton = form.querySelector('input[type="submit"], button[type="submit"]');

      var name = nameInput ? nameInput.value.trim() : "";
      var email = emailInput ? emailInput.value.trim() : "";
      var phone = phoneInput ? phoneInput.value.trim() : "";
      var message = messageInput ? messageInput.value.trim() : "";

      if (!name || !email || !phone || !message) {
        setContactFormState(
          doneElement,
          failElement,
          "error",
          currentLanguage === LANGUAGE_EN
            ? "Please complete all required fields."
            : "Unesite ime, email, broj telefona i poruku."
        );
        return;
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setContactFormState(
          doneElement,
          failElement,
          "error",
          currentLanguage === LANGUAGE_EN
            ? "Please enter a valid email address."
            : "Unesite ispravnu email adresu."
        );
        return;
      }

      if (!isValidPhoneNumber(phone)) {
        setContactFormState(
          doneElement,
          failElement,
          "error",
          currentLanguage === LANGUAGE_EN
            ? "Please enter a valid phone number."
            : "Unesite ispravan broj telefona."
        );
        return;
      }

      if (submitButton) {
        submitButton.setAttribute("disabled", "disabled");
      }

      try {
        var captchaToken = await requestPublicRecaptchaToken(PUBLIC_RECAPTCHA_ACTIONS.contact);

        await requestJson("/contact", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            name: name,
            email: email,
            phone: phone,
            message: message,
            pagePath: window.location.pathname,
            captchaToken: captchaToken
          })
        });

        form.reset();
        setContactFormState(doneElement, failElement, "success");
      } catch (error) {
        console.error(error);
        var normalizedMessage = String((error && error.message) || "").toLowerCase();
        var captchaMessage = normalizeCaptchaFeedbackMessage(error);
        setContactFormState(
          doneElement,
          failElement,
          "error",
          captchaMessage
            ? captchaMessage
            : normalizedMessage.indexOf("phone is invalid") !== -1
            ? currentLanguage === LANGUAGE_EN
              ? "Please enter a valid phone number."
              : "Unesite ispravan broj telefona."
            : currentLanguage === LANGUAGE_EN
              ? "We could not send your message right now. Please try again."
              : "Trenutno ne mozemo poslati poruku. Pokusajte ponovo."
        );
      } finally {
        if (submitButton) {
          submitButton.removeAttribute("disabled");
        }
      }
    });
  }

  function setWholesaleAuthFeedback(element, message, kind) {
    if (!element) {
      return;
    }

    element.className = "vr-wholesale-auth-feedback" + (kind ? " " + kind : "");
    element.textContent = message || "";
  }

  function normalizeWholesaleLoginFeedbackMessage(error) {
    var fallbackMessage = "Prijava nije uspjela. Pokusajte ponovo.";
    var message = String((error && error.message) || "").trim();
    if (!message) {
      return fallbackMessage;
    }

    var normalizedMessage = message.toLowerCase();
    var captchaMessage = normalizeCaptchaFeedbackMessage(error);

    if (captchaMessage) {
      return captchaMessage;
    }

    if (normalizedMessage.indexOf("email and password are required") !== -1) {
      return "Unesite email i sifru.";
    }

    if (normalizedMessage.indexOf("invalid email or password") !== -1) {
      return "Neispravan email ili sifra.";
    }

    if (
      normalizedMessage.indexOf("account is not enabled for wholesale pricing") !== -1 ||
      normalizedMessage.indexOf("wholesale client account is not active") !== -1
    ) {
      return "Vas nalog nema pristup veleprodajnim cijenama.";
    }

    if (
      normalizedMessage.indexOf("api is not configured") !== -1 ||
      normalizedMessage.indexOf("missing supabase") !== -1 ||
      normalizedMessage.indexOf("table is missing") !== -1
    ) {
      return "Prijava trenutno nije dostupna. Pokusajte kasnije.";
    }

    return fallbackMessage;
  }

  function isValidPhoneNumber(value) {
    var normalized = String(value || "").trim();
    if (!/^[0-9+()\-.\s]{6,40}$/.test(normalized)) {
      return false;
    }

    return normalized.replace(/[^0-9]/g, "").length >= 6;
  }

  function clearWholesaleRequestFieldErrors(form) {
    if (!form) {
      return;
    }

    form.querySelectorAll(".text-field[aria-invalid='true']").forEach(function resetField(input) {
      input.removeAttribute("aria-invalid");
    });
  }

  function setWholesaleRequestFieldError(form, fieldName) {
    if (!form || !fieldName || !form.elements || !form.elements[fieldName]) {
      return;
    }

    var field = form.elements[fieldName];
    if (field && typeof field.setAttribute === "function") {
      field.setAttribute("aria-invalid", "true");
    }
  }

  function normalizeWholesaleAccountRequestFeedbackMessage(error) {
    var fallbackMessage =
      currentLanguage === LANGUAGE_EN
        ? "We could not submit your request. Please try again."
        : "Nismo mogli poslati zahtjev. Pokusajte ponovo.";
    var message = String((error && error.message) || "").trim().toLowerCase();

    if (!message) {
      return fallbackMessage;
    }

    var captchaMessage = normalizeCaptchaFeedbackMessage(error);
    if (captchaMessage) {
      return captchaMessage;
    }

    if (message.indexOf("missing required fields") !== -1) {
      return currentLanguage === LANGUAGE_EN
        ? "Please complete all required fields."
        : "Popunite sva obavezna polja.";
    }

    if (message.indexOf("email is invalid") !== -1) {
      return currentLanguage === LANGUAGE_EN
        ? "Please enter a valid email address."
        : "Unesite ispravnu email adresu.";
    }

    if (message.indexOf("phone is invalid") !== -1) {
      return currentLanguage === LANGUAGE_EN
        ? "Please enter a valid phone number."
        : "Unesite ispravan broj telefona.";
    }

    if (message.indexOf("input is too long") !== -1) {
      return currentLanguage === LANGUAGE_EN
        ? "Some fields are too long."
        : "Neka polja imaju previse karaktera.";
    }

    return fallbackMessage;
  }

  function closeWholesaleAccountRequestModal(options) {
    var config = options && typeof options === "object" ? options : {};
    var restoreFocus = !config.skipRestoreFocus;
    var modal = document.getElementById(WHOLESALE_REQUEST_MODAL_ID);

    if (modal && typeof modal.__cleanup === "function") {
      modal.__cleanup();
      modal.__cleanup = null;
    }

    if (modal && modal.parentNode) {
      removeWholesaleRequestModalNode(modal, config.immediate === true);
    }

    if (document.body) {
      document.body.classList.remove(WHOLESALE_REQUEST_MODAL_OPEN_CLASS);
    }

    if (restoreFocus) {
      restoreFocusIfPossible(wholesaleRequestModalLastFocusedElement);
    }
    wholesaleRequestModalLastFocusedElement = null;
  }

  function removeWholesaleRequestModalNode(modal, immediate) {
    var reduceMotion = Boolean(
      window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );

    if (immediate || reduceMotion) {
      modal.parentNode.removeChild(modal);
      return;
    }

    // Keep the dialog mounted for its close animation; a reopen must not find it by id.
    modal.removeAttribute("id");
    modal.classList.add("is-closing");
    window.setTimeout(function removeClosedWholesaleRequestModal() {
      if (modal.parentNode) {
        modal.parentNode.removeChild(modal);
      }
    }, WHOLESALE_REQUEST_MODAL_CLOSE_MS);
  }

  function openWholesaleAccountRequestModal(options) {
    if (!document.body) {
      return;
    }

    closeWholesaleAccountRequestModal({
      skipRestoreFocus: true,
      immediate: true
    });

    var config = options && typeof options === "object" ? options : {};
    var feedbackTarget = config.feedbackElement || null;
    wholesaleRequestModalLastFocusedElement =
      config.triggerElement ||
      (document.activeElement && typeof document.activeElement.focus === "function"
        ? document.activeElement
        : null);

    var modal = document.createElement("div");
    modal.id = WHOLESALE_REQUEST_MODAL_ID;
    modal.className = "vr-wholesale-request-modal is-open";
    modal.innerHTML = [
      '<button type="button" class="vr-wholesale-request-backdrop" data-action="close-wholesale-request-modal" aria-label="Otkazi"></button>',
      '<div class="vr-wholesale-request-dialog" role="dialog" aria-modal="true" aria-labelledby="vr-wholesale-request-title" data-vr-wholesale-request-dialog>',
      '  <button type="button" class="vr-wholesale-request-close" data-action="close-wholesale-request-modal" aria-label="Otkazi">&times;</button>',
      '  <h3 id="vr-wholesale-request-title" class="vr-wholesale-request-title">Zahtjev za veleprodajni nalog</h3>',
      '  <p class="vr-wholesale-request-note">Popunite podatke i tim ce vas kontaktirati u roku od 24-48h.</p>',
      '  <form class="vr-wholesale-request-form" data-vr-wholesale-request-form novalidate>',
      '    <div class="vr-wholesale-request-progress-shell" aria-hidden="true">',
      '      <div class="vr-wholesale-request-progress-track"><span class="vr-wholesale-request-progress-fill" data-vr-wholesale-progress-fill></span></div>',
      "    </div>",
      '    <section class="vr-wholesale-request-step is-active" data-vr-wholesale-step="1">',
      '      <div class="vr-wholesale-request-step-header">',
      '        <h4 class="vr-wholesale-request-step-title">Firma</h4>',
      '        <p class="vr-wholesale-request-step-copy">Osnovni podaci o kompaniji.</p>',
      "      </div>",
      '      <div class="vr-wholesale-request-step-grid">',
      '        <label class="vr-wholesale-request-field">',
      '          <span class="vr-wholesale-request-label">Naziv firme *</span>',
      '          <input class="text-field" type="text" name="businessName" placeholder="Unesite naziv firme" required maxlength="200" />',
      "        </label>",
      '        <label class="vr-wholesale-request-field">',
      '          <span class="vr-wholesale-request-label">Kontakt osoba *</span>',
      '          <input class="text-field" type="text" name="fullName" placeholder="Unesite kontakt osobu" required maxlength="200" />',
      "        </label>",
      '        <label class="vr-wholesale-request-field">',
      '          <span class="vr-wholesale-request-label">Email adresa *</span>',
      '          <input class="text-field" type="email" name="email" placeholder="Email" required maxlength="200" autocomplete="email" />',
      "        </label>",
      "      </div>",
      "    </section>",
      '    <section class="vr-wholesale-request-step" data-vr-wholesale-step="2">',
      '      <div class="vr-wholesale-request-step-header">',
      '        <h4 class="vr-wholesale-request-step-title">Kontakt i adresa</h4>',
      '        <p class="vr-wholesale-request-step-copy">Kako da vas kontaktiramo i gdje poslujete.</p>',
      "      </div>",
      '      <div class="vr-wholesale-request-step-grid">',
      '        <label class="vr-wholesale-request-field">',
      '          <span class="vr-wholesale-request-label">Telefon *</span>',
      '          <input class="text-field" type="tel" name="phone" placeholder="Unesite broj telefona" required maxlength="40" autocomplete="tel" />',
      "        </label>",
      '        <label class="vr-wholesale-request-field">',
      '          <span class="vr-wholesale-request-label">Adresa *</span>',
      '          <input class="text-field" type="text" name="addressLine1" placeholder="Unesite adresu" required maxlength="200" autocomplete="street-address" />',
      "        </label>",
      '        <label class="vr-wholesale-request-field">',
      '          <span class="vr-wholesale-request-label">Adresa 2 (opcionalno)</span>',
      '          <input class="text-field" type="text" name="addressLine2" placeholder="Adresa 2 (opcionalno)" maxlength="200" />',
      "        </label>",
      '        <div class="vr-wholesale-request-field-row">',
      '          <label class="vr-wholesale-request-field">',
      '            <span class="vr-wholesale-request-label">Grad *</span>',
      '            <input class="text-field" type="text" name="city" placeholder="Unesite grad" required maxlength="200" autocomplete="address-level2" />',
      "          </label>",
      '          <label class="vr-wholesale-request-field">',
      '            <span class="vr-wholesale-request-label">Postanski broj</span>',
      '            <input class="text-field" type="text" name="postalCode" placeholder="Unesite postanski broj" maxlength="40" autocomplete="postal-code" />',
      "          </label>",
      "        </div>",
      "      </div>",
      "    </section>",
      '    <section class="vr-wholesale-request-step" data-vr-wholesale-step="3">',
      '      <div class="vr-wholesale-request-step-header">',
      '        <h4 class="vr-wholesale-request-step-title">Dodatno</h4>',
      '        <p class="vr-wholesale-request-step-copy">Opcioni podaci koji nam olaksavaju obradu zahtjeva.</p>',
      "      </div>",
      '      <div class="vr-wholesale-request-step-grid">',
      '        <label class="vr-wholesale-request-field">',
      '          <span class="vr-wholesale-request-label">Poreski broj / JIB (opcionalno)</span>',
      '          <input class="text-field" type="text" name="taxId" placeholder="Unesite poreski broj ili JIB" maxlength="120" />',
      "        </label>",
      '        <label class="vr-wholesale-request-field">',
      '          <span class="vr-wholesale-request-label">Web stranica (opcionalno)</span>',
      '          <input class="text-field" type="url" name="website" placeholder="https://primjer.com" maxlength="200" />',
      "        </label>",
      '        <label class="vr-wholesale-request-field">',
      '          <span class="vr-wholesale-request-label">Napomena (opcionalno)</span>',
      '          <textarea class="text-field" name="notes" placeholder="Dodatne informacije o prodavnici, lokaciji i planu saradnje." maxlength="1200"></textarea>',
      "        </label>",
      "      </div>",
      "    </section>",
      '    <div class="vr-wholesale-request-actions">',
      '      <button type="button" class="vr-wholesale-request-back" data-vr-wholesale-request-back>',
      '        <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M15 18 9 12l6-6"></path></svg>',
      "        Nazad",
      "      </button>",
      '      <button type="button" class="primary-button vr-wholesale-request-next" data-vr-wholesale-request-next>Dalje</button>',
      '      <button type="submit" class="primary-button vr-wholesale-request-submit" data-vr-wholesale-request-submit>Posalji zahtjev</button>',
      "    </div>",
      "  </form>",
      '  <div class="vr-wholesale-auth-feedback" data-vr-wholesale-request-feedback aria-live="polite"></div>',
      "</div>"
    ].join("\n");

    document.body.appendChild(modal);
    document.body.classList.add(WHOLESALE_REQUEST_MODAL_OPEN_CLASS);

    var dialog = modal.querySelector("[data-vr-wholesale-request-dialog]");
    var form = modal.querySelector("[data-vr-wholesale-request-form]");
    var backButton = modal.querySelector("[data-vr-wholesale-request-back]");
    var nextButton = modal.querySelector("[data-vr-wholesale-request-next]");
    var submitButton = modal.querySelector("[data-vr-wholesale-request-submit]");
    var progressFill = modal.querySelector("[data-vr-wholesale-progress-fill]");
    var feedback = modal.querySelector("[data-vr-wholesale-request-feedback]");
    var closeButtons = modal.querySelectorAll('[data-action="close-wholesale-request-modal"]');
    var closeTimerId = null;
    var currentStep = 1;
    var totalSteps = 3;
    var requiredFields = ["businessName", "fullName", "email", "phone", "addressLine1", "city"];
    var stepRequiredFields = {
      1: ["businessName", "fullName", "email"],
      2: ["phone", "addressLine1", "city"],
      3: []
    };
    var fieldStepMap = {
      businessName: 1,
      fullName: 1,
      email: 1,
      phone: 2,
      addressLine1: 2,
      addressLine2: 2,
      city: 2,
      postalCode: 2,
      taxId: 3,
      website: 3,
      notes: 3
    };

    function setModalFeedback(message, kind) {
      setWholesaleAuthFeedback(feedback, message, kind);
    }

    function buildWholesaleRequestPayload() {
      if (!form) {
        return {
          businessName: "",
          fullName: "",
          email: "",
          phone: "",
          addressLine1: "",
          addressLine2: "",
          city: "",
          postalCode: "",
          taxId: "",
          website: "",
          notes: "",
          pagePath: window.location.pathname
        };
      }

      var formData = new FormData(form);
      return {
        businessName: String(formData.get("businessName") || "").trim(),
        fullName: String(formData.get("fullName") || "").trim(),
        email: String(formData.get("email") || "").trim(),
        phone: String(formData.get("phone") || "").trim(),
        addressLine1: String(formData.get("addressLine1") || "").trim(),
        addressLine2: String(formData.get("addressLine2") || "").trim(),
        city: String(formData.get("city") || "").trim(),
        postalCode: String(formData.get("postalCode") || "").trim(),
        taxId: String(formData.get("taxId") || "").trim(),
        website: String(formData.get("website") || "").trim(),
        notes: String(formData.get("notes") || "").trim(),
        pagePath: window.location.pathname
      };
    }

    function focusWholesaleRequestField(fieldName) {
      if (!form || !form.elements || !form.elements[fieldName]) {
        return;
      }

      var field = form.elements[fieldName];
      if (field && typeof field.focus === "function") {
        field.focus();
      }
    }

    function setWholesaleRequestStep(step, options) {
      var config = options && typeof options === "object" ? options : {};
      currentStep = Math.min(totalSteps, Math.max(1, Number(step) || 1));

      if (!form) {
        return;
      }

      form.querySelectorAll("[data-vr-wholesale-step]").forEach(function syncStepVisibility(panel) {
        var panelStep = Number(panel.getAttribute("data-vr-wholesale-step") || "0");
        panel.classList.toggle("is-active", panelStep === currentStep);
      });

      if (progressFill) {
        var progressPercent = totalSteps > 0 ? (currentStep / totalSteps) * 100 : 100;
        progressFill.style.width = progressPercent + "%";
      }

      if (backButton) {
        backButton.style.display = currentStep > 1 ? "inline-flex" : "none";
      }
      if (nextButton) {
        nextButton.style.display = currentStep < totalSteps ? "inline-flex" : "none";
      }
      if (submitButton) {
        submitButton.style.display = currentStep === totalSteps ? "inline-flex" : "none";
      }

      if (config.skipFocus) {
        return;
      }

      var activeStep = form.querySelector('[data-vr-wholesale-step="' + currentStep + '"]');
      var firstField = activeStep && activeStep.querySelector("input, textarea, select");
      if (firstField && typeof firstField.focus === "function") {
        firstField.focus();
      }
    }

    function validateWholesaleRequestStep(payload, step) {
      var requiredByStep = stepRequiredFields[step] || [];
      var firstMissingField = requiredByStep.find(function findMissingField(fieldName) {
        return !payload[fieldName];
      });

      if (firstMissingField) {
        setWholesaleRequestFieldError(form, firstMissingField);
        setModalFeedback(
          currentLanguage === LANGUAGE_EN
            ? "Please complete all required fields."
            : "Popunite sva obavezna polja.",
          "error"
        );
        setWholesaleRequestStep(fieldStepMap[firstMissingField] || step, {
          skipFocus: true
        });
        focusWholesaleRequestField(firstMissingField);
        return false;
      }

      if (step >= 1 && payload.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) {
        setWholesaleRequestFieldError(form, "email");
        setModalFeedback(
          currentLanguage === LANGUAGE_EN
            ? "Please enter a valid email address."
            : "Unesite ispravnu email adresu.",
          "error"
        );
        setWholesaleRequestStep(fieldStepMap.email || step, {
          skipFocus: true
        });
        focusWholesaleRequestField("email");
        return false;
      }

      if (step >= 2 && payload.phone && !isValidPhoneNumber(payload.phone)) {
        setWholesaleRequestFieldError(form, "phone");
        setModalFeedback(
          currentLanguage === LANGUAGE_EN
            ? "Please enter a valid phone number."
            : "Unesite ispravan broj telefona.",
          "error"
        );
        setWholesaleRequestStep(fieldStepMap.phone || step, {
          skipFocus: true
        });
        focusWholesaleRequestField("phone");
        return false;
      }

      return true;
    }

    function validateWholesaleRequestBeforeSubmit(payload) {
      var firstMissingField = requiredFields.find(function findMissingField(fieldName) {
        return !payload[fieldName];
      });

      if (firstMissingField) {
        setWholesaleRequestFieldError(form, firstMissingField);
        setModalFeedback(
          currentLanguage === LANGUAGE_EN
            ? "Please complete all required fields."
            : "Popunite sva obavezna polja.",
          "error"
        );
        setWholesaleRequestStep(fieldStepMap[firstMissingField] || 1, {
          skipFocus: true
        });
        focusWholesaleRequestField(firstMissingField);
        return false;
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) {
        setWholesaleRequestFieldError(form, "email");
        setModalFeedback(
          currentLanguage === LANGUAGE_EN
            ? "Please enter a valid email address."
            : "Unesite ispravnu email adresu.",
          "error"
        );
        setWholesaleRequestStep(fieldStepMap.email || 1, {
          skipFocus: true
        });
        focusWholesaleRequestField("email");
        return false;
      }

      if (!isValidPhoneNumber(payload.phone)) {
        setWholesaleRequestFieldError(form, "phone");
        setModalFeedback(
          currentLanguage === LANGUAGE_EN
            ? "Please enter a valid phone number."
            : "Unesite ispravan broj telefona.",
          "error"
        );
        setWholesaleRequestStep(fieldStepMap.phone || 2, {
          skipFocus: true
        });
        focusWholesaleRequestField("phone");
        return false;
      }

      return true;
    }

    function handleCloseClick(event) {
      event.preventDefault();
      closeWholesaleAccountRequestModal();
    }

    function handleModalKeydown(event) {
      if (!document.getElementById(WHOLESALE_REQUEST_MODAL_ID)) {
        return;
      }

      if (event.key === "Escape") {
        event.preventDefault();
        closeWholesaleAccountRequestModal();
        return;
      }

      if (event.key === "Tab" && dialog) {
        trapFocusWithinContainer(dialog, event);
      }
    }

    function handleBackClick(event) {
      event.preventDefault();
      clearWholesaleRequestFieldErrors(form);
      setModalFeedback("", "");
      setWholesaleRequestStep(currentStep - 1);
    }

    function handleNextClick(event) {
      event.preventDefault();
      clearWholesaleRequestFieldErrors(form);
      setModalFeedback("", "");

      var payload = buildWholesaleRequestPayload();
      if (!validateWholesaleRequestStep(payload, currentStep)) {
        return;
      }

      setWholesaleRequestStep(currentStep + 1);
    }

    closeButtons.forEach(function bindCloseButton(button) {
      button.addEventListener("click", handleCloseClick);
    });
    if (backButton) {
      backButton.addEventListener("click", handleBackClick);
    }
    if (nextButton) {
      nextButton.addEventListener("click", handleNextClick);
    }
    document.addEventListener("keydown", handleModalKeydown);

    modal.__cleanup = function cleanupWholesaleRequestModal() {
      if (closeTimerId) {
        window.clearTimeout(closeTimerId);
        closeTimerId = null;
      }

      closeButtons.forEach(function unbindCloseButton(button) {
        button.removeEventListener("click", handleCloseClick);
      });
      if (backButton) {
        backButton.removeEventListener("click", handleBackClick);
      }
      if (nextButton) {
        nextButton.removeEventListener("click", handleNextClick);
      }
      document.removeEventListener("keydown", handleModalKeydown);
    };

    if (form) {
      form.addEventListener("submit", async function onWholesaleRequestSubmit(event) {
        event.preventDefault();

        clearWholesaleRequestFieldErrors(form);
        setModalFeedback("", "");

        var payload = buildWholesaleRequestPayload();

        if (currentStep < totalSteps) {
          if (validateWholesaleRequestStep(payload, currentStep)) {
            setWholesaleRequestStep(currentStep + 1);
          }
          return;
        }

        if (!validateWholesaleRequestBeforeSubmit(payload)) {
          return;
        }

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = currentLanguage === LANGUAGE_EN ? "Sending..." : "Slanje...";
        }

        try {
          var captchaToken = await requestPublicRecaptchaToken(PUBLIC_RECAPTCHA_ACTIONS.wholesaleAccountRequest);

          await requestJson("/wholesale/account-request", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(
              Object.assign({}, payload, {
                captchaToken: captchaToken
              })
            )
          });

          form.reset();
          setModalFeedback(
            currentLanguage === LANGUAGE_EN
              ? "Request sent. We will contact you soon."
              : "Zahtjev je poslan. Kontaktiracemo vas uskoro.",
            "success"
          );
          if (feedbackTarget) {
            setWholesaleAuthFeedback(
              feedbackTarget,
              currentLanguage === LANGUAGE_EN
                ? "Account request submitted. We will contact you soon."
                : "Zahtjev za nalog je zaprimljen. Kontaktiracemo vas uskoro.",
              "success"
            );
          }

          closeTimerId = window.setTimeout(function closeWholesaleRequestAfterSuccess() {
            closeWholesaleAccountRequestModal();
          }, 900);
        } catch (error) {
          setModalFeedback(normalizeWholesaleAccountRequestFeedbackMessage(error), "error");
        } finally {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = currentLanguage === LANGUAGE_EN ? "Send request" : "Posalji zahtjev";
          }
        }
      });
    }

    setWholesaleRequestStep(1);
  }

  function syncWholesaleAuthPanel(panel) {
    if (!panel) {
      return;
    }

    var form = panel.querySelector("[data-vr-wholesale-form]");
    var active = panel.querySelector("[data-vr-wholesale-active]");
    var label = panel.querySelector("[data-vr-wholesale-email]");
    var signedIn = isWholesaleClientAuthenticated();

    if (form) {
      form.style.display = signedIn ? "none" : "";
    }

    if (active) {
      active.style.display = signedIn ? "" : "none";
    }

    if (label) {
      var displayLabel = "-";
      if (signedIn && wholesaleProfile) {
        displayLabel = wholesaleProfile.full_name || wholesaleProfile.email || "-";
      }

      label.textContent = signedIn ? "Aktivan nalog: " + displayLabel : "";
    }
  }

  function syncWholesaleAuthPanels() {
    document.querySelectorAll("[data-vr-wholesale-auth='1']").forEach(function syncPanel(panel) {
      syncWholesaleAuthPanel(panel);
    });
  }

  function clearWholesaleAuthPanelRetryTimer() {
    if (!wholesaleAuthPanelRetryTimeoutId) {
      return;
    }

    window.clearTimeout(wholesaleAuthPanelRetryTimeoutId);
    wholesaleAuthPanelRetryTimeoutId = null;
  }

  function scheduleWholesaleAuthPanelRetry() {
    if (wholesaleAuthPanelRetryTimeoutId) {
      return;
    }

    if (byPathname(window.location.pathname) !== "wholesale") {
      clearWholesaleAuthPanelRetryTimer();
      wholesaleAuthPanelRetryAttempts = 0;
      return;
    }

    wholesaleAuthPanelRetryTimeoutId = window.setTimeout(function onWholesaleAuthPanelRetryTick() {
      wholesaleAuthPanelRetryTimeoutId = null;

      if (ensureWholesaleAuthPanel()) {
        wholesaleAuthPanelRetryAttempts = 0;
        return;
      }

      wholesaleAuthPanelRetryAttempts += 1;
      if (wholesaleAuthPanelRetryAttempts >= WHOLESALE_AUTH_PANEL_MAX_RETRY_ATTEMPTS) {
        return;
      }

      scheduleWholesaleAuthPanelRetry();
    }, WHOLESALE_AUTH_PANEL_RETRY_DELAY_MS);
  }

  function ensureWholesaleAuthPanelWithRetry() {
    wholesaleAuthPanelRetryAttempts = 0;

    if (ensureWholesaleAuthPanel()) {
      clearWholesaleAuthPanelRetryTimer();
      return;
    }

    scheduleWholesaleAuthPanelRetry();
  }

  function ensureWholesaleAuthPanel() {
    var section = document.querySelector(".section.wholesale-hero");
    if (!section) {
      return false;
    }

    var contactCard = section.querySelector(".div-block-3");
    if (!contactCard) {
      return false;
    }

    var columns = section.querySelector(".vr-wholesale-columns");
    if (!columns) {
      columns = document.createElement("div");
      columns.className = "vr-wholesale-columns";
      if (contactCard.parentNode) {
        contactCard.parentNode.insertBefore(columns, contactCard);
      } else {
        section.appendChild(columns);
      }
    }

    var contactColumn = columns.querySelector(".vr-wholesale-contact-col");
    if (!contactColumn) {
      contactColumn = document.createElement("div");
      contactColumn.className = "vr-wholesale-contact-col";
      columns.appendChild(contactColumn);
    }

    if (contactCard.parentNode !== contactColumn) {
      contactColumn.appendChild(contactCard);
    }

    var authColumn = columns.querySelector(".vr-wholesale-auth-col");
    if (!authColumn) {
      authColumn = document.createElement("div");
      authColumn.className = "vr-wholesale-auth-col";
      columns.appendChild(authColumn);
    }

    var existing = section.querySelector("[data-vr-wholesale-auth='1']");
    if (existing) {
      if (existing.parentNode !== authColumn) {
        authColumn.appendChild(existing);
      }
      primePublicRecaptcha();
      syncWholesaleAuthPanel(existing);
      return true;
    }

    var panel = document.createElement("div");
    panel.className = "vr-wholesale-auth-card";
    panel.setAttribute("data-vr-wholesale-auth", "1");
    panel.innerHTML = [
      '<h2 class="vr-wholesale-auth-title">Prijava za veleprodajne klijente</h2>',
      '<p class="vr-wholesale-auth-note">Prijavite se da vidite veleprodajne cijene u cijelom katalogu.</p>',
      '<form class="vr-wholesale-auth-form" data-vr-wholesale-form autocomplete="on">',
      '  <input class="text-field" type="email" name="email" placeholder="Email" aria-label="Email" required autocomplete="email" />',
      '  <input class="text-field" type="password" name="password" placeholder="Sifra" aria-label="Sifra" required autocomplete="current-password" />',
      '  <div class="vr-wholesale-auth-row">',
      '    <button type="submit" class="primary-button" data-vr-wholesale-submit>Prijavi se</button>',
      "  </div>",
      '  <button type="button" class="vr-wholesale-auth-request-toggle" data-vr-wholesale-open-request>Kreiraj veleprodajni nalog</button>',
      "</form>",
      '<div class="vr-wholesale-auth-active" data-vr-wholesale-active style="display:none;">',
      '  <span class="vr-wholesale-auth-badge">Veleprodajne cijene su aktivne</span>',
      '  <div class="vr-wholesale-auth-note" data-vr-wholesale-email></div>',
      '  <div class="vr-wholesale-auth-row">',
      '    <button type="button" class="primary-button" data-vr-wholesale-logout>Odjavi se</button>',
      "  </div>",
      "</div>",
      '<div class="vr-wholesale-auth-feedback" data-vr-wholesale-feedback aria-live="polite"></div>'
    ].join("\n");
    authColumn.appendChild(panel);

    var form = panel.querySelector("[data-vr-wholesale-form]");
    var submitButton = panel.querySelector("[data-vr-wholesale-submit]");
    var openRequestButton = panel.querySelector("[data-vr-wholesale-open-request]");
    var logoutButton = panel.querySelector("[data-vr-wholesale-logout]");
    var feedback = panel.querySelector("[data-vr-wholesale-feedback]");
    primePublicRecaptcha();

    if (form) {
      form.addEventListener("submit", async function onWholesaleLoginSubmit(event) {
        event.preventDefault();

        var formData = new FormData(form);
        var email = String(formData.get("email") || "").trim();
        var password = String(formData.get("password") || "");

        if (!email || !password) {
          setWholesaleAuthFeedback(feedback, "Unesite email i sifru.", "error");
          return;
        }

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = "Prijava...";
        }

        try {
          var captchaToken = await requestPublicRecaptchaToken(PUBLIC_RECAPTCHA_ACTIONS.wholesaleLogin);
          var payload = await requestJson("/wholesale/login", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              email: email,
              password: password,
              captchaToken: captchaToken
            })
          });

          var session = writeWholesaleSession(payload && payload.session ? payload.session : null);
          if (!session) {
            throw new Error("Prijava nije uspjela. Pokusajte ponovo.");
          }

          setWholesaleProfile(payload && payload.profile ? payload.profile : null);
          syncWholesaleAuthPanels();
          setWholesaleAuthFeedback(feedback, "Prijava uspjesna. Ucitavam veleprodajne cijene...", "success");

          if (window.location && typeof window.location.assign === "function") {
            window.location.assign("/products");
          } else {
            window.location.href = "/products";
          }
          return;

          try {
            await refreshCartPricingFromCatalog();
          } catch (cartRefreshError) {
            console.error("Failed to refresh cart pricing after wholesale login", cartRefreshError);
          }

          refreshCartLinks();
          syncCartDrawer();
        } catch (error) {
          setWholesaleAuthFeedback(feedback, normalizeWholesaleLoginFeedbackMessage(error), "error");
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = "Prijavi se";
          }
        }
      });
    }

    if (openRequestButton) {
      openRequestButton.addEventListener("click", function onWholesaleRequestOpenClick(event) {
        event.preventDefault();
        openWholesaleAccountRequestModal({
          triggerElement: openRequestButton,
          feedbackElement: feedback
        });
      });
    }

    if (logoutButton) {
      logoutButton.addEventListener("click", async function onWholesaleLogout() {
        clearWholesaleSession();
        syncWholesaleAuthPanels();
        setWholesaleAuthFeedback(feedback, "Odjavljeni ste.", "success");

        try {
          await refreshCartPricingFromCatalog();
        } catch (cartRefreshError) {
          console.error("Failed to refresh cart pricing after wholesale logout", cartRefreshError);
        }

        refreshCartLinks();
        syncCartDrawer();
      });
    }

    syncWholesaleAuthPanel(panel);
    return true;
  }

  function markDynamicReady() {
    if (!document.body) {
      return;
    }

    document.body.classList.remove("vr-dyn-loading");
    document.body.classList.add("vr-dyn-ready");
  }

  function markDetailProductReady() {
    if (!document.body) {
      return;
    }

    document.body.classList.remove("vr-detail-loading");
    document.body.classList.add("vr-detail-ready");
  }

  function showGlobalRuntimeError(message) {
    if (!document.body) {
      return;
    }

    var existing = document.getElementById("vr-runtime-error-banner");
    if (existing) {
      existing.textContent = message;
      return;
    }

    var banner = document.createElement("div");
    banner.id = "vr-runtime-error-banner";
    banner.className = "vr-feedback error";
    banner.style.margin = "12px auto";
    banner.style.maxWidth = "1100px";
    banner.style.padding = "0 16px";
    banner.textContent = message;
    document.body.insertBefore(banner, document.body.firstChild);
  }

  async function init() {
    var page = byPathname(window.location.pathname);
    if (document.body) {
      document.body.classList.add("vr-page-" + String(page).replace(/_/g, "-"));
    }

    sanitizeLegacyCommerceNodes();
    ensureCustomStyles();
    ensureMobileNavMenu();
    normalizeCoreImageAltText();
    normalizeFooterTrustLinks();
    initializeLanguageSupport();
    initWholesaleViberCopy();
    ensureWholesaleAuthPanelWithRetry();

    var indexHydrationPromise =
      page === "index"
        ? hydrateIndexPage().catch(function captureEarlyIndexHydrationError(error) {
            return {
              error: error
            };
          })
        : null;

    try {
      await hydrateWholesaleClientSession();
    } catch (wholesaleSessionError) {
      console.error("Wholesale session hydration failed", wholesaleSessionError);
    }

    try {
      await refreshCartPricingFromCatalog();
    } catch (cartPricingError) {
      console.error("Cart price refresh failed", cartPricingError);
    }

    ensureWholesaleAuthPanelWithRetry();
    ensureCartDrawer();
    bindCartDrawerInteractions();
    refreshCartLinks();
    syncCartDrawer();
    bindDesktopProductsStickyCart();
    window.addEventListener(CART_UPDATE_EVENT, refreshCartLinks);

    try {
      if (page === "index") {
        var indexHydrationResult = await indexHydrationPromise;
        if (indexHydrationResult && indexHydrationResult.error) {
          throw indexHydrationResult.error;
        }
      } else if (page === "products") {
        await hydrateProductsPage();
      } else if (page === "detail_product") {
        await Promise.all([
          hydrateProductDetailPage(),
          requestJson("/categories").then(function onCategoriesResponse(result) {
            renderFooterCategories(result.categories || []);
          })
        ]);
      } else if (page === "detail_category") {
        await hydrateDetailCategoryPage();
      } else if (page === "checkout") {
        await Promise.all([
          renderCheckoutPage(),
          requestJson("/categories").then(function onCategoriesResponse(result) {
            renderFooterCategories(result.categories || []);
          })
        ]);
      } else if (page === "order_confirmation") {
        await Promise.all([
          renderOrderConfirmationPage(),
          requestJson("/categories").then(function onCategoriesResponse(result) {
            renderFooterCategories(result.categories || []);
          })
        ]);
      } else {
        requestJson("/categories")
          .then(function onCategoriesResponse(result) {
            renderFooterCategories(result.categories || []);
          })
          .catch(function noop() {
            return null;
          });
      }

      if (page === "contact") {
        hydrateContactForm();
      }
    } catch (error) {
      console.error("Dynamic content initialization failed", error);
      showGlobalRuntimeError(
        currentLanguage === LANGUAGE_EN
          ? "Some content could not be loaded. Please refresh the page."
          : "Nismo mogli ucitati sav sadrzaj. Osvjezite stranicu."
      );
    } finally {
      normalizeCoreImageAltText();
      normalizeDynamicListSemantics();
      normalizeFooterTrustLinks();
      if (currentLanguage === LANGUAGE_EN) {
        requestLanguageSync();
      }

      markDynamicReady();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
